function Ht(n, t) {
  for (var p = 0; p < t.length; p++) {
    const f = t[p];
    if (typeof f != "string" && !Array.isArray(f)) {
      for (const l in f)
        if (l !== "default" && !(l in n)) {
          const i = Object.getOwnPropertyDescriptor(f, l);
          i && Object.defineProperty(n, l, i.get ? i : {
            enumerable: !0,
            get: () => f[l]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }));
}
var Ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Zt(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var ar = {}, Kt = {};
(function(n) {
  var t = typeof Object.defineProperties == "function" ? Object.defineProperty : function(o, a, u) {
    o != Array.prototype && o != Object.prototype && (o[a] = u.value);
  }, p = (typeof window < "u" && window === Ce || typeof Ce < "u" && Ce != null, Ce);
  function f(o, a) {
    if (a) {
      var u = p;
      o = o.split(".");
      for (var h = 0; h < o.length - 1; h++) {
        var R = o[h];
        R in u || (u[R] = {}), u = u[R];
      }
      o = o[o.length - 1], h = u[o], a = a(h), a != h && a != null && t(u, o, { configurable: !0, writable: !0, value: a });
    }
  }
  function l(o) {
    var a = 0;
    return function() {
      return a < o.length ? { done: !1, value: o[a++] } : { done: !0 };
    };
  }
  function i() {
    i = function() {
    }, p.Symbol || (p.Symbol = r);
  }
  function e(o, a) {
    this.a = o, t(this, "description", { configurable: !0, writable: !0, value: a });
  }
  e.prototype.toString = function() {
    return this.a;
  };
  var r = function() {
    function o(u) {
      if (this instanceof o)
        throw new TypeError("Symbol is not a constructor");
      return new e("jscomp_symbol_" + (u || "") + "_" + a++, u);
    }
    var a = 0;
    return o;
  }();
  function s() {
    i();
    var o = p.Symbol.iterator;
    o || (o = p.Symbol.iterator = p.Symbol("Symbol.iterator")), typeof Array.prototype[o] != "function" && t(Array.prototype, o, { configurable: !0, writable: !0, value: function() {
      return d(l(this));
    } }), s = function() {
    };
  }
  function d(o) {
    return s(), o = { next: o }, o[p.Symbol.iterator] = function() {
      return this;
    }, o;
  }
  function A(o, a) {
    s(), o instanceof String && (o += "");
    var u = 0, h = { next: function() {
      if (u < o.length) {
        var R = u++;
        return { value: a(R, o[R]), done: !1 };
      }
      return h.next = function() {
        return { done: !0, value: void 0 };
      }, h.next();
    } };
    return h[Symbol.iterator] = function() {
      return h;
    }, h;
  }
  f("Array.prototype.entries", function(o) {
    return o || function() {
      return A(this, function(a, u) {
        return [a, u];
      });
    };
  });
  var _ = Ce || self;
  function M(o, a, u) {
    o = o.split("."), u = u || _, o[0] in u || typeof u.execScript > "u" || u.execScript("var " + o[0]);
    for (var h; o.length && (h = o.shift()); )
      o.length || a === void 0 ? u[h] && u[h] !== Object.prototype[h] ? u = u[h] : u = u[h] = {} : u[h] = a;
  }
  function X(o) {
    var a = typeof o;
    if (a == "object")
      if (o) {
        if (o instanceof Array)
          return "array";
        if (o instanceof Object)
          return a;
        var u = Object.prototype.toString.call(o);
        if (u == "[object Window]")
          return "object";
        if (u == "[object Array]" || typeof o.length == "number" && typeof o.splice < "u" && typeof o.propertyIsEnumerable < "u" && !o.propertyIsEnumerable("splice"))
          return "array";
        if (u == "[object Function]" || typeof o.call < "u" && typeof o.propertyIsEnumerable < "u" && !o.propertyIsEnumerable("call"))
          return "function";
      } else
        return "null";
    else if (a == "function" && typeof o.call > "u")
      return "object";
    return a;
  }
  function V(o) {
    var a = typeof o;
    return a == "object" && o != null || a == "function";
  }
  function H(o, a, u) {
    M(o, a, u);
  }
  function x(o, a) {
    function u() {
    }
    u.prototype = a.prototype, o.prototype = new u(), o.prototype.constructor = o;
  }
  var E = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
  function D(o, a) {
    for (var u, h, R = 1; R < arguments.length; R++) {
      h = arguments[R];
      for (u in h)
        o[u] = h[u];
      for (var W = 0; W < E.length; W++)
        u = E[W], Object.prototype.hasOwnProperty.call(h, u) && (o[u] = h[u]);
    }
  }
  var O = Array.prototype.forEach ? function(o, a) {
    Array.prototype.forEach.call(o, a, void 0);
  } : function(o, a) {
    for (var u = o.length, h = typeof o == "string" ? o.split("") : o, R = 0; R < u; R++)
      R in h && a.call(void 0, h[R], R, o);
  }, z = Array.prototype.map ? function(o, a) {
    return Array.prototype.map.call(o, a, void 0);
  } : function(o, a) {
    for (var u = o.length, h = Array(u), R = typeof o == "string" ? o.split("") : o, W = 0; W < u; W++)
      W in R && (h[W] = a.call(void 0, R[W], W, o));
    return h;
  };
  function $(o, a, u) {
    return 2 >= arguments.length ? Array.prototype.slice.call(o, a) : Array.prototype.slice.call(o, a, u);
  }
  function J(o, a, u, h) {
    var R = "Assertion failed";
    if (u) {
      R += ": " + u;
      var W = h;
    } else
      o && (R += ": " + o, W = a);
    throw Error(R, W || []);
  }
  function F(o, a, u) {
    for (var h = [], R = 2; R < arguments.length; ++R)
      h[R - 2] = arguments[R];
    return o || J("", null, a, h), o;
  }
  function ee(o, a, u) {
    for (var h = [], R = 2; R < arguments.length; ++R)
      h[R - 2] = arguments[R];
    typeof o != "string" && J("Expected string but got %s: %s.", [X(o), o], a, h);
  }
  function oe(o, a, u) {
    for (var h = [], R = 2; R < arguments.length; ++R)
      h[R - 2] = arguments[R];
    Array.isArray(o) || J("Expected array but got %s: %s.", [X(o), o], a, h);
  }
  function ae(o, a) {
    for (var u = [], h = 1; h < arguments.length; ++h)
      u[h - 1] = arguments[h];
    throw Error("Failure" + (o ? ": " + o : ""), u);
  }
  function fe(o, a, u, h) {
    for (var R = [], W = 3; W < arguments.length; ++W)
      R[W - 3] = arguments[W];
    o instanceof a || J("Expected instanceof %s but got %s.", [I(a), I(o)], u, R);
  }
  function I(o) {
    return o instanceof Function ? o.displayName || o.name || "unknown type name" : o instanceof Object ? o.constructor.displayName || o.constructor.name || Object.prototype.toString.call(o) : o === null ? "null" : typeof o;
  }
  function ne(o, a) {
    if (this.c = o, this.b = a, this.a = {}, this.arrClean = !0, 0 < this.c.length) {
      for (o = 0; o < this.c.length; o++) {
        a = this.c[o];
        var u = a[0];
        this.a[u.toString()] = new We(u, a[1]);
      }
      this.arrClean = !0;
    }
  }
  M("jspb.Map", ne, void 0), ne.prototype.g = function() {
    if (this.arrClean) {
      if (this.b) {
        var o = this.a, a;
        for (a in o)
          if (Object.prototype.hasOwnProperty.call(o, a)) {
            var u = o[a].a;
            u && u.g();
          }
      }
    } else {
      for (this.c.length = 0, o = we(this), o.sort(), a = 0; a < o.length; a++) {
        var h = this.a[o[a]];
        (u = h.a) && u.g(), this.c.push([h.key, h.value]);
      }
      this.arrClean = !0;
    }
    return this.c;
  }, ne.prototype.toArray = ne.prototype.g, ne.prototype.Mc = function(o, a) {
    for (var u = this.g(), h = [], R = 0; R < u.length; R++) {
      var W = this.a[u[R][0].toString()];
      be(this, W);
      var K = W.a;
      K ? (F(a), h.push([W.key, a(o, K)])) : h.push([W.key, W.value]);
    }
    return h;
  }, ne.prototype.toObject = ne.prototype.Mc, ne.fromObject = function(o, a, u) {
    a = new ne([], a);
    for (var h = 0; h < o.length; h++) {
      var R = o[h][0], W = u(o[h][1]);
      a.set(R, W);
    }
    return a;
  };
  function me(o) {
    this.a = 0, this.b = o;
  }
  me.prototype.next = function() {
    return this.a < this.b.length ? { done: !1, value: this.b[this.a++] } : { done: !0, value: void 0 };
  }, typeof Symbol < "u" && (me.prototype[Symbol.iterator] = function() {
    return this;
  }), ne.prototype.Jb = function() {
    return we(this).length;
  }, ne.prototype.getLength = ne.prototype.Jb, ne.prototype.clear = function() {
    this.a = {}, this.arrClean = !1;
  }, ne.prototype.clear = ne.prototype.clear, ne.prototype.Cb = function(o) {
    o = o.toString();
    var a = this.a.hasOwnProperty(o);
    return delete this.a[o], this.arrClean = !1, a;
  }, ne.prototype.del = ne.prototype.Cb, ne.prototype.Eb = function() {
    var o = [], a = we(this);
    a.sort();
    for (var u = 0; u < a.length; u++) {
      var h = this.a[a[u]];
      o.push([h.key, h.value]);
    }
    return o;
  }, ne.prototype.getEntryList = ne.prototype.Eb, ne.prototype.entries = function() {
    var o = [], a = we(this);
    a.sort();
    for (var u = 0; u < a.length; u++) {
      var h = this.a[a[u]];
      o.push([h.key, be(this, h)]);
    }
    return new me(o);
  }, ne.prototype.entries = ne.prototype.entries, ne.prototype.keys = function() {
    var o = [], a = we(this);
    a.sort();
    for (var u = 0; u < a.length; u++)
      o.push(this.a[a[u]].key);
    return new me(o);
  }, ne.prototype.keys = ne.prototype.keys, ne.prototype.values = function() {
    var o = [], a = we(this);
    a.sort();
    for (var u = 0; u < a.length; u++)
      o.push(be(this, this.a[a[u]]));
    return new me(o);
  }, ne.prototype.values = ne.prototype.values, ne.prototype.forEach = function(o, a) {
    var u = we(this);
    u.sort();
    for (var h = 0; h < u.length; h++) {
      var R = this.a[u[h]];
      o.call(a, be(this, R), R.key, this);
    }
  }, ne.prototype.forEach = ne.prototype.forEach, ne.prototype.set = function(o, a) {
    var u = new We(o);
    return this.b ? (u.a = a, u.value = a.g()) : u.value = a, this.a[o.toString()] = u, this.arrClean = !1, this;
  }, ne.prototype.set = ne.prototype.set;
  function be(o, a) {
    return o.b ? (a.a || (a.a = new o.b(a.value)), a.a) : a.value;
  }
  ne.prototype.get = function(o) {
    if (o = this.a[o.toString()])
      return be(this, o);
  }, ne.prototype.get = ne.prototype.get, ne.prototype.has = function(o) {
    return o.toString() in this.a;
  }, ne.prototype.has = ne.prototype.has, ne.prototype.Jc = function(o, a, u, h, R) {
    var W = we(this);
    W.sort();
    for (var K = 0; K < W.length; K++) {
      var ue = this.a[W[K]];
      a.Va(o), u.call(a, 1, ue.key), this.b ? h.call(a, 2, be(this, ue), R) : h.call(a, 2, ue.value), a.Ya();
    }
  }, ne.prototype.serializeBinary = ne.prototype.Jc, ne.deserializeBinary = function(o, a, u, h, R, W, K) {
    for (; a.oa() && !a.bb(); ) {
      var ue = a.c;
      ue == 1 ? W = u.call(a) : ue == 2 && (o.b ? (F(R), K || (K = new o.b()), h.call(a, K, R)) : K = h.call(a));
    }
    F(W != null), F(K != null), o.set(W, K);
  };
  function we(o) {
    o = o.a;
    var a = [], u;
    for (u in o)
      Object.prototype.hasOwnProperty.call(o, u) && a.push(u);
    return a;
  }
  function We(o, a) {
    this.key = o, this.value = a, this.a = void 0;
  }
  function Oe(o) {
    if (8192 >= o.length)
      return String.fromCharCode.apply(null, o);
    for (var a = "", u = 0; u < o.length; u += 8192)
      a += String.fromCharCode.apply(null, $(o, u, u + 8192));
    return a;
  }
  var Me = { "\0": "\\0", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t", "\v": "\\x0B", '"': '\\"', "\\": "\\\\", "<": "\\u003C" }, Le = { "'": "\\'" }, qe = {}, k = null;
  function N(o, a) {
    a === void 0 && (a = 0), L(), a = qe[a];
    for (var u = [], h = 0; h < o.length; h += 3) {
      var R = o[h], W = h + 1 < o.length, K = W ? o[h + 1] : 0, ue = h + 2 < o.length, _e = ue ? o[h + 2] : 0, At = R >> 2;
      R = (R & 3) << 4 | K >> 4, K = (K & 15) << 2 | _e >> 6, _e &= 63, ue || (_e = 64, W || (K = 64)), u.push(a[At], a[R], a[K] || "", a[_e] || "");
    }
    return u.join("");
  }
  function Z(o) {
    var a = o.length, u = 3 * a / 4;
    u % 3 ? u = Math.floor(u) : "=.".indexOf(o[a - 1]) != -1 && (u = "=.".indexOf(o[a - 2]) != -1 ? u - 2 : u - 1);
    var h = new Uint8Array(u), R = 0;
    return le(o, function(W) {
      h[R++] = W;
    }), h.subarray(0, R);
  }
  function le(o, a) {
    function u(_e) {
      for (; h < o.length; ) {
        var At = o.charAt(h++), sn = k[At];
        if (sn != null)
          return sn;
        if (!/^[\s\xa0]*$/.test(At))
          throw Error("Unknown base64 encoding at char: " + At);
      }
      return _e;
    }
    L();
    for (var h = 0; ; ) {
      var R = u(-1), W = u(0), K = u(64), ue = u(64);
      if (ue === 64 && R === -1)
        break;
      a(R << 2 | W >> 4), K != 64 && (a(W << 4 & 240 | K >> 2), ue != 64 && a(K << 6 & 192 | ue));
    }
  }
  function L() {
    if (!k) {
      k = {};
      for (var o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), a = ["+/=", "+/", "-_=", "-_.", "-_"], u = 0; 5 > u; u++) {
        var h = o.concat(a[u].split(""));
        qe[u] = h;
        for (var R = 0; R < h.length; R++) {
          var W = h[R];
          k[W] === void 0 && (k[W] = R);
        }
      }
    }
  }
  M("jspb.ConstBinaryMessage", function() {
  }, void 0), M("jspb.BinaryMessage", function() {
  }, void 0), M("jspb.BinaryConstants.FieldType", { yb: -1, ee: 1, FLOAT: 2, ke: 3, te: 4, je: 5, xb: 6, wb: 7, BOOL: 8, re: 9, ie: 10, le: 11, ce: 12, se: 13, ge: 14, me: 15, ne: 16, oe: 17, pe: 18, he: 30, ve: 31 }, void 0), M("jspb.BinaryConstants.WireType", { yb: -1, ue: 0, xb: 1, de: 2, qe: 3, fe: 4, wb: 5 }, void 0), M("jspb.BinaryConstants.FieldTypeToWireType", function(o) {
    switch (o) {
      case 5:
      case 3:
      case 13:
      case 4:
      case 17:
      case 18:
      case 8:
      case 14:
      case 31:
        return 0;
      case 1:
      case 6:
      case 16:
      case 30:
        return 1;
      case 9:
      case 11:
      case 12:
        return 2;
      case 2:
      case 7:
      case 15:
        return 5;
      default:
        return -1;
    }
  }, void 0), M("jspb.BinaryConstants.INVALID_FIELD_NUMBER", -1, void 0), M("jspb.BinaryConstants.FLOAT32_EPS", 1401298464324817e-60, void 0), M("jspb.BinaryConstants.FLOAT32_MIN", 11754943508222875e-54, void 0), M("jspb.BinaryConstants.FLOAT32_MAX", 34028234663852886e22, void 0), M("jspb.BinaryConstants.FLOAT64_EPS", 5e-324, void 0), M("jspb.BinaryConstants.FLOAT64_MIN", 22250738585072014e-324, void 0), M("jspb.BinaryConstants.FLOAT64_MAX", 17976931348623157e292, void 0), M("jspb.BinaryConstants.TWO_TO_20", 1048576, void 0), M("jspb.BinaryConstants.TWO_TO_23", 8388608, void 0), M("jspb.BinaryConstants.TWO_TO_31", 2147483648, void 0), M("jspb.BinaryConstants.TWO_TO_32", 4294967296, void 0), M("jspb.BinaryConstants.TWO_TO_52", 4503599627370496, void 0), M("jspb.BinaryConstants.TWO_TO_63", 9223372036854776e3, void 0), M("jspb.BinaryConstants.TWO_TO_64", 18446744073709552e3, void 0), M("jspb.BinaryConstants.ZERO_HASH", "\0\0\0\0\0\0\0\0", void 0);
  var B = 0, P = 0;
  M("jspb.utils.getSplit64Low", function() {
    return B;
  }, void 0), M("jspb.utils.getSplit64High", function() {
    return P;
  }, void 0);
  function Y(o) {
    var a = o >>> 0;
    o = Math.floor((o - a) / 4294967296) >>> 0, B = a, P = o;
  }
  M("jspb.utils.splitUint64", Y, void 0);
  function Q(o) {
    var a = 0 > o;
    o = Math.abs(o);
    var u = o >>> 0;
    o = Math.floor((o - u) / 4294967296), o >>>= 0, a && (o = ~o >>> 0, u = (~u >>> 0) + 1, 4294967295 < u && (u = 0, o++, 4294967295 < o && (o = 0))), B = u, P = o;
  }
  M("jspb.utils.splitInt64", Q, void 0);
  function v(o) {
    var a = 0 > o;
    o = 2 * Math.abs(o), Y(o), o = B;
    var u = P;
    a && (o == 0 ? u == 0 ? u = o = 4294967295 : (u--, o = 4294967295) : o--), B = o, P = u;
  }
  M("jspb.utils.splitZigzag64", v, void 0);
  function b(o) {
    var a = 0 > o ? 1 : 0;
    if (o = a ? -o : o, o === 0)
      0 < 1 / o ? B = P = 0 : (P = 0, B = 2147483648);
    else if (isNaN(o))
      P = 0, B = 2147483647;
    else if (34028234663852886e22 < o)
      P = 0, B = (a << 31 | 2139095040) >>> 0;
    else if (11754943508222875e-54 > o)
      o = Math.round(o / Math.pow(2, -149)), P = 0, B = (a << 31 | o) >>> 0;
    else {
      var u = Math.floor(Math.log(o) / Math.LN2);
      o *= Math.pow(2, -u), o = Math.round(8388608 * o), 16777216 <= o && ++u, P = 0, B = (a << 31 | u + 127 << 23 | o & 8388607) >>> 0;
    }
  }
  M("jspb.utils.splitFloat32", b, void 0);
  function U(o) {
    var a = 0 > o ? 1 : 0;
    if (o = a ? -o : o, o === 0)
      P = 0 < 1 / o ? 0 : 2147483648, B = 0;
    else if (isNaN(o))
      P = 2147483647, B = 4294967295;
    else if (17976931348623157e292 < o)
      P = (a << 31 | 2146435072) >>> 0, B = 0;
    else if (22250738585072014e-324 > o)
      o /= Math.pow(2, -1074), P = (a << 31 | o / 4294967296) >>> 0, B = o >>> 0;
    else {
      var u = o, h = 0;
      if (2 <= u)
        for (; 2 <= u && 1023 > h; )
          h++, u /= 2;
      else
        for (; 1 > u && -1022 < h; )
          u *= 2, h--;
      o *= Math.pow(2, -h), P = (a << 31 | h + 1023 << 20 | 1048576 * o & 1048575) >>> 0, B = 4503599627370496 * o >>> 0;
    }
  }
  M("jspb.utils.splitFloat64", U, void 0);
  function te(o) {
    var a = o.charCodeAt(4), u = o.charCodeAt(5), h = o.charCodeAt(6), R = o.charCodeAt(7);
    B = o.charCodeAt(0) + (o.charCodeAt(1) << 8) + (o.charCodeAt(2) << 16) + (o.charCodeAt(3) << 24) >>> 0, P = a + (u << 8) + (h << 16) + (R << 24) >>> 0;
  }
  M("jspb.utils.splitHash64", te, void 0);
  function ye(o, a) {
    return 4294967296 * a + (o >>> 0);
  }
  M("jspb.utils.joinUint64", ye, void 0);
  function se(o, a) {
    var u = a & 2147483648;
    return u && (o = ~o + 1 >>> 0, a = ~a >>> 0, o == 0 && (a = a + 1 >>> 0)), o = ye(o, a), u ? -o : o;
  }
  M("jspb.utils.joinInt64", se, void 0);
  function he(o, a, u) {
    var h = a >> 31;
    return u(o << 1 ^ h, (a << 1 | o >>> 31) ^ h);
  }
  M("jspb.utils.toZigzag64", he, void 0);
  function ze(o, a) {
    return q(o, a, se);
  }
  M("jspb.utils.joinZigzag64", ze, void 0);
  function q(o, a, u) {
    var h = -(o & 1);
    return u((o >>> 1 | a << 31) ^ h, a >>> 1 ^ h);
  }
  M("jspb.utils.fromZigzag64", q, void 0);
  function Ge(o) {
    var a = 2 * (o >> 31) + 1, u = o >>> 23 & 255;
    return o &= 8388607, u == 255 ? o ? NaN : 1 / 0 * a : u == 0 ? a * Math.pow(2, -149) * o : a * Math.pow(2, u - 150) * (o + Math.pow(2, 23));
  }
  M("jspb.utils.joinFloat32", Ge, void 0);
  function xe(o, a) {
    var u = 2 * (a >> 31) + 1, h = a >>> 20 & 2047;
    return o = 4294967296 * (a & 1048575) + o, h == 2047 ? o ? NaN : 1 / 0 * u : h == 0 ? u * Math.pow(2, -1074) * o : u * Math.pow(2, h - 1075) * (o + 4503599627370496);
  }
  M("jspb.utils.joinFloat64", xe, void 0);
  function Se(o, a) {
    return String.fromCharCode(o >>> 0 & 255, o >>> 8 & 255, o >>> 16 & 255, o >>> 24 & 255, a >>> 0 & 255, a >>> 8 & 255, a >>> 16 & 255, a >>> 24 & 255);
  }
  M("jspb.utils.joinHash64", Se, void 0), M("jspb.utils.DIGITS", "0123456789abcdef".split(""), void 0);
  function Re(o, a) {
    function u(R, W) {
      return R = R ? String(R) : "", W ? "0000000".slice(R.length) + R : R;
    }
    if (2097151 >= a)
      return "" + ye(o, a);
    var h = (o >>> 24 | a << 8) >>> 0 & 16777215;
    return a = a >> 16 & 65535, o = (o & 16777215) + 6777216 * h + 6710656 * a, h += 8147497 * a, a *= 2, 1e7 <= o && (h += Math.floor(o / 1e7), o %= 1e7), 1e7 <= h && (a += Math.floor(h / 1e7), h %= 1e7), u(a, 0) + u(h, a) + u(o, 1);
  }
  M("jspb.utils.joinUnsignedDecimalString", Re, void 0);
  function Ne(o, a) {
    var u = a & 2147483648;
    return u && (o = ~o + 1 >>> 0, a = ~a + (o == 0 ? 1 : 0) >>> 0), o = Re(o, a), u ? "-" + o : o;
  }
  M("jspb.utils.joinSignedDecimalString", Ne, void 0);
  function ht(o, a) {
    te(o), o = B;
    var u = P;
    return a ? Ne(o, u) : Re(o, u);
  }
  M("jspb.utils.hash64ToDecimalString", ht, void 0), M("jspb.utils.hash64ArrayToDecimalStrings", function(o, a) {
    for (var u = Array(o.length), h = 0; h < o.length; h++)
      u[h] = ht(o[h], a);
    return u;
  }, void 0);
  function Xe(o) {
    function a(K, ue) {
      for (var _e = 0; 8 > _e && (K !== 1 || 0 < ue); _e++)
        ue = K * R[_e] + ue, R[_e] = ue & 255, ue >>>= 8;
    }
    function u() {
      for (var K = 0; 8 > K; K++)
        R[K] = ~R[K] & 255;
    }
    F(0 < o.length);
    var h = !1;
    o[0] === "-" && (h = !0, o = o.slice(1));
    for (var R = [0, 0, 0, 0, 0, 0, 0, 0], W = 0; W < o.length; W++)
      a(10, o.charCodeAt(W) - 48);
    return h && (u(), a(1, 1)), Oe(R);
  }
  M("jspb.utils.decimalStringToHash64", Xe, void 0), M("jspb.utils.splitDecimalString", function(o) {
    te(Xe(o));
  }, void 0);
  function tt(o) {
    return String.fromCharCode(10 > o ? 48 + o : 87 + o);
  }
  function rt(o) {
    return 97 <= o ? o - 97 + 10 : o - 48;
  }
  M("jspb.utils.hash64ToHexString", function(o) {
    var a = Array(18);
    a[0] = "0", a[1] = "x";
    for (var u = 0; 8 > u; u++) {
      var h = o.charCodeAt(7 - u);
      a[2 * u + 2] = tt(h >> 4), a[2 * u + 3] = tt(h & 15);
    }
    return a.join("");
  }, void 0), M("jspb.utils.hexStringToHash64", function(o) {
    o = o.toLowerCase(), F(o.length == 18), F(o[0] == "0"), F(o[1] == "x");
    for (var a = "", u = 0; 8 > u; u++)
      a = String.fromCharCode(16 * rt(o.charCodeAt(2 * u + 2)) + rt(o.charCodeAt(2 * u + 3))) + a;
    return a;
  }, void 0), M("jspb.utils.hash64ToNumber", function(o, a) {
    te(o), o = B;
    var u = P;
    return a ? se(o, u) : ye(o, u);
  }, void 0), M("jspb.utils.numberToHash64", function(o) {
    return Q(o), Se(B, P);
  }, void 0), M("jspb.utils.countVarints", function(o, a, u) {
    for (var h = 0, R = a; R < u; R++)
      h += o[R] >> 7;
    return u - a - h;
  }, void 0), M("jspb.utils.countVarintFields", function(o, a, u, h) {
    var R = 0;
    if (h *= 8, 128 > h)
      for (; a < u && o[a++] == h; )
        for (R++; ; ) {
          var W = o[a++];
          if (!(W & 128))
            break;
        }
    else
      for (; a < u; ) {
        for (W = h; 128 < W; ) {
          if (o[a] != (W & 127 | 128))
            return R;
          a++, W >>= 7;
        }
        if (o[a++] != W)
          break;
        for (R++; W = o[a++], (W & 128) != 0; )
          ;
      }
    return R;
  }, void 0);
  function gt(o, a, u, h, R) {
    var W = 0;
    if (128 > h)
      for (; a < u && o[a++] == h; )
        W++, a += R;
    else
      for (; a < u; ) {
        for (var K = h; 128 < K; ) {
          if (o[a++] != (K & 127 | 128))
            return W;
          K >>= 7;
        }
        if (o[a++] != K)
          break;
        W++, a += R;
      }
    return W;
  }
  M("jspb.utils.countFixed32Fields", function(o, a, u, h) {
    return gt(o, a, u, 8 * h + 5, 4);
  }, void 0), M("jspb.utils.countFixed64Fields", function(o, a, u, h) {
    return gt(o, a, u, 8 * h + 1, 8);
  }, void 0), M("jspb.utils.countDelimitedFields", function(o, a, u, h) {
    var R = 0;
    for (h = 8 * h + 2; a < u; ) {
      for (var W = h; 128 < W; ) {
        if (o[a++] != (W & 127 | 128))
          return R;
        W >>= 7;
      }
      if (o[a++] != W)
        break;
      R++;
      for (var K = 0, ue = 1; W = o[a++], K += (W & 127) * ue, ue *= 128, (W & 128) != 0; )
        ;
      a += K;
    }
    return R;
  }, void 0), M("jspb.utils.debugBytesToTextFormat", function(o) {
    var a = '"';
    if (o) {
      o = Mt(o);
      for (var u = 0; u < o.length; u++)
        a += "\\x", 16 > o[u] && (a += "0"), a += o[u].toString(16);
    }
    return a + '"';
  }, void 0), M("jspb.utils.debugScalarToTextFormat", function(o) {
    if (typeof o == "string") {
      o = String(o);
      for (var a = ['"'], u = 0; u < o.length; u++) {
        var h = o.charAt(u), R = h.charCodeAt(0), W = u + 1, K;
        (K = Me[h]) || (31 < R && 127 > R || (R = h, R in Le ? h = Le[R] : R in Me ? h = Le[R] = Me[R] : (K = R.charCodeAt(0), 31 < K && 127 > K ? h = R : (256 > K ? (h = "\\x", (16 > K || 256 < K) && (h += "0")) : (h = "\\u", 4096 > K && (h += "0")), h += K.toString(16).toUpperCase()), h = Le[R] = h)), K = h), a[W] = K;
      }
      a.push('"'), o = a.join("");
    } else
      o = o.toString();
    return o;
  }, void 0), M("jspb.utils.stringToByteArray", function(o) {
    for (var a = new Uint8Array(o.length), u = 0; u < o.length; u++) {
      var h = o.charCodeAt(u);
      if (255 < h)
        throw Error("Conversion error: string contains codepoint outside of byte range");
      a[u] = h;
    }
    return a;
  }, void 0);
  function Mt(o) {
    return o.constructor === Uint8Array ? o : o.constructor === ArrayBuffer ? new Uint8Array(o) : o.constructor === Array ? new Uint8Array(o) : o.constructor === String ? Z(o) : o instanceof Uint8Array ? new Uint8Array(o.buffer, o.byteOffset, o.byteLength) : (ae("Type not convertible to Uint8Array."), new Uint8Array(0));
  }
  M("jspb.utils.byteSourceToUint8Array", Mt, void 0);
  function C(o, a, u) {
    this.b = null, this.a = this.c = this.h = 0, this.v = !1, o && this.H(o, a, u);
  }
  M("jspb.BinaryDecoder", C, void 0);
  var Dt = [];
  C.getInstanceCacheLength = function() {
    return Dt.length;
  };
  function Ot(o, a, u) {
    if (Dt.length) {
      var h = Dt.pop();
      return o && h.H(o, a, u), h;
    }
    return new C(o, a, u);
  }
  C.alloc = Ot, C.prototype.Ca = function() {
    this.clear(), 100 > Dt.length && Dt.push(this);
  }, C.prototype.free = C.prototype.Ca, C.prototype.clone = function() {
    return Ot(this.b, this.h, this.c - this.h);
  }, C.prototype.clone = C.prototype.clone, C.prototype.clear = function() {
    this.b = null, this.a = this.c = this.h = 0, this.v = !1;
  }, C.prototype.clear = C.prototype.clear, C.prototype.Y = function() {
    return this.b;
  }, C.prototype.getBuffer = C.prototype.Y, C.prototype.H = function(o, a, u) {
    this.b = Mt(o), this.h = a !== void 0 ? a : 0, this.c = u !== void 0 ? this.h + u : this.b.length, this.a = this.h;
  }, C.prototype.setBlock = C.prototype.H, C.prototype.Db = function() {
    return this.c;
  }, C.prototype.getEnd = C.prototype.Db, C.prototype.setEnd = function(o) {
    this.c = o;
  }, C.prototype.setEnd = C.prototype.setEnd, C.prototype.reset = function() {
    this.a = this.h;
  }, C.prototype.reset = C.prototype.reset, C.prototype.B = function() {
    return this.a;
  }, C.prototype.getCursor = C.prototype.B, C.prototype.Ma = function(o) {
    this.a = o;
  }, C.prototype.setCursor = C.prototype.Ma, C.prototype.advance = function(o) {
    this.a += o, F(this.a <= this.c);
  }, C.prototype.advance = C.prototype.advance, C.prototype.ya = function() {
    return this.a == this.c;
  }, C.prototype.atEnd = C.prototype.ya, C.prototype.Qb = function() {
    return this.a > this.c;
  }, C.prototype.pastEnd = C.prototype.Qb, C.prototype.getError = function() {
    return this.v || 0 > this.a || this.a > this.c;
  }, C.prototype.getError = C.prototype.getError, C.prototype.w = function(o) {
    for (var a = 128, u = 0, h = 0, R = 0; 4 > R && 128 <= a; R++)
      a = this.b[this.a++], u |= (a & 127) << 7 * R;
    if (128 <= a && (a = this.b[this.a++], u |= (a & 127) << 28, h |= (a & 127) >> 4), 128 <= a)
      for (R = 0; 5 > R && 128 <= a; R++)
        a = this.b[this.a++], h |= (a & 127) << 7 * R + 3;
    if (128 > a)
      return o(u >>> 0, h >>> 0);
    ae("Failed to read varint, encoding is invalid."), this.v = !0;
  }, C.prototype.readSplitVarint64 = C.prototype.w, C.prototype.ea = function(o) {
    return this.w(function(a, u) {
      return q(a, u, o);
    });
  }, C.prototype.readSplitZigzagVarint64 = C.prototype.ea, C.prototype.ta = function(o) {
    var a = this.b, u = this.a;
    this.a += 8;
    for (var h = 0, R = 0, W = u + 7; W >= u; W--)
      h = h << 8 | a[W], R = R << 8 | a[W + 4];
    return o(h, R);
  }, C.prototype.readSplitFixed64 = C.prototype.ta, C.prototype.kb = function() {
    for (; this.b[this.a] & 128; )
      this.a++;
    this.a++;
  }, C.prototype.skipVarint = C.prototype.kb, C.prototype.mb = function(o) {
    for (; 128 < o; )
      this.a--, o >>>= 7;
    this.a--;
  }, C.prototype.unskipVarint = C.prototype.mb, C.prototype.o = function() {
    var o = this.b, a = o[this.a], u = a & 127;
    return 128 > a ? (this.a += 1, F(this.a <= this.c), u) : (a = o[this.a + 1], u |= (a & 127) << 7, 128 > a ? (this.a += 2, F(this.a <= this.c), u) : (a = o[this.a + 2], u |= (a & 127) << 14, 128 > a ? (this.a += 3, F(this.a <= this.c), u) : (a = o[this.a + 3], u |= (a & 127) << 21, 128 > a ? (this.a += 4, F(this.a <= this.c), u) : (a = o[this.a + 4], u |= (a & 15) << 28, 128 > a ? (this.a += 5, F(this.a <= this.c), u >>> 0) : (this.a += 5, 128 <= o[this.a++] && 128 <= o[this.a++] && 128 <= o[this.a++] && 128 <= o[this.a++] && 128 <= o[this.a++] && F(!1), F(this.a <= this.c), u)))));
  }, C.prototype.readUnsignedVarint32 = C.prototype.o, C.prototype.da = function() {
    return ~~this.o();
  }, C.prototype.readSignedVarint32 = C.prototype.da, C.prototype.O = function() {
    return this.o().toString();
  }, C.prototype.Ea = function() {
    return this.da().toString();
  }, C.prototype.readSignedVarint32String = C.prototype.Ea, C.prototype.Ia = function() {
    var o = this.o();
    return o >>> 1 ^ -(o & 1);
  }, C.prototype.readZigzagVarint32 = C.prototype.Ia, C.prototype.Ga = function() {
    return this.w(ye);
  }, C.prototype.readUnsignedVarint64 = C.prototype.Ga, C.prototype.Ha = function() {
    return this.w(Re);
  }, C.prototype.readUnsignedVarint64String = C.prototype.Ha, C.prototype.sa = function() {
    return this.w(se);
  }, C.prototype.readSignedVarint64 = C.prototype.sa, C.prototype.Fa = function() {
    return this.w(Ne);
  }, C.prototype.readSignedVarint64String = C.prototype.Fa, C.prototype.Ja = function() {
    return this.w(ze);
  }, C.prototype.readZigzagVarint64 = C.prototype.Ja, C.prototype.fb = function() {
    return this.ea(Se);
  }, C.prototype.readZigzagVarintHash64 = C.prototype.fb, C.prototype.Ka = function() {
    return this.ea(Ne);
  }, C.prototype.readZigzagVarint64String = C.prototype.Ka, C.prototype.Gc = function() {
    var o = this.b[this.a];
    return this.a += 1, F(this.a <= this.c), o;
  }, C.prototype.readUint8 = C.prototype.Gc, C.prototype.Ec = function() {
    var o = this.b[this.a], a = this.b[this.a + 1];
    return this.a += 2, F(this.a <= this.c), o << 0 | a << 8;
  }, C.prototype.readUint16 = C.prototype.Ec, C.prototype.m = function() {
    var o = this.b[this.a], a = this.b[this.a + 1], u = this.b[this.a + 2], h = this.b[this.a + 3];
    return this.a += 4, F(this.a <= this.c), (o << 0 | a << 8 | u << 16 | h << 24) >>> 0;
  }, C.prototype.readUint32 = C.prototype.m, C.prototype.ga = function() {
    var o = this.m(), a = this.m();
    return ye(o, a);
  }, C.prototype.readUint64 = C.prototype.ga, C.prototype.ha = function() {
    var o = this.m(), a = this.m();
    return Re(o, a);
  }, C.prototype.readUint64String = C.prototype.ha, C.prototype.Xb = function() {
    var o = this.b[this.a];
    return this.a += 1, F(this.a <= this.c), o << 24 >> 24;
  }, C.prototype.readInt8 = C.prototype.Xb, C.prototype.Vb = function() {
    var o = this.b[this.a], a = this.b[this.a + 1];
    return this.a += 2, F(this.a <= this.c), (o << 0 | a << 8) << 16 >> 16;
  }, C.prototype.readInt16 = C.prototype.Vb, C.prototype.P = function() {
    var o = this.b[this.a], a = this.b[this.a + 1], u = this.b[this.a + 2], h = this.b[this.a + 3];
    return this.a += 4, F(this.a <= this.c), o << 0 | a << 8 | u << 16 | h << 24;
  }, C.prototype.readInt32 = C.prototype.P, C.prototype.ba = function() {
    var o = this.m(), a = this.m();
    return se(o, a);
  }, C.prototype.readInt64 = C.prototype.ba, C.prototype.ca = function() {
    var o = this.m(), a = this.m();
    return Ne(o, a);
  }, C.prototype.readInt64String = C.prototype.ca, C.prototype.aa = function() {
    var o = this.m();
    return Ge(o);
  }, C.prototype.readFloat = C.prototype.aa, C.prototype.Z = function() {
    var o = this.m(), a = this.m();
    return xe(o, a);
  }, C.prototype.readDouble = C.prototype.Z, C.prototype.pa = function() {
    return !!this.b[this.a++];
  }, C.prototype.readBool = C.prototype.pa, C.prototype.ra = function() {
    return this.da();
  }, C.prototype.readEnum = C.prototype.ra, C.prototype.fa = function(o) {
    var a = this.b, u = this.a;
    o = u + o;
    for (var h = [], R = ""; u < o; ) {
      var W = a[u++];
      if (128 > W)
        h.push(W);
      else {
        if (192 > W)
          continue;
        if (224 > W) {
          var K = a[u++];
          h.push((W & 31) << 6 | K & 63);
        } else if (240 > W) {
          K = a[u++];
          var ue = a[u++];
          h.push((W & 15) << 12 | (K & 63) << 6 | ue & 63);
        } else if (248 > W) {
          K = a[u++], ue = a[u++];
          var _e = a[u++];
          W = (W & 7) << 18 | (K & 63) << 12 | (ue & 63) << 6 | _e & 63, W -= 65536, h.push((W >> 10 & 1023) + 55296, (W & 1023) + 56320);
        }
      }
      8192 <= h.length && (R += String.fromCharCode.apply(null, h), h.length = 0);
    }
    return R += Oe(h), this.a = u, R;
  }, C.prototype.readString = C.prototype.fa, C.prototype.Dc = function() {
    var o = this.o();
    return this.fa(o);
  }, C.prototype.readStringWithLength = C.prototype.Dc, C.prototype.qa = function(o) {
    if (0 > o || this.a + o > this.b.length)
      return this.v = !0, ae("Invalid byte length!"), new Uint8Array(0);
    var a = this.b.subarray(this.a, this.a + o);
    return this.a += o, F(this.a <= this.c), a;
  }, C.prototype.readBytes = C.prototype.qa, C.prototype.ia = function() {
    return this.w(Se);
  }, C.prototype.readVarintHash64 = C.prototype.ia, C.prototype.$ = function() {
    var o = this.b, a = this.a, u = o[a], h = o[a + 1], R = o[a + 2], W = o[a + 3], K = o[a + 4], ue = o[a + 5], _e = o[a + 6];
    return o = o[a + 7], this.a += 8, String.fromCharCode(u, h, R, W, K, ue, _e, o);
  }, C.prototype.readFixedHash64 = C.prototype.$;
  function w(o, a, u) {
    this.a = Ot(o, a, u), this.O = this.a.B(), this.b = this.c = -1, this.h = !1, this.v = null;
  }
  M("jspb.BinaryReader", w, void 0);
  var it = [];
  w.clearInstanceCache = function() {
    it = [];
  }, w.getInstanceCacheLength = function() {
    return it.length;
  };
  function mr(o, a, u) {
    if (it.length) {
      var h = it.pop();
      return o && h.a.H(o, a, u), h;
    }
    return new w(o, a, u);
  }
  w.alloc = mr, w.prototype.zb = mr, w.prototype.alloc = w.prototype.zb, w.prototype.Ca = function() {
    this.a.clear(), this.b = this.c = -1, this.h = !1, this.v = null, 100 > it.length && it.push(this);
  }, w.prototype.free = w.prototype.Ca, w.prototype.Fb = function() {
    return this.O;
  }, w.prototype.getFieldCursor = w.prototype.Fb, w.prototype.B = function() {
    return this.a.B();
  }, w.prototype.getCursor = w.prototype.B, w.prototype.Y = function() {
    return this.a.Y();
  }, w.prototype.getBuffer = w.prototype.Y, w.prototype.Hb = function() {
    return this.c;
  }, w.prototype.getFieldNumber = w.prototype.Hb, w.prototype.Lb = function() {
    return this.b;
  }, w.prototype.getWireType = w.prototype.Lb, w.prototype.Mb = function() {
    return this.b == 2;
  }, w.prototype.isDelimited = w.prototype.Mb, w.prototype.bb = function() {
    return this.b == 4;
  }, w.prototype.isEndGroup = w.prototype.bb, w.prototype.getError = function() {
    return this.h || this.a.getError();
  }, w.prototype.getError = w.prototype.getError, w.prototype.H = function(o, a, u) {
    this.a.H(o, a, u), this.b = this.c = -1;
  }, w.prototype.setBlock = w.prototype.H, w.prototype.reset = function() {
    this.a.reset(), this.b = this.c = -1;
  }, w.prototype.reset = w.prototype.reset, w.prototype.advance = function(o) {
    this.a.advance(o);
  }, w.prototype.advance = w.prototype.advance, w.prototype.oa = function() {
    if (this.a.ya())
      return !1;
    if (this.getError())
      return ae("Decoder hit an error"), !1;
    this.O = this.a.B();
    var o = this.a.o(), a = o >>> 3;
    return o &= 7, o != 0 && o != 5 && o != 1 && o != 2 && o != 3 && o != 4 ? (ae("Invalid wire type: %s (at position %s)", o, this.O), this.h = !0, !1) : (this.c = a, this.b = o, !0);
  }, w.prototype.nextField = w.prototype.oa, w.prototype.Oa = function() {
    this.a.mb(this.c << 3 | this.b);
  }, w.prototype.unskipHeader = w.prototype.Oa, w.prototype.Lc = function() {
    var o = this.c;
    for (this.Oa(); this.oa() && this.c == o; )
      this.C();
    this.a.ya() || this.Oa();
  }, w.prototype.skipMatchingFields = w.prototype.Lc, w.prototype.lb = function() {
    this.b != 0 ? (ae("Invalid wire type for skipVarintField"), this.C()) : this.a.kb();
  }, w.prototype.skipVarintField = w.prototype.lb, w.prototype.gb = function() {
    if (this.b != 2)
      ae("Invalid wire type for skipDelimitedField"), this.C();
    else {
      var o = this.a.o();
      this.a.advance(o);
    }
  }, w.prototype.skipDelimitedField = w.prototype.gb, w.prototype.hb = function() {
    this.b != 5 ? (ae("Invalid wire type for skipFixed32Field"), this.C()) : this.a.advance(4);
  }, w.prototype.skipFixed32Field = w.prototype.hb, w.prototype.ib = function() {
    this.b != 1 ? (ae("Invalid wire type for skipFixed64Field"), this.C()) : this.a.advance(8);
  }, w.prototype.skipFixed64Field = w.prototype.ib, w.prototype.jb = function() {
    var o = this.c;
    do {
      if (!this.oa()) {
        ae("Unmatched start-group tag: stream EOF"), this.h = !0;
        break;
      }
      if (this.b == 4) {
        this.c != o && (ae("Unmatched end-group tag"), this.h = !0);
        break;
      }
      this.C();
    } while (1);
  }, w.prototype.skipGroup = w.prototype.jb, w.prototype.C = function() {
    switch (this.b) {
      case 0:
        this.lb();
        break;
      case 1:
        this.ib();
        break;
      case 2:
        this.gb();
        break;
      case 5:
        this.hb();
        break;
      case 3:
        this.jb();
        break;
      default:
        ae("Invalid wire encoding for field.");
    }
  }, w.prototype.skipField = w.prototype.C, w.prototype.Hc = function(o, a) {
    this.v === null && (this.v = {}), F(!this.v[o]), this.v[o] = a;
  }, w.prototype.registerReadCallback = w.prototype.Hc, w.prototype.Ic = function(o) {
    return F(this.v !== null), o = this.v[o], F(o), o(this);
  }, w.prototype.runReadCallback = w.prototype.Ic, w.prototype.Yb = function(o, a) {
    F(this.b == 2);
    var u = this.a.c, h = this.a.o();
    h = this.a.B() + h, this.a.setEnd(h), a(o, this), this.a.Ma(h), this.a.setEnd(u);
  }, w.prototype.readMessage = w.prototype.Yb, w.prototype.Ub = function(o, a, u) {
    F(this.b == 3), F(this.c == o), u(a, this), this.h || this.b == 4 || (ae("Group submessage did not end with an END_GROUP tag"), this.h = !0);
  }, w.prototype.readGroup = w.prototype.Ub, w.prototype.Gb = function() {
    F(this.b == 2);
    var o = this.a.o(), a = this.a.B(), u = a + o;
    return o = Ot(this.a.Y(), a, o), this.a.Ma(u), o;
  }, w.prototype.getFieldDecoder = w.prototype.Gb, w.prototype.P = function() {
    return F(this.b == 0), this.a.da();
  }, w.prototype.readInt32 = w.prototype.P, w.prototype.Wb = function() {
    return F(this.b == 0), this.a.Ea();
  }, w.prototype.readInt32String = w.prototype.Wb, w.prototype.ba = function() {
    return F(this.b == 0), this.a.sa();
  }, w.prototype.readInt64 = w.prototype.ba, w.prototype.ca = function() {
    return F(this.b == 0), this.a.Fa();
  }, w.prototype.readInt64String = w.prototype.ca, w.prototype.m = function() {
    return F(this.b == 0), this.a.o();
  }, w.prototype.readUint32 = w.prototype.m, w.prototype.Fc = function() {
    return F(this.b == 0), this.a.O();
  }, w.prototype.readUint32String = w.prototype.Fc, w.prototype.ga = function() {
    return F(this.b == 0), this.a.Ga();
  }, w.prototype.readUint64 = w.prototype.ga, w.prototype.ha = function() {
    return F(this.b == 0), this.a.Ha();
  }, w.prototype.readUint64String = w.prototype.ha, w.prototype.zc = function() {
    return F(this.b == 0), this.a.Ia();
  }, w.prototype.readSint32 = w.prototype.zc, w.prototype.Ac = function() {
    return F(this.b == 0), this.a.Ja();
  }, w.prototype.readSint64 = w.prototype.Ac, w.prototype.Bc = function() {
    return F(this.b == 0), this.a.Ka();
  }, w.prototype.readSint64String = w.prototype.Bc, w.prototype.Rb = function() {
    return F(this.b == 5), this.a.m();
  }, w.prototype.readFixed32 = w.prototype.Rb, w.prototype.Sb = function() {
    return F(this.b == 1), this.a.ga();
  }, w.prototype.readFixed64 = w.prototype.Sb, w.prototype.Tb = function() {
    return F(this.b == 1), this.a.ha();
  }, w.prototype.readFixed64String = w.prototype.Tb, w.prototype.vc = function() {
    return F(this.b == 5), this.a.P();
  }, w.prototype.readSfixed32 = w.prototype.vc, w.prototype.wc = function() {
    return F(this.b == 5), this.a.P().toString();
  }, w.prototype.readSfixed32String = w.prototype.wc, w.prototype.xc = function() {
    return F(this.b == 1), this.a.ba();
  }, w.prototype.readSfixed64 = w.prototype.xc, w.prototype.yc = function() {
    return F(this.b == 1), this.a.ca();
  }, w.prototype.readSfixed64String = w.prototype.yc, w.prototype.aa = function() {
    return F(this.b == 5), this.a.aa();
  }, w.prototype.readFloat = w.prototype.aa, w.prototype.Z = function() {
    return F(this.b == 1), this.a.Z();
  }, w.prototype.readDouble = w.prototype.Z, w.prototype.pa = function() {
    return F(this.b == 0), !!this.a.o();
  }, w.prototype.readBool = w.prototype.pa, w.prototype.ra = function() {
    return F(this.b == 0), this.a.sa();
  }, w.prototype.readEnum = w.prototype.ra, w.prototype.fa = function() {
    F(this.b == 2);
    var o = this.a.o();
    return this.a.fa(o);
  }, w.prototype.readString = w.prototype.fa, w.prototype.qa = function() {
    F(this.b == 2);
    var o = this.a.o();
    return this.a.qa(o);
  }, w.prototype.readBytes = w.prototype.qa, w.prototype.ia = function() {
    return F(this.b == 0), this.a.ia();
  }, w.prototype.readVarintHash64 = w.prototype.ia, w.prototype.Cc = function() {
    return F(this.b == 0), this.a.fb();
  }, w.prototype.readSintHash64 = w.prototype.Cc, w.prototype.w = function(o) {
    return F(this.b == 0), this.a.w(o);
  }, w.prototype.readSplitVarint64 = w.prototype.w, w.prototype.ea = function(o) {
    return F(this.b == 0), this.a.w(function(a, u) {
      return q(a, u, o);
    });
  }, w.prototype.readSplitZigzagVarint64 = w.prototype.ea, w.prototype.$ = function() {
    return F(this.b == 1), this.a.$();
  }, w.prototype.readFixedHash64 = w.prototype.$, w.prototype.ta = function(o) {
    return F(this.b == 1), this.a.ta(o);
  }, w.prototype.readSplitFixed64 = w.prototype.ta;
  function Te(o, a) {
    F(o.b == 2);
    var u = o.a.o();
    u = o.a.B() + u;
    for (var h = []; o.a.B() < u; )
      h.push(a.call(o.a));
    return h;
  }
  w.prototype.gc = function() {
    return Te(this, this.a.da);
  }, w.prototype.readPackedInt32 = w.prototype.gc, w.prototype.hc = function() {
    return Te(this, this.a.Ea);
  }, w.prototype.readPackedInt32String = w.prototype.hc, w.prototype.ic = function() {
    return Te(this, this.a.sa);
  }, w.prototype.readPackedInt64 = w.prototype.ic, w.prototype.jc = function() {
    return Te(this, this.a.Fa);
  }, w.prototype.readPackedInt64String = w.prototype.jc, w.prototype.qc = function() {
    return Te(this, this.a.o);
  }, w.prototype.readPackedUint32 = w.prototype.qc, w.prototype.rc = function() {
    return Te(this, this.a.O);
  }, w.prototype.readPackedUint32String = w.prototype.rc, w.prototype.sc = function() {
    return Te(this, this.a.Ga);
  }, w.prototype.readPackedUint64 = w.prototype.sc, w.prototype.tc = function() {
    return Te(this, this.a.Ha);
  }, w.prototype.readPackedUint64String = w.prototype.tc, w.prototype.nc = function() {
    return Te(this, this.a.Ia);
  }, w.prototype.readPackedSint32 = w.prototype.nc, w.prototype.oc = function() {
    return Te(this, this.a.Ja);
  }, w.prototype.readPackedSint64 = w.prototype.oc, w.prototype.pc = function() {
    return Te(this, this.a.Ka);
  }, w.prototype.readPackedSint64String = w.prototype.pc, w.prototype.bc = function() {
    return Te(this, this.a.m);
  }, w.prototype.readPackedFixed32 = w.prototype.bc, w.prototype.cc = function() {
    return Te(this, this.a.ga);
  }, w.prototype.readPackedFixed64 = w.prototype.cc, w.prototype.dc = function() {
    return Te(this, this.a.ha);
  }, w.prototype.readPackedFixed64String = w.prototype.dc, w.prototype.kc = function() {
    return Te(this, this.a.P);
  }, w.prototype.readPackedSfixed32 = w.prototype.kc, w.prototype.lc = function() {
    return Te(this, this.a.ba);
  }, w.prototype.readPackedSfixed64 = w.prototype.lc, w.prototype.mc = function() {
    return Te(this, this.a.ca);
  }, w.prototype.readPackedSfixed64String = w.prototype.mc, w.prototype.fc = function() {
    return Te(this, this.a.aa);
  }, w.prototype.readPackedFloat = w.prototype.fc, w.prototype.$b = function() {
    return Te(this, this.a.Z);
  }, w.prototype.readPackedDouble = w.prototype.$b, w.prototype.Zb = function() {
    return Te(this, this.a.pa);
  }, w.prototype.readPackedBool = w.prototype.Zb, w.prototype.ac = function() {
    return Te(this, this.a.ra);
  }, w.prototype.readPackedEnum = w.prototype.ac, w.prototype.uc = function() {
    return Te(this, this.a.ia);
  }, w.prototype.readPackedVarintHash64 = w.prototype.uc, w.prototype.ec = function() {
    return Te(this, this.a.$);
  }, w.prototype.readPackedFixedHash64 = w.prototype.ec;
  function mt(o, a, u, h, R) {
    this.ma = o, this.Ba = a, this.la = u, this.Na = h, this.na = R;
  }
  M("jspb.ExtensionFieldInfo", mt, void 0);
  function vr(o, a, u, h, R, W) {
    this.Za = o, this.za = a, this.Aa = u, this.Wa = h, this.Ab = R, this.Nb = W;
  }
  M("jspb.ExtensionFieldBinaryInfo", vr, void 0), mt.prototype.F = function() {
    return !!this.la;
  }, mt.prototype.isMessageType = mt.prototype.F;
  function ie() {
  }
  M("jspb.Message", ie, void 0), ie.GENERATE_TO_OBJECT = !0, ie.GENERATE_FROM_OBJECT = !0;
  var Lt = typeof Uint8Array == "function";
  ie.prototype.Ib = function() {
    return this.b;
  }, ie.prototype.getJsPbMessageId = ie.prototype.Ib, ie.initialize = function(o, a, u, h, R, W) {
    o.f = null, a || (a = u ? [u] : []), o.b = u ? String(u) : void 0, o.D = u === 0 ? -1 : 0, o.u = a;
    e: {
      if (u = o.u.length, a = -1, u && (a = u - 1, u = o.u[a], !(u === null || typeof u != "object" || Array.isArray(u) || Lt && u instanceof Uint8Array))) {
        o.G = a - o.D, o.i = u;
        break e;
      }
      -1 < h ? (o.G = Math.max(h, a + 1 - o.D), o.i = null) : o.G = Number.MAX_VALUE;
    }
    if (o.a = {}, R)
      for (h = 0; h < R.length; h++)
        a = R[h], a < o.G ? (a += o.D, o.u[a] = o.u[a] || lt) : (Ve(o), o.i[a] = o.i[a] || lt);
    if (W && W.length)
      for (h = 0; h < W.length; h++)
        de(o, W[h]);
  };
  var lt = Object.freeze ? Object.freeze([]) : [];
  function Ve(o) {
    var a = o.G + o.D;
    o.u[a] || (o.i = o.u[a] = {});
  }
  function zt(o, a, u) {
    for (var h = [], R = 0; R < o.length; R++)
      h[R] = a.call(o[R], u, o[R]);
    return h;
  }
  ie.toObjectList = zt, ie.toObjectExtension = function(o, a, u, h, R) {
    for (var W in u) {
      var K = u[W], ue = h.call(o, K);
      if (ue != null) {
        for (var _e in K.Ba)
          if (K.Ba.hasOwnProperty(_e))
            break;
        a[_e] = K.Na ? K.na ? zt(ue, K.Na, R) : K.Na(R, ue) : ue;
      }
    }
  }, ie.serializeBinaryExtensions = function(o, a, u, h) {
    for (var R in u) {
      var W = u[R], K = W.Za;
      if (!W.Aa)
        throw Error("Message extension present that was generated without binary serialization support");
      var ue = h.call(o, K);
      if (ue != null)
        if (K.F())
          if (W.Wa)
            W.Aa.call(a, K.ma, ue, W.Wa);
          else
            throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
        else
          W.Aa.call(a, K.ma, ue);
    }
  }, ie.readBinaryExtension = function(o, a, u, h, R) {
    var W = u[a.c];
    if (W) {
      if (u = W.Za, !W.za)
        throw Error("Deserializing extension whose generated code does not support binary format");
      if (u.F()) {
        var K = new u.la();
        W.za.call(a, K, W.Ab);
      } else
        K = W.za.call(a);
      u.na && !W.Nb ? (a = h.call(o, u)) ? a.push(K) : R.call(o, u, [K]) : R.call(o, u, K);
    } else
      a.C();
  };
  function $e(o, a) {
    if (a < o.G) {
      a += o.D;
      var u = o.u[a];
      return u === lt ? o.u[a] = [] : u;
    }
    if (o.i)
      return u = o.i[a], u === lt ? o.i[a] = [] : u;
  }
  ie.getField = $e, ie.getRepeatedField = function(o, a) {
    return $e(o, a);
  };
  function at(o, a) {
    return o = $e(o, a), o == null ? o : +o;
  }
  ie.getOptionalFloatingPointField = at;
  function br(o, a) {
    return o = $e(o, a), o == null ? o : !!o;
  }
  ie.getBooleanField = br, ie.getRepeatedFloatingPointField = function(o, a) {
    var u = $e(o, a);
    if (o.a || (o.a = {}), !o.a[a]) {
      for (var h = 0; h < u.length; h++)
        u[h] = +u[h];
      o.a[a] = !0;
    }
    return u;
  }, ie.getRepeatedBooleanField = function(o, a) {
    var u = $e(o, a);
    if (o.a || (o.a = {}), !o.a[a]) {
      for (var h = 0; h < u.length; h++)
        u[h] = !!u[h];
      o.a[a] = !0;
    }
    return u;
  };
  function g(o) {
    return o == null || typeof o == "string" ? o : Lt && o instanceof Uint8Array ? N(o) : (ae("Cannot coerce to b64 string: " + X(o)), null);
  }
  ie.bytesAsB64 = g;
  function c(o) {
    return o == null || o instanceof Uint8Array ? o : typeof o == "string" ? Z(o) : (ae("Cannot coerce to Uint8Array: " + X(o)), null);
  }
  ie.bytesAsU8 = c, ie.bytesListAsB64 = function(o) {
    return y(o), o.length && typeof o[0] != "string" ? z(o, g) : o;
  }, ie.bytesListAsU8 = function(o) {
    return y(o), !o.length || o[0] instanceof Uint8Array ? o : z(o, c);
  };
  function y(o) {
    if (o && 1 < o.length) {
      var a = X(o[0]);
      O(o, function(u) {
        X(u) != a && ae("Inconsistent type in JSPB repeated field array. Got " + X(u) + " expected " + a);
      });
    }
  }
  function S(o, a, u) {
    return o = $e(o, a), o ?? u;
  }
  ie.getFieldWithDefault = S, ie.getBooleanFieldWithDefault = function(o, a, u) {
    return o = br(o, a), o ?? u;
  }, ie.getFloatingPointFieldWithDefault = function(o, a, u) {
    return o = at(o, a), o ?? u;
  }, ie.getFieldProto3 = S, ie.getMapField = function(o, a, u, h) {
    if (o.f || (o.f = {}), a in o.f)
      return o.f[a];
    var R = $e(o, a);
    if (!R) {
      if (u)
        return;
      R = [], T(o, a, R);
    }
    return o.f[a] = new ne(R, h);
  };
  function T(o, a, u) {
    return fe(o, ie), a < o.G ? o.u[a + o.D] = u : (Ve(o), o.i[a] = u), o;
  }
  ie.setField = T, ie.setProto3IntField = function(o, a, u) {
    return j(o, a, u, 0);
  }, ie.setProto3FloatField = function(o, a, u) {
    return j(o, a, u, 0);
  }, ie.setProto3BooleanField = function(o, a, u) {
    return j(o, a, u, !1);
  }, ie.setProto3StringField = function(o, a, u) {
    return j(o, a, u, "");
  }, ie.setProto3BytesField = function(o, a, u) {
    return j(o, a, u, "");
  }, ie.setProto3EnumField = function(o, a, u) {
    return j(o, a, u, 0);
  }, ie.setProto3StringIntField = function(o, a, u) {
    return j(o, a, u, "0");
  };
  function j(o, a, u, h) {
    return fe(o, ie), u !== h ? T(o, a, u) : a < o.G ? o.u[a + o.D] = null : (Ve(o), delete o.i[a]), o;
  }
  ie.addToRepeatedField = function(o, a, u, h) {
    return fe(o, ie), a = $e(o, a), h != null ? a.splice(h, 0, u) : a.push(u), o;
  };
  function G(o, a, u, h) {
    return fe(o, ie), (u = de(o, u)) && u !== a && h !== void 0 && (o.f && u in o.f && (o.f[u] = void 0), T(o, u, void 0)), T(o, a, h);
  }
  ie.setOneofField = G;
  function de(o, a) {
    for (var u, h, R = 0; R < a.length; R++) {
      var W = a[R], K = $e(o, W);
      K != null && (u = W, h = K, T(o, W, void 0));
    }
    return u ? (T(o, u, h), u) : 0;
  }
  ie.computeOneofCase = de, ie.getWrapperField = function(o, a, u, h) {
    if (o.f || (o.f = {}), !o.f[u]) {
      var R = $e(o, u);
      (h || R) && (o.f[u] = new a(R));
    }
    return o.f[u];
  }, ie.getRepeatedWrapperField = function(o, a, u) {
    return De(o, a, u), a = o.f[u], a == lt && (a = o.f[u] = []), a;
  };
  function De(o, a, u) {
    if (o.f || (o.f = {}), !o.f[u]) {
      for (var h = $e(o, u), R = [], W = 0; W < h.length; W++)
        R[W] = new a(h[W]);
      o.f[u] = R;
    }
  }
  ie.setWrapperField = function(o, a, u) {
    fe(o, ie), o.f || (o.f = {});
    var h = u && u.g();
    return o.f[a] = u, T(o, a, h);
  }, ie.setOneofWrapperField = function(o, a, u, h) {
    fe(o, ie), o.f || (o.f = {});
    var R = h && h.g();
    return o.f[a] = h, G(o, a, u, R);
  }, ie.setRepeatedWrapperField = function(o, a, u) {
    fe(o, ie), o.f || (o.f = {}), u = u || [];
    for (var h = [], R = 0; R < u.length; R++)
      h[R] = u[R].g();
    return o.f[a] = u, T(o, a, h);
  }, ie.addToRepeatedWrapperField = function(o, a, u, h, R) {
    De(o, h, a);
    var W = o.f[a];
    return W || (W = o.f[a] = []), u = u || new h(), o = $e(o, a), R != null ? (W.splice(R, 0, u), o.splice(R, 0, u.g())) : (W.push(u), o.push(u.g())), u;
  }, ie.toMap = function(o, a, u, h) {
    for (var R = {}, W = 0; W < o.length; W++)
      R[a.call(o[W])] = u ? u.call(o[W], h, o[W]) : o[W];
    return R;
  };
  function Ee(o) {
    if (o.f)
      for (var a in o.f) {
        var u = o.f[a];
        if (Array.isArray(u))
          for (var h = 0; h < u.length; h++)
            u[h] && u[h].g();
        else
          u && u.g();
      }
  }
  ie.prototype.g = function() {
    return Ee(this), this.u;
  }, ie.prototype.toArray = ie.prototype.g, ie.prototype.toString = function() {
    return Ee(this), this.u.toString();
  }, ie.prototype.getExtension = function(o) {
    if (this.i) {
      this.f || (this.f = {});
      var a = o.ma;
      if (o.na) {
        if (o.F())
          return this.f[a] || (this.f[a] = z(this.i[a] || [], function(u) {
            return new o.la(u);
          })), this.f[a];
      } else if (o.F())
        return !this.f[a] && this.i[a] && (this.f[a] = new o.la(this.i[a])), this.f[a];
      return this.i[a];
    }
  }, ie.prototype.getExtension = ie.prototype.getExtension, ie.prototype.Kc = function(o, a) {
    this.f || (this.f = {}), Ve(this);
    var u = o.ma;
    return o.na ? (a = a || [], o.F() ? (this.f[u] = a, this.i[u] = z(a, function(h) {
      return h.g();
    })) : this.i[u] = a) : o.F() ? (this.f[u] = a, this.i[u] = a && a.g()) : this.i[u] = a, this;
  }, ie.prototype.setExtension = ie.prototype.Kc, ie.difference = function(o, a) {
    if (!(o instanceof a.constructor))
      throw Error("Messages have different types.");
    var u = o.g();
    a = a.g();
    var h = [], R = 0, W = u.length > a.length ? u.length : a.length;
    for (o.b && (h[0] = o.b, R = 1); R < W; R++)
      ve(u[R], a[R]) || (h[R] = a[R]);
    return new o.constructor(h);
  }, ie.equals = function(o, a) {
    return o == a || !(!o || !a) && o instanceof a.constructor && ve(o.g(), a.g());
  };
  function Be(o, a) {
    o = o || {}, a = a || {};
    var u = {}, h;
    for (h in o)
      u[h] = 0;
    for (h in a)
      u[h] = 0;
    for (h in u)
      if (!ve(o[h], a[h]))
        return !1;
    return !0;
  }
  ie.compareExtensions = Be;
  function ve(o, a) {
    if (o == a)
      return !0;
    if (!V(o) || !V(a))
      return typeof o == "number" && isNaN(o) || typeof a == "number" && isNaN(a) ? String(o) == String(a) : !1;
    if (o.constructor != a.constructor)
      return !1;
    if (Lt && o.constructor === Uint8Array) {
      if (o.length != a.length)
        return !1;
      for (var u = 0; u < o.length; u++)
        if (o[u] != a[u])
          return !1;
      return !0;
    }
    if (o.constructor === Array) {
      var h = void 0, R = void 0, W = Math.max(o.length, a.length);
      for (u = 0; u < W; u++) {
        var K = o[u], ue = a[u];
        if (K && K.constructor == Object && (F(h === void 0), F(u === o.length - 1), h = K, K = void 0), ue && ue.constructor == Object && (F(R === void 0), F(u === a.length - 1), R = ue, ue = void 0), !ve(K, ue))
          return !1;
      }
      return h || R ? (h = h || {}, R = R || {}, Be(h, R)) : !0;
    }
    if (o.constructor === Object)
      return Be(o, a);
    throw Error("Invalid type in JSPB array");
  }
  ie.compareFields = ve, ie.prototype.Bb = function() {
    return Sr(this);
  }, ie.prototype.cloneMessage = ie.prototype.Bb, ie.prototype.clone = function() {
    return Sr(this);
  }, ie.prototype.clone = ie.prototype.clone, ie.clone = function(o) {
    return Sr(o);
  };
  function Sr(o) {
    return new o.constructor(Ur(o.g()));
  }
  ie.copyInto = function(o, a) {
    fe(o, ie), fe(a, ie), F(o.constructor == a.constructor, "Copy source and target message should have the same type."), o = Sr(o);
    for (var u = a.g(), h = o.g(), R = u.length = 0; R < h.length; R++)
      u[R] = h[R];
    a.f = o.f, a.i = o.i;
  };
  function Ur(o) {
    if (Array.isArray(o)) {
      for (var a = Array(o.length), u = 0; u < o.length; u++) {
        var h = o[u];
        h != null && (a[u] = typeof h == "object" ? Ur(F(h)) : h);
      }
      return a;
    }
    if (Lt && o instanceof Uint8Array)
      return new Uint8Array(o);
    a = {};
    for (u in o)
      h = o[u], h != null && (a[u] = typeof h == "object" ? Ur(F(h)) : h);
    return a;
  }
  ie.registerMessageType = function(o, a) {
    a.we = o;
  };
  var st = { dump: function(o) {
    return fe(o, ie, "jspb.Message instance expected"), F(o.getExtension, "Only unobfuscated and unoptimized compilation modes supported."), st.X(o);
  } };
  M("jspb.debug.dump", st.dump, void 0), st.X = function(o) {
    var a = X(o);
    if (a == "number" || a == "string" || a == "boolean" || a == "null" || a == "undefined" || typeof Uint8Array < "u" && o instanceof Uint8Array)
      return o;
    if (a == "array")
      return oe(o), z(o, st.X);
    if (o instanceof ne) {
      var u = {};
      o = o.entries();
      for (var h = o.next(); !h.done; h = o.next())
        u[h.value[0]] = st.X(h.value[1]);
      return u;
    }
    fe(o, ie, "Only messages expected: " + o), a = o.constructor;
    var R = { $name: a.name || a.displayName };
    for (ue in a.prototype) {
      var W = /^get([A-Z]\w*)/.exec(ue);
      if (W && ue != "getExtension" && ue != "getJsPbMessageId") {
        var K = "has" + W[1];
        (!o[K] || o[K]()) && (K = o[ue](), R[st.$a(W[1])] = st.X(K));
      }
    }
    if (o.extensionObject_)
      return R.$extensions = "Recursive dumping of extensions not supported in compiled code. Switch to uncompiled or dump extension object directly", R;
    for (h in a.extensions)
      if (/^\d+$/.test(h)) {
        K = a.extensions[h];
        var ue = o.getExtension(K);
        W = void 0, K = K.Ba;
        var _e = [], At = 0;
        for (W in K)
          _e[At++] = W;
        W = _e[0], ue != null && (u || (u = R.$extensions = {}), u[st.$a(W)] = st.X(ue));
      }
    return R;
  }, st.$a = function(o) {
    return o.replace(/^[A-Z]/, function(a) {
      return a.toLowerCase();
    });
  };
  function re() {
    this.a = [];
  }
  M("jspb.BinaryEncoder", re, void 0), re.prototype.length = function() {
    return this.a.length;
  }, re.prototype.length = re.prototype.length, re.prototype.end = function() {
    var o = this.a;
    return this.a = [], o;
  }, re.prototype.end = re.prototype.end, re.prototype.l = function(o, a) {
    for (F(o == Math.floor(o)), F(a == Math.floor(a)), F(0 <= o && 4294967296 > o), F(0 <= a && 4294967296 > a); 0 < a || 127 < o; )
      this.a.push(o & 127 | 128), o = (o >>> 7 | a << 25) >>> 0, a >>>= 7;
    this.a.push(o);
  }, re.prototype.writeSplitVarint64 = re.prototype.l, re.prototype.A = function(o, a) {
    F(o == Math.floor(o)), F(a == Math.floor(a)), F(0 <= o && 4294967296 > o), F(0 <= a && 4294967296 > a), this.s(o), this.s(a);
  }, re.prototype.writeSplitFixed64 = re.prototype.A, re.prototype.j = function(o) {
    for (F(o == Math.floor(o)), F(0 <= o && 4294967296 > o); 127 < o; )
      this.a.push(o & 127 | 128), o >>>= 7;
    this.a.push(o);
  }, re.prototype.writeUnsignedVarint32 = re.prototype.j, re.prototype.M = function(o) {
    if (F(o == Math.floor(o)), F(-2147483648 <= o && 2147483648 > o), 0 <= o)
      this.j(o);
    else {
      for (var a = 0; 9 > a; a++)
        this.a.push(o & 127 | 128), o >>= 7;
      this.a.push(1);
    }
  }, re.prototype.writeSignedVarint32 = re.prototype.M, re.prototype.va = function(o) {
    F(o == Math.floor(o)), F(0 <= o && 18446744073709552e3 > o), Q(o), this.l(B, P);
  }, re.prototype.writeUnsignedVarint64 = re.prototype.va, re.prototype.ua = function(o) {
    F(o == Math.floor(o)), F(-9223372036854776e3 <= o && 9223372036854776e3 > o), Q(o), this.l(B, P);
  }, re.prototype.writeSignedVarint64 = re.prototype.ua, re.prototype.wa = function(o) {
    F(o == Math.floor(o)), F(-2147483648 <= o && 2147483648 > o), this.j((o << 1 ^ o >> 31) >>> 0);
  }, re.prototype.writeZigzagVarint32 = re.prototype.wa, re.prototype.xa = function(o) {
    F(o == Math.floor(o)), F(-9223372036854776e3 <= o && 9223372036854776e3 > o), v(o), this.l(B, P);
  }, re.prototype.writeZigzagVarint64 = re.prototype.xa, re.prototype.Ta = function(o) {
    this.W(Xe(o));
  }, re.prototype.writeZigzagVarint64String = re.prototype.Ta, re.prototype.W = function(o) {
    var a = this;
    te(o), he(B, P, function(u, h) {
      a.l(u >>> 0, h >>> 0);
    });
  }, re.prototype.writeZigzagVarintHash64 = re.prototype.W, re.prototype.be = function(o) {
    F(o == Math.floor(o)), F(0 <= o && 256 > o), this.a.push(o >>> 0 & 255);
  }, re.prototype.writeUint8 = re.prototype.be, re.prototype.ae = function(o) {
    F(o == Math.floor(o)), F(0 <= o && 65536 > o), this.a.push(o >>> 0 & 255), this.a.push(o >>> 8 & 255);
  }, re.prototype.writeUint16 = re.prototype.ae, re.prototype.s = function(o) {
    F(o == Math.floor(o)), F(0 <= o && 4294967296 > o), this.a.push(o >>> 0 & 255), this.a.push(o >>> 8 & 255), this.a.push(o >>> 16 & 255), this.a.push(o >>> 24 & 255);
  }, re.prototype.writeUint32 = re.prototype.s, re.prototype.V = function(o) {
    F(o == Math.floor(o)), F(0 <= o && 18446744073709552e3 > o), Y(o), this.s(B), this.s(P);
  }, re.prototype.writeUint64 = re.prototype.V, re.prototype.Qc = function(o) {
    F(o == Math.floor(o)), F(-128 <= o && 128 > o), this.a.push(o >>> 0 & 255);
  }, re.prototype.writeInt8 = re.prototype.Qc, re.prototype.Pc = function(o) {
    F(o == Math.floor(o)), F(-32768 <= o && 32768 > o), this.a.push(o >>> 0 & 255), this.a.push(o >>> 8 & 255);
  }, re.prototype.writeInt16 = re.prototype.Pc, re.prototype.S = function(o) {
    F(o == Math.floor(o)), F(-2147483648 <= o && 2147483648 > o), this.a.push(o >>> 0 & 255), this.a.push(o >>> 8 & 255), this.a.push(o >>> 16 & 255), this.a.push(o >>> 24 & 255);
  }, re.prototype.writeInt32 = re.prototype.S, re.prototype.T = function(o) {
    F(o == Math.floor(o)), F(-9223372036854776e3 <= o && 9223372036854776e3 > o), Q(o), this.A(B, P);
  }, re.prototype.writeInt64 = re.prototype.T, re.prototype.ka = function(o) {
    F(o == Math.floor(o)), F(-9223372036854776e3 <= +o && 9223372036854776e3 > +o), te(Xe(o)), this.A(B, P);
  }, re.prototype.writeInt64String = re.prototype.ka, re.prototype.L = function(o) {
    F(o === 1 / 0 || o === -1 / 0 || isNaN(o) || -34028234663852886e22 <= o && 34028234663852886e22 >= o), b(o), this.s(B);
  }, re.prototype.writeFloat = re.prototype.L, re.prototype.J = function(o) {
    F(o === 1 / 0 || o === -1 / 0 || isNaN(o) || -17976931348623157e292 <= o && 17976931348623157e292 >= o), U(o), this.s(B), this.s(P);
  }, re.prototype.writeDouble = re.prototype.J, re.prototype.I = function(o) {
    F(typeof o == "boolean" || typeof o == "number"), this.a.push(o ? 1 : 0);
  }, re.prototype.writeBool = re.prototype.I, re.prototype.R = function(o) {
    F(o == Math.floor(o)), F(-2147483648 <= o && 2147483648 > o), this.M(o);
  }, re.prototype.writeEnum = re.prototype.R, re.prototype.ja = function(o) {
    this.a.push.apply(this.a, o);
  }, re.prototype.writeBytes = re.prototype.ja, re.prototype.N = function(o) {
    te(o), this.l(B, P);
  }, re.prototype.writeVarintHash64 = re.prototype.N, re.prototype.K = function(o) {
    te(o), this.s(B), this.s(P);
  }, re.prototype.writeFixedHash64 = re.prototype.K, re.prototype.U = function(o) {
    var a = this.a.length;
    ee(o);
    for (var u = 0; u < o.length; u++) {
      var h = o.charCodeAt(u);
      if (128 > h)
        this.a.push(h);
      else if (2048 > h)
        this.a.push(h >> 6 | 192), this.a.push(h & 63 | 128);
      else if (65536 > h)
        if (55296 <= h && 56319 >= h && u + 1 < o.length) {
          var R = o.charCodeAt(u + 1);
          56320 <= R && 57343 >= R && (h = 1024 * (h - 55296) + R - 56320 + 65536, this.a.push(h >> 18 | 240), this.a.push(h >> 12 & 63 | 128), this.a.push(h >> 6 & 63 | 128), this.a.push(h & 63 | 128), u++);
        } else
          this.a.push(h >> 12 | 224), this.a.push(h >> 6 & 63 | 128), this.a.push(h & 63 | 128);
    }
    return this.a.length - a;
  }, re.prototype.writeString = re.prototype.U;
  function pe(o, a) {
    this.lo = o, this.hi = a;
  }
  M("jspb.arith.UInt64", pe, void 0), pe.prototype.cmp = function(o) {
    return this.hi < o.hi || this.hi == o.hi && this.lo < o.lo ? -1 : this.hi == o.hi && this.lo == o.lo ? 0 : 1;
  }, pe.prototype.cmp = pe.prototype.cmp, pe.prototype.La = function() {
    return new pe((this.lo >>> 1 | (this.hi & 1) << 31) >>> 0, this.hi >>> 1 >>> 0);
  }, pe.prototype.rightShift = pe.prototype.La, pe.prototype.Da = function() {
    return new pe(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
  }, pe.prototype.leftShift = pe.prototype.Da, pe.prototype.cb = function() {
    return !!(this.hi & 2147483648);
  }, pe.prototype.msb = pe.prototype.cb, pe.prototype.Ob = function() {
    return !!(this.lo & 1);
  }, pe.prototype.lsb = pe.prototype.Ob, pe.prototype.Ua = function() {
    return this.lo == 0 && this.hi == 0;
  }, pe.prototype.zero = pe.prototype.Ua, pe.prototype.add = function(o) {
    return new pe((this.lo + o.lo & 4294967295) >>> 0 >>> 0, ((this.hi + o.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + o.lo ? 1 : 0) >>> 0);
  }, pe.prototype.add = pe.prototype.add, pe.prototype.sub = function(o) {
    return new pe((this.lo - o.lo & 4294967295) >>> 0 >>> 0, ((this.hi - o.hi & 4294967295) >>> 0) - (0 > this.lo - o.lo ? 1 : 0) >>> 0);
  }, pe.prototype.sub = pe.prototype.sub;
  function qr(o, a) {
    var u = o & 65535;
    o >>>= 16;
    var h = a & 65535, R = a >>> 16;
    for (a = u * h + 65536 * (u * R & 65535) + 65536 * (o * h & 65535), u = o * R + (u * R >>> 16) + (o * h >>> 16); 4294967296 <= a; )
      a -= 4294967296, u += 1;
    return new pe(a >>> 0, u >>> 0);
  }
  pe.mul32x32 = qr, pe.prototype.eb = function(o) {
    var a = qr(this.lo, o);
    return o = qr(this.hi, o), o.hi = o.lo, o.lo = 0, a.add(o);
  }, pe.prototype.mul = pe.prototype.eb, pe.prototype.Xa = function(o) {
    if (o == 0)
      return [];
    var a = new pe(0, 0), u = new pe(this.lo, this.hi);
    o = new pe(o, 0);
    for (var h = new pe(1, 0); !o.cb(); )
      o = o.Da(), h = h.Da();
    for (; !h.Ua(); )
      0 >= o.cmp(u) && (a = a.add(h), u = u.sub(o)), o = o.La(), h = h.La();
    return [a, u];
  }, pe.prototype.div = pe.prototype.Xa, pe.prototype.toString = function() {
    for (var o = "", a = this; !a.Ua(); ) {
      a = a.Xa(10);
      var u = a[0];
      o = a[1].lo + o, a = u;
    }
    return o == "" && (o = "0"), o;
  }, pe.prototype.toString = pe.prototype.toString;
  function xt(o) {
    for (var a = new pe(0, 0), u = new pe(0, 0), h = 0; h < o.length; h++) {
      if ("0" > o[h] || "9" < o[h])
        return null;
      u.lo = parseInt(o[h], 10), a = a.eb(10).add(u);
    }
    return a;
  }
  pe.fromString = xt, pe.prototype.clone = function() {
    return new pe(this.lo, this.hi);
  }, pe.prototype.clone = pe.prototype.clone;
  function je(o, a) {
    this.lo = o, this.hi = a;
  }
  M("jspb.arith.Int64", je, void 0), je.prototype.add = function(o) {
    return new je((this.lo + o.lo & 4294967295) >>> 0 >>> 0, ((this.hi + o.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + o.lo ? 1 : 0) >>> 0);
  }, je.prototype.add = je.prototype.add, je.prototype.sub = function(o) {
    return new je((this.lo - o.lo & 4294967295) >>> 0 >>> 0, ((this.hi - o.hi & 4294967295) >>> 0) - (0 > this.lo - o.lo ? 1 : 0) >>> 0);
  }, je.prototype.sub = je.prototype.sub, je.prototype.clone = function() {
    return new je(this.lo, this.hi);
  }, je.prototype.clone = je.prototype.clone, je.prototype.toString = function() {
    var o = (this.hi & 2147483648) != 0, a = new pe(this.lo, this.hi);
    return o && (a = new pe(0, 0).sub(a)), (o ? "-" : "") + a.toString();
  }, je.prototype.toString = je.prototype.toString;
  function wr(o) {
    var a = 0 < o.length && o[0] == "-";
    return a && (o = o.substring(1)), o = xt(o), o === null ? null : (a && (o = new pe(0, 0).sub(o)), new je(o.lo, o.hi));
  }
  je.fromString = wr;
  function m() {
    this.c = [], this.b = 0, this.a = new re(), this.h = [];
  }
  M("jspb.BinaryWriter", m, void 0);
  function an(o, a) {
    var u = o.a.end();
    o.c.push(u), o.c.push(a), o.b += u.length + a.length;
  }
  function Ae(o, a) {
    return ce(o, a, 2), a = o.a.end(), o.c.push(a), o.b += a.length, a.push(o.b), a;
  }
  function Ie(o, a) {
    var u = a.pop();
    for (u = o.b + o.a.length() - u, F(0 <= u); 127 < u; )
      a.push(u & 127 | 128), u >>>= 7, o.b++;
    a.push(u), o.b++;
  }
  m.prototype.pb = function(o, a, u) {
    an(this, o.subarray(a, u));
  }, m.prototype.writeSerializedMessage = m.prototype.pb, m.prototype.Pb = function(o, a, u) {
    o != null && a != null && u != null && this.pb(o, a, u);
  }, m.prototype.maybeWriteSerializedMessage = m.prototype.Pb, m.prototype.reset = function() {
    this.c = [], this.a.end(), this.b = 0, this.h = [];
  }, m.prototype.reset = m.prototype.reset, m.prototype.ab = function() {
    F(this.h.length == 0);
    for (var o = new Uint8Array(this.b + this.a.length()), a = this.c, u = a.length, h = 0, R = 0; R < u; R++) {
      var W = a[R];
      o.set(W, h), h += W.length;
    }
    return a = this.a.end(), o.set(a, h), h += a.length, F(h == o.length), this.c = [o], o;
  }, m.prototype.getResultBuffer = m.prototype.ab, m.prototype.Kb = function(o) {
    return N(this.ab(), o);
  }, m.prototype.getResultBase64String = m.prototype.Kb, m.prototype.Va = function(o) {
    this.h.push(Ae(this, o));
  }, m.prototype.beginSubMessage = m.prototype.Va, m.prototype.Ya = function() {
    F(0 <= this.h.length), Ie(this, this.h.pop());
  }, m.prototype.endSubMessage = m.prototype.Ya;
  function ce(o, a, u) {
    F(1 <= a && a == Math.floor(a)), o.a.j(8 * a + u);
  }
  m.prototype.Nc = function(o, a, u) {
    switch (o) {
      case 1:
        this.J(a, u);
        break;
      case 2:
        this.L(a, u);
        break;
      case 3:
        this.T(a, u);
        break;
      case 4:
        this.V(a, u);
        break;
      case 5:
        this.S(a, u);
        break;
      case 6:
        this.Qa(a, u);
        break;
      case 7:
        this.Pa(a, u);
        break;
      case 8:
        this.I(a, u);
        break;
      case 9:
        this.U(a, u);
        break;
      case 10:
        ae("Group field type not supported in writeAny()");
        break;
      case 11:
        ae("Message field type not supported in writeAny()");
        break;
      case 12:
        this.ja(a, u);
        break;
      case 13:
        this.s(a, u);
        break;
      case 14:
        this.R(a, u);
        break;
      case 15:
        this.Ra(a, u);
        break;
      case 16:
        this.Sa(a, u);
        break;
      case 17:
        this.rb(a, u);
        break;
      case 18:
        this.sb(a, u);
        break;
      case 30:
        this.K(a, u);
        break;
      case 31:
        this.N(a, u);
        break;
      default:
        ae("Invalid field type in writeAny()");
    }
  }, m.prototype.writeAny = m.prototype.Nc;
  function Gr(o, a, u) {
    u != null && (ce(o, a, 0), o.a.j(u));
  }
  function Vr(o, a, u) {
    u != null && (ce(o, a, 0), o.a.M(u));
  }
  m.prototype.S = function(o, a) {
    a != null && (F(-2147483648 <= a && 2147483648 > a), Vr(this, o, a));
  }, m.prototype.writeInt32 = m.prototype.S, m.prototype.ob = function(o, a) {
    a != null && (a = parseInt(a, 10), F(-2147483648 <= a && 2147483648 > a), Vr(this, o, a));
  }, m.prototype.writeInt32String = m.prototype.ob, m.prototype.T = function(o, a) {
    a != null && (F(-9223372036854776e3 <= a && 9223372036854776e3 > a), a != null && (ce(this, o, 0), this.a.ua(a)));
  }, m.prototype.writeInt64 = m.prototype.T, m.prototype.ka = function(o, a) {
    a != null && (a = wr(a), ce(this, o, 0), this.a.l(a.lo, a.hi));
  }, m.prototype.writeInt64String = m.prototype.ka, m.prototype.s = function(o, a) {
    a != null && (F(0 <= a && 4294967296 > a), Gr(this, o, a));
  }, m.prototype.writeUint32 = m.prototype.s, m.prototype.ub = function(o, a) {
    a != null && (a = parseInt(a, 10), F(0 <= a && 4294967296 > a), Gr(this, o, a));
  }, m.prototype.writeUint32String = m.prototype.ub, m.prototype.V = function(o, a) {
    a != null && (F(0 <= a && 18446744073709552e3 > a), a != null && (ce(this, o, 0), this.a.va(a)));
  }, m.prototype.writeUint64 = m.prototype.V, m.prototype.vb = function(o, a) {
    a != null && (a = xt(a), ce(this, o, 0), this.a.l(a.lo, a.hi));
  }, m.prototype.writeUint64String = m.prototype.vb, m.prototype.rb = function(o, a) {
    a != null && (F(-2147483648 <= a && 2147483648 > a), a != null && (ce(this, o, 0), this.a.wa(a)));
  }, m.prototype.writeSint32 = m.prototype.rb, m.prototype.sb = function(o, a) {
    a != null && (F(-9223372036854776e3 <= a && 9223372036854776e3 > a), a != null && (ce(this, o, 0), this.a.xa(a)));
  }, m.prototype.writeSint64 = m.prototype.sb, m.prototype.$d = function(o, a) {
    a != null && a != null && (ce(this, o, 0), this.a.W(a));
  }, m.prototype.writeSintHash64 = m.prototype.$d, m.prototype.Zd = function(o, a) {
    a != null && a != null && (ce(this, o, 0), this.a.Ta(a));
  }, m.prototype.writeSint64String = m.prototype.Zd, m.prototype.Pa = function(o, a) {
    a != null && (F(0 <= a && 4294967296 > a), ce(this, o, 5), this.a.s(a));
  }, m.prototype.writeFixed32 = m.prototype.Pa, m.prototype.Qa = function(o, a) {
    a != null && (F(0 <= a && 18446744073709552e3 > a), ce(this, o, 1), this.a.V(a));
  }, m.prototype.writeFixed64 = m.prototype.Qa, m.prototype.nb = function(o, a) {
    a != null && (a = xt(a), ce(this, o, 1), this.a.A(a.lo, a.hi));
  }, m.prototype.writeFixed64String = m.prototype.nb, m.prototype.Ra = function(o, a) {
    a != null && (F(-2147483648 <= a && 2147483648 > a), ce(this, o, 5), this.a.S(a));
  }, m.prototype.writeSfixed32 = m.prototype.Ra, m.prototype.Sa = function(o, a) {
    a != null && (F(-9223372036854776e3 <= a && 9223372036854776e3 > a), ce(this, o, 1), this.a.T(a));
  }, m.prototype.writeSfixed64 = m.prototype.Sa, m.prototype.qb = function(o, a) {
    a != null && (a = wr(a), ce(this, o, 1), this.a.A(a.lo, a.hi));
  }, m.prototype.writeSfixed64String = m.prototype.qb, m.prototype.L = function(o, a) {
    a != null && (ce(this, o, 5), this.a.L(a));
  }, m.prototype.writeFloat = m.prototype.L, m.prototype.J = function(o, a) {
    a != null && (ce(this, o, 1), this.a.J(a));
  }, m.prototype.writeDouble = m.prototype.J, m.prototype.I = function(o, a) {
    a != null && (F(typeof a == "boolean" || typeof a == "number"), ce(this, o, 0), this.a.I(a));
  }, m.prototype.writeBool = m.prototype.I, m.prototype.R = function(o, a) {
    a != null && (F(-2147483648 <= a && 2147483648 > a), ce(this, o, 0), this.a.M(a));
  }, m.prototype.writeEnum = m.prototype.R, m.prototype.U = function(o, a) {
    a != null && (o = Ae(this, o), this.a.U(a), Ie(this, o));
  }, m.prototype.writeString = m.prototype.U, m.prototype.ja = function(o, a) {
    a != null && (a = Mt(a), ce(this, o, 2), this.a.j(a.length), an(this, a));
  }, m.prototype.writeBytes = m.prototype.ja, m.prototype.Rc = function(o, a, u) {
    a != null && (o = Ae(this, o), u(a, this), Ie(this, o));
  }, m.prototype.writeMessage = m.prototype.Rc, m.prototype.Sc = function(o, a, u) {
    a != null && (ce(this, 1, 3), ce(this, 2, 0), this.a.M(o), o = Ae(this, 3), u(a, this), Ie(this, o), ce(this, 1, 4));
  }, m.prototype.writeMessageSet = m.prototype.Sc, m.prototype.Oc = function(o, a, u) {
    a != null && (ce(this, o, 3), u(a, this), ce(this, o, 4));
  }, m.prototype.writeGroup = m.prototype.Oc, m.prototype.K = function(o, a) {
    a != null && (F(a.length == 8), ce(this, o, 1), this.a.K(a));
  }, m.prototype.writeFixedHash64 = m.prototype.K, m.prototype.N = function(o, a) {
    a != null && (F(a.length == 8), ce(this, o, 0), this.a.N(a));
  }, m.prototype.writeVarintHash64 = m.prototype.N, m.prototype.A = function(o, a, u) {
    ce(this, o, 1), this.a.A(a, u);
  }, m.prototype.writeSplitFixed64 = m.prototype.A, m.prototype.l = function(o, a, u) {
    ce(this, o, 0), this.a.l(a, u);
  }, m.prototype.writeSplitVarint64 = m.prototype.l, m.prototype.tb = function(o, a, u) {
    ce(this, o, 0);
    var h = this.a;
    he(a, u, function(R, W) {
      h.l(R >>> 0, W >>> 0);
    });
  }, m.prototype.writeSplitZigzagVarint64 = m.prototype.tb, m.prototype.Ed = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        Vr(this, o, a[u]);
  }, m.prototype.writeRepeatedInt32 = m.prototype.Ed, m.prototype.Fd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.ob(o, a[u]);
  }, m.prototype.writeRepeatedInt32String = m.prototype.Fd, m.prototype.Gd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++) {
        var h = a[u];
        h != null && (ce(this, o, 0), this.a.ua(h));
      }
  }, m.prototype.writeRepeatedInt64 = m.prototype.Gd, m.prototype.Qd = function(o, a, u, h) {
    if (a != null)
      for (var R = 0; R < a.length; R++)
        this.A(o, u(a[R]), h(a[R]));
  }, m.prototype.writeRepeatedSplitFixed64 = m.prototype.Qd, m.prototype.Rd = function(o, a, u, h) {
    if (a != null)
      for (var R = 0; R < a.length; R++)
        this.l(o, u(a[R]), h(a[R]));
  }, m.prototype.writeRepeatedSplitVarint64 = m.prototype.Rd, m.prototype.Sd = function(o, a, u, h) {
    if (a != null)
      for (var R = 0; R < a.length; R++)
        this.tb(o, u(a[R]), h(a[R]));
  }, m.prototype.writeRepeatedSplitZigzagVarint64 = m.prototype.Sd, m.prototype.Hd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.ka(o, a[u]);
  }, m.prototype.writeRepeatedInt64String = m.prototype.Hd, m.prototype.Ud = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        Gr(this, o, a[u]);
  }, m.prototype.writeRepeatedUint32 = m.prototype.Ud, m.prototype.Vd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.ub(o, a[u]);
  }, m.prototype.writeRepeatedUint32String = m.prototype.Vd, m.prototype.Wd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++) {
        var h = a[u];
        h != null && (ce(this, o, 0), this.a.va(h));
      }
  }, m.prototype.writeRepeatedUint64 = m.prototype.Wd, m.prototype.Xd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.vb(o, a[u]);
  }, m.prototype.writeRepeatedUint64String = m.prototype.Xd, m.prototype.Md = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++) {
        var h = a[u];
        h != null && (ce(this, o, 0), this.a.wa(h));
      }
  }, m.prototype.writeRepeatedSint32 = m.prototype.Md, m.prototype.Nd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++) {
        var h = a[u];
        h != null && (ce(this, o, 0), this.a.xa(h));
      }
  }, m.prototype.writeRepeatedSint64 = m.prototype.Nd, m.prototype.Od = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++) {
        var h = a[u];
        h != null && (ce(this, o, 0), this.a.Ta(h));
      }
  }, m.prototype.writeRepeatedSint64String = m.prototype.Od, m.prototype.Pd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++) {
        var h = a[u];
        h != null && (ce(this, o, 0), this.a.W(h));
      }
  }, m.prototype.writeRepeatedSintHash64 = m.prototype.Pd, m.prototype.yd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.Pa(o, a[u]);
  }, m.prototype.writeRepeatedFixed32 = m.prototype.yd, m.prototype.zd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.Qa(o, a[u]);
  }, m.prototype.writeRepeatedFixed64 = m.prototype.zd, m.prototype.Ad = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.nb(o, a[u]);
  }, m.prototype.writeRepeatedFixed64String = m.prototype.Ad, m.prototype.Jd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.Ra(o, a[u]);
  }, m.prototype.writeRepeatedSfixed32 = m.prototype.Jd, m.prototype.Kd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.Sa(o, a[u]);
  }, m.prototype.writeRepeatedSfixed64 = m.prototype.Kd, m.prototype.Ld = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.qb(o, a[u]);
  }, m.prototype.writeRepeatedSfixed64String = m.prototype.Ld, m.prototype.Cd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.L(o, a[u]);
  }, m.prototype.writeRepeatedFloat = m.prototype.Cd, m.prototype.wd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.J(o, a[u]);
  }, m.prototype.writeRepeatedDouble = m.prototype.wd, m.prototype.ud = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.I(o, a[u]);
  }, m.prototype.writeRepeatedBool = m.prototype.ud, m.prototype.xd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.R(o, a[u]);
  }, m.prototype.writeRepeatedEnum = m.prototype.xd, m.prototype.Td = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.U(o, a[u]);
  }, m.prototype.writeRepeatedString = m.prototype.Td, m.prototype.vd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.ja(o, a[u]);
  }, m.prototype.writeRepeatedBytes = m.prototype.vd, m.prototype.Id = function(o, a, u) {
    if (a != null)
      for (var h = 0; h < a.length; h++) {
        var R = Ae(this, o);
        u(a[h], this), Ie(this, R);
      }
  }, m.prototype.writeRepeatedMessage = m.prototype.Id, m.prototype.Dd = function(o, a, u) {
    if (a != null)
      for (var h = 0; h < a.length; h++)
        ce(this, o, 3), u(a[h], this), ce(this, o, 4);
  }, m.prototype.writeRepeatedGroup = m.prototype.Dd, m.prototype.Bd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.K(o, a[u]);
  }, m.prototype.writeRepeatedFixedHash64 = m.prototype.Bd, m.prototype.Yd = function(o, a) {
    if (a != null)
      for (var u = 0; u < a.length; u++)
        this.N(o, a[u]);
  }, m.prototype.writeRepeatedVarintHash64 = m.prototype.Yd, m.prototype.ad = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.M(a[u]);
      Ie(this, o);
    }
  }, m.prototype.writePackedInt32 = m.prototype.ad, m.prototype.bd = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.M(parseInt(a[u], 10));
      Ie(this, o);
    }
  }, m.prototype.writePackedInt32String = m.prototype.bd, m.prototype.cd = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.ua(a[u]);
      Ie(this, o);
    }
  }, m.prototype.writePackedInt64 = m.prototype.cd, m.prototype.md = function(o, a, u, h) {
    if (a != null) {
      o = Ae(this, o);
      for (var R = 0; R < a.length; R++)
        this.a.A(u(a[R]), h(a[R]));
      Ie(this, o);
    }
  }, m.prototype.writePackedSplitFixed64 = m.prototype.md, m.prototype.nd = function(o, a, u, h) {
    if (a != null) {
      o = Ae(this, o);
      for (var R = 0; R < a.length; R++)
        this.a.l(u(a[R]), h(a[R]));
      Ie(this, o);
    }
  }, m.prototype.writePackedSplitVarint64 = m.prototype.nd, m.prototype.od = function(o, a, u, h) {
    if (a != null) {
      o = Ae(this, o);
      for (var R = this.a, W = 0; W < a.length; W++)
        he(u(a[W]), h(a[W]), function(K, ue) {
          R.l(K >>> 0, ue >>> 0);
        });
      Ie(this, o);
    }
  }, m.prototype.writePackedSplitZigzagVarint64 = m.prototype.od, m.prototype.dd = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++) {
        var h = wr(a[u]);
        this.a.l(h.lo, h.hi);
      }
      Ie(this, o);
    }
  }, m.prototype.writePackedInt64String = m.prototype.dd, m.prototype.pd = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.j(a[u]);
      Ie(this, o);
    }
  }, m.prototype.writePackedUint32 = m.prototype.pd, m.prototype.qd = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.j(parseInt(a[u], 10));
      Ie(this, o);
    }
  }, m.prototype.writePackedUint32String = m.prototype.qd, m.prototype.rd = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.va(a[u]);
      Ie(this, o);
    }
  }, m.prototype.writePackedUint64 = m.prototype.rd, m.prototype.sd = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++) {
        var h = xt(a[u]);
        this.a.l(h.lo, h.hi);
      }
      Ie(this, o);
    }
  }, m.prototype.writePackedUint64String = m.prototype.sd, m.prototype.hd = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.wa(a[u]);
      Ie(this, o);
    }
  }, m.prototype.writePackedSint32 = m.prototype.hd, m.prototype.jd = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.xa(a[u]);
      Ie(this, o);
    }
  }, m.prototype.writePackedSint64 = m.prototype.jd, m.prototype.kd = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.W(Xe(a[u]));
      Ie(this, o);
    }
  }, m.prototype.writePackedSint64String = m.prototype.kd, m.prototype.ld = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.W(a[u]);
      Ie(this, o);
    }
  }, m.prototype.writePackedSintHash64 = m.prototype.ld, m.prototype.Wc = function(o, a) {
    if (a != null && a.length)
      for (ce(this, o, 2), this.a.j(4 * a.length), o = 0; o < a.length; o++)
        this.a.s(a[o]);
  }, m.prototype.writePackedFixed32 = m.prototype.Wc, m.prototype.Xc = function(o, a) {
    if (a != null && a.length)
      for (ce(this, o, 2), this.a.j(8 * a.length), o = 0; o < a.length; o++)
        this.a.V(a[o]);
  }, m.prototype.writePackedFixed64 = m.prototype.Xc, m.prototype.Yc = function(o, a) {
    if (a != null && a.length)
      for (ce(this, o, 2), this.a.j(8 * a.length), o = 0; o < a.length; o++) {
        var u = xt(a[o]);
        this.a.A(u.lo, u.hi);
      }
  }, m.prototype.writePackedFixed64String = m.prototype.Yc, m.prototype.ed = function(o, a) {
    if (a != null && a.length)
      for (ce(this, o, 2), this.a.j(4 * a.length), o = 0; o < a.length; o++)
        this.a.S(a[o]);
  }, m.prototype.writePackedSfixed32 = m.prototype.ed, m.prototype.fd = function(o, a) {
    if (a != null && a.length)
      for (ce(this, o, 2), this.a.j(8 * a.length), o = 0; o < a.length; o++)
        this.a.T(a[o]);
  }, m.prototype.writePackedSfixed64 = m.prototype.fd, m.prototype.gd = function(o, a) {
    if (a != null && a.length)
      for (ce(this, o, 2), this.a.j(8 * a.length), o = 0; o < a.length; o++)
        this.a.ka(a[o]);
  }, m.prototype.writePackedSfixed64String = m.prototype.gd, m.prototype.$c = function(o, a) {
    if (a != null && a.length)
      for (ce(this, o, 2), this.a.j(4 * a.length), o = 0; o < a.length; o++)
        this.a.L(a[o]);
  }, m.prototype.writePackedFloat = m.prototype.$c, m.prototype.Uc = function(o, a) {
    if (a != null && a.length)
      for (ce(this, o, 2), this.a.j(8 * a.length), o = 0; o < a.length; o++)
        this.a.J(a[o]);
  }, m.prototype.writePackedDouble = m.prototype.Uc, m.prototype.Tc = function(o, a) {
    if (a != null && a.length)
      for (ce(this, o, 2), this.a.j(a.length), o = 0; o < a.length; o++)
        this.a.I(a[o]);
  }, m.prototype.writePackedBool = m.prototype.Tc, m.prototype.Vc = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.R(a[u]);
      Ie(this, o);
    }
  }, m.prototype.writePackedEnum = m.prototype.Vc, m.prototype.Zc = function(o, a) {
    if (a != null && a.length)
      for (ce(this, o, 2), this.a.j(8 * a.length), o = 0; o < a.length; o++)
        this.a.K(a[o]);
  }, m.prototype.writePackedFixedHash64 = m.prototype.Zc, m.prototype.td = function(o, a) {
    if (a != null && a.length) {
      o = Ae(this, o);
      for (var u = 0; u < a.length; u++)
        this.a.N(a[u]);
      Ie(this, o);
    }
  }, m.prototype.writePackedVarintHash64 = m.prototype.td, n.debug = st, n.Map = ne, n.Message = ie, n.BinaryReader = w, n.BinaryWriter = m, n.ExtensionFieldInfo = mt, n.ExtensionFieldBinaryInfo = vr, n.exportSymbol = H, n.inherits = x, n.object = { extend: D }, n.typeOf = X;
})(Kt);
(function(n) {
  var t = Kt, p = t, f = (function() {
    return this || window || f || self || Function("return this")();
  }).call(null);
  p.exportSymbol("proto.priority.geoservice.Location", null, f), p.exportSymbol("proto.priority.geoservice.LocationList", null, f), proto.priority.geoservice.Location = function(l) {
    t.Message.initialize(this, l, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Location, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Location.displayName = "proto.priority.geoservice.Location"), proto.priority.geoservice.LocationList = function(l) {
    t.Message.initialize(this, l, 0, -1, proto.priority.geoservice.LocationList.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.LocationList, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.LocationList.displayName = "proto.priority.geoservice.LocationList"), t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Location.prototype.toObject = function(l) {
    return proto.priority.geoservice.Location.toObject(l, this);
  }, proto.priority.geoservice.Location.toObject = function(l, i) {
    var e = {
      latitude: t.Message.getFloatingPointFieldWithDefault(i, 1, 0),
      longitude: t.Message.getFloatingPointFieldWithDefault(i, 2, 0)
    };
    return l && (e.$jspbMessageInstance = i), e;
  }), proto.priority.geoservice.Location.deserializeBinary = function(l) {
    var i = new t.BinaryReader(l), e = new proto.priority.geoservice.Location();
    return proto.priority.geoservice.Location.deserializeBinaryFromReader(e, i);
  }, proto.priority.geoservice.Location.deserializeBinaryFromReader = function(l, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var e = i.getFieldNumber();
      switch (e) {
        case 1:
          var r = (
            /** @type {number} */
            i.readDouble()
          );
          l.setLatitude(r);
          break;
        case 2:
          var r = (
            /** @type {number} */
            i.readDouble()
          );
          l.setLongitude(r);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return l;
  }, proto.priority.geoservice.Location.prototype.serializeBinary = function() {
    var l = new t.BinaryWriter();
    return proto.priority.geoservice.Location.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, proto.priority.geoservice.Location.serializeBinaryToWriter = function(l, i) {
    var e = void 0;
    e = l.getLatitude(), e !== 0 && i.writeDouble(
      1,
      e
    ), e = l.getLongitude(), e !== 0 && i.writeDouble(
      2,
      e
    );
  }, proto.priority.geoservice.Location.prototype.getLatitude = function() {
    return (
      /** @type {number} */
      t.Message.getFloatingPointFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.geoservice.Location.prototype.setLatitude = function(l) {
    return t.Message.setProto3FloatField(this, 1, l);
  }, proto.priority.geoservice.Location.prototype.getLongitude = function() {
    return (
      /** @type {number} */
      t.Message.getFloatingPointFieldWithDefault(this, 2, 0)
    );
  }, proto.priority.geoservice.Location.prototype.setLongitude = function(l) {
    return t.Message.setProto3FloatField(this, 2, l);
  }, proto.priority.geoservice.LocationList.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.LocationList.prototype.toObject = function(l) {
    return proto.priority.geoservice.LocationList.toObject(l, this);
  }, proto.priority.geoservice.LocationList.toObject = function(l, i) {
    var e = {
      locationsList: t.Message.toObjectList(
        i.getLocationsList(),
        proto.priority.geoservice.Location.toObject,
        l
      )
    };
    return l && (e.$jspbMessageInstance = i), e;
  }), proto.priority.geoservice.LocationList.deserializeBinary = function(l) {
    var i = new t.BinaryReader(l), e = new proto.priority.geoservice.LocationList();
    return proto.priority.geoservice.LocationList.deserializeBinaryFromReader(e, i);
  }, proto.priority.geoservice.LocationList.deserializeBinaryFromReader = function(l, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var e = i.getFieldNumber();
      switch (e) {
        case 1:
          var r = new proto.priority.geoservice.Location();
          i.readMessage(r, proto.priority.geoservice.Location.deserializeBinaryFromReader), l.addLocations(r);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return l;
  }, proto.priority.geoservice.LocationList.prototype.serializeBinary = function() {
    var l = new t.BinaryWriter();
    return proto.priority.geoservice.LocationList.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, proto.priority.geoservice.LocationList.serializeBinaryToWriter = function(l, i) {
    var e = void 0;
    e = l.getLocationsList(), e.length > 0 && i.writeRepeatedMessage(
      1,
      e,
      proto.priority.geoservice.Location.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.LocationList.prototype.getLocationsList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.Location>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.Location, 1)
    );
  }, proto.priority.geoservice.LocationList.prototype.setLocationsList = function(l) {
    return t.Message.setRepeatedWrapperField(this, 1, l);
  }, proto.priority.geoservice.LocationList.prototype.addLocations = function(l, i) {
    return t.Message.addToRepeatedWrapperField(this, 1, l, proto.priority.geoservice.Location, i);
  }, proto.priority.geoservice.LocationList.prototype.clearLocationsList = function() {
    return this.setLocationsList([]);
  }, p.object.extend(n, proto.priority.geoservice);
})(ar);
const ep = /* @__PURE__ */ Zt(ar), sl = /* @__PURE__ */ Ht({
  __proto__: null,
  default: ep
}, [ar]);
var pt = {};
(function(n) {
  var t = Kt, p = t, f = (function() {
    return this || window || f || self || Function("return this")();
  }).call(null), l = ar;
  p.object.extend(proto, l), p.exportSymbol("proto.priority.geoservice.LocationResult", null, f), p.exportSymbol("proto.priority.geoservice.LocationResult.LocationResultType", null, f), p.exportSymbol("proto.priority.geoservice.SearchItem", null, f), p.exportSymbol("proto.priority.geoservice.SearchRq", null, f), p.exportSymbol("proto.priority.geoservice.SearchRs", null, f), p.exportSymbol("proto.priority.geoservice.SearchRs.ResultType", null, f), proto.priority.geoservice.SearchItem = function(i) {
    t.Message.initialize(this, i, 0, -1, proto.priority.geoservice.SearchItem.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.SearchItem, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.SearchItem.displayName = "proto.priority.geoservice.SearchItem"), proto.priority.geoservice.SearchRq = function(i) {
    t.Message.initialize(this, i, 0, -1, proto.priority.geoservice.SearchRq.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.SearchRq, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.SearchRq.displayName = "proto.priority.geoservice.SearchRq"), proto.priority.geoservice.LocationResult = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.LocationResult, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.LocationResult.displayName = "proto.priority.geoservice.LocationResult"), proto.priority.geoservice.SearchRs = function(i) {
    t.Message.initialize(this, i, 0, -1, proto.priority.geoservice.SearchRs.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.SearchRs, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.SearchRs.displayName = "proto.priority.geoservice.SearchRs"), proto.priority.geoservice.SearchItem.repeatedFields_ = [2], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.SearchItem.prototype.toObject = function(i) {
    return proto.priority.geoservice.SearchItem.toObject(i, this);
  }, proto.priority.geoservice.SearchItem.toObject = function(i, e) {
    var r, s = {
      id: t.Message.getFieldWithDefault(e, 1, ""),
      addressList: (r = t.Message.getRepeatedField(e, 2)) == null ? void 0 : r,
      city: t.Message.getFieldWithDefault(e, 3, ""),
      state: t.Message.getFieldWithDefault(e, 4, ""),
      postalcode: t.Message.getFieldWithDefault(e, 5, ""),
      country: t.Message.getFieldWithDefault(e, 6, ""),
      language: t.Message.getFieldWithDefault(e, 7, ""),
      biasposition: (r = e.getBiasposition()) && l.Location.toObject(i, r),
      filterbox: (r = e.getFilterbox()) && l.LocationList.toObject(i, r)
    };
    return i && (s.$jspbMessageInstance = e), s;
  }), proto.priority.geoservice.SearchItem.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.priority.geoservice.SearchItem();
    return proto.priority.geoservice.SearchItem.deserializeBinaryFromReader(r, e);
  }, proto.priority.geoservice.SearchItem.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setId(s);
          break;
        case 2:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.addAddress(s);
          break;
        case 3:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setCity(s);
          break;
        case 4:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setState(s);
          break;
        case 5:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setPostalcode(s);
          break;
        case 6:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setCountry(s);
          break;
        case 7:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setLanguage(s);
          break;
        case 8:
          var s = new l.Location();
          e.readMessage(s, l.Location.deserializeBinaryFromReader), i.setBiasposition(s);
          break;
        case 9:
          var s = new l.LocationList();
          e.readMessage(s, l.LocationList.deserializeBinaryFromReader), i.setFilterbox(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.priority.geoservice.SearchItem.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.priority.geoservice.SearchItem.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.priority.geoservice.SearchItem.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getId(), r.length > 0 && e.writeString(
      1,
      r
    ), r = i.getAddressList(), r.length > 0 && e.writeRepeatedString(
      2,
      r
    ), r = /** @type {string} */
    t.Message.getField(i, 3), r != null && e.writeString(
      3,
      r
    ), r = /** @type {string} */
    t.Message.getField(i, 4), r != null && e.writeString(
      4,
      r
    ), r = /** @type {string} */
    t.Message.getField(i, 5), r != null && e.writeString(
      5,
      r
    ), r = /** @type {string} */
    t.Message.getField(i, 6), r != null && e.writeString(
      6,
      r
    ), r = /** @type {string} */
    t.Message.getField(i, 7), r != null && e.writeString(
      7,
      r
    ), r = i.getBiasposition(), r != null && e.writeMessage(
      8,
      r,
      l.Location.serializeBinaryToWriter
    ), r = i.getFilterbox(), r != null && e.writeMessage(
      9,
      r,
      l.LocationList.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.SearchItem.prototype.getId = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.geoservice.SearchItem.prototype.setId = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.priority.geoservice.SearchItem.prototype.getAddressList = function() {
    return (
      /** @type {!Array<string>} */
      t.Message.getRepeatedField(this, 2)
    );
  }, proto.priority.geoservice.SearchItem.prototype.setAddressList = function(i) {
    return t.Message.setField(this, 2, i || []);
  }, proto.priority.geoservice.SearchItem.prototype.addAddress = function(i, e) {
    return t.Message.addToRepeatedField(this, 2, i, e);
  }, proto.priority.geoservice.SearchItem.prototype.clearAddressList = function() {
    return this.setAddressList([]);
  }, proto.priority.geoservice.SearchItem.prototype.getCity = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.priority.geoservice.SearchItem.prototype.setCity = function(i) {
    return t.Message.setField(this, 3, i);
  }, proto.priority.geoservice.SearchItem.prototype.clearCity = function() {
    return t.Message.setField(this, 3, void 0);
  }, proto.priority.geoservice.SearchItem.prototype.hasCity = function() {
    return t.Message.getField(this, 3) != null;
  }, proto.priority.geoservice.SearchItem.prototype.getState = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.priority.geoservice.SearchItem.prototype.setState = function(i) {
    return t.Message.setField(this, 4, i);
  }, proto.priority.geoservice.SearchItem.prototype.clearState = function() {
    return t.Message.setField(this, 4, void 0);
  }, proto.priority.geoservice.SearchItem.prototype.hasState = function() {
    return t.Message.getField(this, 4) != null;
  }, proto.priority.geoservice.SearchItem.prototype.getPostalcode = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 5, "")
    );
  }, proto.priority.geoservice.SearchItem.prototype.setPostalcode = function(i) {
    return t.Message.setField(this, 5, i);
  }, proto.priority.geoservice.SearchItem.prototype.clearPostalcode = function() {
    return t.Message.setField(this, 5, void 0);
  }, proto.priority.geoservice.SearchItem.prototype.hasPostalcode = function() {
    return t.Message.getField(this, 5) != null;
  }, proto.priority.geoservice.SearchItem.prototype.getCountry = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 6, "")
    );
  }, proto.priority.geoservice.SearchItem.prototype.setCountry = function(i) {
    return t.Message.setField(this, 6, i);
  }, proto.priority.geoservice.SearchItem.prototype.clearCountry = function() {
    return t.Message.setField(this, 6, void 0);
  }, proto.priority.geoservice.SearchItem.prototype.hasCountry = function() {
    return t.Message.getField(this, 6) != null;
  }, proto.priority.geoservice.SearchItem.prototype.getLanguage = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 7, "")
    );
  }, proto.priority.geoservice.SearchItem.prototype.setLanguage = function(i) {
    return t.Message.setField(this, 7, i);
  }, proto.priority.geoservice.SearchItem.prototype.clearLanguage = function() {
    return t.Message.setField(this, 7, void 0);
  }, proto.priority.geoservice.SearchItem.prototype.hasLanguage = function() {
    return t.Message.getField(this, 7) != null;
  }, proto.priority.geoservice.SearchItem.prototype.getBiasposition = function() {
    return (
      /** @type{?proto.priority.geoservice.Location} */
      t.Message.getWrapperField(this, l.Location, 8)
    );
  }, proto.priority.geoservice.SearchItem.prototype.setBiasposition = function(i) {
    return t.Message.setWrapperField(this, 8, i);
  }, proto.priority.geoservice.SearchItem.prototype.clearBiasposition = function() {
    return this.setBiasposition(void 0);
  }, proto.priority.geoservice.SearchItem.prototype.hasBiasposition = function() {
    return t.Message.getField(this, 8) != null;
  }, proto.priority.geoservice.SearchItem.prototype.getFilterbox = function() {
    return (
      /** @type{?proto.priority.geoservice.LocationList} */
      t.Message.getWrapperField(this, l.LocationList, 9)
    );
  }, proto.priority.geoservice.SearchItem.prototype.setFilterbox = function(i) {
    return t.Message.setWrapperField(this, 9, i);
  }, proto.priority.geoservice.SearchItem.prototype.clearFilterbox = function() {
    return this.setFilterbox(void 0);
  }, proto.priority.geoservice.SearchItem.prototype.hasFilterbox = function() {
    return t.Message.getField(this, 9) != null;
  }, proto.priority.geoservice.SearchRq.repeatedFields_ = [3], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.SearchRq.prototype.toObject = function(i) {
    return proto.priority.geoservice.SearchRq.toObject(i, this);
  }, proto.priority.geoservice.SearchRq.toObject = function(i, e) {
    var r = {
      id: t.Message.getFieldWithDefault(e, 1, ""),
      client: t.Message.getFieldWithDefault(e, 2, ""),
      searchitemsList: t.Message.toObjectList(
        e.getSearchitemsList(),
        proto.priority.geoservice.SearchItem.toObject,
        i
      ),
      maxresults: t.Message.getFieldWithDefault(e, 4, 0)
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.priority.geoservice.SearchRq.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.priority.geoservice.SearchRq();
    return proto.priority.geoservice.SearchRq.deserializeBinaryFromReader(r, e);
  }, proto.priority.geoservice.SearchRq.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setId(s);
          break;
        case 2:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setClient(s);
          break;
        case 3:
          var s = new proto.priority.geoservice.SearchItem();
          e.readMessage(s, proto.priority.geoservice.SearchItem.deserializeBinaryFromReader), i.addSearchitems(s);
          break;
        case 4:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setMaxresults(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.priority.geoservice.SearchRq.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.priority.geoservice.SearchRq.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.priority.geoservice.SearchRq.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getId(), r.length > 0 && e.writeString(
      1,
      r
    ), r = i.getClient(), r.length > 0 && e.writeString(
      2,
      r
    ), r = i.getSearchitemsList(), r.length > 0 && e.writeRepeatedMessage(
      3,
      r,
      proto.priority.geoservice.SearchItem.serializeBinaryToWriter
    ), r = /** @type {number} */
    t.Message.getField(i, 4), r != null && e.writeInt32(
      4,
      r
    );
  }, proto.priority.geoservice.SearchRq.prototype.getId = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.geoservice.SearchRq.prototype.setId = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.priority.geoservice.SearchRq.prototype.getClient = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.geoservice.SearchRq.prototype.setClient = function(i) {
    return t.Message.setProto3StringField(this, 2, i);
  }, proto.priority.geoservice.SearchRq.prototype.getSearchitemsList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.SearchItem>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.SearchItem, 3)
    );
  }, proto.priority.geoservice.SearchRq.prototype.setSearchitemsList = function(i) {
    return t.Message.setRepeatedWrapperField(this, 3, i);
  }, proto.priority.geoservice.SearchRq.prototype.addSearchitems = function(i, e) {
    return t.Message.addToRepeatedWrapperField(this, 3, i, proto.priority.geoservice.SearchItem, e);
  }, proto.priority.geoservice.SearchRq.prototype.clearSearchitemsList = function() {
    return this.setSearchitemsList([]);
  }, proto.priority.geoservice.SearchRq.prototype.getMaxresults = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.priority.geoservice.SearchRq.prototype.setMaxresults = function(i) {
    return t.Message.setField(this, 4, i);
  }, proto.priority.geoservice.SearchRq.prototype.clearMaxresults = function() {
    return t.Message.setField(this, 4, void 0);
  }, proto.priority.geoservice.SearchRq.prototype.hasMaxresults = function() {
    return t.Message.getField(this, 4) != null;
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.LocationResult.prototype.toObject = function(i) {
    return proto.priority.geoservice.LocationResult.toObject(i, this);
  }, proto.priority.geoservice.LocationResult.toObject = function(i, e) {
    var r, s = {
      id: t.Message.getFieldWithDefault(e, 1, ""),
      result: t.Message.getFieldWithDefault(e, 2, 0),
      location: (r = e.getLocation()) && l.Location.toObject(i, r),
      score: t.Message.getFieldWithDefault(e, 4, 0)
    };
    return i && (s.$jspbMessageInstance = e), s;
  }), proto.priority.geoservice.LocationResult.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.priority.geoservice.LocationResult();
    return proto.priority.geoservice.LocationResult.deserializeBinaryFromReader(r, e);
  }, proto.priority.geoservice.LocationResult.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setId(s);
          break;
        case 2:
          var s = (
            /** @type {!proto.priority.geoservice.LocationResult.LocationResultType} */
            e.readEnum()
          );
          i.setResult(s);
          break;
        case 3:
          var s = new l.Location();
          e.readMessage(s, l.Location.deserializeBinaryFromReader), i.setLocation(s);
          break;
        case 4:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setScore(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.priority.geoservice.LocationResult.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.priority.geoservice.LocationResult.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.priority.geoservice.LocationResult.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getId(), r.length > 0 && e.writeString(
      1,
      r
    ), r = i.getResult(), r !== 0 && e.writeEnum(
      2,
      r
    ), r = i.getLocation(), r != null && e.writeMessage(
      3,
      r,
      l.Location.serializeBinaryToWriter
    ), r = i.getScore(), r !== 0 && e.writeInt32(
      4,
      r
    );
  }, proto.priority.geoservice.LocationResult.LocationResultType = {
    UNKNOWN: 0,
    FOUND: 1,
    NOTFOUND: 2
  }, proto.priority.geoservice.LocationResult.prototype.getId = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.geoservice.LocationResult.prototype.setId = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.priority.geoservice.LocationResult.prototype.getResult = function() {
    return (
      /** @type {!proto.priority.geoservice.LocationResult.LocationResultType} */
      t.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.priority.geoservice.LocationResult.prototype.setResult = function(i) {
    return t.Message.setProto3EnumField(this, 2, i);
  }, proto.priority.geoservice.LocationResult.prototype.getLocation = function() {
    return (
      /** @type{?proto.priority.geoservice.Location} */
      t.Message.getWrapperField(this, l.Location, 3)
    );
  }, proto.priority.geoservice.LocationResult.prototype.setLocation = function(i) {
    return t.Message.setWrapperField(this, 3, i);
  }, proto.priority.geoservice.LocationResult.prototype.clearLocation = function() {
    return this.setLocation(void 0);
  }, proto.priority.geoservice.LocationResult.prototype.hasLocation = function() {
    return t.Message.getField(this, 3) != null;
  }, proto.priority.geoservice.LocationResult.prototype.getScore = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.priority.geoservice.LocationResult.prototype.setScore = function(i) {
    return t.Message.setProto3IntField(this, 4, i);
  }, proto.priority.geoservice.SearchRs.repeatedFields_ = [3], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.SearchRs.prototype.toObject = function(i) {
    return proto.priority.geoservice.SearchRs.toObject(i, this);
  }, proto.priority.geoservice.SearchRs.toObject = function(i, e) {
    var r = {
      id: t.Message.getFieldWithDefault(e, 1, ""),
      result: t.Message.getFieldWithDefault(e, 2, 0),
      locationsList: t.Message.toObjectList(
        e.getLocationsList(),
        proto.priority.geoservice.LocationResult.toObject,
        i
      ),
      errormessage: t.Message.getFieldWithDefault(e, 4, "")
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.priority.geoservice.SearchRs.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.priority.geoservice.SearchRs();
    return proto.priority.geoservice.SearchRs.deserializeBinaryFromReader(r, e);
  }, proto.priority.geoservice.SearchRs.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setId(s);
          break;
        case 2:
          var s = (
            /** @type {!proto.priority.geoservice.SearchRs.ResultType} */
            e.readEnum()
          );
          i.setResult(s);
          break;
        case 3:
          var s = new proto.priority.geoservice.LocationResult();
          e.readMessage(s, proto.priority.geoservice.LocationResult.deserializeBinaryFromReader), i.addLocations(s);
          break;
        case 4:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setErrormessage(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.priority.geoservice.SearchRs.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.priority.geoservice.SearchRs.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.priority.geoservice.SearchRs.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getId(), r.length > 0 && e.writeString(
      1,
      r
    ), r = i.getResult(), r !== 0 && e.writeEnum(
      2,
      r
    ), r = i.getLocationsList(), r.length > 0 && e.writeRepeatedMessage(
      3,
      r,
      proto.priority.geoservice.LocationResult.serializeBinaryToWriter
    ), r = /** @type {string} */
    t.Message.getField(i, 4), r != null && e.writeString(
      4,
      r
    );
  }, proto.priority.geoservice.SearchRs.ResultType = {
    UNKNOWN: 0,
    SUCCESS: 1,
    ERROR: 2
  }, proto.priority.geoservice.SearchRs.prototype.getId = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.geoservice.SearchRs.prototype.setId = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.priority.geoservice.SearchRs.prototype.getResult = function() {
    return (
      /** @type {!proto.priority.geoservice.SearchRs.ResultType} */
      t.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.priority.geoservice.SearchRs.prototype.setResult = function(i) {
    return t.Message.setProto3EnumField(this, 2, i);
  }, proto.priority.geoservice.SearchRs.prototype.getLocationsList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.LocationResult>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.LocationResult, 3)
    );
  }, proto.priority.geoservice.SearchRs.prototype.setLocationsList = function(i) {
    return t.Message.setRepeatedWrapperField(this, 3, i);
  }, proto.priority.geoservice.SearchRs.prototype.addLocations = function(i, e) {
    return t.Message.addToRepeatedWrapperField(this, 3, i, proto.priority.geoservice.LocationResult, e);
  }, proto.priority.geoservice.SearchRs.prototype.clearLocationsList = function() {
    return this.setLocationsList([]);
  }, proto.priority.geoservice.SearchRs.prototype.getErrormessage = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.priority.geoservice.SearchRs.prototype.setErrormessage = function(i) {
    return t.Message.setField(this, 4, i);
  }, proto.priority.geoservice.SearchRs.prototype.clearErrormessage = function() {
    return t.Message.setField(this, 4, void 0);
  }, proto.priority.geoservice.SearchRs.prototype.hasErrormessage = function() {
    return t.Message.getField(this, 4) != null;
  }, p.object.extend(n, proto.priority.geoservice);
})(pt);
const tp = /* @__PURE__ */ Zt(pt), pl = /* @__PURE__ */ Ht({
  __proto__: null,
  default: tp
}, [pt]);
var Tt = {}, Pe;
function Ha(n) {
  var t = 0;
  return function() {
    return t < n.length ? { done: !1, value: n[t++] } : { done: !0 };
  };
}
var Lo = typeof Object.defineProperties == "function" ? Object.defineProperty : function(n, t, p) {
  n != Array.prototype && n != Object.prototype && (n[t] = p.value);
};
function rp(n) {
  n = [typeof window == "object" && window, typeof self == "object" && self, typeof Ce == "object" && Ce, n];
  for (var t = 0; t < n.length; ++t) {
    var p = n[t];
    if (p && p.Math == Math)
      return p;
  }
  throw Error("Cannot find global object");
}
var Et = rp(Ce);
function Rt() {
  Rt = function() {
  }, Et.Symbol || (Et.Symbol = ip);
}
function Za(n, t) {
  this.a = n, Lo(this, "description", { configurable: !0, writable: !0, value: t });
}
Za.prototype.toString = function() {
  return this.a;
};
var ip = function() {
  function n(p) {
    if (this instanceof n)
      throw new TypeError("Symbol is not a constructor");
    return new Za("jscomp_symbol_" + (p || "") + "_" + t++, p);
  }
  var t = 0;
  return n;
}();
function yt() {
  Rt();
  var n = Et.Symbol.iterator;
  n || (n = Et.Symbol.iterator = Et.Symbol("Symbol.iterator")), typeof Array.prototype[n] != "function" && Lo(Array.prototype, n, { configurable: !0, writable: !0, value: function() {
    return op(Ha(this));
  } }), yt = function() {
  };
}
function op(n) {
  return yt(), n = { next: n }, n[Et.Symbol.iterator] = function() {
    return this;
  }, n;
}
function vo(n) {
  var t = typeof Symbol < "u" && Symbol.iterator && n[Symbol.iterator];
  return t ? t.call(n) : { next: Ha(n) };
}
var np = typeof Object.create == "function" ? Object.create : function(n) {
  function t() {
  }
  return t.prototype = n, new t();
}, bo;
if (typeof Object.setPrototypeOf == "function")
  bo = Object.setPrototypeOf;
else {
  var $r;
  e: {
    var ap = { V: !0 }, pn = {};
    try {
      pn.__proto__ = ap, $r = pn.V;
      break e;
    } catch {
    }
    $r = !1;
  }
  bo = $r ? function(n, t) {
    if (n.__proto__ = t, n.__proto__ !== t)
      throw new TypeError(n + " is not extensible");
    return n;
  } : null;
}
var un = bo;
function Ao(n, t) {
  if (n.prototype = np(t.prototype), n.prototype.constructor = n, un)
    un(n, t);
  else
    for (var p in t)
      if (p != "prototype")
        if (Object.defineProperties) {
          var f = Object.getOwnPropertyDescriptor(t, p);
          f && Object.defineProperty(n, p, f);
        } else
          n[p] = t[p];
  n.O = t.prototype;
}
function sp(n, t) {
  yt(), n instanceof String && (n += "");
  var p = 0, f = { next: function() {
    if (p < n.length) {
      var l = p++;
      return { value: t(l, n[l]), done: !1 };
    }
    return f.next = function() {
      return { done: !0, value: void 0 };
    }, f.next();
  } };
  return f[Symbol.iterator] = function() {
    return f;
  }, f;
}
function sr(n, t) {
  if (t) {
    var p = Et;
    n = n.split(".");
    for (var f = 0; f < n.length - 1; f++) {
      var l = n[f];
      l in p || (p[l] = {}), p = p[l];
    }
    n = n[n.length - 1], f = p[n], t = t(f), t != f && t != null && Lo(p, n, { configurable: !0, writable: !0, value: t });
  }
}
sr("Array.prototype.keys", function(n) {
  return n || function() {
    return sp(this, function(t) {
      return t;
    });
  };
});
sr("Array.prototype.find", function(n) {
  return n || function(t, p) {
    e: {
      var f = this;
      f instanceof String && (f = String(f));
      for (var l = f.length, i = 0; i < l; i++) {
        var e = f[i];
        if (t.call(p, e, i, f)) {
          t = e;
          break e;
        }
      }
      t = void 0;
    }
    return t;
  };
});
sr("Object.is", function(n) {
  return n || function(t, p) {
    return t === p ? t !== 0 || 1 / t === 1 / p : t !== t && p !== p;
  };
});
sr("Array.prototype.includes", function(n) {
  return n || function(t, p) {
    var f = this;
    f instanceof String && (f = String(f));
    var l = f.length;
    for (p = p || 0, 0 > p && (p = Math.max(p + l, 0)); p < l; p++) {
      var i = f[p];
      if (i === t || Object.is(i, t))
        return !0;
    }
    return !1;
  };
});
sr("Promise", function(n) {
  function t(e) {
    this.b = 0, this.c = void 0, this.a = [];
    var r = this.f();
    try {
      e(r.resolve, r.reject);
    } catch (s) {
      r.reject(s);
    }
  }
  function p() {
    this.a = null;
  }
  function f(e) {
    return e instanceof t ? e : new t(function(r) {
      r(e);
    });
  }
  if (n)
    return n;
  p.prototype.b = function(e) {
    if (this.a == null) {
      this.a = [];
      var r = this;
      this.c(function() {
        r.g();
      });
    }
    this.a.push(e);
  };
  var l = Et.setTimeout;
  p.prototype.c = function(e) {
    l(e, 0);
  }, p.prototype.g = function() {
    for (; this.a && this.a.length; ) {
      var e = this.a;
      this.a = [];
      for (var r = 0; r < e.length; ++r) {
        var s = e[r];
        e[r] = null;
        try {
          s();
        } catch (d) {
          this.f(d);
        }
      }
    }
    this.a = null;
  }, p.prototype.f = function(e) {
    this.c(function() {
      throw e;
    });
  }, t.prototype.f = function() {
    function e(d) {
      return function(A) {
        s || (s = !0, d.call(r, A));
      };
    }
    var r = this, s = !1;
    return { resolve: e(this.s), reject: e(this.g) };
  }, t.prototype.s = function(e) {
    if (e === this)
      this.g(new TypeError("A Promise cannot resolve to itself"));
    else if (e instanceof t)
      this.v(e);
    else {
      e:
        switch (typeof e) {
          case "object":
            var r = e != null;
            break e;
          case "function":
            r = !0;
            break e;
          default:
            r = !1;
        }
      r ? this.m(e) : this.h(e);
    }
  }, t.prototype.m = function(e) {
    var r = void 0;
    try {
      r = e.then;
    } catch (s) {
      this.g(s);
      return;
    }
    typeof r == "function" ? this.w(r, e) : this.h(e);
  }, t.prototype.g = function(e) {
    this.i(2, e);
  }, t.prototype.h = function(e) {
    this.i(1, e);
  }, t.prototype.i = function(e, r) {
    if (this.b != 0)
      throw Error("Cannot settle(" + e + ", " + r + "): Promise already settled in state" + this.b);
    this.b = e, this.c = r, this.l();
  }, t.prototype.l = function() {
    if (this.a != null) {
      for (var e = 0; e < this.a.length; ++e)
        i.b(this.a[e]);
      this.a = null;
    }
  };
  var i = new p();
  return t.prototype.v = function(e) {
    var r = this.f();
    e.F(r.resolve, r.reject);
  }, t.prototype.w = function(e, r) {
    var s = this.f();
    try {
      e.call(r, s.resolve, s.reject);
    } catch (d) {
      s.reject(d);
    }
  }, t.prototype.then = function(e, r) {
    function s(M, X) {
      return typeof M == "function" ? function(V) {
        try {
          d(M(V));
        } catch (H) {
          A(H);
        }
      } : X;
    }
    var d, A, _ = new t(function(M, X) {
      d = M, A = X;
    });
    return this.F(s(e, d), s(r, A)), _;
  }, t.prototype.catch = function(e) {
    return this.then(void 0, e);
  }, t.prototype.F = function(e, r) {
    function s() {
      switch (d.b) {
        case 1:
          e(d.c);
          break;
        case 2:
          r(d.c);
          break;
        default:
          throw Error("Unexpected state: " + d.b);
      }
    }
    var d = this;
    this.a == null ? i.b(s) : this.a.push(s);
  }, t.resolve = f, t.reject = function(e) {
    return new t(function(r, s) {
      s(e);
    });
  }, t.race = function(e) {
    return new t(function(r, s) {
      for (var d = vo(e), A = d.next(); !A.done; A = d.next())
        f(A.value).F(r, s);
    });
  }, t.all = function(e) {
    var r = vo(e), s = r.next();
    return s.done ? f([]) : new t(function(d, A) {
      function _(V) {
        return function(H) {
          M[V] = H, X--, X == 0 && d(M);
        };
      }
      var M = [], X = 0;
      do
        M.push(void 0), X++, f(s.value).F(_(M.length - 1), A), s = r.next();
      while (!s.done);
    });
  }, t;
});
var Io = Io || {}, Ze = Ce || self;
function tr(n, t) {
  n = n.split("."), t = t || Ze;
  for (var p = 0; p < n.length; p++)
    if (t = t[n[p]], t == null)
      return null;
  return t;
}
function Br() {
}
function Ar(n) {
  var t = typeof n;
  return t == "object" && n != null || t == "function";
}
function pp(n, t, p) {
  return n.call.apply(n.bind, arguments);
}
function up(n, t, p) {
  if (!n)
    throw Error();
  if (2 < arguments.length) {
    var f = Array.prototype.slice.call(arguments, 2);
    return function() {
      var l = Array.prototype.slice.call(arguments);
      return Array.prototype.unshift.apply(l, f), n.apply(t, l);
    };
  }
  return function() {
    return n.apply(t, arguments);
  };
}
function Wt(n, t, p) {
  return Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? Wt = pp : Wt = up, Wt.apply(null, arguments);
}
function Yt(n, t) {
  function p() {
  }
  p.prototype = t.prototype, n.O = t.prototype, n.prototype = new p(), n.prototype.constructor = n;
}
function Ir(n) {
  this.a = n || {};
}
Ir.prototype.get = function(n) {
  return this.a[n];
};
Ir.prototype.G = function() {
  return Object.keys(this.a);
};
function pr(n, t, p, f) {
  this.f = n, this.c = t, this.b = p, this.a = f;
}
pr.prototype.getRequestMessage = function() {
  return this.f;
};
pr.prototype.getMethodDescriptor = function() {
  return this.c;
};
pr.prototype.getMetadata = function() {
  return this.b;
};
pr.prototype.getCallOptions = function() {
  return this.a;
};
function ur(n, t, p, f) {
  p = p === void 0 ? {} : p, this.c = n, this.a = p, this.b = t, this.f = f === void 0 ? null : f;
}
ur.prototype.getResponseMessage = function() {
  return this.c;
};
ur.prototype.getMetadata = function() {
  return this.a;
};
ur.prototype.getMethodDescriptor = function() {
  return this.b;
};
ur.prototype.getStatus = function() {
  return this.f;
};
function Tr(n, t, p, f, l, i) {
  this.name = n, this.a = l, this.b = i;
}
function Wo(n, t, p) {
  p = p === void 0 ? {} : p;
  var f = f === void 0 ? new Ir() : f;
  return new pr(t, n, p, f);
}
Tr.prototype.getName = function() {
  return this.name;
};
Tr.prototype.getName = Tr.prototype.getName;
function lp(n) {
  switch (n) {
    case 200:
      return 0;
    case 400:
      return 3;
    case 401:
      return 16;
    case 403:
      return 7;
    case 404:
      return 5;
    case 409:
      return 10;
    case 412:
      return 9;
    case 429:
      return 8;
    case 499:
      return 1;
    case 500:
      return 2;
    case 501:
      return 12;
    case 503:
      return 14;
    case 504:
      return 4;
    default:
      return 2;
  }
}
function cp(n) {
  switch (n) {
    case 0:
      return "OK";
    case 1:
      return "CANCELLED";
    case 2:
      return "UNKNOWN";
    case 3:
      return "INVALID_ARGUMENT";
    case 4:
      return "DEADLINE_EXCEEDED";
    case 5:
      return "NOT_FOUND";
    case 6:
      return "ALREADY_EXISTS";
    case 7:
      return "PERMISSION_DENIED";
    case 16:
      return "UNAUTHENTICATED";
    case 8:
      return "RESOURCE_EXHAUSTED";
    case 9:
      return "FAILED_PRECONDITION";
    case 10:
      return "ABORTED";
    case 11:
      return "OUT_OF_RANGE";
    case 12:
      return "UNIMPLEMENTED";
    case 13:
      return "INTERNAL";
    case 14:
      return "UNAVAILABLE";
    case 15:
      return "DATA_LOSS";
    default:
      return "";
  }
}
function ut(n, t, p) {
  p = p === void 0 ? {} : p, t = Error.call(this, t), this.message = t.message, "stack" in t && (this.stack = t.stack), this.code = n, this.metadata = p;
}
Ao(ut, Error);
ut.prototype.toString = function() {
  var n = "RpcError(" + (cp(this.code) || String(this.code)) + ")";
  return this.message && (n += ": " + this.message), n;
};
ut.prototype.name = "RpcError";
function Wr(n) {
  this.a = n;
}
Wr.prototype.on = function(n, t) {
  return n == "data" || n == "error" ? this : this.a.on(n, t);
};
Wr.prototype.removeListener = function(n, t) {
  return this.a.removeListener(n, t);
};
Wr.prototype.cancel = function() {
  this.a.cancel();
};
function fp(n) {
  switch (n) {
    case 0:
      return "No Error";
    case 1:
      return "Access denied to content document";
    case 2:
      return "File not found";
    case 3:
      return "Firefox silently errored";
    case 4:
      return "Application custom error";
    case 5:
      return "An exception occurred";
    case 6:
      return "Http response at 400 or 500 level";
    case 7:
      return "Request was aborted";
    case 8:
      return "Request timed out";
    case 9:
      return "The resource is not available offline";
    default:
      return "Unrecognized error code";
  }
}
function lr(n) {
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, lr);
  else {
    var t = Error().stack;
    t && (this.stack = t);
  }
  n && (this.message = String(n));
}
Yt(lr, Error);
lr.prototype.name = "CustomError";
function _o(n, t) {
  n = n.split("%s");
  for (var p = "", f = n.length - 1, l = 0; l < f; l++)
    p += n[l] + (l < t.length ? t[l] : "%s");
  lr.call(this, p + n[f]);
}
Yt(_o, lr);
_o.prototype.name = "AssertionError";
function yp(n, t) {
  throw new _o("Failure" + (n ? ": " + n : ""), Array.prototype.slice.call(arguments, 1));
}
function dp() {
  this.l = null, this.i = [], this.m = 0, this.b = So, this.f = this.a = this.h = 0, this.c = null, this.g = 0;
}
function hp(n, t) {
  function p(d) {
    d == wo || d == ir ? e.h = d : fn(e, r, s, "invalid frame byte"), e.b = ln, e.a = 0, e.f = 0;
  }
  function f(d) {
    e.f++, e.a = (e.a << 8) + d, e.f == 4 && (e.b = cn, e.g = 0, typeof Uint8Array < "u" ? e.c = new Uint8Array(e.a) : e.c = Array(e.a), e.a == 0 && i());
  }
  function l(d) {
    e.c[e.g++] = d, e.g == e.a && i();
  }
  function i() {
    var d = {};
    d[e.h] = e.c, e.i.push(d), e.b = So;
  }
  var e = n, r, s = 0;
  for (t instanceof Uint8Array || t instanceof Array ? r = t : r = new Uint8Array(t); s < r.length; ) {
    switch (e.b) {
      case Ka:
        fn(e, r, s, "stream already broken");
        break;
      case So:
        p(r[s]);
        break;
      case ln:
        f(r[s]);
        break;
      case cn:
        l(r[s]);
        break;
      default:
        throw Error("unexpected parser state: " + e.b);
    }
    e.m++, s++;
  }
  return n = e.i, e.i = [], 0 < n.length ? n : null;
}
var So = 0, ln = 1, cn = 2, Ka = 3, wo = 0, ir = 128;
function fn(n, t, p, f) {
  throw n.b = Ka, n.l = "The stream is broken @" + n.m + "/" + p + ". Error: " + f + `. With input:
` + t, Error(n.l);
}
var Ya = Array.prototype.indexOf ? function(n, t) {
  return Array.prototype.indexOf.call(n, t, void 0);
} : function(n, t) {
  if (typeof n == "string")
    return typeof t != "string" || t.length != 1 ? -1 : n.indexOf(t, 0);
  for (var p = 0; p < n.length; p++)
    if (p in n && n[p] === t)
      return p;
  return -1;
}, yn = String.prototype.trim ? function(n) {
  return n.trim();
} : function(n) {
  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(n)[1];
};
function Qe(n, t) {
  return n.indexOf(t) != -1;
}
function Jr(n, t) {
  return n < t ? -1 : n > t ? 1 : 0;
}
var He;
e: {
  var dn = Ze.navigator;
  if (dn) {
    var hn = dn.userAgent;
    if (hn) {
      He = hn;
      break e;
    }
  }
  He = "";
}
function gp(n, t) {
  for (var p in n)
    t.call(void 0, n[p], p, n);
}
function mp(n, t) {
  var p = {}, f;
  for (f in n)
    p[f] = t.call(void 0, n[f], f, n);
  return p;
}
var gn = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function vp(n, t) {
  for (var p, f, l = 1; l < arguments.length; l++) {
    f = arguments[l];
    for (p in f)
      n[p] = f[p];
    for (var i = 0; i < gn.length; i++)
      p = gn[i], Object.prototype.hasOwnProperty.call(f, p) && (n[p] = f[p]);
  }
}
function bp(n) {
  var t = 1;
  n = n.split(":");
  for (var p = []; 0 < t && n.length; )
    p.push(n.shift()), t--;
  return n.length && p.push(n.join(":")), p;
}
function Po(n) {
  return Po[" "](n), n;
}
Po[" "] = Br;
function Sp(n) {
  var t = Mp;
  return Object.prototype.hasOwnProperty.call(t, 9) ? t[9] : t[9] = n(9);
}
var wp = Qe(He, "Opera"), Ro = Qe(He, "Trident") || Qe(He, "MSIE"), Rp = Qe(He, "Edge"), Xa = Qe(He, "Gecko") && !(Qe(He.toLowerCase(), "webkit") && !Qe(He, "Edge")) && !(Qe(He, "Trident") || Qe(He, "MSIE")) && !Qe(He, "Edge"), Fp = Qe(He.toLowerCase(), "webkit") && !Qe(He, "Edge"), Fo;
e: {
  var Hr = "", Zr = function() {
    var n = He;
    if (Xa)
      return /rv:([^\);]+)(\)|;)/.exec(n);
    if (Rp)
      return /Edge\/([\d\.]+)/.exec(n);
    if (Ro)
      return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(n);
    if (Fp)
      return /WebKit\/(\S+)/.exec(n);
    if (wp)
      return /(?:Version)[ \/]?(\S+)/.exec(n);
  }();
  if (Zr && (Hr = Zr ? Zr[1] : ""), Ro) {
    var Rr, mn = Ze.document;
    if (Rr = mn ? mn.documentMode : void 0, Rr != null && Rr > parseFloat(Hr)) {
      Fo = String(Rr);
      break e;
    }
  }
  Fo = Hr;
}
var Mp = {};
function Ep() {
  return Sp(function() {
    for (var n = 0, t = yn(String(Fo)).split("."), p = yn("9").split("."), f = Math.max(t.length, p.length), l = 0; n == 0 && l < f; l++) {
      var i = t[l] || "", e = p[l] || "";
      do {
        if (i = /(\d*)(\D*)(.*)/.exec(i) || ["", "", "", ""], e = /(\d*)(\D*)(.*)/.exec(e) || ["", "", "", ""], i[0].length == 0 && e[0].length == 0)
          break;
        n = Jr(i[1].length == 0 ? 0 : parseInt(i[1], 10), e[1].length == 0 ? 0 : parseInt(e[1], 10)) || Jr(i[2].length == 0, e[2].length == 0) || Jr(i[2], e[2]), i = i[3], e = e[3];
      } while (n == 0);
    }
    return 0 <= n;
  });
}
function ko() {
  this.K = this.K;
}
ko.prototype.K = !1;
var Bp = Object.freeze || function(n) {
  return n;
};
function qt(n, t) {
  this.type = n, this.a = this.target = t, this.defaultPrevented = !1;
}
qt.prototype.b = function() {
  this.defaultPrevented = !0;
};
var Tp = function() {
  if (!Ze.addEventListener || !Object.defineProperty)
    return !1;
  var n = !1, t = Object.defineProperty({}, "passive", { get: function() {
    n = !0;
  } });
  try {
    Ze.addEventListener("test", Br, t), Ze.removeEventListener("test", Br, t);
  } catch {
  }
  return n;
}();
function nr(n, t) {
  if (qt.call(this, n ? n.type : ""), this.relatedTarget = this.a = this.target = null, this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0, this.key = "", this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1, this.pointerId = 0, this.pointerType = "", this.c = null, n) {
    var p = this.type = n.type, f = n.changedTouches && n.changedTouches.length ? n.changedTouches[0] : null;
    if (this.target = n.target || n.srcElement, this.a = t, t = n.relatedTarget) {
      if (Xa) {
        e: {
          try {
            Po(t.nodeName);
            var l = !0;
            break e;
          } catch {
          }
          l = !1;
        }
        l || (t = null);
      }
    } else
      p == "mouseover" ? t = n.fromElement : p == "mouseout" && (t = n.toElement);
    this.relatedTarget = t, f ? (this.clientX = f.clientX !== void 0 ? f.clientX : f.pageX, this.clientY = f.clientY !== void 0 ? f.clientY : f.pageY, this.screenX = f.screenX || 0, this.screenY = f.screenY || 0) : (this.clientX = n.clientX !== void 0 ? n.clientX : n.pageX, this.clientY = n.clientY !== void 0 ? n.clientY : n.pageY, this.screenX = n.screenX || 0, this.screenY = n.screenY || 0), this.button = n.button, this.key = n.key || "", this.ctrlKey = n.ctrlKey, this.altKey = n.altKey, this.shiftKey = n.shiftKey, this.metaKey = n.metaKey, this.pointerId = n.pointerId || 0, this.pointerType = typeof n.pointerType == "string" ? n.pointerType : Dp[n.pointerType] || "", this.c = n, n.defaultPrevented && nr.O.b.call(this);
  }
}
Yt(nr, qt);
var Dp = Bp({ 2: "touch", 3: "pen", 4: "mouse" });
nr.prototype.b = function() {
  nr.O.b.call(this);
  var n = this.c;
  n.preventDefault ? n.preventDefault() : n.returnValue = !1;
};
var cr = "closure_listenable_" + (1e6 * Math.random() | 0), Op = 0;
function Lp(n, t, p, f, l) {
  this.listener = n, this.proxy = null, this.src = t, this.type = p, this.capture = !!f, this.H = l, this.key = ++Op, this.A = this.D = !1;
}
function Co(n) {
  n.A = !0, n.listener = null, n.proxy = null, n.src = null, n.H = null;
}
function fr(n) {
  this.src = n, this.a = {}, this.b = 0;
}
fr.prototype.add = function(n, t, p, f, l) {
  var i = n.toString();
  n = this.a[i], n || (n = this.a[i] = [], this.b++);
  var e = jo(n, t, f, l);
  return -1 < e ? (t = n[e], p || (t.D = !1)) : (t = new Lp(t, this.src, i, !!f, l), t.D = p, n.push(t)), t;
};
fr.prototype.remove = function(n, t, p, f) {
  if (n = n.toString(), !(n in this.a))
    return !1;
  var l = this.a[n];
  return t = jo(l, t, p, f), -1 < t ? (Co(l[t]), Array.prototype.splice.call(l, t, 1), l.length == 0 && (delete this.a[n], this.b--), !0) : !1;
};
function Mo(n, t) {
  var p = t.type;
  if (p in n.a) {
    var f = n.a[p], l = Ya(f, t), i;
    (i = 0 <= l) && Array.prototype.splice.call(f, l, 1), i && (Co(t), n.a[p].length == 0 && (delete n.a[p], n.b--));
  }
}
function jo(n, t, p, f) {
  for (var l = 0; l < n.length; ++l) {
    var i = n[l];
    if (!i.A && i.listener == t && i.capture == !!p && i.H == f)
      return l;
  }
  return -1;
}
var zo = "closure_lm_" + (1e6 * Math.random() | 0), Kr = {};
function Dr(n, t, p, f, l) {
  if (f && f.once)
    es(n, t, p, f, l);
  else if (Array.isArray(t))
    for (var i = 0; i < t.length; i++)
      Dr(n, t[i], p, f, l);
  else
    p = No(p), n && n[cr] ? n.f.add(String(t), p, !1, Ar(f) ? !!f.capture : !!f, l) : Qa(n, t, p, !1, f, l);
}
function Qa(n, t, p, f, l, i) {
  if (!t)
    throw Error("Invalid event type");
  var e = Ar(l) ? !!l.capture : !!l, r = xo(n);
  if (r || (n[zo] = r = new fr(n)), p = r.add(t, p, f, e, i), !p.proxy)
    if (f = Ap(), p.proxy = f, f.src = n, f.listener = p, n.addEventListener)
      Tp || (l = e), l === void 0 && (l = !1), n.addEventListener(t.toString(), f, l);
    else if (n.attachEvent)
      n.attachEvent(is(t.toString()), f);
    else if (n.addListener && n.removeListener)
      n.addListener(f);
    else
      throw Error("addEventListener and attachEvent are unavailable.");
}
function Ap() {
  function n(p) {
    return t.call(n.src, n.listener, p);
  }
  var t = Ip;
  return n;
}
function es(n, t, p, f, l) {
  if (Array.isArray(t))
    for (var i = 0; i < t.length; i++)
      es(n, t[i], p, f, l);
  else
    p = No(p), n && n[cr] ? n.f.add(String(t), p, !0, Ar(f) ? !!f.capture : !!f, l) : Qa(n, t, p, !0, f, l);
}
function ts(n, t, p, f, l) {
  if (Array.isArray(t))
    for (var i = 0; i < t.length; i++)
      ts(n, t[i], p, f, l);
  else
    f = Ar(f) ? !!f.capture : !!f, p = No(p), n && n[cr] ? n.f.remove(String(t), p, f, l) : n && (n = xo(n)) && (t = n.a[t.toString()], n = -1, t && (n = jo(t, p, f, l)), (p = -1 < n ? t[n] : null) && rs(p));
}
function rs(n) {
  if (typeof n != "number" && n && !n.A) {
    var t = n.src;
    if (t && t[cr])
      Mo(t.f, n);
    else {
      var p = n.type, f = n.proxy;
      t.removeEventListener ? t.removeEventListener(p, f, n.capture) : t.detachEvent ? t.detachEvent(is(p), f) : t.addListener && t.removeListener && t.removeListener(f), (p = xo(t)) ? (Mo(p, n), p.b == 0 && (p.src = null, t[zo] = null)) : Co(n);
    }
  }
}
function is(n) {
  return n in Kr ? Kr[n] : Kr[n] = "on" + n;
}
function Ip(n, t) {
  if (n.A)
    n = !0;
  else {
    t = new nr(t, this);
    var p = n.listener, f = n.H || n.src;
    n.D && rs(n), n = p.call(f, t);
  }
  return n;
}
function xo(n) {
  return n = n[zo], n instanceof fr ? n : null;
}
var Yr = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
function No(n) {
  return typeof n == "function" ? n : (n[Yr] || (n[Yr] = function(t) {
    return n.handleEvent(t);
  }), n[Yr]);
}
function Xt() {
  ko.call(this), this.f = new fr(this), this.U = this;
}
Yt(Xt, ko);
Xt.prototype[cr] = !0;
Xt.prototype.addEventListener = function(n, t, p, f) {
  Dr(this, n, t, p, f);
};
Xt.prototype.removeEventListener = function(n, t, p, f) {
  ts(this, n, t, p, f);
};
function wt(n, t) {
  n = n.U;
  var p = t.type || t;
  if (typeof t == "string")
    t = new qt(t, n);
  else if (t instanceof qt)
    t.target = t.target || n;
  else {
    var f = t;
    t = new qt(p, n), vp(t, f);
  }
  n = t.a = n, vn(n, p, !0, t), vn(n, p, !1, t);
}
function vn(n, t, p, f) {
  if (t = n.f.a[String(t)]) {
    t = t.concat();
    for (var l = !0, i = 0; i < t.length; ++i) {
      var e = t[i];
      if (e && !e.A && e.capture == p) {
        var r = e.listener, s = e.H || e.src;
        e.D && Mo(n.f, e), l = r.call(s, f) !== !1 && l;
      }
    }
  }
}
var Uo = Ze;
function os(n, t, p) {
  if (typeof n == "function")
    p && (n = Wt(n, p));
  else if (n && typeof n.handleEvent == "function")
    n = Wt(n.handleEvent, n);
  else
    throw Error("Invalid listener argument");
  return 2147483647 < Number(t) ? -1 : Uo.setTimeout(n, t || 0);
}
function yr(n, t) {
  this.name = n, this.value = t;
}
yr.prototype.toString = function() {
  return this.name;
};
var Or = new yr("OFF", 1 / 0), ns = new yr("SEVERE", 1e3), Wp = new yr("CONFIG", 700), _p = new yr("FINE", 500);
function as() {
  this.clear();
}
var bn;
as.prototype.clear = function() {
};
function ss(n, t, p) {
  this.reset(n || Or, t, p, void 0, void 0);
}
ss.prototype.reset = function() {
};
function ps(n, t) {
  this.a = null, this.f = [], this.b = (t === void 0 ? null : t) || null, this.c = [], this.g = { getName: function() {
    return n;
  } };
}
function us(n) {
  return n.a ? n.a : n.b ? us(n.b) : (yp("Root logger has no level set."), Or);
}
function Pp(n, t) {
  for (; n; )
    n.f.forEach(function(p) {
      p(t);
    }), n = n.b;
}
function kp() {
  this.entries = {};
  var n = new ps("");
  n.a = Wp, this.entries[""] = n;
}
var Xr;
function Lr(n, t, p) {
  var f = n.entries[t];
  if (f)
    return p !== void 0 && (f.a = p), f;
  f = Lr(n, t.substr(0, t.lastIndexOf(".")));
  var l = new ps(t, f);
  return n.entries[t] = l, f.c.push(l), p !== void 0 && (l.a = p), l;
}
function Eo() {
  return Xr || (Xr = new kp()), Xr;
}
function qo(n, t, p) {
  var f;
  if ((f = n) && (f = n && t)) {
    f = t.value;
    var l = n ? us(Lr(Eo(), n.getName())) : Or;
    f = f >= l.value;
  }
  f && (t = t || Or, f = Lr(Eo(), n.getName()), typeof p == "function" && (p = p()), bn || (bn = new as()), n = n.getName(), n = new ss(t, p, n), Pp(f, n));
}
function ot(n, t) {
  n && qo(n, _p, t);
}
function ls() {
}
ls.prototype.a = null;
function Sn(n) {
  var t;
  return (t = n.a) || (t = {}, fs(n) && (t[0] = !0, t[1] = !0), t = n.a = t), t;
}
var Bo;
function cs() {
}
Yt(cs, ls);
function wn(n) {
  return (n = fs(n)) ? new ActiveXObject(n) : new XMLHttpRequest();
}
function fs(n) {
  if (!n.b && typeof XMLHttpRequest > "u" && typeof ActiveXObject < "u") {
    for (var t = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], p = 0; p < t.length; p++) {
      var f = t[p];
      try {
        return new ActiveXObject(f), n.b = f;
      } catch {
      }
    }
    throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
  }
  return n.b;
}
Bo = new cs();
Rt();
yt();
function Go(n, t) {
  this.b = n[Ze.Symbol.iterator](), this.c = t, this.f = 0;
}
Go.prototype[Symbol.iterator] = function() {
  return this;
};
Go.prototype.next = function() {
  var n = this.b.next();
  return { value: n.done ? void 0 : this.c.call(void 0, n.value, this.f++), done: n.done };
};
function Cp(n, t) {
  return new Go(n, t);
}
Rt();
yt();
Rt();
yt();
var _r = "StopIteration" in Ze ? Ze.StopIteration : { message: "StopIteration", stack: "" };
function _t() {
}
_t.prototype.next = function() {
  return _t.prototype.a.call(this);
};
_t.prototype.a = function() {
  throw _r;
};
_t.prototype.u = function() {
  return this;
};
function ys(n) {
  if (n instanceof bt || n instanceof Bt || n instanceof Ct)
    return n;
  if (typeof n.next == "function")
    return new bt(function() {
      return Rn(n);
    });
  if (Rt(), yt(), typeof n[Symbol.iterator] == "function")
    return Rt(), yt(), new bt(function() {
      return n[Symbol.iterator]();
    });
  if (typeof n.u == "function")
    return new bt(function() {
      return Rn(n.u());
    });
  throw Error("Not an iterator or iterable.");
}
function Rn(n) {
  if (!(n instanceof _t))
    return n;
  var t = !1;
  return { next: function() {
    for (var p; !t; )
      try {
        p = n.a();
        break;
      } catch (f) {
        if (f !== _r)
          throw f;
        t = !0;
      }
    return { value: p, done: t };
  } };
}
Rt();
yt();
function bt(n) {
  this.b = n;
}
bt.prototype.u = function() {
  return new Bt(this.b());
};
bt.prototype[Symbol.iterator] = function() {
  return new Ct(this.b());
};
bt.prototype.c = function() {
  return new Ct(this.b());
};
Rt();
yt();
function Bt(n) {
  this.b = n;
}
Ao(Bt, _t);
Bt.prototype.a = function() {
  var n = this.b.next();
  if (n.done)
    throw _r;
  return n.value;
};
Bt.prototype.next = function() {
  return Bt.prototype.a.call(this);
};
Bt.prototype[Symbol.iterator] = function() {
  return new Ct(this.b);
};
Bt.prototype.c = function() {
  return new Ct(this.b);
};
function Ct(n) {
  bt.call(this, function() {
    return n;
  }), this.f = n;
}
Ao(Ct, bt);
Ct.prototype.next = function() {
  return this.f.next();
};
function Pr(n, t) {
  this.o = {}, this.j = [], this.B = this.size = 0;
  var p = arguments.length;
  if (1 < p) {
    if (p % 2)
      throw Error("Uneven number of arguments");
    for (var f = 0; f < p; f += 2)
      this.set(arguments[f], arguments[f + 1]);
  } else
    n && this.addAll(n);
}
Pe = Pr.prototype;
Pe.G = function() {
  return Vo(this), this.j.concat();
};
Pe.has = function(n) {
  return $t(this.o, n);
};
Pe.clear = function() {
  this.o = {}, this.B = this.size = this.j.length = 0;
};
Pe.remove = function(n) {
  return this.delete(n);
};
Pe.delete = function(n) {
  return $t(this.o, n) ? (delete this.o[n], --this.size, this.B++, this.j.length > 2 * this.size && Vo(this), !0) : !1;
};
function Vo(n) {
  if (n.size != n.j.length) {
    for (var t = 0, p = 0; t < n.j.length; ) {
      var f = n.j[t];
      $t(n.o, f) && (n.j[p++] = f), t++;
    }
    n.j.length = p;
  }
  if (n.size != n.j.length) {
    var l = {};
    for (p = t = 0; t < n.j.length; )
      f = n.j[t], $t(l, f) || (n.j[p++] = f, l[f] = 1), t++;
    n.j.length = p;
  }
}
Pe.get = function(n, t) {
  return $t(this.o, n) ? this.o[n] : t;
};
Pe.set = function(n, t) {
  $t(this.o, n) || (this.size += 1, this.j.push(n), this.B++), this.o[n] = t;
};
Pe.addAll = function(n) {
  if (n instanceof Pr)
    for (var t = n.G(), p = 0; p < t.length; p++)
      this.set(t[p], n.get(t[p]));
  else
    for (t in n)
      this.set(t, n[t]);
};
Pe.forEach = function(n, t) {
  for (var p = this.G(), f = 0; f < p.length; f++) {
    var l = p[f], i = this.get(l);
    n.call(t, i, l, this);
  }
};
Pe.clone = function() {
  return new Pr(this);
};
Pe.keys = function() {
  return ys(this.u(!0)).c();
};
Pe.values = function() {
  return ys(this.u(!1)).c();
};
Pe.entries = function() {
  var n = this;
  return Cp(this.keys(), function(t) {
    return [t, n.get(t)];
  });
};
Pe.u = function(n) {
  Vo(this);
  var t = 0, p = this.B, f = this, l = new _t();
  return l.a = function() {
    if (p != f.B)
      throw Error("The map has changed since the iterator was created");
    if (t >= f.j.length)
      throw _r;
    var i = f.j[t++];
    return n ? i : f.o[i];
  }, l.next = l.a.bind(l), l;
};
function $t(n, t) {
  return Object.prototype.hasOwnProperty.call(n, t);
}
var jp = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function kr(n) {
  Xt.call(this), this.headers = new Pr(), this.C = n || null, this.c = !1, this.J = this.a = null, this.P = this.v = "", this.g = 0, this.l = "", this.i = this.N = this.s = this.L = !1, this.h = 0, this.w = null, this.m = ds, this.I = this.M = !1;
}
Yt(kr, Xt);
var ds = "";
kr.prototype.b = Lr(Eo(), "goog.net.XhrIo", void 0).g;
var zp = /^https?$/i, xp = ["POST", "PUT"];
function Np(n, t, p) {
  if (n.a)
    throw Error("[goog.net.XhrIo] Object is active with another request=" + n.v + "; newUri=" + t);
  n.v = t, n.l = "", n.g = 0, n.P = "POST", n.L = !1, n.c = !0, n.a = n.C ? wn(n.C) : wn(Bo), n.J = n.C ? Sn(n.C) : Sn(Bo), n.a.onreadystatechange = Wt(n.R, n);
  try {
    ot(n.b, vt(n, "Opening Xhr")), n.N = !0, n.a.open("POST", String(t), !0), n.N = !1;
  } catch (i) {
    ot(n.b, vt(n, "Error opening Xhr: " + i.message)), Fn(n, i);
    return;
  }
  t = p || "", p = n.headers.clone();
  var f = p.G().find(function(i) {
    return i.toLowerCase() == "content-type";
  }), l = Ze.FormData && t instanceof Ze.FormData;
  !(0 <= Ya(xp, "POST")) || f || l || p.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"), p.forEach(function(i, e) {
    this.a.setRequestHeader(e, i);
  }, n), n.m && (n.a.responseType = n.m), "withCredentials" in n.a && n.a.withCredentials !== n.M && (n.a.withCredentials = n.M);
  try {
    ms(n), 0 < n.h && (n.I = Up(n.a), ot(n.b, vt(n, "Will abort after " + n.h + "ms if incomplete, xhr2 " + n.I)), n.I ? (n.a.timeout = n.h, n.a.ontimeout = Wt(n.T, n)) : n.w = os(n.T, n.h, n)), ot(n.b, vt(n, "Sending request")), n.s = !0, n.a.send(t), n.s = !1;
  } catch (i) {
    ot(
      n.b,
      vt(n, "Send error: " + i.message)
    ), Fn(n, i);
  }
}
function Up(n) {
  return Ro && Ep() && typeof n.timeout == "number" && n.ontimeout !== void 0;
}
Pe = kr.prototype;
Pe.T = function() {
  typeof Io < "u" && this.a && (this.l = "Timed out after " + this.h + "ms, aborting", this.g = 8, ot(this.b, vt(this, this.l)), wt(this, "timeout"), this.abort(8));
};
function Fn(n, t) {
  n.c = !1, n.a && (n.i = !0, n.a.abort(), n.i = !1), n.l = t, n.g = 5, hs(n), $o(n);
}
function hs(n) {
  n.L || (n.L = !0, wt(n, "complete"), wt(n, "error"));
}
Pe.abort = function(n) {
  this.a && this.c && (ot(this.b, vt(this, "Aborting")), this.c = !1, this.i = !0, this.a.abort(), this.i = !1, this.g = n || 7, wt(this, "complete"), wt(this, "abort"), $o(this));
};
Pe.R = function() {
  this.K || (this.N || this.s || this.i ? gs(this) : this.W());
};
Pe.W = function() {
  gs(this);
};
function gs(n) {
  if (n.c && typeof Io < "u") {
    if (n.J[1] && Ut(n) == 4 && n.getStatus() == 2)
      ot(n.b, vt(n, "Local request error detected and ignored"));
    else if (n.s && Ut(n) == 4)
      os(n.R, 0, n);
    else if (wt(n, "readystatechange"), Ut(n) == 4) {
      ot(n.b, vt(n, "Request complete")), n.c = !1;
      try {
        var t = n.getStatus();
        e:
          switch (t) {
            case 200:
            case 201:
            case 202:
            case 204:
            case 206:
            case 304:
            case 1223:
              var p = !0;
              break e;
            default:
              p = !1;
          }
        var f;
        if (!(f = p)) {
          var l;
          if (l = t === 0) {
            var i = String(n.v).match(jp)[1] || null;
            if (!i && Ze.self && Ze.self.location) {
              var e = Ze.self.location.protocol;
              i = e.substr(0, e.length - 1);
            }
            l = !zp.test(i ? i.toLowerCase() : "");
          }
          f = l;
        }
        if (f)
          wt(n, "complete"), wt(n, "success");
        else {
          n.g = 6;
          try {
            var r = 2 < Ut(n) ? n.a.statusText : "";
          } catch (s) {
            ot(n.b, "Can not get status: " + s.message), r = "";
          }
          n.l = r + " [" + n.getStatus() + "]", hs(n);
        }
      } finally {
        $o(n);
      }
    }
  }
}
function $o(n) {
  if (n.a) {
    ms(n);
    var t = n.a, p = n.J[0] ? Br : null;
    n.a = null, n.J = null, wt(n, "ready");
    try {
      t.onreadystatechange = p;
    } catch (f) {
      (n = n.b) && qo(n, ns, "Problem encountered resetting onreadystatechange: " + f.message);
    }
  }
}
function ms(n) {
  n.a && n.I && (n.a.ontimeout = null), n.w && (Uo.clearTimeout(n.w), n.w = null);
}
function Ut(n) {
  return n.a ? n.a.readyState : 0;
}
Pe.getStatus = function() {
  try {
    return 2 < Ut(this) ? this.a.status : -1;
  } catch {
    return -1;
  }
};
function qp(n) {
  try {
    if (!n.a)
      return null;
    if ("response" in n.a)
      return n.a.response;
    switch (n.m) {
      case ds:
      case "text":
        return n.a.responseText;
      case "arraybuffer":
        if ("mozResponseArrayBuffer" in n.a)
          return n.a.mozResponseArrayBuffer;
    }
    var t = n.b;
    return t && qo(t, ns, "Response type " + n.m + " is not supported on this browser"), null;
  } catch (p) {
    return ot(n.b, "Can not get response: " + p.message), null;
  }
}
function Gp(n) {
  var t = {};
  n = (n.a && Ut(n) == 4 && n.a.getAllResponseHeaders() || "").split(`\r
`);
  for (var p = 0; p < n.length; p++)
    if (!/^[\s\xa0]*$/.test(n[p])) {
      var f = bp(n[p]), l = f[0];
      if (f = f[1], typeof f == "string") {
        f = f.trim();
        var i = t[l] || [];
        t[l] = i, i.push(f);
      }
    }
  return mp(t, function(e) {
    return e.join(", ");
  });
}
function vt(n, t) {
  return t + " [" + n.P + " " + n.v + " " + n.getStatus() + "]";
}
var vs = {}, or = null;
function Vp(n) {
  var t = n.length, p = 3 * t / 4;
  p % 3 ? p = Math.floor(p) : Qe("=.", n[t - 1]) && (p = Qe("=.", n[t - 2]) ? p - 2 : p - 1);
  var f = new Uint8Array(p), l = 0;
  return $p(n, function(i) {
    f[l++] = i;
  }), f.subarray(0, l);
}
function $p(n, t) {
  function p(s) {
    for (; f < n.length; ) {
      var d = n.charAt(f++), A = or[d];
      if (A != null)
        return A;
      if (!/^[\s\xa0]*$/.test(d))
        throw Error("Unknown base64 encoding at char: " + d);
    }
    return s;
  }
  bs();
  for (var f = 0; ; ) {
    var l = p(-1), i = p(0), e = p(64), r = p(64);
    if (r === 64 && l === -1)
      break;
    t(l << 2 | i >> 4), e != 64 && (t(i << 4 & 240 | e >> 2), r != 64 && t(e << 6 & 192 | r));
  }
}
function bs() {
  if (!or) {
    or = {};
    for (var n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), t = ["+/=", "+/", "-_=", "-_.", "-_"], p = 0; 5 > p; p++) {
      var f = n.concat(t[p].split(""));
      vs[p] = f;
      for (var l = 0; l < f.length; l++) {
        var i = f[l];
        or[i] === void 0 && (or[i] = l);
      }
    }
  }
}
var Jp = ["content-type", "grpc-status", "grpc-message"];
function dt(n) {
  this.a = n.Z, this.m = null, this.b = [], this.h = [], this.g = [], this.f = [], this.c = [], this.l = !1, this.i = 0, this.s = new dp();
  var t = this;
  Dr(this.a, "readystatechange", function() {
    var p = t.a;
    if (p = p.a ? p.a.getResponseHeader("Content-Type") : null) {
      if (p = p.toLowerCase(), p.lastIndexOf("application/grpc-web-text", 0) == 0) {
        p = t.a;
        try {
          var f = p.a ? p.a.responseText : "";
        } catch (s) {
          ot(p.b, "Can not get responseText: " + s.message), f = "";
        }
        if (p = f || "", f = p.length - p.length % 4, p = p.substr(t.i, f - t.i), p.length == 0)
          return;
        t.i = f, p = Vp(p);
      } else if (p.lastIndexOf("application/grpc", 0) == 0)
        p = new Uint8Array(qp(t.a));
      else {
        Nt(t, new ut(2, "Unknown Content-type received."));
        return;
      }
      f = null;
      try {
        f = hp(t.s, p);
      } catch {
        Nt(t, new ut(2, "Error in parsing response body"));
      }
      if (f)
        for (p = 0; p < f.length; p++) {
          if (wo in f[p]) {
            var l = f[p][wo];
            if (l) {
              var i = !1, e = void 0;
              try {
                e = t.m(l), i = !0;
              } catch (s) {
                Nt(t, new ut(13, "Error when deserializing response data; error: " + s + (", response: " + e)));
              }
              if (i)
                for (l = e, i = 0; i < t.b.length; i++)
                  t.b[i](l);
            }
          }
          if (ir in f[p] && 0 < f[p][ir].length) {
            for (l = "", i = 0; i < f[p][ir].length; i++)
              l += String.fromCharCode(f[p][ir][i]);
            for (l = l.trim().split(`\r
`), i = {}, e = 0; e < l.length; e++) {
              var r = l[e].indexOf(":");
              i[l[e].substring(0, r).trim()] = l[e].substring(r + 1).trim();
            }
            l = i, i = 0, e = "", "grpc-status" in l && (i = Number(l["grpc-status"]), delete l["grpc-status"]), "grpc-message" in l && (e = l["grpc-message"], delete l["grpc-message"]), Nt(t, new ut(i, e, l));
          }
        }
    }
  }), Dr(this.a, "complete", function() {
    var p = t.a.g, f = 2, l = "", i = {};
    f = Gp(t.a);
    var e = {};
    for (r in f)
      f.hasOwnProperty(r) && (e[r.toLowerCase()] = f[r]);
    Object.keys(e).forEach(function(s) {
      Jp.includes(s) || (i[s] = e[s]);
    }), Hp(t, i);
    var r = -1;
    if (p != 0) {
      switch (p) {
        case 7:
          f = 10;
          break;
        case 8:
          f = 4;
          break;
        case 6:
          r = t.a.getStatus(), f = lp(r);
          break;
        default:
          f = 14;
      }
      f == 10 && t.l || (l = fp(p), r != -1 && (l += ", http status code: " + r), Nt(t, new ut(f, l)));
    } else
      p = !1, "grpc-status" in e && (f = Number(e["grpc-status"]), "grpc-message" in e && (l = e["grpc-message"]), f != 0 && (Nt(t, new ut(f, l || "", e)), p = !0)), p || Zp(t);
  });
}
dt.prototype.on = function(n, t) {
  return n == "data" ? this.b.push(t) : n == "status" ? this.h.push(t) : n == "metadata" ? this.g.push(t) : n == "end" ? this.c.push(t) : n == "error" && this.f.push(t), this;
};
function rr(n, t) {
  t = n.indexOf(t), -1 < t && n.splice(t, 1);
}
dt.prototype.removeListener = function(n, t) {
  return n == "data" ? rr(this.b, t) : n == "status" ? rr(this.h, t) : n == "metadata" ? rr(this.g, t) : n == "end" ? rr(this.c, t) : n == "error" && rr(this.f, t), this;
};
dt.prototype.cancel = function() {
  this.l = !0, this.a.abort();
};
function Nt(n, t) {
  if (t.code != 0)
    for (var p = new ut(t.code, decodeURIComponent(t.message || ""), t.metadata), f = 0; f < n.f.length; f++)
      n.f[f](p);
  for (t = { code: t.code, details: decodeURIComponent(t.message || ""), metadata: t.metadata }, p = 0; p < n.h.length; p++)
    n.h[p](t);
}
function Hp(n, t) {
  for (var p = 0; p < n.g.length; p++)
    n.g[p](t);
}
function Zp(n) {
  for (var t = 0; t < n.c.length; t++)
    n.c[t]();
}
dt.prototype.cancel = dt.prototype.cancel;
dt.prototype.removeListener = dt.prototype.removeListener;
dt.prototype.on = dt.prototype.on;
function Kp(n) {
  var t = "";
  return gp(n, function(p, f) {
    t += f, t += ":", t += p, t += `\r
`;
  }), t;
}
function et(n, t) {
  n = n === void 0 ? {} : n, this.a = n.format || tr("format", n) || "text", this.g = n.aa || tr("suppressCorsPreflight", n) || !1, this.f = n.withCredentials || tr("withCredentials", n) || !1, this.b = n.$ || tr("streamInterceptors", n) || [], this.h = n.ba || tr("unaryInterceptors", n) || [], this.c = t || null;
}
et.prototype.X = function(n, t, p, f, l) {
  var i = this, e = n.substr(0, n.length - f.name.length);
  return n = Ho(function(r) {
    return Jo(i, r, e);
  }, this.b).call(this, Wo(f, t, p)), Ss(n, l, !1), new Wr(n);
};
et.prototype.S = function(n, t, p, f) {
  var l = this, i = n.substr(0, n.length - f.name.length);
  return Ho(function(e) {
    return new Promise(function(r, s) {
      var d = Jo(l, e, i), A, _, M;
      Ss(d, function(X, V, H, x, E) {
        X ? s(X) : E ? M = V : H ? _ = H : x ? A = x : (X = e.getMethodDescriptor(), V = A, V = V === void 0 ? {} : V, r(new ur(M, X, V, _ === void 0 ? null : _)));
      }, !0);
    });
  }, this.h).call(this, Wo(f, t, p)).then(function(e) {
    return e.getResponseMessage();
  });
};
et.prototype.unaryCall = function(n, t, p, f) {
  return this.S(n, t, p, f);
};
et.prototype.Y = function(n, t, p, f) {
  var l = this, i = n.substr(0, n.length - f.name.length);
  return Ho(function(e) {
    return Jo(l, e, i);
  }, this.b).call(this, Wo(f, t, p));
};
function Jo(n, t, p) {
  var f = t.getMethodDescriptor(), l = p + f.getName();
  p = n.c ? n.c : new kr(), p.M = n.f;
  var i = new dt({ Z: p });
  i.m = f.b;
  var e = t.getMetadata();
  for (r in e)
    p.headers.set(r, e[r]);
  if (n.a == "text" ? (p.headers.set("Content-Type", "application/grpc-web-text"), p.headers.set("Accept", "application/grpc-web-text")) : p.headers.set("Content-Type", "application/grpc-web+proto"), p.headers.set("X-User-Agent", "grpc-web-javascript/0.1"), p.headers.set("X-Grpc-Web", "1"), p.headers.has("deadline")) {
    var r = Number(p.headers.get("deadline"));
    r = Math.ceil(r - (/* @__PURE__ */ new Date()).getTime()), p.headers.delete("deadline"), r === 1 / 0 && (r = 0), 0 < r && (p.headers.set("grpc-timeout", r + "m"), p.h = Math.max(0, Math.max(1e3, Math.ceil(1.1 * r))));
  }
  if (n.g) {
    e = p.headers, r = {};
    for (var s = vo(e.keys()), d = s.next(); !d.done; d = s.next())
      d = d.value, r[d] = e.get(d);
    p.headers.clear();
    e: {
      for (A in r) {
        var A = !1;
        break e;
      }
      A = !0;
    }
    A || (r = Kp(r), typeof l == "string" ? (A = encodeURIComponent("$httpHeaders"), r = r != null ? "=" + encodeURIComponent(String(r)) : "", (A += r) && (r = l.indexOf("#"), 0 > r && (r = l.length), e = l.indexOf("?"), 0 > e || e > r ? (e = r, s = "") : s = l.substring(e + 1, r), l = [l.substr(0, e), s, l.substr(r)], r = l[1], l[1] = A ? r ? r + "&" + A : A : r, l = l[0] + (l[1] ? "?" + l[1] : "") + l[2])) : l.a("$httpHeaders", r));
  }
  for (t = (0, f.a)(t.getRequestMessage()), f = t.length, A = [0, 0, 0, 0], r = new Uint8Array(5 + f), e = 3; 0 <= e; e--)
    A[e] = f % 256, f >>>= 8;
  if (r.set(new Uint8Array(A), 1), r.set(t, 5), t = r, n.a == "text") {
    n = t;
    var _;
    for (_ === void 0 && (_ = 0), bs(), _ = vs[_], t = Array(Math.floor(n.length / 3)), f = _[64] || "", A = r = 0; r < n.length - 2; r += 3) {
      d = n[r];
      var M = n[r + 1];
      s = n[r + 2], e = _[d >> 2], d = _[(d & 3) << 4 | M >> 4], M = _[(M & 15) << 2 | s >> 6], s = _[s & 63], t[A++] = e + d + M + s;
    }
    switch (e = 0, s = f, n.length - r) {
      case 2:
        e = n[r + 1], s = _[(e & 15) << 2] || f;
      case 1:
        n = n[r], t[A] = _[n >> 2] + _[(n & 3) << 4 | e >> 4] + s + f;
    }
    t = t.join("");
  } else
    n.a == "binary" && (p.m = "arraybuffer");
  return Np(p, l, t), i;
}
function Ss(n, t, p) {
  var f = !1, l = null, i = !1;
  n.on("data", function(e) {
    f = !0, l = e;
  }), n.on("error", function(e) {
    e.code == 0 || i || (i = !0, t(e, null));
  }), n.on("status", function(e) {
    e.code == 0 || i ? p && t(null, null, e) : (i = !0, t({ code: e.code, message: e.details, metadata: e.metadata }, null));
  }), p && n.on("metadata", function(e) {
    t(null, null, null, e);
  }), n.on("end", function() {
    i || (f ? p ? t(null, l, null, null, !0) : t(null, l) : t({ code: 2, message: "Incomplete response" })), p && t(null, null);
  });
}
function Ho(n, t) {
  var p = n;
  return t.forEach(function(f) {
    var l = p;
    p = function(i) {
      return f.intercept(i, l);
    };
  }), p;
}
et.prototype.serverStreaming = et.prototype.Y;
et.prototype.unaryCall = et.prototype.unaryCall;
et.prototype.thenableCall = et.prototype.S;
et.prototype.rpcCall = et.prototype.X;
Tt.CallOptions = Ir;
Tt.MethodDescriptor = Tr;
Tt.GrpcWebClientBase = et;
Tt.RpcError = ut;
var Mn = Tt.StatusCode = { OK: 0, CANCELLED: 1, UNKNOWN: 2, INVALID_ARGUMENT: 3, DEADLINE_EXCEEDED: 4, NOT_FOUND: 5, ALREADY_EXISTS: 6, PERMISSION_DENIED: 7, UNAUTHENTICATED: 16, RESOURCE_EXHAUSTED: 8, FAILED_PRECONDITION: 9, ABORTED: 10, OUT_OF_RANGE: 11, UNIMPLEMENTED: 12, INTERNAL: 13, UNAVAILABLE: 14, DATA_LOSS: 15 };
Tt.MethodType = { UNARY: "unary", SERVER_STREAMING: "server_streaming", BIDI_STREAMING: "bidi_streaming" };
Uo = typeof globalThis < "u" && globalThis || self;
const Pt = {};
Pt.web = Tt;
const Ke = {};
Ke.priority = {};
Ke.priority.geoservice = pt;
Ke.priority.geoservice.GeocodeClient = function(n, t, p) {
  p || (p = {}), p.format = "text", this.client_ = new Pt.web.GrpcWebClientBase(p), this.hostname_ = n.replace(/\/+$/, "");
};
Ke.priority.geoservice.GeocodePromiseClient = function(n, t, p) {
  p || (p = {}), p.format = "text", this.client_ = new Pt.web.GrpcWebClientBase(p), this.hostname_ = n.replace(/\/+$/, "");
};
const ws = new Pt.web.MethodDescriptor(
  "/priority.geoservice.Geocode/Search",
  Pt.web.MethodType.UNARY,
  Ke.priority.geoservice.SearchRq,
  Ke.priority.geoservice.SearchRs,
  /**
   * @param {!proto.priority.geoservice.SearchRq} request
   * @return {!Uint8Array}
   */
  function(n) {
    return n.serializeBinary();
  },
  Ke.priority.geoservice.SearchRs.deserializeBinary
);
Ke.priority.geoservice.GeocodeClient.prototype.search = function(n, t, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/priority.geoservice.Geocode/Search",
    n,
    t || {},
    ws,
    p
  );
};
Ke.priority.geoservice.GeocodePromiseClient.prototype.search = function(n, t) {
  return this.client_.unaryCall(
    this.hostname_ + "/priority.geoservice.Geocode/Search",
    n,
    t || {},
    ws
  );
};
const Rs = new Pt.web.MethodDescriptor(
  "/priority.geoservice.Geocode/ExtSearch",
  Pt.web.MethodType.UNARY,
  Ke.priority.geoservice.SearchRq,
  Ke.priority.geoservice.SearchRs,
  /**
   * @param {!proto.priority.geoservice.SearchRq} request
   * @return {!Uint8Array}
   */
  function(n) {
    return n.serializeBinary();
  },
  Ke.priority.geoservice.SearchRs.deserializeBinary
);
Ke.priority.geoservice.GeocodeClient.prototype.extSearch = function(n, t, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/priority.geoservice.Geocode/ExtSearch",
    n,
    t || {},
    Rs,
    p
  );
};
Ke.priority.geoservice.GeocodePromiseClient.prototype.extSearch = function(n, t) {
  return this.client_.unaryCall(
    this.hostname_ + "/priority.geoservice.Geocode/ExtSearch",
    n,
    t || {},
    Rs
  );
};
var Zo = Ke.priority.geoservice;
const Yp = /* @__PURE__ */ Zt(Zo), ul = /* @__PURE__ */ Ht({
  __proto__: null,
  default: Yp
}, [Zo]);
var Je = {}, Cr = {}, Fs = {};
(function(n) {
  var t = Kt, p = t, f = (function() {
    return this || window || f || self || Function("return this")();
  }).call(null);
  p.exportSymbol("proto.priority.netitems.metadata.AdditionalProperties", null, f), p.exportSymbol("proto.priority.netitems.metadata.AdditionalProperties.ADCInternal", null, f), p.exportSymbol("proto.priority.netitems.metadata.AsapiDetails", null, f), p.exportSymbol("proto.priority.netitems.metadata.Credentials", null, f), p.exportSymbol("proto.priority.netitems.metadata.Credentials.Basic", null, f), p.exportSymbol("proto.priority.netitems.metadata.Credentials.Bearer", null, f), p.exportSymbol("proto.priority.netitems.metadata.Credentials.CredsCase", null, f), p.exportSymbol("proto.priority.netitems.metadata.Location", null, f), p.exportSymbol("proto.priority.netitems.metadata.TimeZone", null, f), proto.priority.netitems.metadata.AsapiDetails = function(l) {
    t.Message.initialize(this, l, 0, -1, null, null);
  }, p.inherits(proto.priority.netitems.metadata.AsapiDetails, t.Message), p.DEBUG && !COMPILED && (proto.priority.netitems.metadata.AsapiDetails.displayName = "proto.priority.netitems.metadata.AsapiDetails"), proto.priority.netitems.metadata.Location = function(l) {
    t.Message.initialize(this, l, 0, -1, null, null);
  }, p.inherits(proto.priority.netitems.metadata.Location, t.Message), p.DEBUG && !COMPILED && (proto.priority.netitems.metadata.Location.displayName = "proto.priority.netitems.metadata.Location"), proto.priority.netitems.metadata.TimeZone = function(l) {
    t.Message.initialize(this, l, 0, -1, null, null);
  }, p.inherits(proto.priority.netitems.metadata.TimeZone, t.Message), p.DEBUG && !COMPILED && (proto.priority.netitems.metadata.TimeZone.displayName = "proto.priority.netitems.metadata.TimeZone"), proto.priority.netitems.metadata.Credentials = function(l) {
    t.Message.initialize(this, l, 0, -1, null, proto.priority.netitems.metadata.Credentials.oneofGroups_);
  }, p.inherits(proto.priority.netitems.metadata.Credentials, t.Message), p.DEBUG && !COMPILED && (proto.priority.netitems.metadata.Credentials.displayName = "proto.priority.netitems.metadata.Credentials"), proto.priority.netitems.metadata.Credentials.Basic = function(l) {
    t.Message.initialize(this, l, 0, -1, null, null);
  }, p.inherits(proto.priority.netitems.metadata.Credentials.Basic, t.Message), p.DEBUG && !COMPILED && (proto.priority.netitems.metadata.Credentials.Basic.displayName = "proto.priority.netitems.metadata.Credentials.Basic"), proto.priority.netitems.metadata.Credentials.Bearer = function(l) {
    t.Message.initialize(this, l, 0, -1, null, null);
  }, p.inherits(proto.priority.netitems.metadata.Credentials.Bearer, t.Message), p.DEBUG && !COMPILED && (proto.priority.netitems.metadata.Credentials.Bearer.displayName = "proto.priority.netitems.metadata.Credentials.Bearer"), proto.priority.netitems.metadata.AdditionalProperties = function(l) {
    t.Message.initialize(this, l, 0, -1, null, null);
  }, p.inherits(proto.priority.netitems.metadata.AdditionalProperties, t.Message), p.DEBUG && !COMPILED && (proto.priority.netitems.metadata.AdditionalProperties.displayName = "proto.priority.netitems.metadata.AdditionalProperties"), t.Message.GENERATE_TO_OBJECT && (proto.priority.netitems.metadata.AsapiDetails.prototype.toObject = function(l) {
    return proto.priority.netitems.metadata.AsapiDetails.toObject(l, this);
  }, proto.priority.netitems.metadata.AsapiDetails.toObject = function(l, i) {
    var e = {
      id: t.Message.getFieldWithDefault(i, 1, ""),
      key: t.Message.getFieldWithDefault(i, 2, "")
    };
    return l && (e.$jspbMessageInstance = i), e;
  }), proto.priority.netitems.metadata.AsapiDetails.deserializeBinary = function(l) {
    var i = new t.BinaryReader(l), e = new proto.priority.netitems.metadata.AsapiDetails();
    return proto.priority.netitems.metadata.AsapiDetails.deserializeBinaryFromReader(e, i);
  }, proto.priority.netitems.metadata.AsapiDetails.deserializeBinaryFromReader = function(l, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var e = i.getFieldNumber();
      switch (e) {
        case 1:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setId(r);
          break;
        case 2:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setKey(r);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return l;
  }, proto.priority.netitems.metadata.AsapiDetails.prototype.serializeBinary = function() {
    var l = new t.BinaryWriter();
    return proto.priority.netitems.metadata.AsapiDetails.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, proto.priority.netitems.metadata.AsapiDetails.serializeBinaryToWriter = function(l, i) {
    var e = void 0;
    e = l.getId(), e.length > 0 && i.writeString(
      1,
      e
    ), e = l.getKey(), e.length > 0 && i.writeString(
      2,
      e
    );
  }, proto.priority.netitems.metadata.AsapiDetails.prototype.getId = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.netitems.metadata.AsapiDetails.prototype.setId = function(l) {
    return t.Message.setProto3StringField(this, 1, l);
  }, proto.priority.netitems.metadata.AsapiDetails.prototype.getKey = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.netitems.metadata.AsapiDetails.prototype.setKey = function(l) {
    return t.Message.setProto3StringField(this, 2, l);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.netitems.metadata.Location.prototype.toObject = function(l) {
    return proto.priority.netitems.metadata.Location.toObject(l, this);
  }, proto.priority.netitems.metadata.Location.toObject = function(l, i) {
    var e = {
      address: t.Message.getFieldWithDefault(i, 1, ""),
      latitude: t.Message.getFieldWithDefault(i, 2, ""),
      longitude: t.Message.getFieldWithDefault(i, 3, "")
    };
    return l && (e.$jspbMessageInstance = i), e;
  }), proto.priority.netitems.metadata.Location.deserializeBinary = function(l) {
    var i = new t.BinaryReader(l), e = new proto.priority.netitems.metadata.Location();
    return proto.priority.netitems.metadata.Location.deserializeBinaryFromReader(e, i);
  }, proto.priority.netitems.metadata.Location.deserializeBinaryFromReader = function(l, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var e = i.getFieldNumber();
      switch (e) {
        case 1:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setAddress(r);
          break;
        case 2:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setLatitude(r);
          break;
        case 3:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setLongitude(r);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return l;
  }, proto.priority.netitems.metadata.Location.prototype.serializeBinary = function() {
    var l = new t.BinaryWriter();
    return proto.priority.netitems.metadata.Location.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, proto.priority.netitems.metadata.Location.serializeBinaryToWriter = function(l, i) {
    var e = void 0;
    e = l.getAddress(), e.length > 0 && i.writeString(
      1,
      e
    ), e = l.getLatitude(), e.length > 0 && i.writeString(
      2,
      e
    ), e = l.getLongitude(), e.length > 0 && i.writeString(
      3,
      e
    );
  }, proto.priority.netitems.metadata.Location.prototype.getAddress = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.netitems.metadata.Location.prototype.setAddress = function(l) {
    return t.Message.setProto3StringField(this, 1, l);
  }, proto.priority.netitems.metadata.Location.prototype.getLatitude = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.netitems.metadata.Location.prototype.setLatitude = function(l) {
    return t.Message.setProto3StringField(this, 2, l);
  }, proto.priority.netitems.metadata.Location.prototype.getLongitude = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.priority.netitems.metadata.Location.prototype.setLongitude = function(l) {
    return t.Message.setProto3StringField(this, 3, l);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.netitems.metadata.TimeZone.prototype.toObject = function(l) {
    return proto.priority.netitems.metadata.TimeZone.toObject(l, this);
  }, proto.priority.netitems.metadata.TimeZone.toObject = function(l, i) {
    var e = {
      diff: t.Message.getFieldWithDefault(i, 1, 0),
      iana: t.Message.getFieldWithDefault(i, 2, "")
    };
    return l && (e.$jspbMessageInstance = i), e;
  }), proto.priority.netitems.metadata.TimeZone.deserializeBinary = function(l) {
    var i = new t.BinaryReader(l), e = new proto.priority.netitems.metadata.TimeZone();
    return proto.priority.netitems.metadata.TimeZone.deserializeBinaryFromReader(e, i);
  }, proto.priority.netitems.metadata.TimeZone.deserializeBinaryFromReader = function(l, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var e = i.getFieldNumber();
      switch (e) {
        case 1:
          var r = (
            /** @type {number} */
            i.readInt32()
          );
          l.setDiff(r);
          break;
        case 2:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setIana(r);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return l;
  }, proto.priority.netitems.metadata.TimeZone.prototype.serializeBinary = function() {
    var l = new t.BinaryWriter();
    return proto.priority.netitems.metadata.TimeZone.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, proto.priority.netitems.metadata.TimeZone.serializeBinaryToWriter = function(l, i) {
    var e = void 0;
    e = l.getDiff(), e !== 0 && i.writeInt32(
      1,
      e
    ), e = l.getIana(), e.length > 0 && i.writeString(
      2,
      e
    );
  }, proto.priority.netitems.metadata.TimeZone.prototype.getDiff = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.netitems.metadata.TimeZone.prototype.setDiff = function(l) {
    return t.Message.setProto3IntField(this, 1, l);
  }, proto.priority.netitems.metadata.TimeZone.prototype.getIana = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.netitems.metadata.TimeZone.prototype.setIana = function(l) {
    return t.Message.setProto3StringField(this, 2, l);
  }, proto.priority.netitems.metadata.Credentials.oneofGroups_ = [[1, 2]], proto.priority.netitems.metadata.Credentials.CredsCase = {
    CREDS_NOT_SET: 0,
    SIMPLE: 1,
    OPENID: 2
  }, proto.priority.netitems.metadata.Credentials.prototype.getCredsCase = function() {
    return (
      /** @type {proto.priority.netitems.metadata.Credentials.CredsCase} */
      t.Message.computeOneofCase(this, proto.priority.netitems.metadata.Credentials.oneofGroups_[0])
    );
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.netitems.metadata.Credentials.prototype.toObject = function(l) {
    return proto.priority.netitems.metadata.Credentials.toObject(l, this);
  }, proto.priority.netitems.metadata.Credentials.toObject = function(l, i) {
    var e, r = {
      simple: (e = i.getSimple()) && proto.priority.netitems.metadata.Credentials.Basic.toObject(l, e),
      openid: (e = i.getOpenid()) && proto.priority.netitems.metadata.Credentials.Bearer.toObject(l, e)
    };
    return l && (r.$jspbMessageInstance = i), r;
  }), proto.priority.netitems.metadata.Credentials.deserializeBinary = function(l) {
    var i = new t.BinaryReader(l), e = new proto.priority.netitems.metadata.Credentials();
    return proto.priority.netitems.metadata.Credentials.deserializeBinaryFromReader(e, i);
  }, proto.priority.netitems.metadata.Credentials.deserializeBinaryFromReader = function(l, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var e = i.getFieldNumber();
      switch (e) {
        case 1:
          var r = new proto.priority.netitems.metadata.Credentials.Basic();
          i.readMessage(r, proto.priority.netitems.metadata.Credentials.Basic.deserializeBinaryFromReader), l.setSimple(r);
          break;
        case 2:
          var r = new proto.priority.netitems.metadata.Credentials.Bearer();
          i.readMessage(r, proto.priority.netitems.metadata.Credentials.Bearer.deserializeBinaryFromReader), l.setOpenid(r);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return l;
  }, proto.priority.netitems.metadata.Credentials.prototype.serializeBinary = function() {
    var l = new t.BinaryWriter();
    return proto.priority.netitems.metadata.Credentials.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, proto.priority.netitems.metadata.Credentials.serializeBinaryToWriter = function(l, i) {
    var e = void 0;
    e = l.getSimple(), e != null && i.writeMessage(
      1,
      e,
      proto.priority.netitems.metadata.Credentials.Basic.serializeBinaryToWriter
    ), e = l.getOpenid(), e != null && i.writeMessage(
      2,
      e,
      proto.priority.netitems.metadata.Credentials.Bearer.serializeBinaryToWriter
    );
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.netitems.metadata.Credentials.Basic.prototype.toObject = function(l) {
    return proto.priority.netitems.metadata.Credentials.Basic.toObject(l, this);
  }, proto.priority.netitems.metadata.Credentials.Basic.toObject = function(l, i) {
    var e = {
      userlogin: t.Message.getFieldWithDefault(i, 1, ""),
      password: t.Message.getFieldWithDefault(i, 2, "")
    };
    return l && (e.$jspbMessageInstance = i), e;
  }), proto.priority.netitems.metadata.Credentials.Basic.deserializeBinary = function(l) {
    var i = new t.BinaryReader(l), e = new proto.priority.netitems.metadata.Credentials.Basic();
    return proto.priority.netitems.metadata.Credentials.Basic.deserializeBinaryFromReader(e, i);
  }, proto.priority.netitems.metadata.Credentials.Basic.deserializeBinaryFromReader = function(l, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var e = i.getFieldNumber();
      switch (e) {
        case 1:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setUserlogin(r);
          break;
        case 2:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setPassword(r);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return l;
  }, proto.priority.netitems.metadata.Credentials.Basic.prototype.serializeBinary = function() {
    var l = new t.BinaryWriter();
    return proto.priority.netitems.metadata.Credentials.Basic.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, proto.priority.netitems.metadata.Credentials.Basic.serializeBinaryToWriter = function(l, i) {
    var e = void 0;
    e = l.getUserlogin(), e.length > 0 && i.writeString(
      1,
      e
    ), e = l.getPassword(), e.length > 0 && i.writeString(
      2,
      e
    );
  }, proto.priority.netitems.metadata.Credentials.Basic.prototype.getUserlogin = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.netitems.metadata.Credentials.Basic.prototype.setUserlogin = function(l) {
    return t.Message.setProto3StringField(this, 1, l);
  }, proto.priority.netitems.metadata.Credentials.Basic.prototype.getPassword = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.netitems.metadata.Credentials.Basic.prototype.setPassword = function(l) {
    return t.Message.setProto3StringField(this, 2, l);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.netitems.metadata.Credentials.Bearer.prototype.toObject = function(l) {
    return proto.priority.netitems.metadata.Credentials.Bearer.toObject(l, this);
  }, proto.priority.netitems.metadata.Credentials.Bearer.toObject = function(l, i) {
    var e = {
      token: t.Message.getFieldWithDefault(i, 1, "")
    };
    return l && (e.$jspbMessageInstance = i), e;
  }), proto.priority.netitems.metadata.Credentials.Bearer.deserializeBinary = function(l) {
    var i = new t.BinaryReader(l), e = new proto.priority.netitems.metadata.Credentials.Bearer();
    return proto.priority.netitems.metadata.Credentials.Bearer.deserializeBinaryFromReader(e, i);
  }, proto.priority.netitems.metadata.Credentials.Bearer.deserializeBinaryFromReader = function(l, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var e = i.getFieldNumber();
      switch (e) {
        case 1:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setToken(r);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return l;
  }, proto.priority.netitems.metadata.Credentials.Bearer.prototype.serializeBinary = function() {
    var l = new t.BinaryWriter();
    return proto.priority.netitems.metadata.Credentials.Bearer.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, proto.priority.netitems.metadata.Credentials.Bearer.serializeBinaryToWriter = function(l, i) {
    var e = void 0;
    e = l.getToken(), e.length > 0 && i.writeString(
      1,
      e
    );
  }, proto.priority.netitems.metadata.Credentials.Bearer.prototype.getToken = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.netitems.metadata.Credentials.Bearer.prototype.setToken = function(l) {
    return t.Message.setProto3StringField(this, 1, l);
  }, proto.priority.netitems.metadata.Credentials.prototype.getSimple = function() {
    return (
      /** @type{?proto.priority.netitems.metadata.Credentials.Basic} */
      t.Message.getWrapperField(this, proto.priority.netitems.metadata.Credentials.Basic, 1)
    );
  }, proto.priority.netitems.metadata.Credentials.prototype.setSimple = function(l) {
    return t.Message.setOneofWrapperField(this, 1, proto.priority.netitems.metadata.Credentials.oneofGroups_[0], l);
  }, proto.priority.netitems.metadata.Credentials.prototype.clearSimple = function() {
    return this.setSimple(void 0);
  }, proto.priority.netitems.metadata.Credentials.prototype.hasSimple = function() {
    return t.Message.getField(this, 1) != null;
  }, proto.priority.netitems.metadata.Credentials.prototype.getOpenid = function() {
    return (
      /** @type{?proto.priority.netitems.metadata.Credentials.Bearer} */
      t.Message.getWrapperField(this, proto.priority.netitems.metadata.Credentials.Bearer, 2)
    );
  }, proto.priority.netitems.metadata.Credentials.prototype.setOpenid = function(l) {
    return t.Message.setOneofWrapperField(this, 2, proto.priority.netitems.metadata.Credentials.oneofGroups_[0], l);
  }, proto.priority.netitems.metadata.Credentials.prototype.clearOpenid = function() {
    return this.setOpenid(void 0);
  }, proto.priority.netitems.metadata.Credentials.prototype.hasOpenid = function() {
    return t.Message.getField(this, 2) != null;
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.netitems.metadata.AdditionalProperties.prototype.toObject = function(l) {
    return proto.priority.netitems.metadata.AdditionalProperties.toObject(l, this);
  }, proto.priority.netitems.metadata.AdditionalProperties.toObject = function(l, i) {
    var e, r = {
      tenantid: t.Message.getFieldWithDefault(i, 1, ""),
      tabulaini: t.Message.getFieldWithDefault(i, 2, ""),
      dname: t.Message.getFieldWithDefault(i, 3, ""),
      language: t.Message.getFieldWithDefault(i, 4, 0),
      debug: t.Message.getBooleanFieldWithDefault(i, 5, !1),
      userlogin: t.Message.getFieldWithDefault(i, 6, ""),
      applicationname: t.Message.getFieldWithDefault(i, 7, ""),
      asapi: (e = i.getAsapi()) && proto.priority.netitems.metadata.AsapiDetails.toObject(l, e),
      location: (e = i.getLocation()) && proto.priority.netitems.metadata.Location.toObject(l, e),
      timezone: (e = i.getTimezone()) && proto.priority.netitems.metadata.TimeZone.toObject(l, e),
      pluginenabled: t.Message.getBooleanFieldWithDefault(i, 11, !1),
      credentials: (e = i.getCredentials()) && proto.priority.netitems.metadata.Credentials.toObject(l, e),
      iswebsdk: t.Message.getBooleanFieldWithDefault(i, 13, !1),
      otherinfo: t.Message.getFieldWithDefault(i, 14, ""),
      trace: t.Message.getBooleanFieldWithDefault(i, 15, !1),
      adc: t.Message.getFieldWithDefault(i, 16, 0),
      traceid: t.Message.getFieldWithDefault(i, 17, 0),
      spandid: t.Message.getFieldWithDefault(i, 18, 0),
      userid: t.Message.getFieldWithDefault(i, 19, 0),
      debugserver: t.Message.getFieldWithDefault(i, 20, 0),
      customtimeoutseconds: t.Message.getFieldWithDefault(i, 21, 0)
    };
    return l && (r.$jspbMessageInstance = i), r;
  }), proto.priority.netitems.metadata.AdditionalProperties.deserializeBinary = function(l) {
    var i = new t.BinaryReader(l), e = new proto.priority.netitems.metadata.AdditionalProperties();
    return proto.priority.netitems.metadata.AdditionalProperties.deserializeBinaryFromReader(e, i);
  }, proto.priority.netitems.metadata.AdditionalProperties.deserializeBinaryFromReader = function(l, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var e = i.getFieldNumber();
      switch (e) {
        case 1:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setTenantid(r);
          break;
        case 2:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setTabulaini(r);
          break;
        case 3:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setDname(r);
          break;
        case 4:
          var r = (
            /** @type {number} */
            i.readInt64()
          );
          l.setLanguage(r);
          break;
        case 5:
          var r = (
            /** @type {boolean} */
            i.readBool()
          );
          l.setDebug(r);
          break;
        case 6:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setUserlogin(r);
          break;
        case 7:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setApplicationname(r);
          break;
        case 8:
          var r = new proto.priority.netitems.metadata.AsapiDetails();
          i.readMessage(r, proto.priority.netitems.metadata.AsapiDetails.deserializeBinaryFromReader), l.setAsapi(r);
          break;
        case 9:
          var r = new proto.priority.netitems.metadata.Location();
          i.readMessage(r, proto.priority.netitems.metadata.Location.deserializeBinaryFromReader), l.setLocation(r);
          break;
        case 10:
          var r = new proto.priority.netitems.metadata.TimeZone();
          i.readMessage(r, proto.priority.netitems.metadata.TimeZone.deserializeBinaryFromReader), l.setTimezone(r);
          break;
        case 11:
          var r = (
            /** @type {boolean} */
            i.readBool()
          );
          l.setPluginenabled(r);
          break;
        case 12:
          var r = new proto.priority.netitems.metadata.Credentials();
          i.readMessage(r, proto.priority.netitems.metadata.Credentials.deserializeBinaryFromReader), l.setCredentials(r);
          break;
        case 13:
          var r = (
            /** @type {boolean} */
            i.readBool()
          );
          l.setIswebsdk(r);
          break;
        case 14:
          var r = (
            /** @type {string} */
            i.readString()
          );
          l.setOtherinfo(r);
          break;
        case 15:
          var r = (
            /** @type {boolean} */
            i.readBool()
          );
          l.setTrace(r);
          break;
        case 16:
          var r = (
            /** @type {!proto.priority.netitems.metadata.AdditionalProperties.ADCInternal} */
            i.readEnum()
          );
          l.setAdc(r);
          break;
        case 17:
          var r = (
            /** @type {number} */
            i.readUint64()
          );
          l.setTraceid(r);
          break;
        case 18:
          var r = (
            /** @type {number} */
            i.readUint64()
          );
          l.setSpandid(r);
          break;
        case 19:
          var r = (
            /** @type {number} */
            i.readInt64()
          );
          l.setUserid(r);
          break;
        case 20:
          var r = (
            /** @type {number} */
            i.readInt64()
          );
          l.setDebugserver(r);
          break;
        case 21:
          var r = (
            /** @type {number} */
            i.readInt64()
          );
          l.setCustomtimeoutseconds(r);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return l;
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.serializeBinary = function() {
    var l = new t.BinaryWriter();
    return proto.priority.netitems.metadata.AdditionalProperties.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, proto.priority.netitems.metadata.AdditionalProperties.serializeBinaryToWriter = function(l, i) {
    var e = void 0;
    e = l.getTenantid(), e.length > 0 && i.writeString(
      1,
      e
    ), e = l.getTabulaini(), e.length > 0 && i.writeString(
      2,
      e
    ), e = l.getDname(), e.length > 0 && i.writeString(
      3,
      e
    ), e = l.getLanguage(), e !== 0 && i.writeInt64(
      4,
      e
    ), e = l.getDebug(), e && i.writeBool(
      5,
      e
    ), e = l.getUserlogin(), e.length > 0 && i.writeString(
      6,
      e
    ), e = l.getApplicationname(), e.length > 0 && i.writeString(
      7,
      e
    ), e = l.getAsapi(), e != null && i.writeMessage(
      8,
      e,
      proto.priority.netitems.metadata.AsapiDetails.serializeBinaryToWriter
    ), e = l.getLocation(), e != null && i.writeMessage(
      9,
      e,
      proto.priority.netitems.metadata.Location.serializeBinaryToWriter
    ), e = l.getTimezone(), e != null && i.writeMessage(
      10,
      e,
      proto.priority.netitems.metadata.TimeZone.serializeBinaryToWriter
    ), e = l.getPluginenabled(), e && i.writeBool(
      11,
      e
    ), e = l.getCredentials(), e != null && i.writeMessage(
      12,
      e,
      proto.priority.netitems.metadata.Credentials.serializeBinaryToWriter
    ), e = l.getIswebsdk(), e && i.writeBool(
      13,
      e
    ), e = l.getOtherinfo(), e.length > 0 && i.writeString(
      14,
      e
    ), e = l.getTrace(), e && i.writeBool(
      15,
      e
    ), e = l.getAdc(), e !== 0 && i.writeEnum(
      16,
      e
    ), e = l.getTraceid(), e !== 0 && i.writeUint64(
      17,
      e
    ), e = l.getSpandid(), e !== 0 && i.writeUint64(
      18,
      e
    ), e = l.getUserid(), e !== 0 && i.writeInt64(
      19,
      e
    ), e = l.getDebugserver(), e !== 0 && i.writeInt64(
      20,
      e
    ), e = l.getCustomtimeoutseconds(), e !== 0 && i.writeInt64(
      21,
      e
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.ADCInternal = {
    NONE: 0,
    WMS: 1
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getTenantid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setTenantid = function(l) {
    return t.Message.setProto3StringField(this, 1, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getTabulaini = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setTabulaini = function(l) {
    return t.Message.setProto3StringField(this, 2, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getDname = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setDname = function(l) {
    return t.Message.setProto3StringField(this, 3, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getLanguage = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setLanguage = function(l) {
    return t.Message.setProto3IntField(this, 4, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getDebug = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 5, !1)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setDebug = function(l) {
    return t.Message.setProto3BooleanField(this, 5, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getUserlogin = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 6, "")
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setUserlogin = function(l) {
    return t.Message.setProto3StringField(this, 6, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getApplicationname = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 7, "")
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setApplicationname = function(l) {
    return t.Message.setProto3StringField(this, 7, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getAsapi = function() {
    return (
      /** @type{?proto.priority.netitems.metadata.AsapiDetails} */
      t.Message.getWrapperField(this, proto.priority.netitems.metadata.AsapiDetails, 8)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setAsapi = function(l) {
    return t.Message.setWrapperField(this, 8, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.clearAsapi = function() {
    return this.setAsapi(void 0);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.hasAsapi = function() {
    return t.Message.getField(this, 8) != null;
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getLocation = function() {
    return (
      /** @type{?proto.priority.netitems.metadata.Location} */
      t.Message.getWrapperField(this, proto.priority.netitems.metadata.Location, 9)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setLocation = function(l) {
    return t.Message.setWrapperField(this, 9, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.clearLocation = function() {
    return this.setLocation(void 0);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.hasLocation = function() {
    return t.Message.getField(this, 9) != null;
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getTimezone = function() {
    return (
      /** @type{?proto.priority.netitems.metadata.TimeZone} */
      t.Message.getWrapperField(this, proto.priority.netitems.metadata.TimeZone, 10)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setTimezone = function(l) {
    return t.Message.setWrapperField(this, 10, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.clearTimezone = function() {
    return this.setTimezone(void 0);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.hasTimezone = function() {
    return t.Message.getField(this, 10) != null;
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getPluginenabled = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 11, !1)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setPluginenabled = function(l) {
    return t.Message.setProto3BooleanField(this, 11, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getCredentials = function() {
    return (
      /** @type{?proto.priority.netitems.metadata.Credentials} */
      t.Message.getWrapperField(this, proto.priority.netitems.metadata.Credentials, 12)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setCredentials = function(l) {
    return t.Message.setWrapperField(this, 12, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.clearCredentials = function() {
    return this.setCredentials(void 0);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.hasCredentials = function() {
    return t.Message.getField(this, 12) != null;
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getIswebsdk = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 13, !1)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setIswebsdk = function(l) {
    return t.Message.setProto3BooleanField(this, 13, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getOtherinfo = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 14, "")
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setOtherinfo = function(l) {
    return t.Message.setProto3StringField(this, 14, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getTrace = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 15, !1)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setTrace = function(l) {
    return t.Message.setProto3BooleanField(this, 15, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getAdc = function() {
    return (
      /** @type {!proto.priority.netitems.metadata.AdditionalProperties.ADCInternal} */
      t.Message.getFieldWithDefault(this, 16, 0)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setAdc = function(l) {
    return t.Message.setProto3EnumField(this, 16, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getTraceid = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 17, 0)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setTraceid = function(l) {
    return t.Message.setProto3IntField(this, 17, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getSpandid = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 18, 0)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setSpandid = function(l) {
    return t.Message.setProto3IntField(this, 18, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getUserid = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 19, 0)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setUserid = function(l) {
    return t.Message.setProto3IntField(this, 19, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getDebugserver = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 20, 0)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setDebugserver = function(l) {
    return t.Message.setProto3IntField(this, 20, l);
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.getCustomtimeoutseconds = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 21, 0)
    );
  }, proto.priority.netitems.metadata.AdditionalProperties.prototype.setCustomtimeoutseconds = function(l) {
    return t.Message.setProto3IntField(this, 21, l);
  }, p.object.extend(n, proto.priority.netitems.metadata);
})(Fs);
(function(n) {
  var t = Kt, p = t, f = (function() {
    return this || window || f || self || Function("return this")();
  }).call(null), l = Fs;
  p.object.extend(proto, l), p.exportSymbol("proto.common.AdditionalProperties", null, f), p.exportSymbol("proto.common.Bool", null, f), p.exportSymbol("proto.common.CompaniesRq", null, f), p.exportSymbol("proto.common.CompaniesRs", null, f), p.exportSymbol("proto.common.CompanyData", null, f), p.exportSymbol("proto.common.Constant", null, f), p.exportSymbol("proto.common.Constant.ValueCase", null, f), p.exportSymbol("proto.common.Date", null, f), p.exportSymbol("proto.common.DateTime", null, f), p.exportSymbol("proto.common.Empty", null, f), p.exportSymbol("proto.common.File", null, f), p.exportSymbol("proto.common.FileDownload", null, f), p.exportSymbol("proto.common.GrpcError", null, f), p.exportSymbol("proto.common.InternalServiceMetadata", null, f), p.exportSymbol("proto.common.MssqlInstance", null, f), p.exportSymbol("proto.common.SessionID", null, f), p.exportSymbol("proto.common.SessionRq", null, f), p.exportSymbol("proto.common.SessionRs", null, f), p.exportSymbol("proto.common.SessionStatus", null, f), p.exportSymbol("proto.common.SessionStatus.DataCase", null, f), p.exportSymbol("proto.common.SessionStatus.StatusType", null, f), p.exportSymbol("proto.common.SqlTier", null, f), p.exportSymbol("proto.common.String", null, f), p.exportSymbol("proto.common.Strings", null, f), p.exportSymbol("proto.common.TenantData", null, f), p.exportSymbol("proto.common.TenantDetails", null, f), p.exportSymbol("proto.common.TenantDynamoData", null, f), p.exportSymbol("proto.common.TenantDynamoDataRq", null, f), p.exportSymbol("proto.common.TenantDynamoTable", null, f), p.exportSymbol("proto.common.Tenants", null, f), p.exportSymbol("proto.common.TimeOfDay", null, f), proto.common.AdditionalProperties = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.AdditionalProperties, t.Message), p.DEBUG && !COMPILED && (proto.common.AdditionalProperties.displayName = "proto.common.AdditionalProperties"), proto.common.Bool = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.Bool, t.Message), p.DEBUG && !COMPILED && (proto.common.Bool.displayName = "proto.common.Bool"), proto.common.String = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.String, t.Message), p.DEBUG && !COMPILED && (proto.common.String.displayName = "proto.common.String"), proto.common.Strings = function(i) {
    t.Message.initialize(this, i, 0, -1, proto.common.Strings.repeatedFields_, null);
  }, p.inherits(proto.common.Strings, t.Message), p.DEBUG && !COMPILED && (proto.common.Strings.displayName = "proto.common.Strings"), proto.common.Empty = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.Empty, t.Message), p.DEBUG && !COMPILED && (proto.common.Empty.displayName = "proto.common.Empty"), proto.common.TimeOfDay = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.TimeOfDay, t.Message), p.DEBUG && !COMPILED && (proto.common.TimeOfDay.displayName = "proto.common.TimeOfDay"), proto.common.Date = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.Date, t.Message), p.DEBUG && !COMPILED && (proto.common.Date.displayName = "proto.common.Date"), proto.common.DateTime = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.DateTime, t.Message), p.DEBUG && !COMPILED && (proto.common.DateTime.displayName = "proto.common.DateTime"), proto.common.File = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.File, t.Message), p.DEBUG && !COMPILED && (proto.common.File.displayName = "proto.common.File"), proto.common.Constant = function(i) {
    t.Message.initialize(this, i, 0, -1, null, proto.common.Constant.oneofGroups_);
  }, p.inherits(proto.common.Constant, t.Message), p.DEBUG && !COMPILED && (proto.common.Constant.displayName = "proto.common.Constant"), proto.common.TenantDetails = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.TenantDetails, t.Message), p.DEBUG && !COMPILED && (proto.common.TenantDetails.displayName = "proto.common.TenantDetails"), proto.common.GrpcError = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.GrpcError, t.Message), p.DEBUG && !COMPILED && (proto.common.GrpcError.displayName = "proto.common.GrpcError"), proto.common.CompanyData = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.CompanyData, t.Message), p.DEBUG && !COMPILED && (proto.common.CompanyData.displayName = "proto.common.CompanyData"), proto.common.CompaniesRq = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.CompaniesRq, t.Message), p.DEBUG && !COMPILED && (proto.common.CompaniesRq.displayName = "proto.common.CompaniesRq"), proto.common.CompaniesRs = function(i) {
    t.Message.initialize(this, i, 0, -1, proto.common.CompaniesRs.repeatedFields_, null);
  }, p.inherits(proto.common.CompaniesRs, t.Message), p.DEBUG && !COMPILED && (proto.common.CompaniesRs.displayName = "proto.common.CompaniesRs"), proto.common.InternalServiceMetadata = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.InternalServiceMetadata, t.Message), p.DEBUG && !COMPILED && (proto.common.InternalServiceMetadata.displayName = "proto.common.InternalServiceMetadata"), proto.common.TenantData = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.TenantData, t.Message), p.DEBUG && !COMPILED && (proto.common.TenantData.displayName = "proto.common.TenantData"), proto.common.Tenants = function(i) {
    t.Message.initialize(this, i, 0, -1, proto.common.Tenants.repeatedFields_, null);
  }, p.inherits(proto.common.Tenants, t.Message), p.DEBUG && !COMPILED && (proto.common.Tenants.displayName = "proto.common.Tenants"), proto.common.MssqlInstance = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.MssqlInstance, t.Message), p.DEBUG && !COMPILED && (proto.common.MssqlInstance.displayName = "proto.common.MssqlInstance"), proto.common.SessionStatus = function(i) {
    t.Message.initialize(this, i, 0, -1, null, proto.common.SessionStatus.oneofGroups_);
  }, p.inherits(proto.common.SessionStatus, t.Message), p.DEBUG && !COMPILED && (proto.common.SessionStatus.displayName = "proto.common.SessionStatus"), proto.common.FileDownload = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.FileDownload, t.Message), p.DEBUG && !COMPILED && (proto.common.FileDownload.displayName = "proto.common.FileDownload"), proto.common.SessionRq = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.SessionRq, t.Message), p.DEBUG && !COMPILED && (proto.common.SessionRq.displayName = "proto.common.SessionRq"), proto.common.SessionRs = function(i) {
    t.Message.initialize(this, i, 0, -1, proto.common.SessionRs.repeatedFields_, null);
  }, p.inherits(proto.common.SessionRs, t.Message), p.DEBUG && !COMPILED && (proto.common.SessionRs.displayName = "proto.common.SessionRs"), proto.common.SessionID = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.SessionID, t.Message), p.DEBUG && !COMPILED && (proto.common.SessionID.displayName = "proto.common.SessionID"), proto.common.TenantDynamoTable = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.TenantDynamoTable, t.Message), p.DEBUG && !COMPILED && (proto.common.TenantDynamoTable.displayName = "proto.common.TenantDynamoTable"), proto.common.TenantDynamoData = function(i) {
    t.Message.initialize(this, i, 0, -1, proto.common.TenantDynamoData.repeatedFields_, null);
  }, p.inherits(proto.common.TenantDynamoData, t.Message), p.DEBUG && !COMPILED && (proto.common.TenantDynamoData.displayName = "proto.common.TenantDynamoData"), proto.common.TenantDynamoDataRq = function(i) {
    t.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.common.TenantDynamoDataRq, t.Message), p.DEBUG && !COMPILED && (proto.common.TenantDynamoDataRq.displayName = "proto.common.TenantDynamoDataRq"), t.Message.GENERATE_TO_OBJECT && (proto.common.AdditionalProperties.prototype.toObject = function(i) {
    return proto.common.AdditionalProperties.toObject(i, this);
  }, proto.common.AdditionalProperties.toObject = function(i, e) {
    var r = {
      tenantid: t.Message.getFieldWithDefault(e, 1, ""),
      tabulaini: t.Message.getFieldWithDefault(e, 2, ""),
      dname: t.Message.getFieldWithDefault(e, 3, ""),
      language: t.Message.getFieldWithDefault(e, 4, 0),
      debug: t.Message.getBooleanFieldWithDefault(e, 5, !1),
      userlogin: t.Message.getFieldWithDefault(e, 6, "")
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.AdditionalProperties.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.AdditionalProperties();
    return proto.common.AdditionalProperties.deserializeBinaryFromReader(r, e);
  }, proto.common.AdditionalProperties.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setTenantid(s);
          break;
        case 2:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setTabulaini(s);
          break;
        case 3:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setDname(s);
          break;
        case 4:
          var s = (
            /** @type {number} */
            e.readInt64()
          );
          i.setLanguage(s);
          break;
        case 5:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setDebug(s);
          break;
        case 6:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setUserlogin(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.AdditionalProperties.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.AdditionalProperties.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.AdditionalProperties.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getTenantid(), r.length > 0 && e.writeString(
      1,
      r
    ), r = i.getTabulaini(), r.length > 0 && e.writeString(
      2,
      r
    ), r = i.getDname(), r.length > 0 && e.writeString(
      3,
      r
    ), r = i.getLanguage(), r !== 0 && e.writeInt64(
      4,
      r
    ), r = i.getDebug(), r && e.writeBool(
      5,
      r
    ), r = i.getUserlogin(), r.length > 0 && e.writeString(
      6,
      r
    );
  }, proto.common.AdditionalProperties.prototype.getTenantid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.AdditionalProperties.prototype.setTenantid = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.common.AdditionalProperties.prototype.getTabulaini = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.common.AdditionalProperties.prototype.setTabulaini = function(i) {
    return t.Message.setProto3StringField(this, 2, i);
  }, proto.common.AdditionalProperties.prototype.getDname = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.common.AdditionalProperties.prototype.setDname = function(i) {
    return t.Message.setProto3StringField(this, 3, i);
  }, proto.common.AdditionalProperties.prototype.getLanguage = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.common.AdditionalProperties.prototype.setLanguage = function(i) {
    return t.Message.setProto3IntField(this, 4, i);
  }, proto.common.AdditionalProperties.prototype.getDebug = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 5, !1)
    );
  }, proto.common.AdditionalProperties.prototype.setDebug = function(i) {
    return t.Message.setProto3BooleanField(this, 5, i);
  }, proto.common.AdditionalProperties.prototype.getUserlogin = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 6, "")
    );
  }, proto.common.AdditionalProperties.prototype.setUserlogin = function(i) {
    return t.Message.setProto3StringField(this, 6, i);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.Bool.prototype.toObject = function(i) {
    return proto.common.Bool.toObject(i, this);
  }, proto.common.Bool.toObject = function(i, e) {
    var r = {
      value: t.Message.getBooleanFieldWithDefault(e, 1, !1)
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.Bool.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.Bool();
    return proto.common.Bool.deserializeBinaryFromReader(r, e);
  }, proto.common.Bool.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setValue(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.Bool.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.Bool.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.Bool.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getValue(), r && e.writeBool(
      1,
      r
    );
  }, proto.common.Bool.prototype.getValue = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 1, !1)
    );
  }, proto.common.Bool.prototype.setValue = function(i) {
    return t.Message.setProto3BooleanField(this, 1, i);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.String.prototype.toObject = function(i) {
    return proto.common.String.toObject(i, this);
  }, proto.common.String.toObject = function(i, e) {
    var r = {
      value: t.Message.getFieldWithDefault(e, 1, "")
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.String.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.String();
    return proto.common.String.deserializeBinaryFromReader(r, e);
  }, proto.common.String.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setValue(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.String.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.String.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.String.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getValue(), r.length > 0 && e.writeString(
      1,
      r
    );
  }, proto.common.String.prototype.getValue = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.String.prototype.setValue = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.common.Strings.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.common.Strings.prototype.toObject = function(i) {
    return proto.common.Strings.toObject(i, this);
  }, proto.common.Strings.toObject = function(i, e) {
    var r, s = {
      valuesList: (r = t.Message.getRepeatedField(e, 1)) == null ? void 0 : r
    };
    return i && (s.$jspbMessageInstance = e), s;
  }), proto.common.Strings.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.Strings();
    return proto.common.Strings.deserializeBinaryFromReader(r, e);
  }, proto.common.Strings.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.addValues(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.Strings.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.Strings.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.Strings.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getValuesList(), r.length > 0 && e.writeRepeatedString(
      1,
      r
    );
  }, proto.common.Strings.prototype.getValuesList = function() {
    return (
      /** @type {!Array<string>} */
      t.Message.getRepeatedField(this, 1)
    );
  }, proto.common.Strings.prototype.setValuesList = function(i) {
    return t.Message.setField(this, 1, i || []);
  }, proto.common.Strings.prototype.addValues = function(i, e) {
    return t.Message.addToRepeatedField(this, 1, i, e);
  }, proto.common.Strings.prototype.clearValuesList = function() {
    return this.setValuesList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.Empty.prototype.toObject = function(i) {
    return proto.common.Empty.toObject(i, this);
  }, proto.common.Empty.toObject = function(i, e) {
    var r = {};
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.Empty.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.Empty();
    return proto.common.Empty.deserializeBinaryFromReader(r, e);
  }, proto.common.Empty.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.Empty.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.Empty.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.Empty.serializeBinaryToWriter = function(i, e) {
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.TimeOfDay.prototype.toObject = function(i) {
    return proto.common.TimeOfDay.toObject(i, this);
  }, proto.common.TimeOfDay.toObject = function(i, e) {
    var r = {
      hours: t.Message.getFieldWithDefault(e, 1, 0),
      minutes: t.Message.getFieldWithDefault(e, 2, 0),
      seconds: t.Message.getFieldWithDefault(e, 3, 0)
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.TimeOfDay.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.TimeOfDay();
    return proto.common.TimeOfDay.deserializeBinaryFromReader(r, e);
  }, proto.common.TimeOfDay.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setHours(s);
          break;
        case 2:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setMinutes(s);
          break;
        case 3:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setSeconds(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.TimeOfDay.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.TimeOfDay.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.TimeOfDay.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getHours(), r !== 0 && e.writeInt32(
      1,
      r
    ), r = i.getMinutes(), r !== 0 && e.writeInt32(
      2,
      r
    ), r = i.getSeconds(), r !== 0 && e.writeInt32(
      3,
      r
    );
  }, proto.common.TimeOfDay.prototype.getHours = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.common.TimeOfDay.prototype.setHours = function(i) {
    return t.Message.setProto3IntField(this, 1, i);
  }, proto.common.TimeOfDay.prototype.getMinutes = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.common.TimeOfDay.prototype.setMinutes = function(i) {
    return t.Message.setProto3IntField(this, 2, i);
  }, proto.common.TimeOfDay.prototype.getSeconds = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.common.TimeOfDay.prototype.setSeconds = function(i) {
    return t.Message.setProto3IntField(this, 3, i);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.Date.prototype.toObject = function(i) {
    return proto.common.Date.toObject(i, this);
  }, proto.common.Date.toObject = function(i, e) {
    var r = {
      year: t.Message.getFieldWithDefault(e, 1, 0),
      month: t.Message.getFieldWithDefault(e, 2, 0),
      day: t.Message.getFieldWithDefault(e, 3, 0)
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.Date.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.Date();
    return proto.common.Date.deserializeBinaryFromReader(r, e);
  }, proto.common.Date.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setYear(s);
          break;
        case 2:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setMonth(s);
          break;
        case 3:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setDay(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.Date.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.Date.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.Date.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getYear(), r !== 0 && e.writeInt32(
      1,
      r
    ), r = i.getMonth(), r !== 0 && e.writeInt32(
      2,
      r
    ), r = i.getDay(), r !== 0 && e.writeInt32(
      3,
      r
    );
  }, proto.common.Date.prototype.getYear = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.common.Date.prototype.setYear = function(i) {
    return t.Message.setProto3IntField(this, 1, i);
  }, proto.common.Date.prototype.getMonth = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.common.Date.prototype.setMonth = function(i) {
    return t.Message.setProto3IntField(this, 2, i);
  }, proto.common.Date.prototype.getDay = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.common.Date.prototype.setDay = function(i) {
    return t.Message.setProto3IntField(this, 3, i);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.DateTime.prototype.toObject = function(i) {
    return proto.common.DateTime.toObject(i, this);
  }, proto.common.DateTime.toObject = function(i, e) {
    var r = {
      year: t.Message.getFieldWithDefault(e, 1, 0),
      month: t.Message.getFieldWithDefault(e, 2, 0),
      day: t.Message.getFieldWithDefault(e, 3, 0),
      hours: t.Message.getFieldWithDefault(e, 4, 0),
      minutes: t.Message.getFieldWithDefault(e, 5, 0),
      seconds: t.Message.getFieldWithDefault(e, 6, 0)
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.DateTime.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.DateTime();
    return proto.common.DateTime.deserializeBinaryFromReader(r, e);
  }, proto.common.DateTime.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setYear(s);
          break;
        case 2:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setMonth(s);
          break;
        case 3:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setDay(s);
          break;
        case 4:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setHours(s);
          break;
        case 5:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setMinutes(s);
          break;
        case 6:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setSeconds(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.DateTime.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.DateTime.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.DateTime.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getYear(), r !== 0 && e.writeInt32(
      1,
      r
    ), r = i.getMonth(), r !== 0 && e.writeInt32(
      2,
      r
    ), r = i.getDay(), r !== 0 && e.writeInt32(
      3,
      r
    ), r = i.getHours(), r !== 0 && e.writeInt32(
      4,
      r
    ), r = i.getMinutes(), r !== 0 && e.writeInt32(
      5,
      r
    ), r = i.getSeconds(), r !== 0 && e.writeInt32(
      6,
      r
    );
  }, proto.common.DateTime.prototype.getYear = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.common.DateTime.prototype.setYear = function(i) {
    return t.Message.setProto3IntField(this, 1, i);
  }, proto.common.DateTime.prototype.getMonth = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.common.DateTime.prototype.setMonth = function(i) {
    return t.Message.setProto3IntField(this, 2, i);
  }, proto.common.DateTime.prototype.getDay = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.common.DateTime.prototype.setDay = function(i) {
    return t.Message.setProto3IntField(this, 3, i);
  }, proto.common.DateTime.prototype.getHours = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.common.DateTime.prototype.setHours = function(i) {
    return t.Message.setProto3IntField(this, 4, i);
  }, proto.common.DateTime.prototype.getMinutes = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.common.DateTime.prototype.setMinutes = function(i) {
    return t.Message.setProto3IntField(this, 5, i);
  }, proto.common.DateTime.prototype.getSeconds = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 6, 0)
    );
  }, proto.common.DateTime.prototype.setSeconds = function(i) {
    return t.Message.setProto3IntField(this, 6, i);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.File.prototype.toObject = function(i) {
    return proto.common.File.toObject(i, this);
  }, proto.common.File.toObject = function(i, e) {
    var r = {
      data: e.getData_asB64(),
      mimetype: t.Message.getFieldWithDefault(e, 2, ""),
      extension: t.Message.getFieldWithDefault(e, 3, ""),
      path: t.Message.getFieldWithDefault(e, 4, "")
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.File.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.File();
    return proto.common.File.deserializeBinaryFromReader(r, e);
  }, proto.common.File.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {!Uint8Array} */
            e.readBytes()
          );
          i.setData(s);
          break;
        case 2:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setMimetype(s);
          break;
        case 3:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setExtension$(s);
          break;
        case 4:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setPath(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.File.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.File.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.File.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getData_asU8(), r.length > 0 && e.writeBytes(
      1,
      r
    ), r = i.getMimetype(), r.length > 0 && e.writeString(
      2,
      r
    ), r = i.getExtension$(), r.length > 0 && e.writeString(
      3,
      r
    ), r = i.getPath(), r.length > 0 && e.writeString(
      4,
      r
    );
  }, proto.common.File.prototype.getData = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.File.prototype.getData_asB64 = function() {
    return (
      /** @type {string} */
      t.Message.bytesAsB64(
        this.getData()
      )
    );
  }, proto.common.File.prototype.getData_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      t.Message.bytesAsU8(
        this.getData()
      )
    );
  }, proto.common.File.prototype.setData = function(i) {
    return t.Message.setProto3BytesField(this, 1, i);
  }, proto.common.File.prototype.getMimetype = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.common.File.prototype.setMimetype = function(i) {
    return t.Message.setProto3StringField(this, 2, i);
  }, proto.common.File.prototype.getExtension$ = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.common.File.prototype.setExtension$ = function(i) {
    return t.Message.setProto3StringField(this, 3, i);
  }, proto.common.File.prototype.getPath = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.common.File.prototype.setPath = function(i) {
    return t.Message.setProto3StringField(this, 4, i);
  }, proto.common.Constant.oneofGroups_ = [[1, 2, 3, 4, 5, 6, 7, 8, 9]], proto.common.Constant.ValueCase = {
    VALUE_NOT_SET: 0,
    INT: 1,
    REAL: 2,
    SHIFTED: 3,
    STR: 4,
    BOOLEAN: 5,
    DATE: 6,
    TIME: 7,
    DATETIME: 8,
    FILE: 9
  }, proto.common.Constant.prototype.getValueCase = function() {
    return (
      /** @type {proto.common.Constant.ValueCase} */
      t.Message.computeOneofCase(this, proto.common.Constant.oneofGroups_[0])
    );
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.Constant.prototype.toObject = function(i) {
    return proto.common.Constant.toObject(i, this);
  }, proto.common.Constant.toObject = function(i, e) {
    var r, s = {
      pb_int: t.Message.getFieldWithDefault(e, 1, 0),
      real: t.Message.getFloatingPointFieldWithDefault(e, 2, 0),
      shifted: t.Message.getFloatingPointFieldWithDefault(e, 3, 0),
      str: t.Message.getFieldWithDefault(e, 4, ""),
      pb_boolean: t.Message.getBooleanFieldWithDefault(e, 5, !1),
      date: (r = e.getDate()) && proto.common.Date.toObject(i, r),
      time: (r = e.getTime()) && proto.common.TimeOfDay.toObject(i, r),
      datetime: (r = e.getDatetime()) && proto.common.DateTime.toObject(i, r),
      file: (r = e.getFile()) && proto.common.File.toObject(i, r)
    };
    return i && (s.$jspbMessageInstance = e), s;
  }), proto.common.Constant.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.Constant();
    return proto.common.Constant.deserializeBinaryFromReader(r, e);
  }, proto.common.Constant.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {number} */
            e.readInt64()
          );
          i.setInt(s);
          break;
        case 2:
          var s = (
            /** @type {number} */
            e.readDouble()
          );
          i.setReal(s);
          break;
        case 3:
          var s = (
            /** @type {number} */
            e.readDouble()
          );
          i.setShifted(s);
          break;
        case 4:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setStr(s);
          break;
        case 5:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setBoolean(s);
          break;
        case 6:
          var s = new proto.common.Date();
          e.readMessage(s, proto.common.Date.deserializeBinaryFromReader), i.setDate(s);
          break;
        case 7:
          var s = new proto.common.TimeOfDay();
          e.readMessage(s, proto.common.TimeOfDay.deserializeBinaryFromReader), i.setTime(s);
          break;
        case 8:
          var s = new proto.common.DateTime();
          e.readMessage(s, proto.common.DateTime.deserializeBinaryFromReader), i.setDatetime(s);
          break;
        case 9:
          var s = new proto.common.File();
          e.readMessage(s, proto.common.File.deserializeBinaryFromReader), i.setFile(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.Constant.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.Constant.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.Constant.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = /** @type {number} */
    t.Message.getField(i, 1), r != null && e.writeInt64(
      1,
      r
    ), r = /** @type {number} */
    t.Message.getField(i, 2), r != null && e.writeDouble(
      2,
      r
    ), r = /** @type {number} */
    t.Message.getField(i, 3), r != null && e.writeDouble(
      3,
      r
    ), r = /** @type {string} */
    t.Message.getField(i, 4), r != null && e.writeString(
      4,
      r
    ), r = /** @type {boolean} */
    t.Message.getField(i, 5), r != null && e.writeBool(
      5,
      r
    ), r = i.getDate(), r != null && e.writeMessage(
      6,
      r,
      proto.common.Date.serializeBinaryToWriter
    ), r = i.getTime(), r != null && e.writeMessage(
      7,
      r,
      proto.common.TimeOfDay.serializeBinaryToWriter
    ), r = i.getDatetime(), r != null && e.writeMessage(
      8,
      r,
      proto.common.DateTime.serializeBinaryToWriter
    ), r = i.getFile(), r != null && e.writeMessage(
      9,
      r,
      proto.common.File.serializeBinaryToWriter
    );
  }, proto.common.Constant.prototype.getInt = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.common.Constant.prototype.setInt = function(i) {
    return t.Message.setOneofField(this, 1, proto.common.Constant.oneofGroups_[0], i);
  }, proto.common.Constant.prototype.clearInt = function() {
    return t.Message.setOneofField(this, 1, proto.common.Constant.oneofGroups_[0], void 0);
  }, proto.common.Constant.prototype.hasInt = function() {
    return t.Message.getField(this, 1) != null;
  }, proto.common.Constant.prototype.getReal = function() {
    return (
      /** @type {number} */
      t.Message.getFloatingPointFieldWithDefault(this, 2, 0)
    );
  }, proto.common.Constant.prototype.setReal = function(i) {
    return t.Message.setOneofField(this, 2, proto.common.Constant.oneofGroups_[0], i);
  }, proto.common.Constant.prototype.clearReal = function() {
    return t.Message.setOneofField(this, 2, proto.common.Constant.oneofGroups_[0], void 0);
  }, proto.common.Constant.prototype.hasReal = function() {
    return t.Message.getField(this, 2) != null;
  }, proto.common.Constant.prototype.getShifted = function() {
    return (
      /** @type {number} */
      t.Message.getFloatingPointFieldWithDefault(this, 3, 0)
    );
  }, proto.common.Constant.prototype.setShifted = function(i) {
    return t.Message.setOneofField(this, 3, proto.common.Constant.oneofGroups_[0], i);
  }, proto.common.Constant.prototype.clearShifted = function() {
    return t.Message.setOneofField(this, 3, proto.common.Constant.oneofGroups_[0], void 0);
  }, proto.common.Constant.prototype.hasShifted = function() {
    return t.Message.getField(this, 3) != null;
  }, proto.common.Constant.prototype.getStr = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.common.Constant.prototype.setStr = function(i) {
    return t.Message.setOneofField(this, 4, proto.common.Constant.oneofGroups_[0], i);
  }, proto.common.Constant.prototype.clearStr = function() {
    return t.Message.setOneofField(this, 4, proto.common.Constant.oneofGroups_[0], void 0);
  }, proto.common.Constant.prototype.hasStr = function() {
    return t.Message.getField(this, 4) != null;
  }, proto.common.Constant.prototype.getBoolean = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 5, !1)
    );
  }, proto.common.Constant.prototype.setBoolean = function(i) {
    return t.Message.setOneofField(this, 5, proto.common.Constant.oneofGroups_[0], i);
  }, proto.common.Constant.prototype.clearBoolean = function() {
    return t.Message.setOneofField(this, 5, proto.common.Constant.oneofGroups_[0], void 0);
  }, proto.common.Constant.prototype.hasBoolean = function() {
    return t.Message.getField(this, 5) != null;
  }, proto.common.Constant.prototype.getDate = function() {
    return (
      /** @type{?proto.common.Date} */
      t.Message.getWrapperField(this, proto.common.Date, 6)
    );
  }, proto.common.Constant.prototype.setDate = function(i) {
    return t.Message.setOneofWrapperField(this, 6, proto.common.Constant.oneofGroups_[0], i);
  }, proto.common.Constant.prototype.clearDate = function() {
    return this.setDate(void 0);
  }, proto.common.Constant.prototype.hasDate = function() {
    return t.Message.getField(this, 6) != null;
  }, proto.common.Constant.prototype.getTime = function() {
    return (
      /** @type{?proto.common.TimeOfDay} */
      t.Message.getWrapperField(this, proto.common.TimeOfDay, 7)
    );
  }, proto.common.Constant.prototype.setTime = function(i) {
    return t.Message.setOneofWrapperField(this, 7, proto.common.Constant.oneofGroups_[0], i);
  }, proto.common.Constant.prototype.clearTime = function() {
    return this.setTime(void 0);
  }, proto.common.Constant.prototype.hasTime = function() {
    return t.Message.getField(this, 7) != null;
  }, proto.common.Constant.prototype.getDatetime = function() {
    return (
      /** @type{?proto.common.DateTime} */
      t.Message.getWrapperField(this, proto.common.DateTime, 8)
    );
  }, proto.common.Constant.prototype.setDatetime = function(i) {
    return t.Message.setOneofWrapperField(this, 8, proto.common.Constant.oneofGroups_[0], i);
  }, proto.common.Constant.prototype.clearDatetime = function() {
    return this.setDatetime(void 0);
  }, proto.common.Constant.prototype.hasDatetime = function() {
    return t.Message.getField(this, 8) != null;
  }, proto.common.Constant.prototype.getFile = function() {
    return (
      /** @type{?proto.common.File} */
      t.Message.getWrapperField(this, proto.common.File, 9)
    );
  }, proto.common.Constant.prototype.setFile = function(i) {
    return t.Message.setOneofWrapperField(this, 9, proto.common.Constant.oneofGroups_[0], i);
  }, proto.common.Constant.prototype.clearFile = function() {
    return this.setFile(void 0);
  }, proto.common.Constant.prototype.hasFile = function() {
    return t.Message.getField(this, 9) != null;
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.TenantDetails.prototype.toObject = function(i) {
    return proto.common.TenantDetails.toObject(i, this);
  }, proto.common.TenantDetails.toObject = function(i, e) {
    var r = {
      hosting: t.Message.getBooleanFieldWithDefault(e, 1, !1),
      licenseid: t.Message.getFieldWithDefault(e, 2, ""),
      tenantid: t.Message.getFieldWithDefault(e, 3, ""),
      gatewayurl: t.Message.getFieldWithDefault(e, 4, ""),
      publickeyid: t.Message.getFieldWithDefault(e, 5, ""),
      publickeydata: t.Message.getFieldWithDefault(e, 6, ""),
      wcfurl: t.Message.getFieldWithDefault(e, 7, ""),
      resturl: t.Message.getFieldWithDefault(e, 8, "")
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.TenantDetails.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.TenantDetails();
    return proto.common.TenantDetails.deserializeBinaryFromReader(r, e);
  }, proto.common.TenantDetails.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setHosting(s);
          break;
        case 2:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setLicenseid(s);
          break;
        case 3:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setTenantid(s);
          break;
        case 4:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setGatewayurl(s);
          break;
        case 5:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setPublickeyid(s);
          break;
        case 6:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setPublickeydata(s);
          break;
        case 7:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setWcfurl(s);
          break;
        case 8:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setResturl(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.TenantDetails.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.TenantDetails.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.TenantDetails.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getHosting(), r && e.writeBool(
      1,
      r
    ), r = i.getLicenseid(), r.length > 0 && e.writeString(
      2,
      r
    ), r = i.getTenantid(), r.length > 0 && e.writeString(
      3,
      r
    ), r = i.getGatewayurl(), r.length > 0 && e.writeString(
      4,
      r
    ), r = i.getPublickeyid(), r.length > 0 && e.writeString(
      5,
      r
    ), r = i.getPublickeydata(), r.length > 0 && e.writeString(
      6,
      r
    ), r = i.getWcfurl(), r.length > 0 && e.writeString(
      7,
      r
    ), r = i.getResturl(), r.length > 0 && e.writeString(
      8,
      r
    );
  }, proto.common.TenantDetails.prototype.getHosting = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 1, !1)
    );
  }, proto.common.TenantDetails.prototype.setHosting = function(i) {
    return t.Message.setProto3BooleanField(this, 1, i);
  }, proto.common.TenantDetails.prototype.getLicenseid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.common.TenantDetails.prototype.setLicenseid = function(i) {
    return t.Message.setProto3StringField(this, 2, i);
  }, proto.common.TenantDetails.prototype.getTenantid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.common.TenantDetails.prototype.setTenantid = function(i) {
    return t.Message.setProto3StringField(this, 3, i);
  }, proto.common.TenantDetails.prototype.getGatewayurl = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.common.TenantDetails.prototype.setGatewayurl = function(i) {
    return t.Message.setProto3StringField(this, 4, i);
  }, proto.common.TenantDetails.prototype.getPublickeyid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 5, "")
    );
  }, proto.common.TenantDetails.prototype.setPublickeyid = function(i) {
    return t.Message.setProto3StringField(this, 5, i);
  }, proto.common.TenantDetails.prototype.getPublickeydata = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 6, "")
    );
  }, proto.common.TenantDetails.prototype.setPublickeydata = function(i) {
    return t.Message.setProto3StringField(this, 6, i);
  }, proto.common.TenantDetails.prototype.getWcfurl = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 7, "")
    );
  }, proto.common.TenantDetails.prototype.setWcfurl = function(i) {
    return t.Message.setProto3StringField(this, 7, i);
  }, proto.common.TenantDetails.prototype.getResturl = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 8, "")
    );
  }, proto.common.TenantDetails.prototype.setResturl = function(i) {
    return t.Message.setProto3StringField(this, 8, i);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.GrpcError.prototype.toObject = function(i) {
    return proto.common.GrpcError.toObject(i, this);
  }, proto.common.GrpcError.toObject = function(i, e) {
    var r = {
      error: t.Message.getFieldWithDefault(e, 1, ""),
      code: t.Message.getFieldWithDefault(e, 2, 0)
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.GrpcError.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.GrpcError();
    return proto.common.GrpcError.deserializeBinaryFromReader(r, e);
  }, proto.common.GrpcError.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setError(s);
          break;
        case 2:
          var s = (
            /** @type {number} */
            e.readInt64()
          );
          i.setCode(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.GrpcError.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.GrpcError.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.GrpcError.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getError(), r.length > 0 && e.writeString(
      1,
      r
    ), r = i.getCode(), r !== 0 && e.writeInt64(
      2,
      r
    );
  }, proto.common.GrpcError.prototype.getError = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.GrpcError.prototype.setError = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.common.GrpcError.prototype.getCode = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.common.GrpcError.prototype.setCode = function(i) {
    return t.Message.setProto3IntField(this, 2, i);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.CompanyData.prototype.toObject = function(i) {
    return proto.common.CompanyData.toObject(i, this);
  }, proto.common.CompanyData.toObject = function(i, e) {
    var r = {
      dname: t.Message.getFieldWithDefault(e, 1, ""),
      title: t.Message.getFieldWithDefault(e, 2, ""),
      active: t.Message.getBooleanFieldWithDefault(e, 3, !1)
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.CompanyData.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.CompanyData();
    return proto.common.CompanyData.deserializeBinaryFromReader(r, e);
  }, proto.common.CompanyData.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setDname(s);
          break;
        case 2:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setTitle(s);
          break;
        case 3:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setActive(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.CompanyData.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.CompanyData.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.CompanyData.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getDname(), r.length > 0 && e.writeString(
      1,
      r
    ), r = i.getTitle(), r.length > 0 && e.writeString(
      2,
      r
    ), r = i.getActive(), r && e.writeBool(
      3,
      r
    );
  }, proto.common.CompanyData.prototype.getDname = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.CompanyData.prototype.setDname = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.common.CompanyData.prototype.getTitle = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.common.CompanyData.prototype.setTitle = function(i) {
    return t.Message.setProto3StringField(this, 2, i);
  }, proto.common.CompanyData.prototype.getActive = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, proto.common.CompanyData.prototype.setActive = function(i) {
    return t.Message.setProto3BooleanField(this, 3, i);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.CompaniesRq.prototype.toObject = function(i) {
    return proto.common.CompaniesRq.toObject(i, this);
  }, proto.common.CompaniesRq.toObject = function(i, e) {
    var r, s = {
      properties: (r = e.getProperties()) && l.AdditionalProperties.toObject(i, r),
      oneonly: t.Message.getBooleanFieldWithDefault(e, 2, !1)
    };
    return i && (s.$jspbMessageInstance = e), s;
  }), proto.common.CompaniesRq.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.CompaniesRq();
    return proto.common.CompaniesRq.deserializeBinaryFromReader(r, e);
  }, proto.common.CompaniesRq.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = new l.AdditionalProperties();
          e.readMessage(s, l.AdditionalProperties.deserializeBinaryFromReader), i.setProperties(s);
          break;
        case 2:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setOneonly(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.CompaniesRq.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.CompaniesRq.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.CompaniesRq.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getProperties(), r != null && e.writeMessage(
      1,
      r,
      l.AdditionalProperties.serializeBinaryToWriter
    ), r = i.getOneonly(), r && e.writeBool(
      2,
      r
    );
  }, proto.common.CompaniesRq.prototype.getProperties = function() {
    return (
      /** @type{?proto.priority.netitems.metadata.AdditionalProperties} */
      t.Message.getWrapperField(this, l.AdditionalProperties, 1)
    );
  }, proto.common.CompaniesRq.prototype.setProperties = function(i) {
    return t.Message.setWrapperField(this, 1, i);
  }, proto.common.CompaniesRq.prototype.clearProperties = function() {
    return this.setProperties(void 0);
  }, proto.common.CompaniesRq.prototype.hasProperties = function() {
    return t.Message.getField(this, 1) != null;
  }, proto.common.CompaniesRq.prototype.getOneonly = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, proto.common.CompaniesRq.prototype.setOneonly = function(i) {
    return t.Message.setProto3BooleanField(this, 2, i);
  }, proto.common.CompaniesRs.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.common.CompaniesRs.prototype.toObject = function(i) {
    return proto.common.CompaniesRs.toObject(i, this);
  }, proto.common.CompaniesRs.toObject = function(i, e) {
    var r = {
      companiesList: t.Message.toObjectList(
        e.getCompaniesList(),
        proto.common.CompanyData.toObject,
        i
      )
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.CompaniesRs.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.CompaniesRs();
    return proto.common.CompaniesRs.deserializeBinaryFromReader(r, e);
  }, proto.common.CompaniesRs.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = new proto.common.CompanyData();
          e.readMessage(s, proto.common.CompanyData.deserializeBinaryFromReader), i.addCompanies(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.CompaniesRs.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.CompaniesRs.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.CompaniesRs.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getCompaniesList(), r.length > 0 && e.writeRepeatedMessage(
      1,
      r,
      proto.common.CompanyData.serializeBinaryToWriter
    );
  }, proto.common.CompaniesRs.prototype.getCompaniesList = function() {
    return (
      /** @type{!Array<!proto.common.CompanyData>} */
      t.Message.getRepeatedWrapperField(this, proto.common.CompanyData, 1)
    );
  }, proto.common.CompaniesRs.prototype.setCompaniesList = function(i) {
    return t.Message.setRepeatedWrapperField(this, 1, i);
  }, proto.common.CompaniesRs.prototype.addCompanies = function(i, e) {
    return t.Message.addToRepeatedWrapperField(this, 1, i, proto.common.CompanyData, e);
  }, proto.common.CompaniesRs.prototype.clearCompaniesList = function() {
    return this.setCompaniesList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.InternalServiceMetadata.prototype.toObject = function(i) {
    return proto.common.InternalServiceMetadata.toObject(i, this);
  }, proto.common.InternalServiceMetadata.toObject = function(i, e) {
    var r = {
      tenantid: t.Message.getFieldWithDefault(e, 1, ""),
      prefix: t.Message.getFieldWithDefault(e, 2, "")
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.InternalServiceMetadata.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.InternalServiceMetadata();
    return proto.common.InternalServiceMetadata.deserializeBinaryFromReader(r, e);
  }, proto.common.InternalServiceMetadata.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setTenantid(s);
          break;
        case 2:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setPrefix(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.InternalServiceMetadata.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.InternalServiceMetadata.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.InternalServiceMetadata.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getTenantid(), r.length > 0 && e.writeString(
      1,
      r
    ), r = i.getPrefix(), r.length > 0 && e.writeString(
      2,
      r
    );
  }, proto.common.InternalServiceMetadata.prototype.getTenantid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.InternalServiceMetadata.prototype.setTenantid = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.common.InternalServiceMetadata.prototype.getPrefix = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.common.InternalServiceMetadata.prototype.setPrefix = function(i) {
    return t.Message.setProto3StringField(this, 2, i);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.TenantData.prototype.toObject = function(i) {
    return proto.common.TenantData.toObject(i, this);
  }, proto.common.TenantData.toObject = function(i, e) {
    var r, s = {
      licenseid: t.Message.getFieldWithDefault(e, 1, ""),
      tenantid: t.Message.getFieldWithDefault(e, 2, ""),
      tabini: t.Message.getFieldWithDefault(e, 3, ""),
      wcf: t.Message.getFieldWithDefault(e, 4, ""),
      server: t.Message.getFieldWithDefault(e, 5, ""),
      dname: t.Message.getFieldWithDefault(e, 6, ""),
      version: t.Message.getFloatingPointFieldWithDefault(e, 9, 0),
      basiclanguage: t.Message.getFieldWithDefault(e, 10, 0),
      webclient: t.Message.getFieldWithDefault(e, 11, ""),
      externalonly: t.Message.getBooleanFieldWithDefault(e, 12, !1),
      admode: t.Message.getFieldWithDefault(e, 13, 0),
      defaultprettyname: t.Message.getFieldWithDefault(e, 14, ""),
      locktype: t.Message.getFieldWithDefault(e, 15, ""),
      tsdisabled: t.Message.getBooleanFieldWithDefault(e, 16, !1),
      alert: t.Message.getFieldWithDefault(e, 17, ""),
      isrealcloud: t.Message.getBooleanFieldWithDefault(e, 18, !1),
      prefix: t.Message.getFieldWithDefault(e, 19, ""),
      db: (r = e.getDb()) && proto.common.MssqlInstance.toObject(i, r),
      sqltier: t.Message.getFieldWithDefault(e, 21, 0)
    };
    return i && (s.$jspbMessageInstance = e), s;
  }), proto.common.TenantData.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.TenantData();
    return proto.common.TenantData.deserializeBinaryFromReader(r, e);
  }, proto.common.TenantData.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setLicenseid(s);
          break;
        case 2:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setTenantid(s);
          break;
        case 3:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setTabini(s);
          break;
        case 4:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setWcf(s);
          break;
        case 5:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setServer(s);
          break;
        case 6:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setDname(s);
          break;
        case 9:
          var s = (
            /** @type {number} */
            e.readFloat()
          );
          i.setVersion(s);
          break;
        case 10:
          var s = (
            /** @type {number} */
            e.readInt64()
          );
          i.setBasiclanguage(s);
          break;
        case 11:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setWebclient(s);
          break;
        case 12:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setExternalonly(s);
          break;
        case 13:
          var s = (
            /** @type {number} */
            e.readInt64()
          );
          i.setAdmode(s);
          break;
        case 14:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setDefaultprettyname(s);
          break;
        case 15:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setLocktype(s);
          break;
        case 16:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setTsdisabled(s);
          break;
        case 17:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setAlert(s);
          break;
        case 18:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setIsrealcloud(s);
          break;
        case 19:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setPrefix(s);
          break;
        case 20:
          var s = new proto.common.MssqlInstance();
          e.readMessage(s, proto.common.MssqlInstance.deserializeBinaryFromReader), i.setDb(s);
          break;
        case 21:
          var s = (
            /** @type {!proto.common.SqlTier} */
            e.readEnum()
          );
          i.setSqltier(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.TenantData.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.TenantData.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.TenantData.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getLicenseid(), r.length > 0 && e.writeString(
      1,
      r
    ), r = i.getTenantid(), r.length > 0 && e.writeString(
      2,
      r
    ), r = i.getTabini(), r.length > 0 && e.writeString(
      3,
      r
    ), r = i.getWcf(), r.length > 0 && e.writeString(
      4,
      r
    ), r = i.getServer(), r.length > 0 && e.writeString(
      5,
      r
    ), r = i.getDname(), r.length > 0 && e.writeString(
      6,
      r
    ), r = i.getVersion(), r !== 0 && e.writeFloat(
      9,
      r
    ), r = i.getBasiclanguage(), r !== 0 && e.writeInt64(
      10,
      r
    ), r = i.getWebclient(), r.length > 0 && e.writeString(
      11,
      r
    ), r = i.getExternalonly(), r && e.writeBool(
      12,
      r
    ), r = i.getAdmode(), r !== 0 && e.writeInt64(
      13,
      r
    ), r = i.getDefaultprettyname(), r.length > 0 && e.writeString(
      14,
      r
    ), r = i.getLocktype(), r.length > 0 && e.writeString(
      15,
      r
    ), r = i.getTsdisabled(), r && e.writeBool(
      16,
      r
    ), r = i.getAlert(), r.length > 0 && e.writeString(
      17,
      r
    ), r = i.getIsrealcloud(), r && e.writeBool(
      18,
      r
    ), r = i.getPrefix(), r.length > 0 && e.writeString(
      19,
      r
    ), r = i.getDb(), r != null && e.writeMessage(
      20,
      r,
      proto.common.MssqlInstance.serializeBinaryToWriter
    ), r = i.getSqltier(), r !== 0 && e.writeEnum(
      21,
      r
    );
  }, proto.common.TenantData.prototype.getLicenseid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.TenantData.prototype.setLicenseid = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.common.TenantData.prototype.getTenantid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.common.TenantData.prototype.setTenantid = function(i) {
    return t.Message.setProto3StringField(this, 2, i);
  }, proto.common.TenantData.prototype.getTabini = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.common.TenantData.prototype.setTabini = function(i) {
    return t.Message.setProto3StringField(this, 3, i);
  }, proto.common.TenantData.prototype.getWcf = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.common.TenantData.prototype.setWcf = function(i) {
    return t.Message.setProto3StringField(this, 4, i);
  }, proto.common.TenantData.prototype.getServer = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 5, "")
    );
  }, proto.common.TenantData.prototype.setServer = function(i) {
    return t.Message.setProto3StringField(this, 5, i);
  }, proto.common.TenantData.prototype.getDname = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 6, "")
    );
  }, proto.common.TenantData.prototype.setDname = function(i) {
    return t.Message.setProto3StringField(this, 6, i);
  }, proto.common.TenantData.prototype.getVersion = function() {
    return (
      /** @type {number} */
      t.Message.getFloatingPointFieldWithDefault(this, 9, 0)
    );
  }, proto.common.TenantData.prototype.setVersion = function(i) {
    return t.Message.setProto3FloatField(this, 9, i);
  }, proto.common.TenantData.prototype.getBasiclanguage = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 10, 0)
    );
  }, proto.common.TenantData.prototype.setBasiclanguage = function(i) {
    return t.Message.setProto3IntField(this, 10, i);
  }, proto.common.TenantData.prototype.getWebclient = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.common.TenantData.prototype.setWebclient = function(i) {
    return t.Message.setProto3StringField(this, 11, i);
  }, proto.common.TenantData.prototype.getExternalonly = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 12, !1)
    );
  }, proto.common.TenantData.prototype.setExternalonly = function(i) {
    return t.Message.setProto3BooleanField(this, 12, i);
  }, proto.common.TenantData.prototype.getAdmode = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 13, 0)
    );
  }, proto.common.TenantData.prototype.setAdmode = function(i) {
    return t.Message.setProto3IntField(this, 13, i);
  }, proto.common.TenantData.prototype.getDefaultprettyname = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 14, "")
    );
  }, proto.common.TenantData.prototype.setDefaultprettyname = function(i) {
    return t.Message.setProto3StringField(this, 14, i);
  }, proto.common.TenantData.prototype.getLocktype = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 15, "")
    );
  }, proto.common.TenantData.prototype.setLocktype = function(i) {
    return t.Message.setProto3StringField(this, 15, i);
  }, proto.common.TenantData.prototype.getTsdisabled = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 16, !1)
    );
  }, proto.common.TenantData.prototype.setTsdisabled = function(i) {
    return t.Message.setProto3BooleanField(this, 16, i);
  }, proto.common.TenantData.prototype.getAlert = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 17, "")
    );
  }, proto.common.TenantData.prototype.setAlert = function(i) {
    return t.Message.setProto3StringField(this, 17, i);
  }, proto.common.TenantData.prototype.getIsrealcloud = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 18, !1)
    );
  }, proto.common.TenantData.prototype.setIsrealcloud = function(i) {
    return t.Message.setProto3BooleanField(this, 18, i);
  }, proto.common.TenantData.prototype.getPrefix = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 19, "")
    );
  }, proto.common.TenantData.prototype.setPrefix = function(i) {
    return t.Message.setProto3StringField(this, 19, i);
  }, proto.common.TenantData.prototype.getDb = function() {
    return (
      /** @type{?proto.common.MssqlInstance} */
      t.Message.getWrapperField(this, proto.common.MssqlInstance, 20)
    );
  }, proto.common.TenantData.prototype.setDb = function(i) {
    return t.Message.setWrapperField(this, 20, i);
  }, proto.common.TenantData.prototype.clearDb = function() {
    return this.setDb(void 0);
  }, proto.common.TenantData.prototype.hasDb = function() {
    return t.Message.getField(this, 20) != null;
  }, proto.common.TenantData.prototype.getSqltier = function() {
    return (
      /** @type {!proto.common.SqlTier} */
      t.Message.getFieldWithDefault(this, 21, 0)
    );
  }, proto.common.TenantData.prototype.setSqltier = function(i) {
    return t.Message.setProto3EnumField(this, 21, i);
  }, proto.common.Tenants.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.common.Tenants.prototype.toObject = function(i) {
    return proto.common.Tenants.toObject(i, this);
  }, proto.common.Tenants.toObject = function(i, e) {
    var r = {
      valuesList: t.Message.toObjectList(
        e.getValuesList(),
        proto.common.TenantData.toObject,
        i
      )
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.Tenants.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.Tenants();
    return proto.common.Tenants.deserializeBinaryFromReader(r, e);
  }, proto.common.Tenants.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = new proto.common.TenantData();
          e.readMessage(s, proto.common.TenantData.deserializeBinaryFromReader), i.addValues(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.Tenants.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.Tenants.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.Tenants.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getValuesList(), r.length > 0 && e.writeRepeatedMessage(
      1,
      r,
      proto.common.TenantData.serializeBinaryToWriter
    );
  }, proto.common.Tenants.prototype.getValuesList = function() {
    return (
      /** @type{!Array<!proto.common.TenantData>} */
      t.Message.getRepeatedWrapperField(this, proto.common.TenantData, 1)
    );
  }, proto.common.Tenants.prototype.setValuesList = function(i) {
    return t.Message.setRepeatedWrapperField(this, 1, i);
  }, proto.common.Tenants.prototype.addValues = function(i, e) {
    return t.Message.addToRepeatedWrapperField(this, 1, i, proto.common.TenantData, e);
  }, proto.common.Tenants.prototype.clearValuesList = function() {
    return this.setValuesList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.MssqlInstance.prototype.toObject = function(i) {
    return proto.common.MssqlInstance.toObject(i, this);
  }, proto.common.MssqlInstance.toObject = function(i, e) {
    var r = {
      id: t.Message.getFieldWithDefault(e, 1, 0),
      name: t.Message.getFieldWithDefault(e, 2, ""),
      collation: t.Message.getFieldWithDefault(e, 3, ""),
      edition: t.Message.getFieldWithDefault(e, 4, ""),
      memorylimit: t.Message.getFieldWithDefault(e, 5, 0),
      active: t.Message.getBooleanFieldWithDefault(e, 6, !1),
      host: t.Message.getFieldWithDefault(e, 7, ""),
      maxtenants: t.Message.getFieldWithDefault(e, 8, 0),
      hostlocation: t.Message.getFieldWithDefault(e, 9, ""),
      sapassword: t.Message.getFieldWithDefault(e, 10, ""),
      instancetype: t.Message.getFieldWithDefault(e, 11, ""),
      volumeid: t.Message.getFieldWithDefault(e, 12, 0)
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.MssqlInstance.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.MssqlInstance();
    return proto.common.MssqlInstance.deserializeBinaryFromReader(r, e);
  }, proto.common.MssqlInstance.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {number} */
            e.readInt64()
          );
          i.setId(s);
          break;
        case 2:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setName(s);
          break;
        case 3:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setCollation(s);
          break;
        case 4:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setEdition(s);
          break;
        case 5:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setMemorylimit(s);
          break;
        case 6:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setActive(s);
          break;
        case 7:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setHost(s);
          break;
        case 8:
          var s = (
            /** @type {number} */
            e.readInt32()
          );
          i.setMaxtenants(s);
          break;
        case 9:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setHostlocation(s);
          break;
        case 10:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setSapassword(s);
          break;
        case 11:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setInstancetype(s);
          break;
        case 12:
          var s = (
            /** @type {number} */
            e.readInt64()
          );
          i.setVolumeid(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.MssqlInstance.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.MssqlInstance.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.MssqlInstance.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getId(), r !== 0 && e.writeInt64(
      1,
      r
    ), r = i.getName(), r.length > 0 && e.writeString(
      2,
      r
    ), r = i.getCollation(), r.length > 0 && e.writeString(
      3,
      r
    ), r = i.getEdition(), r.length > 0 && e.writeString(
      4,
      r
    ), r = i.getMemorylimit(), r !== 0 && e.writeInt32(
      5,
      r
    ), r = i.getActive(), r && e.writeBool(
      6,
      r
    ), r = i.getHost(), r.length > 0 && e.writeString(
      7,
      r
    ), r = i.getMaxtenants(), r !== 0 && e.writeInt32(
      8,
      r
    ), r = i.getHostlocation(), r.length > 0 && e.writeString(
      9,
      r
    ), r = i.getSapassword(), r.length > 0 && e.writeString(
      10,
      r
    ), r = i.getInstancetype(), r.length > 0 && e.writeString(
      11,
      r
    ), r = i.getVolumeid(), r !== 0 && e.writeInt64(
      12,
      r
    );
  }, proto.common.MssqlInstance.prototype.getId = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.common.MssqlInstance.prototype.setId = function(i) {
    return t.Message.setProto3IntField(this, 1, i);
  }, proto.common.MssqlInstance.prototype.getName = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.common.MssqlInstance.prototype.setName = function(i) {
    return t.Message.setProto3StringField(this, 2, i);
  }, proto.common.MssqlInstance.prototype.getCollation = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.common.MssqlInstance.prototype.setCollation = function(i) {
    return t.Message.setProto3StringField(this, 3, i);
  }, proto.common.MssqlInstance.prototype.getEdition = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.common.MssqlInstance.prototype.setEdition = function(i) {
    return t.Message.setProto3StringField(this, 4, i);
  }, proto.common.MssqlInstance.prototype.getMemorylimit = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.common.MssqlInstance.prototype.setMemorylimit = function(i) {
    return t.Message.setProto3IntField(this, 5, i);
  }, proto.common.MssqlInstance.prototype.getActive = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 6, !1)
    );
  }, proto.common.MssqlInstance.prototype.setActive = function(i) {
    return t.Message.setProto3BooleanField(this, 6, i);
  }, proto.common.MssqlInstance.prototype.getHost = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 7, "")
    );
  }, proto.common.MssqlInstance.prototype.setHost = function(i) {
    return t.Message.setProto3StringField(this, 7, i);
  }, proto.common.MssqlInstance.prototype.getMaxtenants = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 8, 0)
    );
  }, proto.common.MssqlInstance.prototype.setMaxtenants = function(i) {
    return t.Message.setProto3IntField(this, 8, i);
  }, proto.common.MssqlInstance.prototype.getHostlocation = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 9, "")
    );
  }, proto.common.MssqlInstance.prototype.setHostlocation = function(i) {
    return t.Message.setProto3StringField(this, 9, i);
  }, proto.common.MssqlInstance.prototype.getSapassword = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 10, "")
    );
  }, proto.common.MssqlInstance.prototype.setSapassword = function(i) {
    return t.Message.setProto3StringField(this, 10, i);
  }, proto.common.MssqlInstance.prototype.getInstancetype = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.common.MssqlInstance.prototype.setInstancetype = function(i) {
    return t.Message.setProto3StringField(this, 11, i);
  }, proto.common.MssqlInstance.prototype.getVolumeid = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.common.MssqlInstance.prototype.setVolumeid = function(i) {
    return t.Message.setProto3IntField(this, 12, i);
  }, proto.common.SessionStatus.oneofGroups_ = [[5]], proto.common.SessionStatus.DataCase = {
    DATA_NOT_SET: 0,
    FILED: 5
  }, proto.common.SessionStatus.prototype.getDataCase = function() {
    return (
      /** @type {proto.common.SessionStatus.DataCase} */
      t.Message.computeOneofCase(this, proto.common.SessionStatus.oneofGroups_[0])
    );
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.SessionStatus.prototype.toObject = function(i) {
    return proto.common.SessionStatus.toObject(i, this);
  }, proto.common.SessionStatus.toObject = function(i, e) {
    var r, s = {
      type: t.Message.getFieldWithDefault(e, 1, 0),
      message: t.Message.getFieldWithDefault(e, 2, ""),
      updateline: t.Message.getBooleanFieldWithDefault(e, 3, !1),
      pb_final: t.Message.getBooleanFieldWithDefault(e, 4, !1),
      filed: (r = e.getFiled()) && proto.common.FileDownload.toObject(i, r)
    };
    return i && (s.$jspbMessageInstance = e), s;
  }), proto.common.SessionStatus.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.SessionStatus();
    return proto.common.SessionStatus.deserializeBinaryFromReader(r, e);
  }, proto.common.SessionStatus.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {!proto.common.SessionStatus.StatusType} */
            e.readEnum()
          );
          i.setType(s);
          break;
        case 2:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setMessage(s);
          break;
        case 3:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setUpdateline(s);
          break;
        case 4:
          var s = (
            /** @type {boolean} */
            e.readBool()
          );
          i.setFinal(s);
          break;
        case 5:
          var s = new proto.common.FileDownload();
          e.readMessage(s, proto.common.FileDownload.deserializeBinaryFromReader), i.setFiled(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.SessionStatus.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.SessionStatus.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.SessionStatus.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getType(), r !== 0 && e.writeEnum(
      1,
      r
    ), r = i.getMessage(), r.length > 0 && e.writeString(
      2,
      r
    ), r = i.getUpdateline(), r && e.writeBool(
      3,
      r
    ), r = i.getFinal(), r && e.writeBool(
      4,
      r
    ), r = i.getFiled(), r != null && e.writeMessage(
      5,
      r,
      proto.common.FileDownload.serializeBinaryToWriter
    );
  }, proto.common.SessionStatus.StatusType = {
    INFO: 0,
    ERROR: 1,
    CRITICALERROR: 2
  }, proto.common.SessionStatus.prototype.getType = function() {
    return (
      /** @type {!proto.common.SessionStatus.StatusType} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.common.SessionStatus.prototype.setType = function(i) {
    return t.Message.setProto3EnumField(this, 1, i);
  }, proto.common.SessionStatus.prototype.getMessage = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.common.SessionStatus.prototype.setMessage = function(i) {
    return t.Message.setProto3StringField(this, 2, i);
  }, proto.common.SessionStatus.prototype.getUpdateline = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, proto.common.SessionStatus.prototype.setUpdateline = function(i) {
    return t.Message.setProto3BooleanField(this, 3, i);
  }, proto.common.SessionStatus.prototype.getFinal = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 4, !1)
    );
  }, proto.common.SessionStatus.prototype.setFinal = function(i) {
    return t.Message.setProto3BooleanField(this, 4, i);
  }, proto.common.SessionStatus.prototype.getFiled = function() {
    return (
      /** @type{?proto.common.FileDownload} */
      t.Message.getWrapperField(this, proto.common.FileDownload, 5)
    );
  }, proto.common.SessionStatus.prototype.setFiled = function(i) {
    return t.Message.setOneofWrapperField(this, 5, proto.common.SessionStatus.oneofGroups_[0], i);
  }, proto.common.SessionStatus.prototype.clearFiled = function() {
    return this.setFiled(void 0);
  }, proto.common.SessionStatus.prototype.hasFiled = function() {
    return t.Message.getField(this, 5) != null;
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.FileDownload.prototype.toObject = function(i) {
    return proto.common.FileDownload.toObject(i, this);
  }, proto.common.FileDownload.toObject = function(i, e) {
    var r = {
      url: t.Message.getFieldWithDefault(e, 1, ""),
      filesize: t.Message.getFloatingPointFieldWithDefault(e, 2, 0)
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.FileDownload.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.FileDownload();
    return proto.common.FileDownload.deserializeBinaryFromReader(r, e);
  }, proto.common.FileDownload.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setUrl(s);
          break;
        case 2:
          var s = (
            /** @type {number} */
            e.readDouble()
          );
          i.setFilesize(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.FileDownload.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.FileDownload.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.FileDownload.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getUrl(), r.length > 0 && e.writeString(
      1,
      r
    ), r = i.getFilesize(), r !== 0 && e.writeDouble(
      2,
      r
    );
  }, proto.common.FileDownload.prototype.getUrl = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.FileDownload.prototype.setUrl = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.common.FileDownload.prototype.getFilesize = function() {
    return (
      /** @type {number} */
      t.Message.getFloatingPointFieldWithDefault(this, 2, 0)
    );
  }, proto.common.FileDownload.prototype.setFilesize = function(i) {
    return t.Message.setProto3FloatField(this, 2, i);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.SessionRq.prototype.toObject = function(i) {
    return proto.common.SessionRq.toObject(i, this);
  }, proto.common.SessionRq.toObject = function(i, e) {
    var r = {
      session: t.Message.getFieldWithDefault(e, 1, "")
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.SessionRq.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.SessionRq();
    return proto.common.SessionRq.deserializeBinaryFromReader(r, e);
  }, proto.common.SessionRq.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setSession(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.SessionRq.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.SessionRq.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.SessionRq.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getSession(), r.length > 0 && e.writeString(
      1,
      r
    );
  }, proto.common.SessionRq.prototype.getSession = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.SessionRq.prototype.setSession = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.common.SessionRs.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.common.SessionRs.prototype.toObject = function(i) {
    return proto.common.SessionRs.toObject(i, this);
  }, proto.common.SessionRs.toObject = function(i, e) {
    var r = {
      statusesList: t.Message.toObjectList(
        e.getStatusesList(),
        proto.common.SessionStatus.toObject,
        i
      )
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.SessionRs.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.SessionRs();
    return proto.common.SessionRs.deserializeBinaryFromReader(r, e);
  }, proto.common.SessionRs.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = new proto.common.SessionStatus();
          e.readMessage(s, proto.common.SessionStatus.deserializeBinaryFromReader), i.addStatuses(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.SessionRs.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.SessionRs.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.SessionRs.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getStatusesList(), r.length > 0 && e.writeRepeatedMessage(
      1,
      r,
      proto.common.SessionStatus.serializeBinaryToWriter
    );
  }, proto.common.SessionRs.prototype.getStatusesList = function() {
    return (
      /** @type{!Array<!proto.common.SessionStatus>} */
      t.Message.getRepeatedWrapperField(this, proto.common.SessionStatus, 1)
    );
  }, proto.common.SessionRs.prototype.setStatusesList = function(i) {
    return t.Message.setRepeatedWrapperField(this, 1, i);
  }, proto.common.SessionRs.prototype.addStatuses = function(i, e) {
    return t.Message.addToRepeatedWrapperField(this, 1, i, proto.common.SessionStatus, e);
  }, proto.common.SessionRs.prototype.clearStatusesList = function() {
    return this.setStatusesList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.SessionID.prototype.toObject = function(i) {
    return proto.common.SessionID.toObject(i, this);
  }, proto.common.SessionID.toObject = function(i, e) {
    var r = {
      sessionid: t.Message.getFieldWithDefault(e, 1, "")
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.SessionID.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.SessionID();
    return proto.common.SessionID.deserializeBinaryFromReader(r, e);
  }, proto.common.SessionID.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setSessionid(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.SessionID.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.SessionID.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.SessionID.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getSessionid(), r.length > 0 && e.writeString(
      1,
      r
    );
  }, proto.common.SessionID.prototype.getSessionid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.SessionID.prototype.setSessionid = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.TenantDynamoTable.prototype.toObject = function(i) {
    return proto.common.TenantDynamoTable.toObject(i, this);
  }, proto.common.TenantDynamoTable.toObject = function(i, e) {
    var r = {
      tablename: t.Message.getFieldWithDefault(e, 1, ""),
      datajson: e.getDatajson_asB64()
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.TenantDynamoTable.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.TenantDynamoTable();
    return proto.common.TenantDynamoTable.deserializeBinaryFromReader(r, e);
  }, proto.common.TenantDynamoTable.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setTablename(s);
          break;
        case 2:
          var s = (
            /** @type {!Uint8Array} */
            e.readBytes()
          );
          i.setDatajson(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.TenantDynamoTable.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.TenantDynamoTable.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.TenantDynamoTable.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getTablename(), r.length > 0 && e.writeString(
      1,
      r
    ), r = i.getDatajson_asU8(), r.length > 0 && e.writeBytes(
      2,
      r
    );
  }, proto.common.TenantDynamoTable.prototype.getTablename = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.TenantDynamoTable.prototype.setTablename = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.common.TenantDynamoTable.prototype.getDatajson = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.common.TenantDynamoTable.prototype.getDatajson_asB64 = function() {
    return (
      /** @type {string} */
      t.Message.bytesAsB64(
        this.getDatajson()
      )
    );
  }, proto.common.TenantDynamoTable.prototype.getDatajson_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      t.Message.bytesAsU8(
        this.getDatajson()
      )
    );
  }, proto.common.TenantDynamoTable.prototype.setDatajson = function(i) {
    return t.Message.setProto3BytesField(this, 2, i);
  }, proto.common.TenantDynamoData.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.common.TenantDynamoData.prototype.toObject = function(i) {
    return proto.common.TenantDynamoData.toObject(i, this);
  }, proto.common.TenantDynamoData.toObject = function(i, e) {
    var r = {
      tablesdataList: t.Message.toObjectList(
        e.getTablesdataList(),
        proto.common.TenantDynamoTable.toObject,
        i
      )
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.TenantDynamoData.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.TenantDynamoData();
    return proto.common.TenantDynamoData.deserializeBinaryFromReader(r, e);
  }, proto.common.TenantDynamoData.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = new proto.common.TenantDynamoTable();
          e.readMessage(s, proto.common.TenantDynamoTable.deserializeBinaryFromReader), i.addTablesdata(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.TenantDynamoData.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.TenantDynamoData.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.TenantDynamoData.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getTablesdataList(), r.length > 0 && e.writeRepeatedMessage(
      1,
      r,
      proto.common.TenantDynamoTable.serializeBinaryToWriter
    );
  }, proto.common.TenantDynamoData.prototype.getTablesdataList = function() {
    return (
      /** @type{!Array<!proto.common.TenantDynamoTable>} */
      t.Message.getRepeatedWrapperField(this, proto.common.TenantDynamoTable, 1)
    );
  }, proto.common.TenantDynamoData.prototype.setTablesdataList = function(i) {
    return t.Message.setRepeatedWrapperField(this, 1, i);
  }, proto.common.TenantDynamoData.prototype.addTablesdata = function(i, e) {
    return t.Message.addToRepeatedWrapperField(this, 1, i, proto.common.TenantDynamoTable, e);
  }, proto.common.TenantDynamoData.prototype.clearTablesdataList = function() {
    return this.setTablesdataList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.common.TenantDynamoDataRq.prototype.toObject = function(i) {
    return proto.common.TenantDynamoDataRq.toObject(i, this);
  }, proto.common.TenantDynamoDataRq.toObject = function(i, e) {
    var r = {
      tenantid: t.Message.getFieldWithDefault(e, 1, "")
    };
    return i && (r.$jspbMessageInstance = e), r;
  }), proto.common.TenantDynamoDataRq.deserializeBinary = function(i) {
    var e = new t.BinaryReader(i), r = new proto.common.TenantDynamoDataRq();
    return proto.common.TenantDynamoDataRq.deserializeBinaryFromReader(r, e);
  }, proto.common.TenantDynamoDataRq.deserializeBinaryFromReader = function(i, e) {
    for (; e.nextField() && !e.isEndGroup(); ) {
      var r = e.getFieldNumber();
      switch (r) {
        case 1:
          var s = (
            /** @type {string} */
            e.readString()
          );
          i.setTenantid(s);
          break;
        default:
          e.skipField();
          break;
      }
    }
    return i;
  }, proto.common.TenantDynamoDataRq.prototype.serializeBinary = function() {
    var i = new t.BinaryWriter();
    return proto.common.TenantDynamoDataRq.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.common.TenantDynamoDataRq.serializeBinaryToWriter = function(i, e) {
    var r = void 0;
    r = i.getTenantid(), r.length > 0 && e.writeString(
      1,
      r
    );
  }, proto.common.TenantDynamoDataRq.prototype.getTenantid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.common.TenantDynamoDataRq.prototype.setTenantid = function(i) {
    return t.Message.setProto3StringField(this, 1, i);
  }, proto.common.SqlTier = {
    NONE: 0,
    ZOOM: 1,
    SMALL: 2,
    MEDIUM: 3,
    LARGE: 4,
    XLARGE: 5,
    ENTERPRISE: 6
  }, p.object.extend(n, proto.common);
})(Cr);
const Xp = /* @__PURE__ */ Zt(Cr), ll = /* @__PURE__ */ Ht({
  __proto__: null,
  default: Xp
}, [Cr]);
(function(n) {
  var t = Kt, p = t, f = (function() {
    return this || window || f || self || Function("return this")();
  }).call(null), l = Cr;
  p.object.extend(proto, l);
  var i = ar;
  p.object.extend(proto, i), p.exportSymbol("proto.priority.geoservice.CapacityList", null, f), p.exportSymbol("proto.priority.geoservice.Delivery", null, f), p.exportSymbol("proto.priority.geoservice.DeliveryList", null, f), p.exportSymbol("proto.priority.geoservice.Job", null, f), p.exportSymbol("proto.priority.geoservice.Options", null, f), p.exportSymbol("proto.priority.geoservice.Options.MetricType", null, f), p.exportSymbol("proto.priority.geoservice.Pickup", null, f), p.exportSymbol("proto.priority.geoservice.PickupList", null, f), p.exportSymbol("proto.priority.geoservice.Relation", null, f), p.exportSymbol("proto.priority.geoservice.Relation.RelationStep", null, f), p.exportSymbol("proto.priority.geoservice.Relation.RelationType", null, f), p.exportSymbol("proto.priority.geoservice.Relation.StepType", null, f), p.exportSymbol("proto.priority.geoservice.RelationList", null, f), p.exportSymbol("proto.priority.geoservice.Route", null, f), p.exportSymbol("proto.priority.geoservice.RouteList", null, f), p.exportSymbol("proto.priority.geoservice.RouteOptimizationRq", null, f), p.exportSymbol("proto.priority.geoservice.RouteOptimizationRs", null, f), p.exportSymbol("proto.priority.geoservice.SkillList", null, f), p.exportSymbol("proto.priority.geoservice.Status", null, f), p.exportSymbol("proto.priority.geoservice.Status.StateType", null, f), p.exportSymbol("proto.priority.geoservice.Step", null, f), p.exportSymbol("proto.priority.geoservice.Step.StepType", null, f), p.exportSymbol("proto.priority.geoservice.Summary", null, f), p.exportSymbol("proto.priority.geoservice.TimeWindow", null, f), p.exportSymbol("proto.priority.geoservice.TimeWindowList", null, f), p.exportSymbol("proto.priority.geoservice.Unassigned", null, f), p.exportSymbol("proto.priority.geoservice.UnassignedList", null, f), p.exportSymbol("proto.priority.geoservice.Vehicle", null, f), p.exportSymbol("proto.priority.geoservice.Zone", null, f), p.exportSymbol("proto.priority.geoservice.ZoneList", null, f), proto.priority.geoservice.Delivery = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Delivery, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Delivery.displayName = "proto.priority.geoservice.Delivery"), proto.priority.geoservice.DeliveryList = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.DeliveryList.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.DeliveryList, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.DeliveryList.displayName = "proto.priority.geoservice.DeliveryList"), proto.priority.geoservice.Pickup = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Pickup, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Pickup.displayName = "proto.priority.geoservice.Pickup"), proto.priority.geoservice.PickupList = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.PickupList.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.PickupList, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.PickupList.displayName = "proto.priority.geoservice.PickupList"), proto.priority.geoservice.SkillList = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.SkillList.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.SkillList, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.SkillList.displayName = "proto.priority.geoservice.SkillList"), proto.priority.geoservice.TimeWindow = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.TimeWindow, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.TimeWindow.displayName = "proto.priority.geoservice.TimeWindow"), proto.priority.geoservice.TimeWindowList = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.TimeWindowList.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.TimeWindowList, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.TimeWindowList.displayName = "proto.priority.geoservice.TimeWindowList"), proto.priority.geoservice.Zone = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Zone, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Zone.displayName = "proto.priority.geoservice.Zone"), proto.priority.geoservice.ZoneList = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.ZoneList.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.ZoneList, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.ZoneList.displayName = "proto.priority.geoservice.ZoneList"), proto.priority.geoservice.Job = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Job, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Job.displayName = "proto.priority.geoservice.Job"), proto.priority.geoservice.CapacityList = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.CapacityList.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.CapacityList, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.CapacityList.displayName = "proto.priority.geoservice.CapacityList"), proto.priority.geoservice.Vehicle = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Vehicle, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Vehicle.displayName = "proto.priority.geoservice.Vehicle"), proto.priority.geoservice.Relation = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.Relation.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.Relation, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Relation.displayName = "proto.priority.geoservice.Relation"), proto.priority.geoservice.Relation.RelationStep = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Relation.RelationStep, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Relation.RelationStep.displayName = "proto.priority.geoservice.Relation.RelationStep"), proto.priority.geoservice.RelationList = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.RelationList.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.RelationList, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.RelationList.displayName = "proto.priority.geoservice.RelationList"), proto.priority.geoservice.Options = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Options, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Options.displayName = "proto.priority.geoservice.Options"), proto.priority.geoservice.RouteOptimizationRq = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.RouteOptimizationRq.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.RouteOptimizationRq, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.RouteOptimizationRq.displayName = "proto.priority.geoservice.RouteOptimizationRq"), proto.priority.geoservice.Status = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Status, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Status.displayName = "proto.priority.geoservice.Status"), proto.priority.geoservice.Summary = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Summary, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Summary.displayName = "proto.priority.geoservice.Summary"), proto.priority.geoservice.Step = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Step, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Step.displayName = "proto.priority.geoservice.Step"), proto.priority.geoservice.Route = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.Route.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.Route, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Route.displayName = "proto.priority.geoservice.Route"), proto.priority.geoservice.RouteList = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.RouteList.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.RouteList, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.RouteList.displayName = "proto.priority.geoservice.RouteList"), proto.priority.geoservice.Unassigned = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.Unassigned, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.Unassigned.displayName = "proto.priority.geoservice.Unassigned"), proto.priority.geoservice.UnassignedList = function(e) {
    t.Message.initialize(this, e, 0, -1, proto.priority.geoservice.UnassignedList.repeatedFields_, null);
  }, p.inherits(proto.priority.geoservice.UnassignedList, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.UnassignedList.displayName = "proto.priority.geoservice.UnassignedList"), proto.priority.geoservice.RouteOptimizationRs = function(e) {
    t.Message.initialize(this, e, 0, -1, null, null);
  }, p.inherits(proto.priority.geoservice.RouteOptimizationRs, t.Message), p.DEBUG && !COMPILED && (proto.priority.geoservice.RouteOptimizationRs.displayName = "proto.priority.geoservice.RouteOptimizationRs"), t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Delivery.prototype.toObject = function(e) {
    return proto.priority.geoservice.Delivery.toObject(e, this);
  }, proto.priority.geoservice.Delivery.toObject = function(e, r) {
    var s = {
      weight: t.Message.getFieldWithDefault(r, 1, 0),
      volume: t.Message.getFieldWithDefault(r, 2, 0)
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.Delivery.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Delivery();
    return proto.priority.geoservice.Delivery.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Delivery.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setWeight(d);
          break;
        case 2:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setVolume(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Delivery.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Delivery.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Delivery.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getWeight(), s !== 0 && r.writeInt32(
      1,
      s
    ), s = e.getVolume(), s !== 0 && r.writeInt32(
      2,
      s
    );
  }, proto.priority.geoservice.Delivery.prototype.getWeight = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.geoservice.Delivery.prototype.setWeight = function(e) {
    return t.Message.setProto3IntField(this, 1, e);
  }, proto.priority.geoservice.Delivery.prototype.getVolume = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.priority.geoservice.Delivery.prototype.setVolume = function(e) {
    return t.Message.setProto3IntField(this, 2, e);
  }, proto.priority.geoservice.DeliveryList.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.DeliveryList.prototype.toObject = function(e) {
    return proto.priority.geoservice.DeliveryList.toObject(e, this);
  }, proto.priority.geoservice.DeliveryList.toObject = function(e, r) {
    var s = {
      deliveriesList: t.Message.toObjectList(
        r.getDeliveriesList(),
        proto.priority.geoservice.Delivery.toObject,
        e
      )
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.DeliveryList.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.DeliveryList();
    return proto.priority.geoservice.DeliveryList.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.DeliveryList.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = new proto.priority.geoservice.Delivery();
          r.readMessage(d, proto.priority.geoservice.Delivery.deserializeBinaryFromReader), e.addDeliveries(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.DeliveryList.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.DeliveryList.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.DeliveryList.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getDeliveriesList(), s.length > 0 && r.writeRepeatedMessage(
      1,
      s,
      proto.priority.geoservice.Delivery.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.DeliveryList.prototype.getDeliveriesList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.Delivery>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.Delivery, 1)
    );
  }, proto.priority.geoservice.DeliveryList.prototype.setDeliveriesList = function(e) {
    return t.Message.setRepeatedWrapperField(this, 1, e);
  }, proto.priority.geoservice.DeliveryList.prototype.addDeliveries = function(e, r) {
    return t.Message.addToRepeatedWrapperField(this, 1, e, proto.priority.geoservice.Delivery, r);
  }, proto.priority.geoservice.DeliveryList.prototype.clearDeliveriesList = function() {
    return this.setDeliveriesList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Pickup.prototype.toObject = function(e) {
    return proto.priority.geoservice.Pickup.toObject(e, this);
  }, proto.priority.geoservice.Pickup.toObject = function(e, r) {
    var s = {
      weight: t.Message.getFieldWithDefault(r, 1, 0),
      volume: t.Message.getFieldWithDefault(r, 2, 0)
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.Pickup.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Pickup();
    return proto.priority.geoservice.Pickup.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Pickup.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setWeight(d);
          break;
        case 2:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setVolume(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Pickup.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Pickup.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Pickup.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getWeight(), s !== 0 && r.writeInt32(
      1,
      s
    ), s = e.getVolume(), s !== 0 && r.writeInt32(
      2,
      s
    );
  }, proto.priority.geoservice.Pickup.prototype.getWeight = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.geoservice.Pickup.prototype.setWeight = function(e) {
    return t.Message.setProto3IntField(this, 1, e);
  }, proto.priority.geoservice.Pickup.prototype.getVolume = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.priority.geoservice.Pickup.prototype.setVolume = function(e) {
    return t.Message.setProto3IntField(this, 2, e);
  }, proto.priority.geoservice.PickupList.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.PickupList.prototype.toObject = function(e) {
    return proto.priority.geoservice.PickupList.toObject(e, this);
  }, proto.priority.geoservice.PickupList.toObject = function(e, r) {
    var s = {
      pickupsList: t.Message.toObjectList(
        r.getPickupsList(),
        proto.priority.geoservice.Pickup.toObject,
        e
      )
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.PickupList.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.PickupList();
    return proto.priority.geoservice.PickupList.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.PickupList.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = new proto.priority.geoservice.Pickup();
          r.readMessage(d, proto.priority.geoservice.Pickup.deserializeBinaryFromReader), e.addPickups(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.PickupList.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.PickupList.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.PickupList.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getPickupsList(), s.length > 0 && r.writeRepeatedMessage(
      1,
      s,
      proto.priority.geoservice.Pickup.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.PickupList.prototype.getPickupsList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.Pickup>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.Pickup, 1)
    );
  }, proto.priority.geoservice.PickupList.prototype.setPickupsList = function(e) {
    return t.Message.setRepeatedWrapperField(this, 1, e);
  }, proto.priority.geoservice.PickupList.prototype.addPickups = function(e, r) {
    return t.Message.addToRepeatedWrapperField(this, 1, e, proto.priority.geoservice.Pickup, r);
  }, proto.priority.geoservice.PickupList.prototype.clearPickupsList = function() {
    return this.setPickupsList([]);
  }, proto.priority.geoservice.SkillList.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.SkillList.prototype.toObject = function(e) {
    return proto.priority.geoservice.SkillList.toObject(e, this);
  }, proto.priority.geoservice.SkillList.toObject = function(e, r) {
    var s, d = {
      skillsList: (s = t.Message.getRepeatedField(r, 1)) == null ? void 0 : s
    };
    return e && (d.$jspbMessageInstance = r), d;
  }), proto.priority.geoservice.SkillList.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.SkillList();
    return proto.priority.geoservice.SkillList.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.SkillList.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          for (var d = (
            /** @type {!Array<number>} */
            r.isDelimited() ? r.readPackedInt32() : [r.readInt32()]
          ), A = 0; A < d.length; A++)
            e.addSkills(d[A]);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.SkillList.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.SkillList.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.SkillList.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getSkillsList(), s.length > 0 && r.writePackedInt32(
      1,
      s
    );
  }, proto.priority.geoservice.SkillList.prototype.getSkillsList = function() {
    return (
      /** @type {!Array<number>} */
      t.Message.getRepeatedField(this, 1)
    );
  }, proto.priority.geoservice.SkillList.prototype.setSkillsList = function(e) {
    return t.Message.setField(this, 1, e || []);
  }, proto.priority.geoservice.SkillList.prototype.addSkills = function(e, r) {
    return t.Message.addToRepeatedField(this, 1, e, r);
  }, proto.priority.geoservice.SkillList.prototype.clearSkillsList = function() {
    return this.setSkillsList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.TimeWindow.prototype.toObject = function(e) {
    return proto.priority.geoservice.TimeWindow.toObject(e, this);
  }, proto.priority.geoservice.TimeWindow.toObject = function(e, r) {
    var s = {
      start: t.Message.getFieldWithDefault(r, 1, 0),
      end: t.Message.getFieldWithDefault(r, 2, 0)
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.TimeWindow.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.TimeWindow();
    return proto.priority.geoservice.TimeWindow.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.TimeWindow.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {number} */
            r.readInt64()
          );
          e.setStart(d);
          break;
        case 2:
          var d = (
            /** @type {number} */
            r.readInt64()
          );
          e.setEnd(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.TimeWindow.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.TimeWindow.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.TimeWindow.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getStart(), s !== 0 && r.writeInt64(
      1,
      s
    ), s = e.getEnd(), s !== 0 && r.writeInt64(
      2,
      s
    );
  }, proto.priority.geoservice.TimeWindow.prototype.getStart = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.geoservice.TimeWindow.prototype.setStart = function(e) {
    return t.Message.setProto3IntField(this, 1, e);
  }, proto.priority.geoservice.TimeWindow.prototype.getEnd = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.priority.geoservice.TimeWindow.prototype.setEnd = function(e) {
    return t.Message.setProto3IntField(this, 2, e);
  }, proto.priority.geoservice.TimeWindowList.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.TimeWindowList.prototype.toObject = function(e) {
    return proto.priority.geoservice.TimeWindowList.toObject(e, this);
  }, proto.priority.geoservice.TimeWindowList.toObject = function(e, r) {
    var s = {
      timewindowsList: t.Message.toObjectList(
        r.getTimewindowsList(),
        proto.priority.geoservice.TimeWindow.toObject,
        e
      )
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.TimeWindowList.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.TimeWindowList();
    return proto.priority.geoservice.TimeWindowList.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.TimeWindowList.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = new proto.priority.geoservice.TimeWindow();
          r.readMessage(d, proto.priority.geoservice.TimeWindow.deserializeBinaryFromReader), e.addTimewindows(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.TimeWindowList.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.TimeWindowList.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.TimeWindowList.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getTimewindowsList(), s.length > 0 && r.writeRepeatedMessage(
      1,
      s,
      proto.priority.geoservice.TimeWindow.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.TimeWindowList.prototype.getTimewindowsList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.TimeWindow>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.TimeWindow, 1)
    );
  }, proto.priority.geoservice.TimeWindowList.prototype.setTimewindowsList = function(e) {
    return t.Message.setRepeatedWrapperField(this, 1, e);
  }, proto.priority.geoservice.TimeWindowList.prototype.addTimewindows = function(e, r) {
    return t.Message.addToRepeatedWrapperField(this, 1, e, proto.priority.geoservice.TimeWindow, r);
  }, proto.priority.geoservice.TimeWindowList.prototype.clearTimewindowsList = function() {
    return this.setTimewindowsList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Zone.prototype.toObject = function(e) {
    return proto.priority.geoservice.Zone.toObject(e, this);
  }, proto.priority.geoservice.Zone.toObject = function(e, r) {
    var s, d = {
      id: t.Message.getFieldWithDefault(r, 1, 0),
      description: t.Message.getFieldWithDefault(r, 2, ""),
      coordinates: (s = r.getCoordinates()) && i.LocationList.toObject(e, s)
    };
    return e && (d.$jspbMessageInstance = r), d;
  }), proto.priority.geoservice.Zone.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Zone();
    return proto.priority.geoservice.Zone.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Zone.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setDescription(d);
          break;
        case 3:
          var d = new i.LocationList();
          r.readMessage(d, i.LocationList.deserializeBinaryFromReader), e.setCoordinates(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Zone.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Zone.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Zone.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getId(), s !== 0 && r.writeInt32(
      1,
      s
    ), s = e.getDescription(), s.length > 0 && r.writeString(
      2,
      s
    ), s = e.getCoordinates(), s != null && r.writeMessage(
      3,
      s,
      i.LocationList.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.Zone.prototype.getId = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.geoservice.Zone.prototype.setId = function(e) {
    return t.Message.setProto3IntField(this, 1, e);
  }, proto.priority.geoservice.Zone.prototype.getDescription = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.geoservice.Zone.prototype.setDescription = function(e) {
    return t.Message.setProto3StringField(this, 2, e);
  }, proto.priority.geoservice.Zone.prototype.getCoordinates = function() {
    return (
      /** @type{?proto.priority.geoservice.LocationList} */
      t.Message.getWrapperField(this, i.LocationList, 3)
    );
  }, proto.priority.geoservice.Zone.prototype.setCoordinates = function(e) {
    return t.Message.setWrapperField(this, 3, e);
  }, proto.priority.geoservice.Zone.prototype.clearCoordinates = function() {
    return this.setCoordinates(void 0);
  }, proto.priority.geoservice.Zone.prototype.hasCoordinates = function() {
    return t.Message.getField(this, 3) != null;
  }, proto.priority.geoservice.ZoneList.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.ZoneList.prototype.toObject = function(e) {
    return proto.priority.geoservice.ZoneList.toObject(e, this);
  }, proto.priority.geoservice.ZoneList.toObject = function(e, r) {
    var s, d = {
      zonesList: (s = t.Message.getRepeatedField(r, 1)) == null ? void 0 : s
    };
    return e && (d.$jspbMessageInstance = r), d;
  }), proto.priority.geoservice.ZoneList.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.ZoneList();
    return proto.priority.geoservice.ZoneList.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.ZoneList.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          for (var d = (
            /** @type {!Array<number>} */
            r.isDelimited() ? r.readPackedInt32() : [r.readInt32()]
          ), A = 0; A < d.length; A++)
            e.addZones(d[A]);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.ZoneList.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.ZoneList.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.ZoneList.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getZonesList(), s.length > 0 && r.writePackedInt32(
      1,
      s
    );
  }, proto.priority.geoservice.ZoneList.prototype.getZonesList = function() {
    return (
      /** @type {!Array<number>} */
      t.Message.getRepeatedField(this, 1)
    );
  }, proto.priority.geoservice.ZoneList.prototype.setZonesList = function(e) {
    return t.Message.setField(this, 1, e || []);
  }, proto.priority.geoservice.ZoneList.prototype.addZones = function(e, r) {
    return t.Message.addToRepeatedField(this, 1, e, r);
  }, proto.priority.geoservice.ZoneList.prototype.clearZonesList = function() {
    return this.setZonesList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Job.prototype.toObject = function(e) {
    return proto.priority.geoservice.Job.toObject(e, this);
  }, proto.priority.geoservice.Job.toObject = function(e, r) {
    var s, d = {
      id: t.Message.getFieldWithDefault(r, 1, ""),
      description: t.Message.getFieldWithDefault(r, 2, ""),
      locationindex: t.Message.getFieldWithDefault(r, 3, 0),
      sequenceorder: t.Message.getFieldWithDefault(r, 4, 0),
      service: t.Message.getFieldWithDefault(r, 5, 0),
      deliveries: (s = r.getDeliveries()) && proto.priority.geoservice.DeliveryList.toObject(e, s),
      pickups: (s = r.getPickups()) && proto.priority.geoservice.PickupList.toObject(e, s),
      skills: (s = r.getSkills()) && proto.priority.geoservice.SkillList.toObject(e, s),
      timewindows: (s = r.getTimewindows()) && proto.priority.geoservice.TimeWindowList.toObject(e, s),
      zones: (s = r.getZones()) && proto.priority.geoservice.ZoneList.toObject(e, s)
    };
    return e && (d.$jspbMessageInstance = r), d;
  }), proto.priority.geoservice.Job.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Job();
    return proto.priority.geoservice.Job.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Job.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setDescription(d);
          break;
        case 3:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setLocationindex(d);
          break;
        case 4:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setSequenceorder(d);
          break;
        case 5:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setService(d);
          break;
        case 6:
          var d = new proto.priority.geoservice.DeliveryList();
          r.readMessage(d, proto.priority.geoservice.DeliveryList.deserializeBinaryFromReader), e.setDeliveries(d);
          break;
        case 7:
          var d = new proto.priority.geoservice.PickupList();
          r.readMessage(d, proto.priority.geoservice.PickupList.deserializeBinaryFromReader), e.setPickups(d);
          break;
        case 8:
          var d = new proto.priority.geoservice.SkillList();
          r.readMessage(d, proto.priority.geoservice.SkillList.deserializeBinaryFromReader), e.setSkills(d);
          break;
        case 9:
          var d = new proto.priority.geoservice.TimeWindowList();
          r.readMessage(d, proto.priority.geoservice.TimeWindowList.deserializeBinaryFromReader), e.setTimewindows(d);
          break;
        case 10:
          var d = new proto.priority.geoservice.ZoneList();
          r.readMessage(d, proto.priority.geoservice.ZoneList.deserializeBinaryFromReader), e.setZones(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Job.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Job.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Job.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getId(), s.length > 0 && r.writeString(
      1,
      s
    ), s = e.getDescription(), s.length > 0 && r.writeString(
      2,
      s
    ), s = e.getLocationindex(), s !== 0 && r.writeInt32(
      3,
      s
    ), s = /** @type {number} */
    t.Message.getField(e, 4), s != null && r.writeInt32(
      4,
      s
    ), s = /** @type {number} */
    t.Message.getField(e, 5), s != null && r.writeInt32(
      5,
      s
    ), s = e.getDeliveries(), s != null && r.writeMessage(
      6,
      s,
      proto.priority.geoservice.DeliveryList.serializeBinaryToWriter
    ), s = e.getPickups(), s != null && r.writeMessage(
      7,
      s,
      proto.priority.geoservice.PickupList.serializeBinaryToWriter
    ), s = e.getSkills(), s != null && r.writeMessage(
      8,
      s,
      proto.priority.geoservice.SkillList.serializeBinaryToWriter
    ), s = e.getTimewindows(), s != null && r.writeMessage(
      9,
      s,
      proto.priority.geoservice.TimeWindowList.serializeBinaryToWriter
    ), s = e.getZones(), s != null && r.writeMessage(
      10,
      s,
      proto.priority.geoservice.ZoneList.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.Job.prototype.getId = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.geoservice.Job.prototype.setId = function(e) {
    return t.Message.setProto3StringField(this, 1, e);
  }, proto.priority.geoservice.Job.prototype.getDescription = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.geoservice.Job.prototype.setDescription = function(e) {
    return t.Message.setProto3StringField(this, 2, e);
  }, proto.priority.geoservice.Job.prototype.getLocationindex = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.priority.geoservice.Job.prototype.setLocationindex = function(e) {
    return t.Message.setProto3IntField(this, 3, e);
  }, proto.priority.geoservice.Job.prototype.getSequenceorder = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.priority.geoservice.Job.prototype.setSequenceorder = function(e) {
    return t.Message.setField(this, 4, e);
  }, proto.priority.geoservice.Job.prototype.clearSequenceorder = function() {
    return t.Message.setField(this, 4, void 0);
  }, proto.priority.geoservice.Job.prototype.hasSequenceorder = function() {
    return t.Message.getField(this, 4) != null;
  }, proto.priority.geoservice.Job.prototype.getService = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.priority.geoservice.Job.prototype.setService = function(e) {
    return t.Message.setField(this, 5, e);
  }, proto.priority.geoservice.Job.prototype.clearService = function() {
    return t.Message.setField(this, 5, void 0);
  }, proto.priority.geoservice.Job.prototype.hasService = function() {
    return t.Message.getField(this, 5) != null;
  }, proto.priority.geoservice.Job.prototype.getDeliveries = function() {
    return (
      /** @type{?proto.priority.geoservice.DeliveryList} */
      t.Message.getWrapperField(this, proto.priority.geoservice.DeliveryList, 6)
    );
  }, proto.priority.geoservice.Job.prototype.setDeliveries = function(e) {
    return t.Message.setWrapperField(this, 6, e);
  }, proto.priority.geoservice.Job.prototype.clearDeliveries = function() {
    return this.setDeliveries(void 0);
  }, proto.priority.geoservice.Job.prototype.hasDeliveries = function() {
    return t.Message.getField(this, 6) != null;
  }, proto.priority.geoservice.Job.prototype.getPickups = function() {
    return (
      /** @type{?proto.priority.geoservice.PickupList} */
      t.Message.getWrapperField(this, proto.priority.geoservice.PickupList, 7)
    );
  }, proto.priority.geoservice.Job.prototype.setPickups = function(e) {
    return t.Message.setWrapperField(this, 7, e);
  }, proto.priority.geoservice.Job.prototype.clearPickups = function() {
    return this.setPickups(void 0);
  }, proto.priority.geoservice.Job.prototype.hasPickups = function() {
    return t.Message.getField(this, 7) != null;
  }, proto.priority.geoservice.Job.prototype.getSkills = function() {
    return (
      /** @type{?proto.priority.geoservice.SkillList} */
      t.Message.getWrapperField(this, proto.priority.geoservice.SkillList, 8)
    );
  }, proto.priority.geoservice.Job.prototype.setSkills = function(e) {
    return t.Message.setWrapperField(this, 8, e);
  }, proto.priority.geoservice.Job.prototype.clearSkills = function() {
    return this.setSkills(void 0);
  }, proto.priority.geoservice.Job.prototype.hasSkills = function() {
    return t.Message.getField(this, 8) != null;
  }, proto.priority.geoservice.Job.prototype.getTimewindows = function() {
    return (
      /** @type{?proto.priority.geoservice.TimeWindowList} */
      t.Message.getWrapperField(this, proto.priority.geoservice.TimeWindowList, 9)
    );
  }, proto.priority.geoservice.Job.prototype.setTimewindows = function(e) {
    return t.Message.setWrapperField(this, 9, e);
  }, proto.priority.geoservice.Job.prototype.clearTimewindows = function() {
    return this.setTimewindows(void 0);
  }, proto.priority.geoservice.Job.prototype.hasTimewindows = function() {
    return t.Message.getField(this, 9) != null;
  }, proto.priority.geoservice.Job.prototype.getZones = function() {
    return (
      /** @type{?proto.priority.geoservice.ZoneList} */
      t.Message.getWrapperField(this, proto.priority.geoservice.ZoneList, 10)
    );
  }, proto.priority.geoservice.Job.prototype.setZones = function(e) {
    return t.Message.setWrapperField(this, 10, e);
  }, proto.priority.geoservice.Job.prototype.clearZones = function() {
    return this.setZones(void 0);
  }, proto.priority.geoservice.Job.prototype.hasZones = function() {
    return t.Message.getField(this, 10) != null;
  }, proto.priority.geoservice.CapacityList.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.CapacityList.prototype.toObject = function(e) {
    return proto.priority.geoservice.CapacityList.toObject(e, this);
  }, proto.priority.geoservice.CapacityList.toObject = function(e, r) {
    var s, d = {
      capacitiesList: (s = t.Message.getRepeatedField(r, 1)) == null ? void 0 : s
    };
    return e && (d.$jspbMessageInstance = r), d;
  }), proto.priority.geoservice.CapacityList.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.CapacityList();
    return proto.priority.geoservice.CapacityList.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.CapacityList.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          for (var d = (
            /** @type {!Array<number>} */
            r.isDelimited() ? r.readPackedInt32() : [r.readInt32()]
          ), A = 0; A < d.length; A++)
            e.addCapacities(d[A]);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.CapacityList.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.CapacityList.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.CapacityList.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getCapacitiesList(), s.length > 0 && r.writePackedInt32(
      1,
      s
    );
  }, proto.priority.geoservice.CapacityList.prototype.getCapacitiesList = function() {
    return (
      /** @type {!Array<number>} */
      t.Message.getRepeatedField(this, 1)
    );
  }, proto.priority.geoservice.CapacityList.prototype.setCapacitiesList = function(e) {
    return t.Message.setField(this, 1, e || []);
  }, proto.priority.geoservice.CapacityList.prototype.addCapacities = function(e, r) {
    return t.Message.addToRepeatedField(this, 1, e, r);
  }, proto.priority.geoservice.CapacityList.prototype.clearCapacitiesList = function() {
    return this.setCapacitiesList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Vehicle.prototype.toObject = function(e) {
    return proto.priority.geoservice.Vehicle.toObject(e, this);
  }, proto.priority.geoservice.Vehicle.toObject = function(e, r) {
    var s, d = {
      id: t.Message.getFieldWithDefault(r, 1, ""),
      description: t.Message.getFieldWithDefault(r, 2, ""),
      startindex: t.Message.getFieldWithDefault(r, 3, 0),
      endindex: t.Message.getFieldWithDefault(r, 4, 0),
      date: (s = r.getDate()) && l.Date.toObject(e, s),
      capacity: (s = r.getCapacity()) && proto.priority.geoservice.CapacityList.toObject(e, s),
      allowedzones: (s = r.getAllowedzones()) && proto.priority.geoservice.ZoneList.toObject(e, s),
      skills: (s = r.getSkills()) && proto.priority.geoservice.SkillList.toObject(e, s)
    };
    return e && (d.$jspbMessageInstance = r), d;
  }), proto.priority.geoservice.Vehicle.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Vehicle();
    return proto.priority.geoservice.Vehicle.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Vehicle.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setDescription(d);
          break;
        case 3:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setStartindex(d);
          break;
        case 4:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setEndindex(d);
          break;
        case 5:
          var d = new l.Date();
          r.readMessage(d, l.Date.deserializeBinaryFromReader), e.setDate(d);
          break;
        case 6:
          var d = new proto.priority.geoservice.CapacityList();
          r.readMessage(d, proto.priority.geoservice.CapacityList.deserializeBinaryFromReader), e.setCapacity(d);
          break;
        case 7:
          var d = new proto.priority.geoservice.ZoneList();
          r.readMessage(d, proto.priority.geoservice.ZoneList.deserializeBinaryFromReader), e.setAllowedzones(d);
          break;
        case 8:
          var d = new proto.priority.geoservice.SkillList();
          r.readMessage(d, proto.priority.geoservice.SkillList.deserializeBinaryFromReader), e.setSkills(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Vehicle.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Vehicle.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Vehicle.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getId(), s.length > 0 && r.writeString(
      1,
      s
    ), s = e.getDescription(), s.length > 0 && r.writeString(
      2,
      s
    ), s = e.getStartindex(), s !== 0 && r.writeInt32(
      3,
      s
    ), s = /** @type {number} */
    t.Message.getField(e, 4), s != null && r.writeInt32(
      4,
      s
    ), s = e.getDate(), s != null && r.writeMessage(
      5,
      s,
      l.Date.serializeBinaryToWriter
    ), s = e.getCapacity(), s != null && r.writeMessage(
      6,
      s,
      proto.priority.geoservice.CapacityList.serializeBinaryToWriter
    ), s = e.getAllowedzones(), s != null && r.writeMessage(
      7,
      s,
      proto.priority.geoservice.ZoneList.serializeBinaryToWriter
    ), s = e.getSkills(), s != null && r.writeMessage(
      8,
      s,
      proto.priority.geoservice.SkillList.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.Vehicle.prototype.getId = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.geoservice.Vehicle.prototype.setId = function(e) {
    return t.Message.setProto3StringField(this, 1, e);
  }, proto.priority.geoservice.Vehicle.prototype.getDescription = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.geoservice.Vehicle.prototype.setDescription = function(e) {
    return t.Message.setProto3StringField(this, 2, e);
  }, proto.priority.geoservice.Vehicle.prototype.getStartindex = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.priority.geoservice.Vehicle.prototype.setStartindex = function(e) {
    return t.Message.setProto3IntField(this, 3, e);
  }, proto.priority.geoservice.Vehicle.prototype.getEndindex = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.priority.geoservice.Vehicle.prototype.setEndindex = function(e) {
    return t.Message.setField(this, 4, e);
  }, proto.priority.geoservice.Vehicle.prototype.clearEndindex = function() {
    return t.Message.setField(this, 4, void 0);
  }, proto.priority.geoservice.Vehicle.prototype.hasEndindex = function() {
    return t.Message.getField(this, 4) != null;
  }, proto.priority.geoservice.Vehicle.prototype.getDate = function() {
    return (
      /** @type{?proto.common.Date} */
      t.Message.getWrapperField(this, l.Date, 5)
    );
  }, proto.priority.geoservice.Vehicle.prototype.setDate = function(e) {
    return t.Message.setWrapperField(this, 5, e);
  }, proto.priority.geoservice.Vehicle.prototype.clearDate = function() {
    return this.setDate(void 0);
  }, proto.priority.geoservice.Vehicle.prototype.hasDate = function() {
    return t.Message.getField(this, 5) != null;
  }, proto.priority.geoservice.Vehicle.prototype.getCapacity = function() {
    return (
      /** @type{?proto.priority.geoservice.CapacityList} */
      t.Message.getWrapperField(this, proto.priority.geoservice.CapacityList, 6)
    );
  }, proto.priority.geoservice.Vehicle.prototype.setCapacity = function(e) {
    return t.Message.setWrapperField(this, 6, e);
  }, proto.priority.geoservice.Vehicle.prototype.clearCapacity = function() {
    return this.setCapacity(void 0);
  }, proto.priority.geoservice.Vehicle.prototype.hasCapacity = function() {
    return t.Message.getField(this, 6) != null;
  }, proto.priority.geoservice.Vehicle.prototype.getAllowedzones = function() {
    return (
      /** @type{?proto.priority.geoservice.ZoneList} */
      t.Message.getWrapperField(this, proto.priority.geoservice.ZoneList, 7)
    );
  }, proto.priority.geoservice.Vehicle.prototype.setAllowedzones = function(e) {
    return t.Message.setWrapperField(this, 7, e);
  }, proto.priority.geoservice.Vehicle.prototype.clearAllowedzones = function() {
    return this.setAllowedzones(void 0);
  }, proto.priority.geoservice.Vehicle.prototype.hasAllowedzones = function() {
    return t.Message.getField(this, 7) != null;
  }, proto.priority.geoservice.Vehicle.prototype.getSkills = function() {
    return (
      /** @type{?proto.priority.geoservice.SkillList} */
      t.Message.getWrapperField(this, proto.priority.geoservice.SkillList, 8)
    );
  }, proto.priority.geoservice.Vehicle.prototype.setSkills = function(e) {
    return t.Message.setWrapperField(this, 8, e);
  }, proto.priority.geoservice.Vehicle.prototype.clearSkills = function() {
    return this.setSkills(void 0);
  }, proto.priority.geoservice.Vehicle.prototype.hasSkills = function() {
    return t.Message.getField(this, 8) != null;
  }, proto.priority.geoservice.Relation.repeatedFields_ = [2], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Relation.prototype.toObject = function(e) {
    return proto.priority.geoservice.Relation.toObject(e, this);
  }, proto.priority.geoservice.Relation.toObject = function(e, r) {
    var s = {
      type: t.Message.getFieldWithDefault(r, 1, 0),
      stepsList: t.Message.toObjectList(
        r.getStepsList(),
        proto.priority.geoservice.Relation.RelationStep.toObject,
        e
      )
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.Relation.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Relation();
    return proto.priority.geoservice.Relation.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Relation.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {!proto.priority.geoservice.Relation.RelationType} */
            r.readEnum()
          );
          e.setType(d);
          break;
        case 2:
          var d = new proto.priority.geoservice.Relation.RelationStep();
          r.readMessage(d, proto.priority.geoservice.Relation.RelationStep.deserializeBinaryFromReader), e.addSteps(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Relation.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Relation.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Relation.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getType(), s !== 0 && r.writeEnum(
      1,
      s
    ), s = e.getStepsList(), s.length > 0 && r.writeRepeatedMessage(
      2,
      s,
      proto.priority.geoservice.Relation.RelationStep.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.Relation.RelationType = {
    UNKNOWN: 0,
    INSAMEROUTE: 1,
    INSEQUENCE: 2,
    INDIRECTSEQUENCE: 3
  }, proto.priority.geoservice.Relation.StepType = {
    STEPTYPEUNKNOWN: 0,
    START: 1,
    JOB: 2,
    PICKUP: 3,
    DELIVERY: 4,
    END: 5
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Relation.RelationStep.prototype.toObject = function(e) {
    return proto.priority.geoservice.Relation.RelationStep.toObject(e, this);
  }, proto.priority.geoservice.Relation.RelationStep.toObject = function(e, r) {
    var s = {
      type: t.Message.getFieldWithDefault(r, 1, 0),
      jobid: t.Message.getFieldWithDefault(r, 2, "")
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.Relation.RelationStep.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Relation.RelationStep();
    return proto.priority.geoservice.Relation.RelationStep.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Relation.RelationStep.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {!proto.priority.geoservice.Relation.StepType} */
            r.readEnum()
          );
          e.setType(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setJobid(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Relation.RelationStep.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Relation.RelationStep.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Relation.RelationStep.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getType(), s !== 0 && r.writeEnum(
      1,
      s
    ), s = /** @type {string} */
    t.Message.getField(e, 2), s != null && r.writeString(
      2,
      s
    );
  }, proto.priority.geoservice.Relation.RelationStep.prototype.getType = function() {
    return (
      /** @type {!proto.priority.geoservice.Relation.StepType} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.geoservice.Relation.RelationStep.prototype.setType = function(e) {
    return t.Message.setProto3EnumField(this, 1, e);
  }, proto.priority.geoservice.Relation.RelationStep.prototype.getJobid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.geoservice.Relation.RelationStep.prototype.setJobid = function(e) {
    return t.Message.setField(this, 2, e);
  }, proto.priority.geoservice.Relation.RelationStep.prototype.clearJobid = function() {
    return t.Message.setField(this, 2, void 0);
  }, proto.priority.geoservice.Relation.RelationStep.prototype.hasJobid = function() {
    return t.Message.getField(this, 2) != null;
  }, proto.priority.geoservice.Relation.prototype.getType = function() {
    return (
      /** @type {!proto.priority.geoservice.Relation.RelationType} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.geoservice.Relation.prototype.setType = function(e) {
    return t.Message.setProto3EnumField(this, 1, e);
  }, proto.priority.geoservice.Relation.prototype.getStepsList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.Relation.RelationStep>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.Relation.RelationStep, 2)
    );
  }, proto.priority.geoservice.Relation.prototype.setStepsList = function(e) {
    return t.Message.setRepeatedWrapperField(this, 2, e);
  }, proto.priority.geoservice.Relation.prototype.addSteps = function(e, r) {
    return t.Message.addToRepeatedWrapperField(this, 2, e, proto.priority.geoservice.Relation.RelationStep, r);
  }, proto.priority.geoservice.Relation.prototype.clearStepsList = function() {
    return this.setStepsList([]);
  }, proto.priority.geoservice.RelationList.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.RelationList.prototype.toObject = function(e) {
    return proto.priority.geoservice.RelationList.toObject(e, this);
  }, proto.priority.geoservice.RelationList.toObject = function(e, r) {
    var s = {
      relationsList: t.Message.toObjectList(
        r.getRelationsList(),
        proto.priority.geoservice.Relation.toObject,
        e
      )
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.RelationList.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.RelationList();
    return proto.priority.geoservice.RelationList.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.RelationList.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = new proto.priority.geoservice.Relation();
          r.readMessage(d, proto.priority.geoservice.Relation.deserializeBinaryFromReader), e.addRelations(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.RelationList.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.RelationList.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.RelationList.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getRelationsList(), s.length > 0 && r.writeRepeatedMessage(
      1,
      s,
      proto.priority.geoservice.Relation.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.RelationList.prototype.getRelationsList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.Relation>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.Relation, 1)
    );
  }, proto.priority.geoservice.RelationList.prototype.setRelationsList = function(e) {
    return t.Message.setRepeatedWrapperField(this, 1, e);
  }, proto.priority.geoservice.RelationList.prototype.addRelations = function(e, r) {
    return t.Message.addToRepeatedWrapperField(this, 1, e, proto.priority.geoservice.Relation, r);
  }, proto.priority.geoservice.RelationList.prototype.clearRelationsList = function() {
    return this.setRelationsList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Options.prototype.toObject = function(e) {
    return proto.priority.geoservice.Options.toObject(e, this);
  }, proto.priority.geoservice.Options.toObject = function(e, r) {
    var s = {
      metric: t.Message.getFieldWithDefault(r, 1, 0),
      roundtrip: t.Message.getBooleanFieldWithDefault(r, 2, !1),
      cost: t.Message.getFieldWithDefault(r, 3, 0)
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.Options.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Options();
    return proto.priority.geoservice.Options.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Options.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {!proto.priority.geoservice.Options.MetricType} */
            r.readEnum()
          );
          e.setMetric(d);
          break;
        case 2:
          var d = (
            /** @type {boolean} */
            r.readBool()
          );
          e.setRoundtrip(d);
          break;
        case 3:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setCost(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Options.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Options.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Options.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getMetric(), s !== 0 && r.writeEnum(
      1,
      s
    ), s = /** @type {boolean} */
    t.Message.getField(e, 2), s != null && r.writeBool(
      2,
      s
    ), s = /** @type {number} */
    t.Message.getField(e, 3), s != null && r.writeInt32(
      3,
      s
    );
  }, proto.priority.geoservice.Options.MetricType = {
    UNKNOWN: 0,
    DURATION: 1,
    DISTANCE: 2
  }, proto.priority.geoservice.Options.prototype.getMetric = function() {
    return (
      /** @type {!proto.priority.geoservice.Options.MetricType} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.geoservice.Options.prototype.setMetric = function(e) {
    return t.Message.setProto3EnumField(this, 1, e);
  }, proto.priority.geoservice.Options.prototype.getRoundtrip = function() {
    return (
      /** @type {boolean} */
      t.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, proto.priority.geoservice.Options.prototype.setRoundtrip = function(e) {
    return t.Message.setField(this, 2, e);
  }, proto.priority.geoservice.Options.prototype.clearRoundtrip = function() {
    return t.Message.setField(this, 2, void 0);
  }, proto.priority.geoservice.Options.prototype.hasRoundtrip = function() {
    return t.Message.getField(this, 2) != null;
  }, proto.priority.geoservice.Options.prototype.getCost = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.priority.geoservice.Options.prototype.setCost = function(e) {
    return t.Message.setField(this, 3, e);
  }, proto.priority.geoservice.Options.prototype.clearCost = function() {
    return t.Message.setField(this, 3, void 0);
  }, proto.priority.geoservice.Options.prototype.hasCost = function() {
    return t.Message.getField(this, 3) != null;
  }, proto.priority.geoservice.RouteOptimizationRq.repeatedFields_ = [3, 4, 5], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.RouteOptimizationRq.prototype.toObject = function(e) {
    return proto.priority.geoservice.RouteOptimizationRq.toObject(e, this);
  }, proto.priority.geoservice.RouteOptimizationRq.toObject = function(e, r) {
    var s, d = {
      id: t.Message.getFieldWithDefault(r, 1, ""),
      client: t.Message.getFieldWithDefault(r, 2, ""),
      locationsList: t.Message.toObjectList(
        r.getLocationsList(),
        i.Location.toObject,
        e
      ),
      jobsList: t.Message.toObjectList(
        r.getJobsList(),
        proto.priority.geoservice.Job.toObject,
        e
      ),
      vehiclesList: t.Message.toObjectList(
        r.getVehiclesList(),
        proto.priority.geoservice.Vehicle.toObject,
        e
      ),
      relations: (s = r.getRelations()) && proto.priority.geoservice.RelationList.toObject(e, s),
      options: (s = r.getOptions()) && proto.priority.geoservice.Options.toObject(e, s)
    };
    return e && (d.$jspbMessageInstance = r), d;
  }), proto.priority.geoservice.RouteOptimizationRq.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.RouteOptimizationRq();
    return proto.priority.geoservice.RouteOptimizationRq.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.RouteOptimizationRq.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setClient(d);
          break;
        case 3:
          var d = new i.Location();
          r.readMessage(d, i.Location.deserializeBinaryFromReader), e.addLocations(d);
          break;
        case 4:
          var d = new proto.priority.geoservice.Job();
          r.readMessage(d, proto.priority.geoservice.Job.deserializeBinaryFromReader), e.addJobs(d);
          break;
        case 5:
          var d = new proto.priority.geoservice.Vehicle();
          r.readMessage(d, proto.priority.geoservice.Vehicle.deserializeBinaryFromReader), e.addVehicles(d);
          break;
        case 6:
          var d = new proto.priority.geoservice.RelationList();
          r.readMessage(d, proto.priority.geoservice.RelationList.deserializeBinaryFromReader), e.setRelations(d);
          break;
        case 7:
          var d = new proto.priority.geoservice.Options();
          r.readMessage(d, proto.priority.geoservice.Options.deserializeBinaryFromReader), e.setOptions(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.RouteOptimizationRq.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.RouteOptimizationRq.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getId(), s.length > 0 && r.writeString(
      1,
      s
    ), s = e.getClient(), s.length > 0 && r.writeString(
      2,
      s
    ), s = e.getLocationsList(), s.length > 0 && r.writeRepeatedMessage(
      3,
      s,
      i.Location.serializeBinaryToWriter
    ), s = e.getJobsList(), s.length > 0 && r.writeRepeatedMessage(
      4,
      s,
      proto.priority.geoservice.Job.serializeBinaryToWriter
    ), s = e.getVehiclesList(), s.length > 0 && r.writeRepeatedMessage(
      5,
      s,
      proto.priority.geoservice.Vehicle.serializeBinaryToWriter
    ), s = e.getRelations(), s != null && r.writeMessage(
      6,
      s,
      proto.priority.geoservice.RelationList.serializeBinaryToWriter
    ), s = e.getOptions(), s != null && r.writeMessage(
      7,
      s,
      proto.priority.geoservice.Options.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.getId = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.setId = function(e) {
    return t.Message.setProto3StringField(this, 1, e);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.getClient = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.setClient = function(e) {
    return t.Message.setProto3StringField(this, 2, e);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.getLocationsList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.Location>} */
      t.Message.getRepeatedWrapperField(this, i.Location, 3)
    );
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.setLocationsList = function(e) {
    return t.Message.setRepeatedWrapperField(this, 3, e);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.addLocations = function(e, r) {
    return t.Message.addToRepeatedWrapperField(this, 3, e, proto.priority.geoservice.Location, r);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.clearLocationsList = function() {
    return this.setLocationsList([]);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.getJobsList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.Job>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.Job, 4)
    );
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.setJobsList = function(e) {
    return t.Message.setRepeatedWrapperField(this, 4, e);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.addJobs = function(e, r) {
    return t.Message.addToRepeatedWrapperField(this, 4, e, proto.priority.geoservice.Job, r);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.clearJobsList = function() {
    return this.setJobsList([]);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.getVehiclesList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.Vehicle>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.Vehicle, 5)
    );
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.setVehiclesList = function(e) {
    return t.Message.setRepeatedWrapperField(this, 5, e);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.addVehicles = function(e, r) {
    return t.Message.addToRepeatedWrapperField(this, 5, e, proto.priority.geoservice.Vehicle, r);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.clearVehiclesList = function() {
    return this.setVehiclesList([]);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.getRelations = function() {
    return (
      /** @type{?proto.priority.geoservice.RelationList} */
      t.Message.getWrapperField(this, proto.priority.geoservice.RelationList, 6)
    );
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.setRelations = function(e) {
    return t.Message.setWrapperField(this, 6, e);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.clearRelations = function() {
    return this.setRelations(void 0);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.hasRelations = function() {
    return t.Message.getField(this, 6) != null;
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.getOptions = function() {
    return (
      /** @type{?proto.priority.geoservice.Options} */
      t.Message.getWrapperField(this, proto.priority.geoservice.Options, 7)
    );
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.setOptions = function(e) {
    return t.Message.setWrapperField(this, 7, e);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.priority.geoservice.RouteOptimizationRq.prototype.hasOptions = function() {
    return t.Message.getField(this, 7) != null;
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Status.prototype.toObject = function(e) {
    return proto.priority.geoservice.Status.toObject(e, this);
  }, proto.priority.geoservice.Status.toObject = function(e, r) {
    var s = {
      state: t.Message.getFieldWithDefault(r, 1, 0)
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.Status.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Status();
    return proto.priority.geoservice.Status.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Status.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {!proto.priority.geoservice.Status.StateType} */
            r.readEnum()
          );
          e.setState(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Status.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Status.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Status.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getState(), s !== 0 && r.writeEnum(
      1,
      s
    );
  }, proto.priority.geoservice.Status.StateType = {
    UNKNOWN: 0,
    INPROGRESS: 1,
    CANCELED: 2,
    FINISHED: 3,
    FAILED: 4
  }, proto.priority.geoservice.Status.prototype.getState = function() {
    return (
      /** @type {!proto.priority.geoservice.Status.StateType} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.geoservice.Status.prototype.setState = function(e) {
    return t.Message.setProto3EnumField(this, 1, e);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Summary.prototype.toObject = function(e) {
    return proto.priority.geoservice.Summary.toObject(e, this);
  }, proto.priority.geoservice.Summary.toObject = function(e, r) {
    var s = {
      code: t.Message.getFieldWithDefault(r, 1, 0),
      description: t.Message.getFieldWithDefault(r, 2, ""),
      jobsassigned: t.Message.getFieldWithDefault(r, 3, 0),
      jobsunassigned: t.Message.getFieldWithDefault(r, 4, 0),
      totalroutes: t.Message.getFieldWithDefault(r, 5, 0),
      totaldistance: t.Message.getFieldWithDefault(r, 6, 0),
      totalduration: t.Message.getFieldWithDefault(r, 7, 0),
      totalservice: t.Message.getFieldWithDefault(r, 8, 0),
      licenseutilization: t.Message.getFloatingPointFieldWithDefault(r, 9, 0)
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.Summary.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Summary();
    return proto.priority.geoservice.Summary.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Summary.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setCode(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setDescription(d);
          break;
        case 3:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setJobsassigned(d);
          break;
        case 4:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setJobsunassigned(d);
          break;
        case 5:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setTotalroutes(d);
          break;
        case 6:
          var d = (
            /** @type {number} */
            r.readInt64()
          );
          e.setTotaldistance(d);
          break;
        case 7:
          var d = (
            /** @type {number} */
            r.readInt64()
          );
          e.setTotalduration(d);
          break;
        case 8:
          var d = (
            /** @type {number} */
            r.readInt64()
          );
          e.setTotalservice(d);
          break;
        case 9:
          var d = (
            /** @type {number} */
            r.readFloat()
          );
          e.setLicenseutilization(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Summary.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Summary.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Summary.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getCode(), s !== 0 && r.writeInt32(
      1,
      s
    ), s = e.getDescription(), s.length > 0 && r.writeString(
      2,
      s
    ), s = e.getJobsassigned(), s !== 0 && r.writeInt32(
      3,
      s
    ), s = e.getJobsunassigned(), s !== 0 && r.writeInt32(
      4,
      s
    ), s = e.getTotalroutes(), s !== 0 && r.writeInt32(
      5,
      s
    ), s = e.getTotaldistance(), s !== 0 && r.writeInt64(
      6,
      s
    ), s = e.getTotalduration(), s !== 0 && r.writeInt64(
      7,
      s
    ), s = e.getTotalservice(), s !== 0 && r.writeInt64(
      8,
      s
    ), s = e.getLicenseutilization(), s !== 0 && r.writeFloat(
      9,
      s
    );
  }, proto.priority.geoservice.Summary.prototype.getCode = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.geoservice.Summary.prototype.setCode = function(e) {
    return t.Message.setProto3IntField(this, 1, e);
  }, proto.priority.geoservice.Summary.prototype.getDescription = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.geoservice.Summary.prototype.setDescription = function(e) {
    return t.Message.setProto3StringField(this, 2, e);
  }, proto.priority.geoservice.Summary.prototype.getJobsassigned = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.priority.geoservice.Summary.prototype.setJobsassigned = function(e) {
    return t.Message.setProto3IntField(this, 3, e);
  }, proto.priority.geoservice.Summary.prototype.getJobsunassigned = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.priority.geoservice.Summary.prototype.setJobsunassigned = function(e) {
    return t.Message.setProto3IntField(this, 4, e);
  }, proto.priority.geoservice.Summary.prototype.getTotalroutes = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.priority.geoservice.Summary.prototype.setTotalroutes = function(e) {
    return t.Message.setProto3IntField(this, 5, e);
  }, proto.priority.geoservice.Summary.prototype.getTotaldistance = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 6, 0)
    );
  }, proto.priority.geoservice.Summary.prototype.setTotaldistance = function(e) {
    return t.Message.setProto3IntField(this, 6, e);
  }, proto.priority.geoservice.Summary.prototype.getTotalduration = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 7, 0)
    );
  }, proto.priority.geoservice.Summary.prototype.setTotalduration = function(e) {
    return t.Message.setProto3IntField(this, 7, e);
  }, proto.priority.geoservice.Summary.prototype.getTotalservice = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 8, 0)
    );
  }, proto.priority.geoservice.Summary.prototype.setTotalservice = function(e) {
    return t.Message.setProto3IntField(this, 8, e);
  }, proto.priority.geoservice.Summary.prototype.getLicenseutilization = function() {
    return (
      /** @type {number} */
      t.Message.getFloatingPointFieldWithDefault(this, 9, 0)
    );
  }, proto.priority.geoservice.Summary.prototype.setLicenseutilization = function(e) {
    return t.Message.setProto3FloatField(this, 9, e);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Step.prototype.toObject = function(e) {
    return proto.priority.geoservice.Step.toObject(e, this);
  }, proto.priority.geoservice.Step.toObject = function(e, r) {
    var s = {
      jobid: t.Message.getFieldWithDefault(r, 1, ""),
      type: t.Message.getFieldWithDefault(r, 2, 0)
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.Step.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Step();
    return proto.priority.geoservice.Step.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Step.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setJobid(d);
          break;
        case 2:
          var d = (
            /** @type {!proto.priority.geoservice.Step.StepType} */
            r.readEnum()
          );
          e.setType(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Step.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Step.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Step.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getJobid(), s.length > 0 && r.writeString(
      1,
      s
    ), s = e.getType(), s !== 0 && r.writeEnum(
      2,
      s
    );
  }, proto.priority.geoservice.Step.StepType = {
    UNKNOWN: 0,
    START: 1,
    JOB: 2,
    END: 3
  }, proto.priority.geoservice.Step.prototype.getJobid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.geoservice.Step.prototype.setJobid = function(e) {
    return t.Message.setProto3StringField(this, 1, e);
  }, proto.priority.geoservice.Step.prototype.getType = function() {
    return (
      /** @type {!proto.priority.geoservice.Step.StepType} */
      t.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.priority.geoservice.Step.prototype.setType = function(e) {
    return t.Message.setProto3EnumField(this, 2, e);
  }, proto.priority.geoservice.Route.repeatedFields_ = [8], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Route.prototype.toObject = function(e) {
    return proto.priority.geoservice.Route.toObject(e, this);
  }, proto.priority.geoservice.Route.toObject = function(e, r) {
    var s, d = {
      vehicleindex: t.Message.getFieldWithDefault(r, 1, 0),
      vehicleid: t.Message.getFieldWithDefault(r, 2, ""),
      vehicledate: (s = r.getVehicledate()) && l.Date.toObject(e, s),
      description: t.Message.getFieldWithDefault(r, 4, ""),
      cost: t.Message.getFieldWithDefault(r, 5, 0),
      duration: t.Message.getFieldWithDefault(r, 6, 0),
      distance: t.Message.getFieldWithDefault(r, 7, 0),
      stepsList: t.Message.toObjectList(
        r.getStepsList(),
        proto.priority.geoservice.Step.toObject,
        e
      )
    };
    return e && (d.$jspbMessageInstance = r), d;
  }), proto.priority.geoservice.Route.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Route();
    return proto.priority.geoservice.Route.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Route.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setVehicleindex(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setVehicleid(d);
          break;
        case 3:
          var d = new l.Date();
          r.readMessage(d, l.Date.deserializeBinaryFromReader), e.setVehicledate(d);
          break;
        case 4:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setDescription(d);
          break;
        case 5:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          e.setCost(d);
          break;
        case 6:
          var d = (
            /** @type {number} */
            r.readInt64()
          );
          e.setDuration(d);
          break;
        case 7:
          var d = (
            /** @type {number} */
            r.readInt64()
          );
          e.setDistance(d);
          break;
        case 8:
          var d = new proto.priority.geoservice.Step();
          r.readMessage(d, proto.priority.geoservice.Step.deserializeBinaryFromReader), e.addSteps(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Route.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Route.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Route.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getVehicleindex(), s !== 0 && r.writeInt32(
      1,
      s
    ), s = e.getVehicleid(), s.length > 0 && r.writeString(
      2,
      s
    ), s = e.getVehicledate(), s != null && r.writeMessage(
      3,
      s,
      l.Date.serializeBinaryToWriter
    ), s = e.getDescription(), s.length > 0 && r.writeString(
      4,
      s
    ), s = e.getCost(), s !== 0 && r.writeInt32(
      5,
      s
    ), s = e.getDuration(), s !== 0 && r.writeInt64(
      6,
      s
    ), s = e.getDistance(), s !== 0 && r.writeInt64(
      7,
      s
    ), s = e.getStepsList(), s.length > 0 && r.writeRepeatedMessage(
      8,
      s,
      proto.priority.geoservice.Step.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.Route.prototype.getVehicleindex = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.priority.geoservice.Route.prototype.setVehicleindex = function(e) {
    return t.Message.setProto3IntField(this, 1, e);
  }, proto.priority.geoservice.Route.prototype.getVehicleid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.geoservice.Route.prototype.setVehicleid = function(e) {
    return t.Message.setProto3StringField(this, 2, e);
  }, proto.priority.geoservice.Route.prototype.getVehicledate = function() {
    return (
      /** @type{?proto.common.Date} */
      t.Message.getWrapperField(this, l.Date, 3)
    );
  }, proto.priority.geoservice.Route.prototype.setVehicledate = function(e) {
    return t.Message.setWrapperField(this, 3, e);
  }, proto.priority.geoservice.Route.prototype.clearVehicledate = function() {
    return this.setVehicledate(void 0);
  }, proto.priority.geoservice.Route.prototype.hasVehicledate = function() {
    return t.Message.getField(this, 3) != null;
  }, proto.priority.geoservice.Route.prototype.getDescription = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.priority.geoservice.Route.prototype.setDescription = function(e) {
    return t.Message.setProto3StringField(this, 4, e);
  }, proto.priority.geoservice.Route.prototype.getCost = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.priority.geoservice.Route.prototype.setCost = function(e) {
    return t.Message.setProto3IntField(this, 5, e);
  }, proto.priority.geoservice.Route.prototype.getDuration = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 6, 0)
    );
  }, proto.priority.geoservice.Route.prototype.setDuration = function(e) {
    return t.Message.setProto3IntField(this, 6, e);
  }, proto.priority.geoservice.Route.prototype.getDistance = function() {
    return (
      /** @type {number} */
      t.Message.getFieldWithDefault(this, 7, 0)
    );
  }, proto.priority.geoservice.Route.prototype.setDistance = function(e) {
    return t.Message.setProto3IntField(this, 7, e);
  }, proto.priority.geoservice.Route.prototype.getStepsList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.Step>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.Step, 8)
    );
  }, proto.priority.geoservice.Route.prototype.setStepsList = function(e) {
    return t.Message.setRepeatedWrapperField(this, 8, e);
  }, proto.priority.geoservice.Route.prototype.addSteps = function(e, r) {
    return t.Message.addToRepeatedWrapperField(this, 8, e, proto.priority.geoservice.Step, r);
  }, proto.priority.geoservice.Route.prototype.clearStepsList = function() {
    return this.setStepsList([]);
  }, proto.priority.geoservice.RouteList.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.RouteList.prototype.toObject = function(e) {
    return proto.priority.geoservice.RouteList.toObject(e, this);
  }, proto.priority.geoservice.RouteList.toObject = function(e, r) {
    var s = {
      routesList: t.Message.toObjectList(
        r.getRoutesList(),
        proto.priority.geoservice.Route.toObject,
        e
      )
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.RouteList.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.RouteList();
    return proto.priority.geoservice.RouteList.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.RouteList.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = new proto.priority.geoservice.Route();
          r.readMessage(d, proto.priority.geoservice.Route.deserializeBinaryFromReader), e.addRoutes(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.RouteList.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.RouteList.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.RouteList.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getRoutesList(), s.length > 0 && r.writeRepeatedMessage(
      1,
      s,
      proto.priority.geoservice.Route.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.RouteList.prototype.getRoutesList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.Route>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.Route, 1)
    );
  }, proto.priority.geoservice.RouteList.prototype.setRoutesList = function(e) {
    return t.Message.setRepeatedWrapperField(this, 1, e);
  }, proto.priority.geoservice.RouteList.prototype.addRoutes = function(e, r) {
    return t.Message.addToRepeatedWrapperField(this, 1, e, proto.priority.geoservice.Route, r);
  }, proto.priority.geoservice.RouteList.prototype.clearRoutesList = function() {
    return this.setRoutesList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.Unassigned.prototype.toObject = function(e) {
    return proto.priority.geoservice.Unassigned.toObject(e, this);
  }, proto.priority.geoservice.Unassigned.toObject = function(e, r) {
    var s = {
      jobid: t.Message.getFieldWithDefault(r, 1, ""),
      reason: t.Message.getFieldWithDefault(r, 2, ""),
      type: t.Message.getFieldWithDefault(r, 3, ""),
      location: t.Message.getFieldWithDefault(r, 4, "")
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.Unassigned.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.Unassigned();
    return proto.priority.geoservice.Unassigned.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.Unassigned.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setJobid(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setReason(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setType(d);
          break;
        case 4:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setLocation(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.Unassigned.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.Unassigned.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.Unassigned.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getJobid(), s.length > 0 && r.writeString(
      1,
      s
    ), s = e.getReason(), s.length > 0 && r.writeString(
      2,
      s
    ), s = e.getType(), s.length > 0 && r.writeString(
      3,
      s
    ), s = e.getLocation(), s.length > 0 && r.writeString(
      4,
      s
    );
  }, proto.priority.geoservice.Unassigned.prototype.getJobid = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.geoservice.Unassigned.prototype.setJobid = function(e) {
    return t.Message.setProto3StringField(this, 1, e);
  }, proto.priority.geoservice.Unassigned.prototype.getReason = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.priority.geoservice.Unassigned.prototype.setReason = function(e) {
    return t.Message.setProto3StringField(this, 2, e);
  }, proto.priority.geoservice.Unassigned.prototype.getType = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.priority.geoservice.Unassigned.prototype.setType = function(e) {
    return t.Message.setProto3StringField(this, 3, e);
  }, proto.priority.geoservice.Unassigned.prototype.getLocation = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.priority.geoservice.Unassigned.prototype.setLocation = function(e) {
    return t.Message.setProto3StringField(this, 4, e);
  }, proto.priority.geoservice.UnassignedList.repeatedFields_ = [1], t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.UnassignedList.prototype.toObject = function(e) {
    return proto.priority.geoservice.UnassignedList.toObject(e, this);
  }, proto.priority.geoservice.UnassignedList.toObject = function(e, r) {
    var s = {
      jobsList: t.Message.toObjectList(
        r.getJobsList(),
        proto.priority.geoservice.Unassigned.toObject,
        e
      )
    };
    return e && (s.$jspbMessageInstance = r), s;
  }), proto.priority.geoservice.UnassignedList.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.UnassignedList();
    return proto.priority.geoservice.UnassignedList.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.UnassignedList.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = new proto.priority.geoservice.Unassigned();
          r.readMessage(d, proto.priority.geoservice.Unassigned.deserializeBinaryFromReader), e.addJobs(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.UnassignedList.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.UnassignedList.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.UnassignedList.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getJobsList(), s.length > 0 && r.writeRepeatedMessage(
      1,
      s,
      proto.priority.geoservice.Unassigned.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.UnassignedList.prototype.getJobsList = function() {
    return (
      /** @type{!Array<!proto.priority.geoservice.Unassigned>} */
      t.Message.getRepeatedWrapperField(this, proto.priority.geoservice.Unassigned, 1)
    );
  }, proto.priority.geoservice.UnassignedList.prototype.setJobsList = function(e) {
    return t.Message.setRepeatedWrapperField(this, 1, e);
  }, proto.priority.geoservice.UnassignedList.prototype.addJobs = function(e, r) {
    return t.Message.addToRepeatedWrapperField(this, 1, e, proto.priority.geoservice.Unassigned, r);
  }, proto.priority.geoservice.UnassignedList.prototype.clearJobsList = function() {
    return this.setJobsList([]);
  }, t.Message.GENERATE_TO_OBJECT && (proto.priority.geoservice.RouteOptimizationRs.prototype.toObject = function(e) {
    return proto.priority.geoservice.RouteOptimizationRs.toObject(e, this);
  }, proto.priority.geoservice.RouteOptimizationRs.toObject = function(e, r) {
    var s, d = {
      id: t.Message.getFieldWithDefault(r, 1, ""),
      status: (s = r.getStatus()) && proto.priority.geoservice.Status.toObject(e, s),
      summary: (s = r.getSummary()) && proto.priority.geoservice.Summary.toObject(e, s),
      routes: (s = r.getRoutes()) && proto.priority.geoservice.RouteList.toObject(e, s),
      unassigned: (s = r.getUnassigned()) && proto.priority.geoservice.UnassignedList.toObject(e, s)
    };
    return e && (d.$jspbMessageInstance = r), d;
  }), proto.priority.geoservice.RouteOptimizationRs.deserializeBinary = function(e) {
    var r = new t.BinaryReader(e), s = new proto.priority.geoservice.RouteOptimizationRs();
    return proto.priority.geoservice.RouteOptimizationRs.deserializeBinaryFromReader(s, r);
  }, proto.priority.geoservice.RouteOptimizationRs.deserializeBinaryFromReader = function(e, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var s = r.getFieldNumber();
      switch (s) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          e.setId(d);
          break;
        case 2:
          var d = new proto.priority.geoservice.Status();
          r.readMessage(d, proto.priority.geoservice.Status.deserializeBinaryFromReader), e.setStatus(d);
          break;
        case 3:
          var d = new proto.priority.geoservice.Summary();
          r.readMessage(d, proto.priority.geoservice.Summary.deserializeBinaryFromReader), e.setSummary(d);
          break;
        case 4:
          var d = new proto.priority.geoservice.RouteList();
          r.readMessage(d, proto.priority.geoservice.RouteList.deserializeBinaryFromReader), e.setRoutes(d);
          break;
        case 5:
          var d = new proto.priority.geoservice.UnassignedList();
          r.readMessage(d, proto.priority.geoservice.UnassignedList.deserializeBinaryFromReader), e.setUnassigned(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return e;
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.serializeBinary = function() {
    var e = new t.BinaryWriter();
    return proto.priority.geoservice.RouteOptimizationRs.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.priority.geoservice.RouteOptimizationRs.serializeBinaryToWriter = function(e, r) {
    var s = void 0;
    s = e.getId(), s.length > 0 && r.writeString(
      1,
      s
    ), s = e.getStatus(), s != null && r.writeMessage(
      2,
      s,
      proto.priority.geoservice.Status.serializeBinaryToWriter
    ), s = e.getSummary(), s != null && r.writeMessage(
      3,
      s,
      proto.priority.geoservice.Summary.serializeBinaryToWriter
    ), s = e.getRoutes(), s != null && r.writeMessage(
      4,
      s,
      proto.priority.geoservice.RouteList.serializeBinaryToWriter
    ), s = e.getUnassigned(), s != null && r.writeMessage(
      5,
      s,
      proto.priority.geoservice.UnassignedList.serializeBinaryToWriter
    );
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.getId = function() {
    return (
      /** @type {string} */
      t.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.setId = function(e) {
    return t.Message.setProto3StringField(this, 1, e);
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.getStatus = function() {
    return (
      /** @type{?proto.priority.geoservice.Status} */
      t.Message.getWrapperField(this, proto.priority.geoservice.Status, 2)
    );
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.setStatus = function(e) {
    return t.Message.setWrapperField(this, 2, e);
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.clearStatus = function() {
    return this.setStatus(void 0);
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.hasStatus = function() {
    return t.Message.getField(this, 2) != null;
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.getSummary = function() {
    return (
      /** @type{?proto.priority.geoservice.Summary} */
      t.Message.getWrapperField(this, proto.priority.geoservice.Summary, 3)
    );
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.setSummary = function(e) {
    return t.Message.setWrapperField(this, 3, e);
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.clearSummary = function() {
    return this.setSummary(void 0);
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.hasSummary = function() {
    return t.Message.getField(this, 3) != null;
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.getRoutes = function() {
    return (
      /** @type{?proto.priority.geoservice.RouteList} */
      t.Message.getWrapperField(this, proto.priority.geoservice.RouteList, 4)
    );
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.setRoutes = function(e) {
    return t.Message.setWrapperField(this, 4, e);
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.clearRoutes = function() {
    return this.setRoutes(void 0);
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.hasRoutes = function() {
    return t.Message.getField(this, 4) != null;
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.getUnassigned = function() {
    return (
      /** @type{?proto.priority.geoservice.UnassignedList} */
      t.Message.getWrapperField(this, proto.priority.geoservice.UnassignedList, 5)
    );
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.setUnassigned = function(e) {
    return t.Message.setWrapperField(this, 5, e);
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.clearUnassigned = function() {
    return this.setUnassigned(void 0);
  }, proto.priority.geoservice.RouteOptimizationRs.prototype.hasUnassigned = function() {
    return t.Message.getField(this, 5) != null;
  }, p.object.extend(n, proto.priority.geoservice);
})(Je);
const Qp = /* @__PURE__ */ Zt(Je), cl = /* @__PURE__ */ Ht({
  __proto__: null,
  default: Qp
}, [Je]), kt = {};
kt.web = Tt;
const Ye = {};
Ye.priority = {};
Ye.priority.geoservice = Je;
Ye.priority.geoservice.RouteOptimizationClient = function(n, t, p) {
  p || (p = {}), p.format = "text", this.client_ = new kt.web.GrpcWebClientBase(p), this.hostname_ = n.replace(/\/+$/, "");
};
Ye.priority.geoservice.RouteOptimizationPromiseClient = function(n, t, p) {
  p || (p = {}), p.format = "text", this.client_ = new kt.web.GrpcWebClientBase(p), this.hostname_ = n.replace(/\/+$/, "");
};
const Ms = new kt.web.MethodDescriptor(
  "/priority.geoservice.RouteOptimization/OptimizeRoute",
  kt.web.MethodType.SERVER_STREAMING,
  Ye.priority.geoservice.RouteOptimizationRq,
  Ye.priority.geoservice.RouteOptimizationRs,
  /**
   * @param {!proto.priority.geoservice.RouteOptimizationRq} request
   * @return {!Uint8Array}
   */
  function(n) {
    return n.serializeBinary();
  },
  Ye.priority.geoservice.RouteOptimizationRs.deserializeBinary
);
Ye.priority.geoservice.RouteOptimizationClient.prototype.optimizeRoute = function(n, t) {
  return this.client_.serverStreaming(
    this.hostname_ + "/priority.geoservice.RouteOptimization/OptimizeRoute",
    n,
    t || {},
    Ms
  );
};
Ye.priority.geoservice.RouteOptimizationPromiseClient.prototype.optimizeRoute = function(n, t) {
  return this.client_.serverStreaming(
    this.hostname_ + "/priority.geoservice.RouteOptimization/OptimizeRoute",
    n,
    t || {},
    Ms
  );
};
const Es = new kt.web.MethodDescriptor(
  "/priority.geoservice.RouteOptimization/ExtOptimizeRoute",
  kt.web.MethodType.SERVER_STREAMING,
  Ye.priority.geoservice.RouteOptimizationRq,
  Ye.priority.geoservice.RouteOptimizationRs,
  /**
   * @param {!proto.priority.geoservice.RouteOptimizationRq} request
   * @return {!Uint8Array}
   */
  function(n) {
    return n.serializeBinary();
  },
  Ye.priority.geoservice.RouteOptimizationRs.deserializeBinary
);
Ye.priority.geoservice.RouteOptimizationClient.prototype.extOptimizeRoute = function(n, t) {
  return this.client_.serverStreaming(
    this.hostname_ + "/priority.geoservice.RouteOptimization/ExtOptimizeRoute",
    n,
    t || {},
    Es
  );
};
Ye.priority.geoservice.RouteOptimizationPromiseClient.prototype.extOptimizeRoute = function(n, t) {
  return this.client_.serverStreaming(
    this.hostname_ + "/priority.geoservice.RouteOptimization/ExtOptimizeRoute",
    n,
    t || {},
    Es
  );
};
var Ko = Ye.priority.geoservice;
const eu = /* @__PURE__ */ Zt(Ko), fl = /* @__PURE__ */ Ht({
  __proto__: null,
  default: eu
}, [Ko]), Ue = [];
for (let n = 0; n < 256; ++n)
  Ue.push((n + 256).toString(16).slice(1));
function tu(n, t = 0) {
  return (Ue[n[t + 0]] + Ue[n[t + 1]] + Ue[n[t + 2]] + Ue[n[t + 3]] + "-" + Ue[n[t + 4]] + Ue[n[t + 5]] + "-" + Ue[n[t + 6]] + Ue[n[t + 7]] + "-" + Ue[n[t + 8]] + Ue[n[t + 9]] + "-" + Ue[n[t + 10]] + Ue[n[t + 11]] + Ue[n[t + 12]] + Ue[n[t + 13]] + Ue[n[t + 14]] + Ue[n[t + 15]]).toLowerCase();
}
let Qr;
const ru = new Uint8Array(16);
function iu() {
  if (!Qr) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Qr = crypto.getRandomValues.bind(crypto);
  }
  return Qr(ru);
}
const ou = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), En = { randomUUID: ou };
function Bn(n, t, p) {
  var l;
  if (En.randomUUID && !t && !n)
    return En.randomUUID();
  n = n || {};
  const f = n.random ?? ((l = n.rng) == null ? void 0 : l.call(n)) ?? iu();
  if (f.length < 16)
    throw new Error("Random bytes length must be >= 16");
  if (f[6] = f[6] & 15 | 64, f[8] = f[8] & 63 | 128, t) {
    if (p = p || 0, p < 0 || p + 16 > t.length)
      throw new RangeError(`UUID byte range ${p}:${p + 15} is out of buffer bounds`);
    for (let i = 0; i < 16; ++i)
      t[p + i] = f[i];
    return t;
  }
  return tu(f);
}
var Yo = { exports: {} }, Gt = typeof Reflect == "object" ? Reflect : null, Tn = Gt && typeof Gt.apply == "function" ? Gt.apply : function(t, p, f) {
  return Function.prototype.apply.call(t, p, f);
}, Mr;
Gt && typeof Gt.ownKeys == "function" ? Mr = Gt.ownKeys : Object.getOwnPropertySymbols ? Mr = function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : Mr = function(t) {
  return Object.getOwnPropertyNames(t);
};
function nu(n) {
  console && console.warn && console.warn(n);
}
var Bs = Number.isNaN || function(t) {
  return t !== t;
};
function Fe() {
  Fe.init.call(this);
}
Yo.exports = Fe;
Yo.exports.once = uu;
Fe.EventEmitter = Fe;
Fe.prototype._events = void 0;
Fe.prototype._eventsCount = 0;
Fe.prototype._maxListeners = void 0;
var Dn = 10;
function jr(n) {
  if (typeof n != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof n);
}
Object.defineProperty(Fe, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Dn;
  },
  set: function(n) {
    if (typeof n != "number" || n < 0 || Bs(n))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + n + ".");
    Dn = n;
  }
});
Fe.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Fe.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || Bs(t))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
  return this._maxListeners = t, this;
};
function Ts(n) {
  return n._maxListeners === void 0 ? Fe.defaultMaxListeners : n._maxListeners;
}
Fe.prototype.getMaxListeners = function() {
  return Ts(this);
};
Fe.prototype.emit = function(t) {
  for (var p = [], f = 1; f < arguments.length; f++)
    p.push(arguments[f]);
  var l = t === "error", i = this._events;
  if (i !== void 0)
    l = l && i.error === void 0;
  else if (!l)
    return !1;
  if (l) {
    var e;
    if (p.length > 0 && (e = p[0]), e instanceof Error)
      throw e;
    var r = new Error("Unhandled error." + (e ? " (" + e.message + ")" : ""));
    throw r.context = e, r;
  }
  var s = i[t];
  if (s === void 0)
    return !1;
  if (typeof s == "function")
    Tn(s, this, p);
  else
    for (var d = s.length, A = Is(s, d), f = 0; f < d; ++f)
      Tn(A[f], this, p);
  return !0;
};
function Ds(n, t, p, f) {
  var l, i, e;
  if (jr(p), i = n._events, i === void 0 ? (i = n._events = /* @__PURE__ */ Object.create(null), n._eventsCount = 0) : (i.newListener !== void 0 && (n.emit(
    "newListener",
    t,
    p.listener ? p.listener : p
  ), i = n._events), e = i[t]), e === void 0)
    e = i[t] = p, ++n._eventsCount;
  else if (typeof e == "function" ? e = i[t] = f ? [p, e] : [e, p] : f ? e.unshift(p) : e.push(p), l = Ts(n), l > 0 && e.length > l && !e.warned) {
    e.warned = !0;
    var r = new Error("Possible EventEmitter memory leak detected. " + e.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    r.name = "MaxListenersExceededWarning", r.emitter = n, r.type = t, r.count = e.length, nu(r);
  }
  return n;
}
Fe.prototype.addListener = function(t, p) {
  return Ds(this, t, p, !1);
};
Fe.prototype.on = Fe.prototype.addListener;
Fe.prototype.prependListener = function(t, p) {
  return Ds(this, t, p, !0);
};
function au() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function Os(n, t, p) {
  var f = { fired: !1, wrapFn: void 0, target: n, type: t, listener: p }, l = au.bind(f);
  return l.listener = p, f.wrapFn = l, l;
}
Fe.prototype.once = function(t, p) {
  return jr(p), this.on(t, Os(this, t, p)), this;
};
Fe.prototype.prependOnceListener = function(t, p) {
  return jr(p), this.prependListener(t, Os(this, t, p)), this;
};
Fe.prototype.removeListener = function(t, p) {
  var f, l, i, e, r;
  if (jr(p), l = this._events, l === void 0)
    return this;
  if (f = l[t], f === void 0)
    return this;
  if (f === p || f.listener === p)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete l[t], l.removeListener && this.emit("removeListener", t, f.listener || p));
  else if (typeof f != "function") {
    for (i = -1, e = f.length - 1; e >= 0; e--)
      if (f[e] === p || f[e].listener === p) {
        r = f[e].listener, i = e;
        break;
      }
    if (i < 0)
      return this;
    i === 0 ? f.shift() : su(f, i), f.length === 1 && (l[t] = f[0]), l.removeListener !== void 0 && this.emit("removeListener", t, r || p);
  }
  return this;
};
Fe.prototype.off = Fe.prototype.removeListener;
Fe.prototype.removeAllListeners = function(t) {
  var p, f, l;
  if (f = this._events, f === void 0)
    return this;
  if (f.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : f[t] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete f[t]), this;
  if (arguments.length === 0) {
    var i = Object.keys(f), e;
    for (l = 0; l < i.length; ++l)
      e = i[l], e !== "removeListener" && this.removeAllListeners(e);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (p = f[t], typeof p == "function")
    this.removeListener(t, p);
  else if (p !== void 0)
    for (l = p.length - 1; l >= 0; l--)
      this.removeListener(t, p[l]);
  return this;
};
function Ls(n, t, p) {
  var f = n._events;
  if (f === void 0)
    return [];
  var l = f[t];
  return l === void 0 ? [] : typeof l == "function" ? p ? [l.listener || l] : [l] : p ? pu(l) : Is(l, l.length);
}
Fe.prototype.listeners = function(t) {
  return Ls(this, t, !0);
};
Fe.prototype.rawListeners = function(t) {
  return Ls(this, t, !1);
};
Fe.listenerCount = function(n, t) {
  return typeof n.listenerCount == "function" ? n.listenerCount(t) : As.call(n, t);
};
Fe.prototype.listenerCount = As;
function As(n) {
  var t = this._events;
  if (t !== void 0) {
    var p = t[n];
    if (typeof p == "function")
      return 1;
    if (p !== void 0)
      return p.length;
  }
  return 0;
}
Fe.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Mr(this._events) : [];
};
function Is(n, t) {
  for (var p = new Array(t), f = 0; f < t; ++f)
    p[f] = n[f];
  return p;
}
function su(n, t) {
  for (; t + 1 < n.length; t++)
    n[t] = n[t + 1];
  n.pop();
}
function pu(n) {
  for (var t = new Array(n.length), p = 0; p < t.length; ++p)
    t[p] = n[p].listener || n[p];
  return t;
}
function uu(n, t) {
  return new Promise(function(p, f) {
    function l(e) {
      n.removeListener(t, i), f(e);
    }
    function i() {
      typeof n.removeListener == "function" && n.removeListener("error", l), p([].slice.call(arguments));
    }
    Ws(n, t, i, { once: !0 }), t !== "error" && lu(n, l, { once: !0 });
  });
}
function lu(n, t, p) {
  typeof n.on == "function" && Ws(n, "error", t, p);
}
function Ws(n, t, p, f) {
  if (typeof n.on == "function")
    f.once ? n.once(t, p) : n.on(t, p);
  else if (typeof n.addEventListener == "function")
    n.addEventListener(t, function l(i) {
      f.once && n.removeEventListener(t, l), p(i);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof n);
}
var Xo = Yo.exports, To = { exports: {} };
typeof Object.create == "function" ? To.exports = function(t, p) {
  p && (t.super_ = p, t.prototype = Object.create(p.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : To.exports = function(t, p) {
  if (p) {
    t.super_ = p;
    var f = function() {
    };
    f.prototype = p.prototype, t.prototype = new f(), t.prototype.constructor = t;
  }
};
var jt = To.exports;
function cu(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var _s = { exports: {} }, ke = _s.exports = {}, ct, ft;
function Do() {
  throw new Error("setTimeout has not been defined");
}
function Oo() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? ct = setTimeout : ct = Do;
  } catch {
    ct = Do;
  }
  try {
    typeof clearTimeout == "function" ? ft = clearTimeout : ft = Oo;
  } catch {
    ft = Oo;
  }
})();
function Ps(n) {
  if (ct === setTimeout)
    return setTimeout(n, 0);
  if ((ct === Do || !ct) && setTimeout)
    return ct = setTimeout, setTimeout(n, 0);
  try {
    return ct(n, 0);
  } catch {
    try {
      return ct.call(null, n, 0);
    } catch {
      return ct.call(this, n, 0);
    }
  }
}
function fu(n) {
  if (ft === clearTimeout)
    return clearTimeout(n);
  if ((ft === Oo || !ft) && clearTimeout)
    return ft = clearTimeout, clearTimeout(n);
  try {
    return ft(n);
  } catch {
    try {
      return ft.call(null, n);
    } catch {
      return ft.call(this, n);
    }
  }
}
var St = [], Vt = !1, It, Er = -1;
function yu() {
  !Vt || !It || (Vt = !1, It.length ? St = It.concat(St) : Er = -1, St.length && ks());
}
function ks() {
  if (!Vt) {
    var n = Ps(yu);
    Vt = !0;
    for (var t = St.length; t; ) {
      for (It = St, St = []; ++Er < t; )
        It && It[Er].run();
      Er = -1, t = St.length;
    }
    It = null, Vt = !1, fu(n);
  }
}
ke.nextTick = function(n) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var p = 1; p < arguments.length; p++)
      t[p - 1] = arguments[p];
  St.push(new Cs(n, t)), St.length === 1 && !Vt && Ps(ks);
};
function Cs(n, t) {
  this.fun = n, this.array = t;
}
Cs.prototype.run = function() {
  this.fun.apply(null, this.array);
};
ke.title = "browser";
ke.browser = !0;
ke.env = {};
ke.argv = [];
ke.version = "";
ke.versions = {};
function Ft() {
}
ke.on = Ft;
ke.addListener = Ft;
ke.once = Ft;
ke.off = Ft;
ke.removeListener = Ft;
ke.removeAllListeners = Ft;
ke.emit = Ft;
ke.prependListener = Ft;
ke.prependOnceListener = Ft;
ke.listeners = function(n) {
  return [];
};
ke.binding = function(n) {
  throw new Error("process.binding is not supported");
};
ke.cwd = function() {
  return "/";
};
ke.chdir = function(n) {
  throw new Error("process.chdir is not supported");
};
ke.umask = function() {
  return 0;
};
var du = _s.exports;
const ge = /* @__PURE__ */ cu(du);
var ei, On;
function js() {
  return On || (On = 1, ei = Xo.EventEmitter), ei;
}
var ti = {}, Ln;
function zr() {
  return Ln || (Ln = 1, function(n) {
    Object.defineProperties(n, { __esModule: { value: !0 }, [Symbol.toStringTag]: { value: "Module" } });
    var t = {}, p = {};
    p.byteLength = A, p.toByteArray = M, p.fromByteArray = H;
    for (var f = [], l = [], i = typeof Uint8Array < "u" ? Uint8Array : Array, e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", r = 0, s = e.length; r < s; ++r)
      f[r] = e[r], l[e.charCodeAt(r)] = r;
    l["-".charCodeAt(0)] = 62, l["_".charCodeAt(0)] = 63;
    function d(D) {
      var O = D.length;
      if (O % 4 > 0)
        throw new Error("Invalid string. Length must be a multiple of 4");
      var z = D.indexOf("=");
      z === -1 && (z = O);
      var $ = z === O ? 0 : 4 - z % 4;
      return [z, $];
    }
    function A(D) {
      var O = d(D), z = O[0], $ = O[1];
      return (z + $) * 3 / 4 - $;
    }
    function _(D, O, z) {
      return (O + z) * 3 / 4 - z;
    }
    function M(D) {
      var O, z = d(D), $ = z[0], J = z[1], F = new i(_(D, $, J)), ee = 0, oe = J > 0 ? $ - 4 : $, ae;
      for (ae = 0; ae < oe; ae += 4)
        O = l[D.charCodeAt(ae)] << 18 | l[D.charCodeAt(ae + 1)] << 12 | l[D.charCodeAt(ae + 2)] << 6 | l[D.charCodeAt(ae + 3)], F[ee++] = O >> 16 & 255, F[ee++] = O >> 8 & 255, F[ee++] = O & 255;
      return J === 2 && (O = l[D.charCodeAt(ae)] << 2 | l[D.charCodeAt(ae + 1)] >> 4, F[ee++] = O & 255), J === 1 && (O = l[D.charCodeAt(ae)] << 10 | l[D.charCodeAt(ae + 1)] << 4 | l[D.charCodeAt(ae + 2)] >> 2, F[ee++] = O >> 8 & 255, F[ee++] = O & 255), F;
    }
    function X(D) {
      return f[D >> 18 & 63] + f[D >> 12 & 63] + f[D >> 6 & 63] + f[D & 63];
    }
    function V(D, O, z) {
      for (var $, J = [], F = O; F < z; F += 3)
        $ = (D[F] << 16 & 16711680) + (D[F + 1] << 8 & 65280) + (D[F + 2] & 255), J.push(X($));
      return J.join("");
    }
    function H(D) {
      for (var O, z = D.length, $ = z % 3, J = [], F = 16383, ee = 0, oe = z - $; ee < oe; ee += F)
        J.push(V(D, ee, ee + F > oe ? oe : ee + F));
      return $ === 1 ? (O = D[z - 1], J.push(
        f[O >> 2] + f[O << 4 & 63] + "=="
      )) : $ === 2 && (O = (D[z - 2] << 8) + D[z - 1], J.push(
        f[O >> 10] + f[O >> 4 & 63] + f[O << 2 & 63] + "="
      )), J.join("");
    }
    var x = {};
    /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
    x.read = function(D, O, z, $, J) {
      var F, ee, oe = J * 8 - $ - 1, ae = (1 << oe) - 1, fe = ae >> 1, I = -7, ne = z ? J - 1 : 0, me = z ? -1 : 1, be = D[O + ne];
      for (ne += me, F = be & (1 << -I) - 1, be >>= -I, I += oe; I > 0; F = F * 256 + D[O + ne], ne += me, I -= 8)
        ;
      for (ee = F & (1 << -I) - 1, F >>= -I, I += $; I > 0; ee = ee * 256 + D[O + ne], ne += me, I -= 8)
        ;
      if (F === 0)
        F = 1 - fe;
      else {
        if (F === ae)
          return ee ? NaN : (be ? -1 : 1) * (1 / 0);
        ee = ee + Math.pow(2, $), F = F - fe;
      }
      return (be ? -1 : 1) * ee * Math.pow(2, F - $);
    }, x.write = function(D, O, z, $, J, F) {
      var ee, oe, ae, fe = F * 8 - J - 1, I = (1 << fe) - 1, ne = I >> 1, me = J === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, be = $ ? 0 : F - 1, we = $ ? 1 : -1, We = O < 0 || O === 0 && 1 / O < 0 ? 1 : 0;
      for (O = Math.abs(O), isNaN(O) || O === 1 / 0 ? (oe = isNaN(O) ? 1 : 0, ee = I) : (ee = Math.floor(Math.log(O) / Math.LN2), O * (ae = Math.pow(2, -ee)) < 1 && (ee--, ae *= 2), ee + ne >= 1 ? O += me / ae : O += me * Math.pow(2, 1 - ne), O * ae >= 2 && (ee++, ae /= 2), ee + ne >= I ? (oe = 0, ee = I) : ee + ne >= 1 ? (oe = (O * ae - 1) * Math.pow(2, J), ee = ee + ne) : (oe = O * Math.pow(2, ne - 1) * Math.pow(2, J), ee = 0)); J >= 8; D[z + be] = oe & 255, be += we, oe /= 256, J -= 8)
        ;
      for (ee = ee << J | oe, fe += J; fe > 0; D[z + be] = ee & 255, be += we, ee /= 256, fe -= 8)
        ;
      D[z + be - we] |= We * 128;
    };
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <https://feross.org>
     * @license  MIT
     */
    (function(D) {
      const O = p, z = x, $ = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
      D.Buffer = I, D.SlowBuffer = N, D.INSPECT_MAX_BYTES = 50;
      const J = 2147483647;
      D.kMaxLength = J;
      const { Uint8Array: F, ArrayBuffer: ee, SharedArrayBuffer: oe } = globalThis;
      I.TYPED_ARRAY_SUPPORT = ae(), !I.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
        "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
      );
      function ae() {
        try {
          const g = new F(1), c = { foo: function() {
            return 42;
          } };
          return Object.setPrototypeOf(c, F.prototype), Object.setPrototypeOf(g, c), g.foo() === 42;
        } catch {
          return !1;
        }
      }
      Object.defineProperty(I.prototype, "parent", {
        enumerable: !0,
        get: function() {
          if (I.isBuffer(this))
            return this.buffer;
        }
      }), Object.defineProperty(I.prototype, "offset", {
        enumerable: !0,
        get: function() {
          if (I.isBuffer(this))
            return this.byteOffset;
        }
      });
      function fe(g) {
        if (g > J)
          throw new RangeError('The value "' + g + '" is invalid for option "size"');
        const c = new F(g);
        return Object.setPrototypeOf(c, I.prototype), c;
      }
      function I(g, c, y) {
        if (typeof g == "number") {
          if (typeof c == "string")
            throw new TypeError(
              'The "string" argument must be of type string. Received type number'
            );
          return we(g);
        }
        return ne(g, c, y);
      }
      I.poolSize = 8192;
      function ne(g, c, y) {
        if (typeof g == "string")
          return We(g, c);
        if (ee.isView(g))
          return Me(g);
        if (g == null)
          throw new TypeError(
            "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof g
          );
        if (Ve(g, ee) || g && Ve(g.buffer, ee) || typeof oe < "u" && (Ve(g, oe) || g && Ve(g.buffer, oe)))
          return Le(g, c, y);
        if (typeof g == "number")
          throw new TypeError(
            'The "value" argument must not be of type number. Received type number'
          );
        const S = g.valueOf && g.valueOf();
        if (S != null && S !== g)
          return I.from(S, c, y);
        const T = qe(g);
        if (T)
          return T;
        if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof g[Symbol.toPrimitive] == "function")
          return I.from(g[Symbol.toPrimitive]("string"), c, y);
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof g
        );
      }
      I.from = function(g, c, y) {
        return ne(g, c, y);
      }, Object.setPrototypeOf(I.prototype, F.prototype), Object.setPrototypeOf(I, F);
      function me(g) {
        if (typeof g != "number")
          throw new TypeError('"size" argument must be of type number');
        if (g < 0)
          throw new RangeError('The value "' + g + '" is invalid for option "size"');
      }
      function be(g, c, y) {
        return me(g), g <= 0 ? fe(g) : c !== void 0 ? typeof y == "string" ? fe(g).fill(c, y) : fe(g).fill(c) : fe(g);
      }
      I.alloc = function(g, c, y) {
        return be(g, c, y);
      };
      function we(g) {
        return me(g), fe(g < 0 ? 0 : k(g) | 0);
      }
      I.allocUnsafe = function(g) {
        return we(g);
      }, I.allocUnsafeSlow = function(g) {
        return we(g);
      };
      function We(g, c) {
        if ((typeof c != "string" || c === "") && (c = "utf8"), !I.isEncoding(c))
          throw new TypeError("Unknown encoding: " + c);
        const y = Z(g, c) | 0;
        let S = fe(y);
        const T = S.write(g, c);
        return T !== y && (S = S.slice(0, T)), S;
      }
      function Oe(g) {
        const c = g.length < 0 ? 0 : k(g.length) | 0, y = fe(c);
        for (let S = 0; S < c; S += 1)
          y[S] = g[S] & 255;
        return y;
      }
      function Me(g) {
        if (Ve(g, F)) {
          const c = new F(g);
          return Le(c.buffer, c.byteOffset, c.byteLength);
        }
        return Oe(g);
      }
      function Le(g, c, y) {
        if (c < 0 || g.byteLength < c)
          throw new RangeError('"offset" is outside of buffer bounds');
        if (g.byteLength < c + (y || 0))
          throw new RangeError('"length" is outside of buffer bounds');
        let S;
        return c === void 0 && y === void 0 ? S = new F(g) : y === void 0 ? S = new F(g, c) : S = new F(g, c, y), Object.setPrototypeOf(S, I.prototype), S;
      }
      function qe(g) {
        if (I.isBuffer(g)) {
          const c = k(g.length) | 0, y = fe(c);
          return y.length === 0 || g.copy(y, 0, 0, c), y;
        }
        if (g.length !== void 0)
          return typeof g.length != "number" || zt(g.length) ? fe(0) : Oe(g);
        if (g.type === "Buffer" && Array.isArray(g.data))
          return Oe(g.data);
      }
      function k(g) {
        if (g >= J)
          throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + J.toString(16) + " bytes");
        return g | 0;
      }
      function N(g) {
        return +g != g && (g = 0), I.alloc(+g);
      }
      I.isBuffer = function(c) {
        return c != null && c._isBuffer === !0 && c !== I.prototype;
      }, I.compare = function(c, y) {
        if (Ve(c, F) && (c = I.from(c, c.offset, c.byteLength)), Ve(y, F) && (y = I.from(y, y.offset, y.byteLength)), !I.isBuffer(c) || !I.isBuffer(y))
          throw new TypeError(
            'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
          );
        if (c === y)
          return 0;
        let S = c.length, T = y.length;
        for (let j = 0, G = Math.min(S, T); j < G; ++j)
          if (c[j] !== y[j]) {
            S = c[j], T = y[j];
            break;
          }
        return S < T ? -1 : T < S ? 1 : 0;
      }, I.isEncoding = function(c) {
        switch (String(c).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;
          default:
            return !1;
        }
      }, I.concat = function(c, y) {
        if (!Array.isArray(c))
          throw new TypeError('"list" argument must be an Array of Buffers');
        if (c.length === 0)
          return I.alloc(0);
        let S;
        if (y === void 0)
          for (y = 0, S = 0; S < c.length; ++S)
            y += c[S].length;
        const T = I.allocUnsafe(y);
        let j = 0;
        for (S = 0; S < c.length; ++S) {
          let G = c[S];
          if (Ve(G, F))
            j + G.length > T.length ? (I.isBuffer(G) || (G = I.from(G)), G.copy(T, j)) : F.prototype.set.call(
              T,
              G,
              j
            );
          else if (I.isBuffer(G))
            G.copy(T, j);
          else
            throw new TypeError('"list" argument must be an Array of Buffers');
          j += G.length;
        }
        return T;
      };
      function Z(g, c) {
        if (I.isBuffer(g))
          return g.length;
        if (ee.isView(g) || Ve(g, ee))
          return g.byteLength;
        if (typeof g != "string")
          throw new TypeError(
            'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof g
          );
        const y = g.length, S = arguments.length > 2 && arguments[2] === !0;
        if (!S && y === 0)
          return 0;
        let T = !1;
        for (; ; )
          switch (c) {
            case "ascii":
            case "latin1":
            case "binary":
              return y;
            case "utf8":
            case "utf-8":
              return mt(g).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return y * 2;
            case "hex":
              return y >>> 1;
            case "base64":
              return Lt(g).length;
            default:
              if (T)
                return S ? -1 : mt(g).length;
              c = ("" + c).toLowerCase(), T = !0;
          }
      }
      I.byteLength = Z;
      function le(g, c, y) {
        let S = !1;
        if ((c === void 0 || c < 0) && (c = 0), c > this.length || ((y === void 0 || y > this.length) && (y = this.length), y <= 0) || (y >>>= 0, c >>>= 0, y <= c))
          return "";
        for (g || (g = "utf8"); ; )
          switch (g) {
            case "hex":
              return Ge(this, c, y);
            case "utf8":
            case "utf-8":
              return ye(this, c, y);
            case "ascii":
              return ze(this, c, y);
            case "latin1":
            case "binary":
              return q(this, c, y);
            case "base64":
              return te(this, c, y);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return xe(this, c, y);
            default:
              if (S)
                throw new TypeError("Unknown encoding: " + g);
              g = (g + "").toLowerCase(), S = !0;
          }
      }
      I.prototype._isBuffer = !0;
      function L(g, c, y) {
        const S = g[c];
        g[c] = g[y], g[y] = S;
      }
      I.prototype.swap16 = function() {
        const c = this.length;
        if (c % 2 !== 0)
          throw new RangeError("Buffer size must be a multiple of 16-bits");
        for (let y = 0; y < c; y += 2)
          L(this, y, y + 1);
        return this;
      }, I.prototype.swap32 = function() {
        const c = this.length;
        if (c % 4 !== 0)
          throw new RangeError("Buffer size must be a multiple of 32-bits");
        for (let y = 0; y < c; y += 4)
          L(this, y, y + 3), L(this, y + 1, y + 2);
        return this;
      }, I.prototype.swap64 = function() {
        const c = this.length;
        if (c % 8 !== 0)
          throw new RangeError("Buffer size must be a multiple of 64-bits");
        for (let y = 0; y < c; y += 8)
          L(this, y, y + 7), L(this, y + 1, y + 6), L(this, y + 2, y + 5), L(this, y + 3, y + 4);
        return this;
      }, I.prototype.toString = function() {
        const c = this.length;
        return c === 0 ? "" : arguments.length === 0 ? ye(this, 0, c) : le.apply(this, arguments);
      }, I.prototype.toLocaleString = I.prototype.toString, I.prototype.equals = function(c) {
        if (!I.isBuffer(c))
          throw new TypeError("Argument must be a Buffer");
        return this === c ? !0 : I.compare(this, c) === 0;
      }, I.prototype.inspect = function() {
        let c = "";
        const y = D.INSPECT_MAX_BYTES;
        return c = this.toString("hex", 0, y).replace(/(.{2})/g, "$1 ").trim(), this.length > y && (c += " ... "), "<Buffer " + c + ">";
      }, $ && (I.prototype[$] = I.prototype.inspect), I.prototype.compare = function(c, y, S, T, j) {
        if (Ve(c, F) && (c = I.from(c, c.offset, c.byteLength)), !I.isBuffer(c))
          throw new TypeError(
            'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof c
          );
        if (y === void 0 && (y = 0), S === void 0 && (S = c ? c.length : 0), T === void 0 && (T = 0), j === void 0 && (j = this.length), y < 0 || S > c.length || T < 0 || j > this.length)
          throw new RangeError("out of range index");
        if (T >= j && y >= S)
          return 0;
        if (T >= j)
          return -1;
        if (y >= S)
          return 1;
        if (y >>>= 0, S >>>= 0, T >>>= 0, j >>>= 0, this === c)
          return 0;
        let G = j - T, de = S - y;
        const De = Math.min(G, de), Ee = this.slice(T, j), Be = c.slice(y, S);
        for (let ve = 0; ve < De; ++ve)
          if (Ee[ve] !== Be[ve]) {
            G = Ee[ve], de = Be[ve];
            break;
          }
        return G < de ? -1 : de < G ? 1 : 0;
      };
      function B(g, c, y, S, T) {
        if (g.length === 0)
          return -1;
        if (typeof y == "string" ? (S = y, y = 0) : y > 2147483647 ? y = 2147483647 : y < -2147483648 && (y = -2147483648), y = +y, zt(y) && (y = T ? 0 : g.length - 1), y < 0 && (y = g.length + y), y >= g.length) {
          if (T)
            return -1;
          y = g.length - 1;
        } else if (y < 0)
          if (T)
            y = 0;
          else
            return -1;
        if (typeof c == "string" && (c = I.from(c, S)), I.isBuffer(c))
          return c.length === 0 ? -1 : P(g, c, y, S, T);
        if (typeof c == "number")
          return c = c & 255, typeof F.prototype.indexOf == "function" ? T ? F.prototype.indexOf.call(g, c, y) : F.prototype.lastIndexOf.call(g, c, y) : P(g, [c], y, S, T);
        throw new TypeError("val must be string, number or Buffer");
      }
      function P(g, c, y, S, T) {
        let j = 1, G = g.length, de = c.length;
        if (S !== void 0 && (S = String(S).toLowerCase(), S === "ucs2" || S === "ucs-2" || S === "utf16le" || S === "utf-16le")) {
          if (g.length < 2 || c.length < 2)
            return -1;
          j = 2, G /= 2, de /= 2, y /= 2;
        }
        function De(Be, ve) {
          return j === 1 ? Be[ve] : Be.readUInt16BE(ve * j);
        }
        let Ee;
        if (T) {
          let Be = -1;
          for (Ee = y; Ee < G; Ee++)
            if (De(g, Ee) === De(c, Be === -1 ? 0 : Ee - Be)) {
              if (Be === -1 && (Be = Ee), Ee - Be + 1 === de)
                return Be * j;
            } else
              Be !== -1 && (Ee -= Ee - Be), Be = -1;
        } else
          for (y + de > G && (y = G - de), Ee = y; Ee >= 0; Ee--) {
            let Be = !0;
            for (let ve = 0; ve < de; ve++)
              if (De(g, Ee + ve) !== De(c, ve)) {
                Be = !1;
                break;
              }
            if (Be)
              return Ee;
          }
        return -1;
      }
      I.prototype.includes = function(c, y, S) {
        return this.indexOf(c, y, S) !== -1;
      }, I.prototype.indexOf = function(c, y, S) {
        return B(this, c, y, S, !0);
      }, I.prototype.lastIndexOf = function(c, y, S) {
        return B(this, c, y, S, !1);
      };
      function Y(g, c, y, S) {
        y = Number(y) || 0;
        const T = g.length - y;
        S ? (S = Number(S), S > T && (S = T)) : S = T;
        const j = c.length;
        S > j / 2 && (S = j / 2);
        let G;
        for (G = 0; G < S; ++G) {
          const de = parseInt(c.substr(G * 2, 2), 16);
          if (zt(de))
            return G;
          g[y + G] = de;
        }
        return G;
      }
      function Q(g, c, y, S) {
        return lt(mt(c, g.length - y), g, y, S);
      }
      function v(g, c, y, S) {
        return lt(vr(c), g, y, S);
      }
      function b(g, c, y, S) {
        return lt(Lt(c), g, y, S);
      }
      function U(g, c, y, S) {
        return lt(ie(c, g.length - y), g, y, S);
      }
      I.prototype.write = function(c, y, S, T) {
        if (y === void 0)
          T = "utf8", S = this.length, y = 0;
        else if (S === void 0 && typeof y == "string")
          T = y, S = this.length, y = 0;
        else if (isFinite(y))
          y = y >>> 0, isFinite(S) ? (S = S >>> 0, T === void 0 && (T = "utf8")) : (T = S, S = void 0);
        else
          throw new Error(
            "Buffer.write(string, encoding, offset[, length]) is no longer supported"
          );
        const j = this.length - y;
        if ((S === void 0 || S > j) && (S = j), c.length > 0 && (S < 0 || y < 0) || y > this.length)
          throw new RangeError("Attempt to write outside buffer bounds");
        T || (T = "utf8");
        let G = !1;
        for (; ; )
          switch (T) {
            case "hex":
              return Y(this, c, y, S);
            case "utf8":
            case "utf-8":
              return Q(this, c, y, S);
            case "ascii":
            case "latin1":
            case "binary":
              return v(this, c, y, S);
            case "base64":
              return b(this, c, y, S);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return U(this, c, y, S);
            default:
              if (G)
                throw new TypeError("Unknown encoding: " + T);
              T = ("" + T).toLowerCase(), G = !0;
          }
      }, I.prototype.toJSON = function() {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      function te(g, c, y) {
        return c === 0 && y === g.length ? O.fromByteArray(g) : O.fromByteArray(g.slice(c, y));
      }
      function ye(g, c, y) {
        y = Math.min(g.length, y);
        const S = [];
        let T = c;
        for (; T < y; ) {
          const j = g[T];
          let G = null, de = j > 239 ? 4 : j > 223 ? 3 : j > 191 ? 2 : 1;
          if (T + de <= y) {
            let De, Ee, Be, ve;
            switch (de) {
              case 1:
                j < 128 && (G = j);
                break;
              case 2:
                De = g[T + 1], (De & 192) === 128 && (ve = (j & 31) << 6 | De & 63, ve > 127 && (G = ve));
                break;
              case 3:
                De = g[T + 1], Ee = g[T + 2], (De & 192) === 128 && (Ee & 192) === 128 && (ve = (j & 15) << 12 | (De & 63) << 6 | Ee & 63, ve > 2047 && (ve < 55296 || ve > 57343) && (G = ve));
                break;
              case 4:
                De = g[T + 1], Ee = g[T + 2], Be = g[T + 3], (De & 192) === 128 && (Ee & 192) === 128 && (Be & 192) === 128 && (ve = (j & 15) << 18 | (De & 63) << 12 | (Ee & 63) << 6 | Be & 63, ve > 65535 && ve < 1114112 && (G = ve));
            }
          }
          G === null ? (G = 65533, de = 1) : G > 65535 && (G -= 65536, S.push(G >>> 10 & 1023 | 55296), G = 56320 | G & 1023), S.push(G), T += de;
        }
        return he(S);
      }
      const se = 4096;
      function he(g) {
        const c = g.length;
        if (c <= se)
          return String.fromCharCode.apply(String, g);
        let y = "", S = 0;
        for (; S < c; )
          y += String.fromCharCode.apply(
            String,
            g.slice(S, S += se)
          );
        return y;
      }
      function ze(g, c, y) {
        let S = "";
        y = Math.min(g.length, y);
        for (let T = c; T < y; ++T)
          S += String.fromCharCode(g[T] & 127);
        return S;
      }
      function q(g, c, y) {
        let S = "";
        y = Math.min(g.length, y);
        for (let T = c; T < y; ++T)
          S += String.fromCharCode(g[T]);
        return S;
      }
      function Ge(g, c, y) {
        const S = g.length;
        (!c || c < 0) && (c = 0), (!y || y < 0 || y > S) && (y = S);
        let T = "";
        for (let j = c; j < y; ++j)
          T += $e[g[j]];
        return T;
      }
      function xe(g, c, y) {
        const S = g.slice(c, y);
        let T = "";
        for (let j = 0; j < S.length - 1; j += 2)
          T += String.fromCharCode(S[j] + S[j + 1] * 256);
        return T;
      }
      I.prototype.slice = function(c, y) {
        const S = this.length;
        c = ~~c, y = y === void 0 ? S : ~~y, c < 0 ? (c += S, c < 0 && (c = 0)) : c > S && (c = S), y < 0 ? (y += S, y < 0 && (y = 0)) : y > S && (y = S), y < c && (y = c);
        const T = this.subarray(c, y);
        return Object.setPrototypeOf(T, I.prototype), T;
      };
      function Se(g, c, y) {
        if (g % 1 !== 0 || g < 0)
          throw new RangeError("offset is not uint");
        if (g + c > y)
          throw new RangeError("Trying to access beyond buffer length");
      }
      I.prototype.readUintLE = I.prototype.readUIntLE = function(c, y, S) {
        c = c >>> 0, y = y >>> 0, S || Se(c, y, this.length);
        let T = this[c], j = 1, G = 0;
        for (; ++G < y && (j *= 256); )
          T += this[c + G] * j;
        return T;
      }, I.prototype.readUintBE = I.prototype.readUIntBE = function(c, y, S) {
        c = c >>> 0, y = y >>> 0, S || Se(c, y, this.length);
        let T = this[c + --y], j = 1;
        for (; y > 0 && (j *= 256); )
          T += this[c + --y] * j;
        return T;
      }, I.prototype.readUint8 = I.prototype.readUInt8 = function(c, y) {
        return c = c >>> 0, y || Se(c, 1, this.length), this[c];
      }, I.prototype.readUint16LE = I.prototype.readUInt16LE = function(c, y) {
        return c = c >>> 0, y || Se(c, 2, this.length), this[c] | this[c + 1] << 8;
      }, I.prototype.readUint16BE = I.prototype.readUInt16BE = function(c, y) {
        return c = c >>> 0, y || Se(c, 2, this.length), this[c] << 8 | this[c + 1];
      }, I.prototype.readUint32LE = I.prototype.readUInt32LE = function(c, y) {
        return c = c >>> 0, y || Se(c, 4, this.length), (this[c] | this[c + 1] << 8 | this[c + 2] << 16) + this[c + 3] * 16777216;
      }, I.prototype.readUint32BE = I.prototype.readUInt32BE = function(c, y) {
        return c = c >>> 0, y || Se(c, 4, this.length), this[c] * 16777216 + (this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3]);
      }, I.prototype.readBigUInt64LE = at(function(c) {
        c = c >>> 0, w(c, "offset");
        const y = this[c], S = this[c + 7];
        (y === void 0 || S === void 0) && it(c, this.length - 8);
        const T = y + this[++c] * 2 ** 8 + this[++c] * 2 ** 16 + this[++c] * 2 ** 24, j = this[++c] + this[++c] * 2 ** 8 + this[++c] * 2 ** 16 + S * 2 ** 24;
        return BigInt(T) + (BigInt(j) << BigInt(32));
      }), I.prototype.readBigUInt64BE = at(function(c) {
        c = c >>> 0, w(c, "offset");
        const y = this[c], S = this[c + 7];
        (y === void 0 || S === void 0) && it(c, this.length - 8);
        const T = y * 2 ** 24 + this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + this[++c], j = this[++c] * 2 ** 24 + this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + S;
        return (BigInt(T) << BigInt(32)) + BigInt(j);
      }), I.prototype.readIntLE = function(c, y, S) {
        c = c >>> 0, y = y >>> 0, S || Se(c, y, this.length);
        let T = this[c], j = 1, G = 0;
        for (; ++G < y && (j *= 256); )
          T += this[c + G] * j;
        return j *= 128, T >= j && (T -= Math.pow(2, 8 * y)), T;
      }, I.prototype.readIntBE = function(c, y, S) {
        c = c >>> 0, y = y >>> 0, S || Se(c, y, this.length);
        let T = y, j = 1, G = this[c + --T];
        for (; T > 0 && (j *= 256); )
          G += this[c + --T] * j;
        return j *= 128, G >= j && (G -= Math.pow(2, 8 * y)), G;
      }, I.prototype.readInt8 = function(c, y) {
        return c = c >>> 0, y || Se(c, 1, this.length), this[c] & 128 ? (255 - this[c] + 1) * -1 : this[c];
      }, I.prototype.readInt16LE = function(c, y) {
        c = c >>> 0, y || Se(c, 2, this.length);
        const S = this[c] | this[c + 1] << 8;
        return S & 32768 ? S | 4294901760 : S;
      }, I.prototype.readInt16BE = function(c, y) {
        c = c >>> 0, y || Se(c, 2, this.length);
        const S = this[c + 1] | this[c] << 8;
        return S & 32768 ? S | 4294901760 : S;
      }, I.prototype.readInt32LE = function(c, y) {
        return c = c >>> 0, y || Se(c, 4, this.length), this[c] | this[c + 1] << 8 | this[c + 2] << 16 | this[c + 3] << 24;
      }, I.prototype.readInt32BE = function(c, y) {
        return c = c >>> 0, y || Se(c, 4, this.length), this[c] << 24 | this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3];
      }, I.prototype.readBigInt64LE = at(function(c) {
        c = c >>> 0, w(c, "offset");
        const y = this[c], S = this[c + 7];
        (y === void 0 || S === void 0) && it(c, this.length - 8);
        const T = this[c + 4] + this[c + 5] * 2 ** 8 + this[c + 6] * 2 ** 16 + (S << 24);
        return (BigInt(T) << BigInt(32)) + BigInt(y + this[++c] * 2 ** 8 + this[++c] * 2 ** 16 + this[++c] * 2 ** 24);
      }), I.prototype.readBigInt64BE = at(function(c) {
        c = c >>> 0, w(c, "offset");
        const y = this[c], S = this[c + 7];
        (y === void 0 || S === void 0) && it(c, this.length - 8);
        const T = (y << 24) + // Overflow
        this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + this[++c];
        return (BigInt(T) << BigInt(32)) + BigInt(this[++c] * 2 ** 24 + this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + S);
      }), I.prototype.readFloatLE = function(c, y) {
        return c = c >>> 0, y || Se(c, 4, this.length), z.read(this, c, !0, 23, 4);
      }, I.prototype.readFloatBE = function(c, y) {
        return c = c >>> 0, y || Se(c, 4, this.length), z.read(this, c, !1, 23, 4);
      }, I.prototype.readDoubleLE = function(c, y) {
        return c = c >>> 0, y || Se(c, 8, this.length), z.read(this, c, !0, 52, 8);
      }, I.prototype.readDoubleBE = function(c, y) {
        return c = c >>> 0, y || Se(c, 8, this.length), z.read(this, c, !1, 52, 8);
      };
      function Re(g, c, y, S, T, j) {
        if (!I.isBuffer(g))
          throw new TypeError('"buffer" argument must be a Buffer instance');
        if (c > T || c < j)
          throw new RangeError('"value" argument is out of bounds');
        if (y + S > g.length)
          throw new RangeError("Index out of range");
      }
      I.prototype.writeUintLE = I.prototype.writeUIntLE = function(c, y, S, T) {
        if (c = +c, y = y >>> 0, S = S >>> 0, !T) {
          const de = Math.pow(2, 8 * S) - 1;
          Re(this, c, y, S, de, 0);
        }
        let j = 1, G = 0;
        for (this[y] = c & 255; ++G < S && (j *= 256); )
          this[y + G] = c / j & 255;
        return y + S;
      }, I.prototype.writeUintBE = I.prototype.writeUIntBE = function(c, y, S, T) {
        if (c = +c, y = y >>> 0, S = S >>> 0, !T) {
          const de = Math.pow(2, 8 * S) - 1;
          Re(this, c, y, S, de, 0);
        }
        let j = S - 1, G = 1;
        for (this[y + j] = c & 255; --j >= 0 && (G *= 256); )
          this[y + j] = c / G & 255;
        return y + S;
      }, I.prototype.writeUint8 = I.prototype.writeUInt8 = function(c, y, S) {
        return c = +c, y = y >>> 0, S || Re(this, c, y, 1, 255, 0), this[y] = c & 255, y + 1;
      }, I.prototype.writeUint16LE = I.prototype.writeUInt16LE = function(c, y, S) {
        return c = +c, y = y >>> 0, S || Re(this, c, y, 2, 65535, 0), this[y] = c & 255, this[y + 1] = c >>> 8, y + 2;
      }, I.prototype.writeUint16BE = I.prototype.writeUInt16BE = function(c, y, S) {
        return c = +c, y = y >>> 0, S || Re(this, c, y, 2, 65535, 0), this[y] = c >>> 8, this[y + 1] = c & 255, y + 2;
      }, I.prototype.writeUint32LE = I.prototype.writeUInt32LE = function(c, y, S) {
        return c = +c, y = y >>> 0, S || Re(this, c, y, 4, 4294967295, 0), this[y + 3] = c >>> 24, this[y + 2] = c >>> 16, this[y + 1] = c >>> 8, this[y] = c & 255, y + 4;
      }, I.prototype.writeUint32BE = I.prototype.writeUInt32BE = function(c, y, S) {
        return c = +c, y = y >>> 0, S || Re(this, c, y, 4, 4294967295, 0), this[y] = c >>> 24, this[y + 1] = c >>> 16, this[y + 2] = c >>> 8, this[y + 3] = c & 255, y + 4;
      };
      function Ne(g, c, y, S, T) {
        Ot(c, S, T, g, y, 7);
        let j = Number(c & BigInt(4294967295));
        g[y++] = j, j = j >> 8, g[y++] = j, j = j >> 8, g[y++] = j, j = j >> 8, g[y++] = j;
        let G = Number(c >> BigInt(32) & BigInt(4294967295));
        return g[y++] = G, G = G >> 8, g[y++] = G, G = G >> 8, g[y++] = G, G = G >> 8, g[y++] = G, y;
      }
      function ht(g, c, y, S, T) {
        Ot(c, S, T, g, y, 7);
        let j = Number(c & BigInt(4294967295));
        g[y + 7] = j, j = j >> 8, g[y + 6] = j, j = j >> 8, g[y + 5] = j, j = j >> 8, g[y + 4] = j;
        let G = Number(c >> BigInt(32) & BigInt(4294967295));
        return g[y + 3] = G, G = G >> 8, g[y + 2] = G, G = G >> 8, g[y + 1] = G, G = G >> 8, g[y] = G, y + 8;
      }
      I.prototype.writeBigUInt64LE = at(function(c, y = 0) {
        return Ne(this, c, y, BigInt(0), BigInt("0xffffffffffffffff"));
      }), I.prototype.writeBigUInt64BE = at(function(c, y = 0) {
        return ht(this, c, y, BigInt(0), BigInt("0xffffffffffffffff"));
      }), I.prototype.writeIntLE = function(c, y, S, T) {
        if (c = +c, y = y >>> 0, !T) {
          const De = Math.pow(2, 8 * S - 1);
          Re(this, c, y, S, De - 1, -De);
        }
        let j = 0, G = 1, de = 0;
        for (this[y] = c & 255; ++j < S && (G *= 256); )
          c < 0 && de === 0 && this[y + j - 1] !== 0 && (de = 1), this[y + j] = (c / G >> 0) - de & 255;
        return y + S;
      }, I.prototype.writeIntBE = function(c, y, S, T) {
        if (c = +c, y = y >>> 0, !T) {
          const De = Math.pow(2, 8 * S - 1);
          Re(this, c, y, S, De - 1, -De);
        }
        let j = S - 1, G = 1, de = 0;
        for (this[y + j] = c & 255; --j >= 0 && (G *= 256); )
          c < 0 && de === 0 && this[y + j + 1] !== 0 && (de = 1), this[y + j] = (c / G >> 0) - de & 255;
        return y + S;
      }, I.prototype.writeInt8 = function(c, y, S) {
        return c = +c, y = y >>> 0, S || Re(this, c, y, 1, 127, -128), c < 0 && (c = 255 + c + 1), this[y] = c & 255, y + 1;
      }, I.prototype.writeInt16LE = function(c, y, S) {
        return c = +c, y = y >>> 0, S || Re(this, c, y, 2, 32767, -32768), this[y] = c & 255, this[y + 1] = c >>> 8, y + 2;
      }, I.prototype.writeInt16BE = function(c, y, S) {
        return c = +c, y = y >>> 0, S || Re(this, c, y, 2, 32767, -32768), this[y] = c >>> 8, this[y + 1] = c & 255, y + 2;
      }, I.prototype.writeInt32LE = function(c, y, S) {
        return c = +c, y = y >>> 0, S || Re(this, c, y, 4, 2147483647, -2147483648), this[y] = c & 255, this[y + 1] = c >>> 8, this[y + 2] = c >>> 16, this[y + 3] = c >>> 24, y + 4;
      }, I.prototype.writeInt32BE = function(c, y, S) {
        return c = +c, y = y >>> 0, S || Re(this, c, y, 4, 2147483647, -2147483648), c < 0 && (c = 4294967295 + c + 1), this[y] = c >>> 24, this[y + 1] = c >>> 16, this[y + 2] = c >>> 8, this[y + 3] = c & 255, y + 4;
      }, I.prototype.writeBigInt64LE = at(function(c, y = 0) {
        return Ne(this, c, y, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      }), I.prototype.writeBigInt64BE = at(function(c, y = 0) {
        return ht(this, c, y, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      });
      function Xe(g, c, y, S, T, j) {
        if (y + S > g.length)
          throw new RangeError("Index out of range");
        if (y < 0)
          throw new RangeError("Index out of range");
      }
      function tt(g, c, y, S, T) {
        return c = +c, y = y >>> 0, T || Xe(g, c, y, 4), z.write(g, c, y, S, 23, 4), y + 4;
      }
      I.prototype.writeFloatLE = function(c, y, S) {
        return tt(this, c, y, !0, S);
      }, I.prototype.writeFloatBE = function(c, y, S) {
        return tt(this, c, y, !1, S);
      };
      function rt(g, c, y, S, T) {
        return c = +c, y = y >>> 0, T || Xe(g, c, y, 8), z.write(g, c, y, S, 52, 8), y + 8;
      }
      I.prototype.writeDoubleLE = function(c, y, S) {
        return rt(this, c, y, !0, S);
      }, I.prototype.writeDoubleBE = function(c, y, S) {
        return rt(this, c, y, !1, S);
      }, I.prototype.copy = function(c, y, S, T) {
        if (!I.isBuffer(c))
          throw new TypeError("argument should be a Buffer");
        if (S || (S = 0), !T && T !== 0 && (T = this.length), y >= c.length && (y = c.length), y || (y = 0), T > 0 && T < S && (T = S), T === S || c.length === 0 || this.length === 0)
          return 0;
        if (y < 0)
          throw new RangeError("targetStart out of bounds");
        if (S < 0 || S >= this.length)
          throw new RangeError("Index out of range");
        if (T < 0)
          throw new RangeError("sourceEnd out of bounds");
        T > this.length && (T = this.length), c.length - y < T - S && (T = c.length - y + S);
        const j = T - S;
        return this === c && typeof F.prototype.copyWithin == "function" ? this.copyWithin(y, S, T) : F.prototype.set.call(
          c,
          this.subarray(S, T),
          y
        ), j;
      }, I.prototype.fill = function(c, y, S, T) {
        if (typeof c == "string") {
          if (typeof y == "string" ? (T = y, y = 0, S = this.length) : typeof S == "string" && (T = S, S = this.length), T !== void 0 && typeof T != "string")
            throw new TypeError("encoding must be a string");
          if (typeof T == "string" && !I.isEncoding(T))
            throw new TypeError("Unknown encoding: " + T);
          if (c.length === 1) {
            const G = c.charCodeAt(0);
            (T === "utf8" && G < 128 || T === "latin1") && (c = G);
          }
        } else
          typeof c == "number" ? c = c & 255 : typeof c == "boolean" && (c = Number(c));
        if (y < 0 || this.length < y || this.length < S)
          throw new RangeError("Out of range index");
        if (S <= y)
          return this;
        y = y >>> 0, S = S === void 0 ? this.length : S >>> 0, c || (c = 0);
        let j;
        if (typeof c == "number")
          for (j = y; j < S; ++j)
            this[j] = c;
        else {
          const G = I.isBuffer(c) ? c : I.from(c, T), de = G.length;
          if (de === 0)
            throw new TypeError('The value "' + c + '" is invalid for argument "value"');
          for (j = 0; j < S - y; ++j)
            this[j + y] = G[j % de];
        }
        return this;
      };
      const gt = {};
      function Mt(g, c, y) {
        gt[g] = class extends y {
          constructor() {
            super(), Object.defineProperty(this, "message", {
              value: c.apply(this, arguments),
              writable: !0,
              configurable: !0
            }), this.name = `${this.name} [${g}]`, this.stack, delete this.name;
          }
          get code() {
            return g;
          }
          set code(T) {
            Object.defineProperty(this, "code", {
              configurable: !0,
              enumerable: !0,
              value: T,
              writable: !0
            });
          }
          toString() {
            return `${this.name} [${g}]: ${this.message}`;
          }
        };
      }
      Mt(
        "ERR_BUFFER_OUT_OF_BOUNDS",
        function(g) {
          return g ? `${g} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
        },
        RangeError
      ), Mt(
        "ERR_INVALID_ARG_TYPE",
        function(g, c) {
          return `The "${g}" argument must be of type number. Received type ${typeof c}`;
        },
        TypeError
      ), Mt(
        "ERR_OUT_OF_RANGE",
        function(g, c, y) {
          let S = `The value of "${g}" is out of range.`, T = y;
          return Number.isInteger(y) && Math.abs(y) > 2 ** 32 ? T = C(String(y)) : typeof y == "bigint" && (T = String(y), (y > BigInt(2) ** BigInt(32) || y < -(BigInt(2) ** BigInt(32))) && (T = C(T)), T += "n"), S += ` It must be ${c}. Received ${T}`, S;
        },
        RangeError
      );
      function C(g) {
        let c = "", y = g.length;
        const S = g[0] === "-" ? 1 : 0;
        for (; y >= S + 4; y -= 3)
          c = `_${g.slice(y - 3, y)}${c}`;
        return `${g.slice(0, y)}${c}`;
      }
      function Dt(g, c, y) {
        w(c, "offset"), (g[c] === void 0 || g[c + y] === void 0) && it(c, g.length - (y + 1));
      }
      function Ot(g, c, y, S, T, j) {
        if (g > y || g < c) {
          const G = typeof c == "bigint" ? "n" : "";
          let de;
          throw j > 3 ? c === 0 || c === BigInt(0) ? de = `>= 0${G} and < 2${G} ** ${(j + 1) * 8}${G}` : de = `>= -(2${G} ** ${(j + 1) * 8 - 1}${G}) and < 2 ** ${(j + 1) * 8 - 1}${G}` : de = `>= ${c}${G} and <= ${y}${G}`, new gt.ERR_OUT_OF_RANGE("value", de, g);
        }
        Dt(S, T, j);
      }
      function w(g, c) {
        if (typeof g != "number")
          throw new gt.ERR_INVALID_ARG_TYPE(c, "number", g);
      }
      function it(g, c, y) {
        throw Math.floor(g) !== g ? (w(g, y), new gt.ERR_OUT_OF_RANGE(y || "offset", "an integer", g)) : c < 0 ? new gt.ERR_BUFFER_OUT_OF_BOUNDS() : new gt.ERR_OUT_OF_RANGE(
          y || "offset",
          `>= ${y ? 1 : 0} and <= ${c}`,
          g
        );
      }
      const mr = /[^+/0-9A-Za-z-_]/g;
      function Te(g) {
        if (g = g.split("=")[0], g = g.trim().replace(mr, ""), g.length < 2)
          return "";
        for (; g.length % 4 !== 0; )
          g = g + "=";
        return g;
      }
      function mt(g, c) {
        c = c || 1 / 0;
        let y;
        const S = g.length;
        let T = null;
        const j = [];
        for (let G = 0; G < S; ++G) {
          if (y = g.charCodeAt(G), y > 55295 && y < 57344) {
            if (!T) {
              if (y > 56319) {
                (c -= 3) > -1 && j.push(239, 191, 189);
                continue;
              } else if (G + 1 === S) {
                (c -= 3) > -1 && j.push(239, 191, 189);
                continue;
              }
              T = y;
              continue;
            }
            if (y < 56320) {
              (c -= 3) > -1 && j.push(239, 191, 189), T = y;
              continue;
            }
            y = (T - 55296 << 10 | y - 56320) + 65536;
          } else
            T && (c -= 3) > -1 && j.push(239, 191, 189);
          if (T = null, y < 128) {
            if ((c -= 1) < 0)
              break;
            j.push(y);
          } else if (y < 2048) {
            if ((c -= 2) < 0)
              break;
            j.push(
              y >> 6 | 192,
              y & 63 | 128
            );
          } else if (y < 65536) {
            if ((c -= 3) < 0)
              break;
            j.push(
              y >> 12 | 224,
              y >> 6 & 63 | 128,
              y & 63 | 128
            );
          } else if (y < 1114112) {
            if ((c -= 4) < 0)
              break;
            j.push(
              y >> 18 | 240,
              y >> 12 & 63 | 128,
              y >> 6 & 63 | 128,
              y & 63 | 128
            );
          } else
            throw new Error("Invalid code point");
        }
        return j;
      }
      function vr(g) {
        const c = [];
        for (let y = 0; y < g.length; ++y)
          c.push(g.charCodeAt(y) & 255);
        return c;
      }
      function ie(g, c) {
        let y, S, T;
        const j = [];
        for (let G = 0; G < g.length && !((c -= 2) < 0); ++G)
          y = g.charCodeAt(G), S = y >> 8, T = y % 256, j.push(T), j.push(S);
        return j;
      }
      function Lt(g) {
        return O.toByteArray(Te(g));
      }
      function lt(g, c, y, S) {
        let T;
        for (T = 0; T < S && !(T + y >= c.length || T >= g.length); ++T)
          c[T + y] = g[T];
        return T;
      }
      function Ve(g, c) {
        return g instanceof c || g != null && g.constructor != null && g.constructor.name != null && g.constructor.name === c.name;
      }
      function zt(g) {
        return g !== g;
      }
      const $e = function() {
        const g = "0123456789abcdef", c = new Array(256);
        for (let y = 0; y < 16; ++y) {
          const S = y * 16;
          for (let T = 0; T < 16; ++T)
            c[S + T] = g[y] + g[T];
        }
        return c;
      }();
      function at(g) {
        return typeof BigInt > "u" ? br : g;
      }
      function br() {
        throw new Error("BigInt not supported");
      }
    })(t);
    const E = t.Buffer;
    n.Blob = t.Blob, n.BlobOptions = t.BlobOptions, n.Buffer = t.Buffer, n.File = t.File, n.FileOptions = t.FileOptions, n.INSPECT_MAX_BYTES = t.INSPECT_MAX_BYTES, n.SlowBuffer = t.SlowBuffer, n.TranscodeEncoding = t.TranscodeEncoding, n.atob = t.atob, n.btoa = t.btoa, n.constants = t.constants, n.default = E, n.isAscii = t.isAscii, n.isUtf8 = t.isUtf8, n.kMaxLength = t.kMaxLength, n.kStringMaxLength = t.kStringMaxLength, n.resolveObjectURL = t.resolveObjectURL, n.transcode = t.transcode;
  }(ti)), ti;
}
var ri = {}, ii = {}, oi, An;
function zs() {
  return An || (An = 1, oi = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, p = Symbol("test"), f = Object(p);
    if (typeof p == "string" || Object.prototype.toString.call(p) !== "[object Symbol]" || Object.prototype.toString.call(f) !== "[object Symbol]")
      return !1;
    var l = 42;
    t[p] = l;
    for (var i in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var e = Object.getOwnPropertySymbols(t);
    if (e.length !== 1 || e[0] !== p || !Object.prototype.propertyIsEnumerable.call(t, p))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var r = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, p)
      );
      if (r.value !== l || r.enumerable !== !0)
        return !1;
    }
    return !0;
  }), oi;
}
var ni, In;
function xr() {
  if (In)
    return ni;
  In = 1;
  var n = zs();
  return ni = function() {
    return n() && !!Symbol.toStringTag;
  }, ni;
}
var ai, Wn;
function xs() {
  return Wn || (Wn = 1, ai = Object), ai;
}
var si, _n;
function hu() {
  return _n || (_n = 1, si = Error), si;
}
var pi, Pn;
function gu() {
  return Pn || (Pn = 1, pi = EvalError), pi;
}
var ui, kn;
function mu() {
  return kn || (kn = 1, ui = RangeError), ui;
}
var li, Cn;
function vu() {
  return Cn || (Cn = 1, li = ReferenceError), li;
}
var ci, jn;
function Ns() {
  return jn || (jn = 1, ci = SyntaxError), ci;
}
var fi, zn;
function dr() {
  return zn || (zn = 1, fi = TypeError), fi;
}
var yi, xn;
function bu() {
  return xn || (xn = 1, yi = URIError), yi;
}
var di, Nn;
function Su() {
  return Nn || (Nn = 1, di = Math.abs), di;
}
var hi, Un;
function wu() {
  return Un || (Un = 1, hi = Math.floor), hi;
}
var gi, qn;
function Ru() {
  return qn || (qn = 1, gi = Math.max), gi;
}
var mi, Gn;
function Fu() {
  return Gn || (Gn = 1, mi = Math.min), mi;
}
var vi, Vn;
function Mu() {
  return Vn || (Vn = 1, vi = Math.pow), vi;
}
var bi, $n;
function Eu() {
  return $n || ($n = 1, bi = Math.round), bi;
}
var Si, Jn;
function Bu() {
  return Jn || (Jn = 1, Si = Number.isNaN || function(t) {
    return t !== t;
  }), Si;
}
var wi, Hn;
function Tu() {
  if (Hn)
    return wi;
  Hn = 1;
  var n = Bu();
  return wi = function(p) {
    return n(p) || p === 0 ? p : p < 0 ? -1 : 1;
  }, wi;
}
var Ri, Zn;
function Du() {
  return Zn || (Zn = 1, Ri = Object.getOwnPropertyDescriptor), Ri;
}
var Fi, Kn;
function Qt() {
  if (Kn)
    return Fi;
  Kn = 1;
  var n = Du();
  if (n)
    try {
      n([], "length");
    } catch {
      n = null;
    }
  return Fi = n, Fi;
}
var Mi, Yn;
function Nr() {
  if (Yn)
    return Mi;
  Yn = 1;
  var n = Object.defineProperty || !1;
  if (n)
    try {
      n({}, "a", { value: 1 });
    } catch {
      n = !1;
    }
  return Mi = n, Mi;
}
var Ei, Xn;
function Ou() {
  if (Xn)
    return Ei;
  Xn = 1;
  var n = typeof Symbol < "u" && Symbol, t = zs();
  return Ei = function() {
    return typeof n != "function" || typeof Symbol != "function" || typeof n("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, Ei;
}
var Bi, Qn;
function Us() {
  return Qn || (Qn = 1, Bi = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Bi;
}
var Ti, ea;
function qs() {
  if (ea)
    return Ti;
  ea = 1;
  var n = xs();
  return Ti = n.getPrototypeOf || null, Ti;
}
var Di, ta;
function Lu() {
  if (ta)
    return Di;
  ta = 1;
  var n = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, p = Math.max, f = "[object Function]", l = function(s, d) {
    for (var A = [], _ = 0; _ < s.length; _ += 1)
      A[_] = s[_];
    for (var M = 0; M < d.length; M += 1)
      A[M + s.length] = d[M];
    return A;
  }, i = function(s, d) {
    for (var A = [], _ = d || 0, M = 0; _ < s.length; _ += 1, M += 1)
      A[M] = s[_];
    return A;
  }, e = function(r, s) {
    for (var d = "", A = 0; A < r.length; A += 1)
      d += r[A], A + 1 < r.length && (d += s);
    return d;
  };
  return Di = function(s) {
    var d = this;
    if (typeof d != "function" || t.apply(d) !== f)
      throw new TypeError(n + d);
    for (var A = i(arguments, 1), _, M = function() {
      if (this instanceof _) {
        var E = d.apply(
          this,
          l(A, arguments)
        );
        return Object(E) === E ? E : this;
      }
      return d.apply(
        s,
        l(A, arguments)
      );
    }, X = p(0, d.length - A.length), V = [], H = 0; H < X; H++)
      V[H] = "$" + H;
    if (_ = Function("binder", "return function (" + e(V, ",") + "){ return binder.apply(this,arguments); }")(M), d.prototype) {
      var x = function() {
      };
      x.prototype = d.prototype, _.prototype = new x(), x.prototype = null;
    }
    return _;
  }, Di;
}
var Oi, ra;
function hr() {
  if (ra)
    return Oi;
  ra = 1;
  var n = Lu();
  return Oi = Function.prototype.bind || n, Oi;
}
var Li, ia;
function Qo() {
  return ia || (ia = 1, Li = Function.prototype.call), Li;
}
var Ai, oa;
function en() {
  return oa || (oa = 1, Ai = Function.prototype.apply), Ai;
}
var Ii, na;
function Au() {
  return na || (na = 1, Ii = typeof Reflect < "u" && Reflect && Reflect.apply), Ii;
}
var Wi, aa;
function Gs() {
  if (aa)
    return Wi;
  aa = 1;
  var n = hr(), t = en(), p = Qo(), f = Au();
  return Wi = f || n.call(p, t), Wi;
}
var _i, sa;
function tn() {
  if (sa)
    return _i;
  sa = 1;
  var n = hr(), t = dr(), p = Qo(), f = Gs();
  return _i = function(i) {
    if (i.length < 1 || typeof i[0] != "function")
      throw new t("a function is required");
    return f(n, p, i);
  }, _i;
}
var Pi, pa;
function Iu() {
  if (pa)
    return Pi;
  pa = 1;
  var n = tn(), t = Qt(), p;
  try {
    p = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (e) {
    if (!e || typeof e != "object" || !("code" in e) || e.code !== "ERR_PROTO_ACCESS")
      throw e;
  }
  var f = !!p && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), l = Object, i = l.getPrototypeOf;
  return Pi = f && typeof f.get == "function" ? n([f.get]) : typeof i == "function" ? (
    /** @type {import('./get')} */
    function(r) {
      return i(r == null ? r : l(r));
    }
  ) : !1, Pi;
}
var ki, ua;
function rn() {
  if (ua)
    return ki;
  ua = 1;
  var n = Us(), t = qs(), p = Iu();
  return ki = n ? function(l) {
    return n(l);
  } : t ? function(l) {
    if (!l || typeof l != "object" && typeof l != "function")
      throw new TypeError("getProto: not an object");
    return t(l);
  } : p ? function(l) {
    return p(l);
  } : null, ki;
}
var Ci, la;
function Vs() {
  if (la)
    return Ci;
  la = 1;
  var n = Function.prototype.call, t = Object.prototype.hasOwnProperty, p = hr();
  return Ci = p.call(n, t), Ci;
}
var ji, ca;
function $s() {
  if (ca)
    return ji;
  ca = 1;
  var n, t = xs(), p = hu(), f = gu(), l = mu(), i = vu(), e = Ns(), r = dr(), s = bu(), d = Su(), A = wu(), _ = Ru(), M = Fu(), X = Mu(), V = Eu(), H = Tu(), x = Function, E = function(Y) {
    try {
      return x('"use strict"; return (' + Y + ").constructor;")();
    } catch {
    }
  }, D = Qt(), O = Nr(), z = function() {
    throw new r();
  }, $ = D ? function() {
    try {
      return arguments.callee, z;
    } catch {
      try {
        return D(arguments, "callee").get;
      } catch {
        return z;
      }
    }
  }() : z, J = Ou()(), F = rn(), ee = qs(), oe = Us(), ae = en(), fe = Qo(), I = {}, ne = typeof Uint8Array > "u" || !F ? n : F(Uint8Array), me = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? n : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? n : ArrayBuffer,
    "%ArrayIteratorPrototype%": J && F ? F([][Symbol.iterator]()) : n,
    "%AsyncFromSyncIteratorPrototype%": n,
    "%AsyncFunction%": I,
    "%AsyncGenerator%": I,
    "%AsyncGeneratorFunction%": I,
    "%AsyncIteratorPrototype%": I,
    "%Atomics%": typeof Atomics > "u" ? n : Atomics,
    "%BigInt%": typeof BigInt > "u" ? n : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? n : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? n : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? n : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": p,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": f,
    "%Float16Array%": typeof Float16Array > "u" ? n : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? n : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? n : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? n : FinalizationRegistry,
    "%Function%": x,
    "%GeneratorFunction%": I,
    "%Int8Array%": typeof Int8Array > "u" ? n : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? n : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? n : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": J && F ? F(F([][Symbol.iterator]())) : n,
    "%JSON%": typeof JSON == "object" ? JSON : n,
    "%Map%": typeof Map > "u" ? n : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !J || !F ? n : F((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": D,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? n : Promise,
    "%Proxy%": typeof Proxy > "u" ? n : Proxy,
    "%RangeError%": l,
    "%ReferenceError%": i,
    "%Reflect%": typeof Reflect > "u" ? n : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? n : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !J || !F ? n : F((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? n : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": J && F ? F(""[Symbol.iterator]()) : n,
    "%Symbol%": J ? Symbol : n,
    "%SyntaxError%": e,
    "%ThrowTypeError%": $,
    "%TypedArray%": ne,
    "%TypeError%": r,
    "%Uint8Array%": typeof Uint8Array > "u" ? n : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? n : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? n : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? n : Uint32Array,
    "%URIError%": s,
    "%WeakMap%": typeof WeakMap > "u" ? n : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? n : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? n : WeakSet,
    "%Function.prototype.call%": fe,
    "%Function.prototype.apply%": ae,
    "%Object.defineProperty%": O,
    "%Object.getPrototypeOf%": ee,
    "%Math.abs%": d,
    "%Math.floor%": A,
    "%Math.max%": _,
    "%Math.min%": M,
    "%Math.pow%": X,
    "%Math.round%": V,
    "%Math.sign%": H,
    "%Reflect.getPrototypeOf%": oe
  };
  if (F)
    try {
      null.error;
    } catch (Y) {
      var be = F(F(Y));
      me["%Error.prototype%"] = be;
    }
  var we = function Y(Q) {
    var v;
    if (Q === "%AsyncFunction%")
      v = E("async function () {}");
    else if (Q === "%GeneratorFunction%")
      v = E("function* () {}");
    else if (Q === "%AsyncGeneratorFunction%")
      v = E("async function* () {}");
    else if (Q === "%AsyncGenerator%") {
      var b = Y("%AsyncGeneratorFunction%");
      b && (v = b.prototype);
    } else if (Q === "%AsyncIteratorPrototype%") {
      var U = Y("%AsyncGenerator%");
      U && F && (v = F(U.prototype));
    }
    return me[Q] = v, v;
  }, We = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, Oe = hr(), Me = Vs(), Le = Oe.call(fe, Array.prototype.concat), qe = Oe.call(ae, Array.prototype.splice), k = Oe.call(fe, String.prototype.replace), N = Oe.call(fe, String.prototype.slice), Z = Oe.call(fe, RegExp.prototype.exec), le = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, L = /\\(\\)?/g, B = function(Q) {
    var v = N(Q, 0, 1), b = N(Q, -1);
    if (v === "%" && b !== "%")
      throw new e("invalid intrinsic syntax, expected closing `%`");
    if (b === "%" && v !== "%")
      throw new e("invalid intrinsic syntax, expected opening `%`");
    var U = [];
    return k(Q, le, function(te, ye, se, he) {
      U[U.length] = se ? k(he, L, "$1") : ye || te;
    }), U;
  }, P = function(Q, v) {
    var b = Q, U;
    if (Me(We, b) && (U = We[b], b = "%" + U[0] + "%"), Me(me, b)) {
      var te = me[b];
      if (te === I && (te = we(b)), typeof te > "u" && !v)
        throw new r("intrinsic " + Q + " exists, but is not available. Please file an issue!");
      return {
        alias: U,
        name: b,
        value: te
      };
    }
    throw new e("intrinsic " + Q + " does not exist!");
  };
  return ji = function(Q, v) {
    if (typeof Q != "string" || Q.length === 0)
      throw new r("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof v != "boolean")
      throw new r('"allowMissing" argument must be a boolean');
    if (Z(/^%?[^%]*%?$/, Q) === null)
      throw new e("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var b = B(Q), U = b.length > 0 ? b[0] : "", te = P("%" + U + "%", v), ye = te.name, se = te.value, he = !1, ze = te.alias;
    ze && (U = ze[0], qe(b, Le([0, 1], ze)));
    for (var q = 1, Ge = !0; q < b.length; q += 1) {
      var xe = b[q], Se = N(xe, 0, 1), Re = N(xe, -1);
      if ((Se === '"' || Se === "'" || Se === "`" || Re === '"' || Re === "'" || Re === "`") && Se !== Re)
        throw new e("property names with quotes must have matching quotes");
      if ((xe === "constructor" || !Ge) && (he = !0), U += "." + xe, ye = "%" + U + "%", Me(me, ye))
        se = me[ye];
      else if (se != null) {
        if (!(xe in se)) {
          if (!v)
            throw new r("base intrinsic for " + Q + " exists, but the property is not available.");
          return;
        }
        if (D && q + 1 >= b.length) {
          var Ne = D(se, xe);
          Ge = !!Ne, Ge && "get" in Ne && !("originalValue" in Ne.get) ? se = Ne.get : se = se[xe];
        } else
          Ge = Me(se, xe), se = se[xe];
        Ge && !he && (me[ye] = se);
      }
    }
    return se;
  }, ji;
}
var zi, fa;
function gr() {
  if (fa)
    return zi;
  fa = 1;
  var n = $s(), t = tn(), p = t([n("%String.prototype.indexOf%")]);
  return zi = function(l, i) {
    var e = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      n(l, !!i)
    );
    return typeof e == "function" && p(l, ".prototype.") > -1 ? t(
      /** @type {const} */
      [e]
    ) : e;
  }, zi;
}
var xi, ya;
function Wu() {
  if (ya)
    return xi;
  ya = 1;
  var n = xr()(), t = gr(), p = t("Object.prototype.toString"), f = function(r) {
    return n && r && typeof r == "object" && Symbol.toStringTag in r ? !1 : p(r) === "[object Arguments]";
  }, l = function(r) {
    return f(r) ? !0 : r !== null && typeof r == "object" && "length" in r && typeof r.length == "number" && r.length >= 0 && p(r) !== "[object Array]" && "callee" in r && p(r.callee) === "[object Function]";
  }, i = function() {
    return f(arguments);
  }();
  return f.isLegacyArguments = l, xi = i ? f : l, xi;
}
var Ni, da;
function _u() {
  if (da)
    return Ni;
  da = 1;
  var n = gr(), t = xr()(), p = Vs(), f = Qt(), l;
  if (t) {
    var i = n("RegExp.prototype.exec"), e = {}, r = function() {
      throw e;
    }, s = {
      toString: r,
      valueOf: r
    };
    typeof Symbol.toPrimitive == "symbol" && (s[Symbol.toPrimitive] = r), l = function(M) {
      if (!M || typeof M != "object")
        return !1;
      var X = (
        /** @type {NonNullable<typeof gOPD>} */
        f(
          /** @type {{ lastIndex?: unknown }} */
          M,
          "lastIndex"
        )
      ), V = X && p(X, "value");
      if (!V)
        return !1;
      try {
        i(
          M,
          /** @type {string} */
          /** @type {unknown} */
          s
        );
      } catch (H) {
        return H === e;
      }
    };
  } else {
    var d = n("Object.prototype.toString"), A = "[object RegExp]";
    l = function(M) {
      return !M || typeof M != "object" && typeof M != "function" ? !1 : d(M) === A;
    };
  }
  return Ni = l, Ni;
}
var Ui, ha;
function Pu() {
  if (ha)
    return Ui;
  ha = 1;
  var n = gr(), t = _u(), p = n("RegExp.prototype.exec"), f = dr();
  return Ui = function(i) {
    if (!t(i))
      throw new f("`regex` must be a RegExp");
    return function(r) {
      return p(i, r) !== null;
    };
  }, Ui;
}
var qi, ga;
function ku() {
  if (ga)
    return qi;
  ga = 1;
  var n = gr(), t = Pu(), p = t(/^\s*(?:function)?\*/), f = xr()(), l = rn(), i = n("Object.prototype.toString"), e = n("Function.prototype.toString"), r = function() {
    if (!f)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, s;
  return qi = function(A) {
    if (typeof A != "function")
      return !1;
    if (p(e(A)))
      return !0;
    if (!f) {
      var _ = i(A);
      return _ === "[object GeneratorFunction]";
    }
    if (!l)
      return !1;
    if (typeof s > "u") {
      var M = r();
      s = M ? (
        /** @type {GeneratorFunctionConstructor} */
        l(M)
      ) : !1;
    }
    return l(A) === s;
  }, qi;
}
var Gi, ma;
function Cu() {
  if (ma)
    return Gi;
  ma = 1;
  var n = Function.prototype.toString, t = typeof Reflect == "object" && Reflect !== null && Reflect.apply, p, f;
  if (typeof t == "function" && typeof Object.defineProperty == "function")
    try {
      p = Object.defineProperty({}, "length", {
        get: function() {
          throw f;
        }
      }), f = {}, t(function() {
        throw 42;
      }, null, p);
    } catch (D) {
      D !== f && (t = null);
    }
  else
    t = null;
  var l = /^\s*class\b/, i = function(O) {
    try {
      var z = n.call(O);
      return l.test(z);
    } catch {
      return !1;
    }
  }, e = function(O) {
    try {
      return i(O) ? !1 : (n.call(O), !0);
    } catch {
      return !1;
    }
  }, r = Object.prototype.toString, s = "[object Object]", d = "[object Function]", A = "[object GeneratorFunction]", _ = "[object HTMLAllCollection]", M = "[object HTML document.all class]", X = "[object HTMLCollection]", V = typeof Symbol == "function" && !!Symbol.toStringTag, H = !(0 in [,]), x = function() {
    return !1;
  };
  if (typeof document == "object") {
    var E = document.all;
    r.call(E) === r.call(document.all) && (x = function(O) {
      if ((H || !O) && (typeof O > "u" || typeof O == "object"))
        try {
          var z = r.call(O);
          return (z === _ || z === M || z === X || z === s) && O("") == null;
        } catch {
        }
      return !1;
    });
  }
  return Gi = t ? function(O) {
    if (x(O))
      return !0;
    if (!O || typeof O != "function" && typeof O != "object")
      return !1;
    try {
      t(O, null, p);
    } catch (z) {
      if (z !== f)
        return !1;
    }
    return !i(O) && e(O);
  } : function(O) {
    if (x(O))
      return !0;
    if (!O || typeof O != "function" && typeof O != "object")
      return !1;
    if (V)
      return e(O);
    if (i(O))
      return !1;
    var z = r.call(O);
    return z !== d && z !== A && !/^\[object HTML/.test(z) ? !1 : e(O);
  }, Gi;
}
var Vi, va;
function ju() {
  if (va)
    return Vi;
  va = 1;
  var n = Cu(), t = Object.prototype.toString, p = Object.prototype.hasOwnProperty, f = function(s, d, A) {
    for (var _ = 0, M = s.length; _ < M; _++)
      p.call(s, _) && (A == null ? d(s[_], _, s) : d.call(A, s[_], _, s));
  }, l = function(s, d, A) {
    for (var _ = 0, M = s.length; _ < M; _++)
      A == null ? d(s.charAt(_), _, s) : d.call(A, s.charAt(_), _, s);
  }, i = function(s, d, A) {
    for (var _ in s)
      p.call(s, _) && (A == null ? d(s[_], _, s) : d.call(A, s[_], _, s));
  };
  function e(r) {
    return t.call(r) === "[object Array]";
  }
  return Vi = function(s, d, A) {
    if (!n(d))
      throw new TypeError("iterator must be a function");
    var _;
    arguments.length >= 3 && (_ = A), e(s) ? f(s, d, _) : typeof s == "string" ? l(s, d, _) : i(s, d, _);
  }, Vi;
}
var $i, ba;
function zu() {
  return ba || (ba = 1, $i = [
    "Float16Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), $i;
}
var Ji, Sa;
function xu() {
  if (Sa)
    return Ji;
  Sa = 1;
  var n = zu(), t = typeof globalThis > "u" ? Ce : globalThis;
  return Ji = function() {
    for (var f = [], l = 0; l < n.length; l++)
      typeof t[n[l]] == "function" && (f[f.length] = n[l]);
    return f;
  }, Ji;
}
var Hi = { exports: {} }, Zi, wa;
function Nu() {
  if (wa)
    return Zi;
  wa = 1;
  var n = Nr(), t = Ns(), p = dr(), f = Qt();
  return Zi = function(i, e, r) {
    if (!i || typeof i != "object" && typeof i != "function")
      throw new p("`obj` must be an object or a function`");
    if (typeof e != "string" && typeof e != "symbol")
      throw new p("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new p("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new p("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new p("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new p("`loose`, if provided, must be a boolean");
    var s = arguments.length > 3 ? arguments[3] : null, d = arguments.length > 4 ? arguments[4] : null, A = arguments.length > 5 ? arguments[5] : null, _ = arguments.length > 6 ? arguments[6] : !1, M = !!f && f(i, e);
    if (n)
      n(i, e, {
        configurable: A === null && M ? M.configurable : !A,
        enumerable: s === null && M ? M.enumerable : !s,
        value: r,
        writable: d === null && M ? M.writable : !d
      });
    else if (_ || !s && !d && !A)
      i[e] = r;
    else
      throw new t("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, Zi;
}
var Ki, Ra;
function Uu() {
  if (Ra)
    return Ki;
  Ra = 1;
  var n = Nr(), t = function() {
    return !!n;
  };
  return t.hasArrayLengthDefineBug = function() {
    if (!n)
      return null;
    try {
      return n([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, Ki = t, Ki;
}
var Yi, Fa;
function qu() {
  if (Fa)
    return Yi;
  Fa = 1;
  var n = $s(), t = Nu(), p = Uu()(), f = Qt(), l = dr(), i = n("%Math.floor%");
  return Yi = function(r, s) {
    if (typeof r != "function")
      throw new l("`fn` is not a function");
    if (typeof s != "number" || s < 0 || s > 4294967295 || i(s) !== s)
      throw new l("`length` must be a positive 32-bit integer");
    var d = arguments.length > 2 && !!arguments[2], A = !0, _ = !0;
    if ("length" in r && f) {
      var M = f(r, "length");
      M && !M.configurable && (A = !1), M && !M.writable && (_ = !1);
    }
    return (A || _ || !d) && (p ? t(
      /** @type {Parameters<define>[0]} */
      r,
      "length",
      s,
      !0,
      !0
    ) : t(
      /** @type {Parameters<define>[0]} */
      r,
      "length",
      s
    )), r;
  }, Yi;
}
var Xi, Ma;
function Gu() {
  if (Ma)
    return Xi;
  Ma = 1;
  var n = hr(), t = en(), p = Gs();
  return Xi = function() {
    return p(n, t, arguments);
  }, Xi;
}
var Ea;
function Vu() {
  return Ea || (Ea = 1, function(n) {
    var t = qu(), p = Nr(), f = tn(), l = Gu();
    n.exports = function(e) {
      var r = f(arguments), s = e.length - (arguments.length - 1);
      return t(
        r,
        1 + (s > 0 ? s : 0),
        !0
      );
    }, p ? p(n.exports, "apply", { value: l }) : n.exports.apply = l;
  }(Hi)), Hi.exports;
}
var Qi, Ba;
function Js() {
  if (Ba)
    return Qi;
  Ba = 1;
  var n = ju(), t = xu(), p = Vu(), f = gr(), l = Qt(), i = rn(), e = f("Object.prototype.toString"), r = xr()(), s = typeof globalThis > "u" ? Ce : globalThis, d = t(), A = f("String.prototype.slice"), _ = f("Array.prototype.indexOf", !0) || function(x, E) {
    for (var D = 0; D < x.length; D += 1)
      if (x[D] === E)
        return D;
    return -1;
  }, M = { __proto__: null };
  r && l && i ? n(d, function(H) {
    var x = new s[H]();
    if (Symbol.toStringTag in x && i) {
      var E = i(x), D = l(E, Symbol.toStringTag);
      if (!D && E) {
        var O = i(E);
        D = l(O, Symbol.toStringTag);
      }
      M["$" + H] = p(D.get);
    }
  }) : n(d, function(H) {
    var x = new s[H](), E = x.slice || x.set;
    E && (M[
      /** @type {`$${import('.').TypedArrayName}`} */
      "$" + H
    ] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */
    // @ts-expect-error TODO FIXME
    p(E));
  });
  var X = function(x) {
    var E = !1;
    return n(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      M,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(D, O) {
        if (!E)
          try {
            "$" + D(x) === O && (E = /** @type {import('.').TypedArrayName} */
            A(O, 1));
          } catch {
          }
      }
    ), E;
  }, V = function(x) {
    var E = !1;
    return n(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      M,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(D, O) {
        if (!E)
          try {
            D(x), E = /** @type {import('.').TypedArrayName} */
            A(O, 1);
          } catch {
          }
      }
    ), E;
  };
  return Qi = function(x) {
    if (!x || typeof x != "object")
      return !1;
    if (!r) {
      var E = A(e(x), 8, -1);
      return _(d, E) > -1 ? E : E !== "Object" ? !1 : V(x);
    }
    return l ? X(x) : null;
  }, Qi;
}
var eo, Ta;
function $u() {
  if (Ta)
    return eo;
  Ta = 1;
  var n = Js();
  return eo = function(p) {
    return !!n(p);
  }, eo;
}
var Da;
function Ju() {
  return Da || (Da = 1, function(n) {
    var t = Wu(), p = ku(), f = Js(), l = $u();
    function i(q) {
      return q.call.bind(q);
    }
    var e = typeof BigInt < "u", r = typeof Symbol < "u", s = i(Object.prototype.toString), d = i(Number.prototype.valueOf), A = i(String.prototype.valueOf), _ = i(Boolean.prototype.valueOf);
    if (e)
      var M = i(BigInt.prototype.valueOf);
    if (r)
      var X = i(Symbol.prototype.valueOf);
    function V(q, Ge) {
      if (typeof q != "object")
        return !1;
      try {
        return Ge(q), !0;
      } catch {
        return !1;
      }
    }
    n.isArgumentsObject = t, n.isGeneratorFunction = p, n.isTypedArray = l;
    function H(q) {
      return typeof Promise < "u" && q instanceof Promise || q !== null && typeof q == "object" && typeof q.then == "function" && typeof q.catch == "function";
    }
    n.isPromise = H;
    function x(q) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(q) : l(q) || N(q);
    }
    n.isArrayBufferView = x;
    function E(q) {
      return f(q) === "Uint8Array";
    }
    n.isUint8Array = E;
    function D(q) {
      return f(q) === "Uint8ClampedArray";
    }
    n.isUint8ClampedArray = D;
    function O(q) {
      return f(q) === "Uint16Array";
    }
    n.isUint16Array = O;
    function z(q) {
      return f(q) === "Uint32Array";
    }
    n.isUint32Array = z;
    function $(q) {
      return f(q) === "Int8Array";
    }
    n.isInt8Array = $;
    function J(q) {
      return f(q) === "Int16Array";
    }
    n.isInt16Array = J;
    function F(q) {
      return f(q) === "Int32Array";
    }
    n.isInt32Array = F;
    function ee(q) {
      return f(q) === "Float32Array";
    }
    n.isFloat32Array = ee;
    function oe(q) {
      return f(q) === "Float64Array";
    }
    n.isFloat64Array = oe;
    function ae(q) {
      return f(q) === "BigInt64Array";
    }
    n.isBigInt64Array = ae;
    function fe(q) {
      return f(q) === "BigUint64Array";
    }
    n.isBigUint64Array = fe;
    function I(q) {
      return s(q) === "[object Map]";
    }
    I.working = typeof Map < "u" && I(/* @__PURE__ */ new Map());
    function ne(q) {
      return typeof Map > "u" ? !1 : I.working ? I(q) : q instanceof Map;
    }
    n.isMap = ne;
    function me(q) {
      return s(q) === "[object Set]";
    }
    me.working = typeof Set < "u" && me(/* @__PURE__ */ new Set());
    function be(q) {
      return typeof Set > "u" ? !1 : me.working ? me(q) : q instanceof Set;
    }
    n.isSet = be;
    function we(q) {
      return s(q) === "[object WeakMap]";
    }
    we.working = typeof WeakMap < "u" && we(/* @__PURE__ */ new WeakMap());
    function We(q) {
      return typeof WeakMap > "u" ? !1 : we.working ? we(q) : q instanceof WeakMap;
    }
    n.isWeakMap = We;
    function Oe(q) {
      return s(q) === "[object WeakSet]";
    }
    Oe.working = typeof WeakSet < "u" && Oe(/* @__PURE__ */ new WeakSet());
    function Me(q) {
      return Oe(q);
    }
    n.isWeakSet = Me;
    function Le(q) {
      return s(q) === "[object ArrayBuffer]";
    }
    Le.working = typeof ArrayBuffer < "u" && Le(new ArrayBuffer());
    function qe(q) {
      return typeof ArrayBuffer > "u" ? !1 : Le.working ? Le(q) : q instanceof ArrayBuffer;
    }
    n.isArrayBuffer = qe;
    function k(q) {
      return s(q) === "[object DataView]";
    }
    k.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && k(new DataView(new ArrayBuffer(1), 0, 1));
    function N(q) {
      return typeof DataView > "u" ? !1 : k.working ? k(q) : q instanceof DataView;
    }
    n.isDataView = N;
    var Z = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function le(q) {
      return s(q) === "[object SharedArrayBuffer]";
    }
    function L(q) {
      return typeof Z > "u" ? !1 : (typeof le.working > "u" && (le.working = le(new Z())), le.working ? le(q) : q instanceof Z);
    }
    n.isSharedArrayBuffer = L;
    function B(q) {
      return s(q) === "[object AsyncFunction]";
    }
    n.isAsyncFunction = B;
    function P(q) {
      return s(q) === "[object Map Iterator]";
    }
    n.isMapIterator = P;
    function Y(q) {
      return s(q) === "[object Set Iterator]";
    }
    n.isSetIterator = Y;
    function Q(q) {
      return s(q) === "[object Generator]";
    }
    n.isGeneratorObject = Q;
    function v(q) {
      return s(q) === "[object WebAssembly.Module]";
    }
    n.isWebAssemblyCompiledModule = v;
    function b(q) {
      return V(q, d);
    }
    n.isNumberObject = b;
    function U(q) {
      return V(q, A);
    }
    n.isStringObject = U;
    function te(q) {
      return V(q, _);
    }
    n.isBooleanObject = te;
    function ye(q) {
      return e && V(q, M);
    }
    n.isBigIntObject = ye;
    function se(q) {
      return r && V(q, X);
    }
    n.isSymbolObject = se;
    function he(q) {
      return b(q) || U(q) || te(q) || ye(q) || se(q);
    }
    n.isBoxedPrimitive = he;
    function ze(q) {
      return typeof Uint8Array < "u" && (qe(q) || L(q));
    }
    n.isAnyArrayBuffer = ze, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(q) {
      Object.defineProperty(n, q, {
        enumerable: !1,
        value: function() {
          throw new Error(q + " is not supported in userland");
        }
      });
    });
  }(ii)), ii;
}
var to, Oa;
function Hu() {
  return Oa || (Oa = 1, to = function(t) {
    return t && typeof t == "object" && typeof t.copy == "function" && typeof t.fill == "function" && typeof t.readUInt8 == "function";
  }), to;
}
var La;
function Hs() {
  return La || (La = 1, function(n) {
    var t = Object.getOwnPropertyDescriptors || function(N) {
      for (var Z = Object.keys(N), le = {}, L = 0; L < Z.length; L++)
        le[Z[L]] = Object.getOwnPropertyDescriptor(N, Z[L]);
      return le;
    }, p = /%[sdj%]/g;
    n.format = function(k) {
      if (!$(k)) {
        for (var N = [], Z = 0; Z < arguments.length; Z++)
          N.push(e(arguments[Z]));
        return N.join(" ");
      }
      for (var Z = 1, le = arguments, L = le.length, B = String(k).replace(p, function(Y) {
        if (Y === "%%")
          return "%";
        if (Z >= L)
          return Y;
        switch (Y) {
          case "%s":
            return String(le[Z++]);
          case "%d":
            return Number(le[Z++]);
          case "%j":
            try {
              return JSON.stringify(le[Z++]);
            } catch {
              return "[Circular]";
            }
          default:
            return Y;
        }
      }), P = le[Z]; Z < L; P = le[++Z])
        D(P) || !oe(P) ? B += " " + P : B += " " + e(P);
      return B;
    }, n.deprecate = function(k, N) {
      if (typeof ge < "u" && ge.noDeprecation === !0)
        return k;
      if (typeof ge > "u")
        return function() {
          return n.deprecate(k, N).apply(this, arguments);
        };
      var Z = !1;
      function le() {
        if (!Z) {
          if (ge.throwDeprecation)
            throw new Error(N);
          ge.traceDeprecation ? console.trace(N) : console.error(N), Z = !0;
        }
        return k.apply(this, arguments);
      }
      return le;
    };
    var f = {}, l = /^$/;
    if (ge.env.NODE_DEBUG) {
      var i = ge.env.NODE_DEBUG;
      i = i.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), l = new RegExp("^" + i + "$", "i");
    }
    n.debuglog = function(k) {
      if (k = k.toUpperCase(), !f[k])
        if (l.test(k)) {
          var N = ge.pid;
          f[k] = function() {
            var Z = n.format.apply(n, arguments);
            console.error("%s %d: %s", k, N, Z);
          };
        } else
          f[k] = function() {
          };
      return f[k];
    };
    function e(k, N) {
      var Z = {
        seen: [],
        stylize: s
      };
      return arguments.length >= 3 && (Z.depth = arguments[2]), arguments.length >= 4 && (Z.colors = arguments[3]), E(N) ? Z.showHidden = N : N && n._extend(Z, N), F(Z.showHidden) && (Z.showHidden = !1), F(Z.depth) && (Z.depth = 2), F(Z.colors) && (Z.colors = !1), F(Z.customInspect) && (Z.customInspect = !0), Z.colors && (Z.stylize = r), A(Z, k, Z.depth);
    }
    n.inspect = e, e.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, e.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function r(k, N) {
      var Z = e.styles[N];
      return Z ? "\x1B[" + e.colors[Z][0] + "m" + k + "\x1B[" + e.colors[Z][1] + "m" : k;
    }
    function s(k, N) {
      return k;
    }
    function d(k) {
      var N = {};
      return k.forEach(function(Z, le) {
        N[Z] = !0;
      }), N;
    }
    function A(k, N, Z) {
      if (k.customInspect && N && I(N.inspect) && // Filter out the util module, it's inspect function is special
      N.inspect !== n.inspect && // Also filter out any prototype objects using the circular check.
      !(N.constructor && N.constructor.prototype === N)) {
        var le = N.inspect(Z, k);
        return $(le) || (le = A(k, le, Z)), le;
      }
      var L = _(k, N);
      if (L)
        return L;
      var B = Object.keys(N), P = d(B);
      if (k.showHidden && (B = Object.getOwnPropertyNames(N)), fe(N) && (B.indexOf("message") >= 0 || B.indexOf("description") >= 0))
        return M(N);
      if (B.length === 0) {
        if (I(N)) {
          var Y = N.name ? ": " + N.name : "";
          return k.stylize("[Function" + Y + "]", "special");
        }
        if (ee(N))
          return k.stylize(RegExp.prototype.toString.call(N), "regexp");
        if (ae(N))
          return k.stylize(Date.prototype.toString.call(N), "date");
        if (fe(N))
          return M(N);
      }
      var Q = "", v = !1, b = ["{", "}"];
      if (x(N) && (v = !0, b = ["[", "]"]), I(N)) {
        var U = N.name ? ": " + N.name : "";
        Q = " [Function" + U + "]";
      }
      if (ee(N) && (Q = " " + RegExp.prototype.toString.call(N)), ae(N) && (Q = " " + Date.prototype.toUTCString.call(N)), fe(N) && (Q = " " + M(N)), B.length === 0 && (!v || N.length == 0))
        return b[0] + Q + b[1];
      if (Z < 0)
        return ee(N) ? k.stylize(RegExp.prototype.toString.call(N), "regexp") : k.stylize("[Object]", "special");
      k.seen.push(N);
      var te;
      return v ? te = X(k, N, Z, P, B) : te = B.map(function(ye) {
        return V(k, N, Z, P, ye, v);
      }), k.seen.pop(), H(te, Q, b);
    }
    function _(k, N) {
      if (F(N))
        return k.stylize("undefined", "undefined");
      if ($(N)) {
        var Z = "'" + JSON.stringify(N).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return k.stylize(Z, "string");
      }
      if (z(N))
        return k.stylize("" + N, "number");
      if (E(N))
        return k.stylize("" + N, "boolean");
      if (D(N))
        return k.stylize("null", "null");
    }
    function M(k) {
      return "[" + Error.prototype.toString.call(k) + "]";
    }
    function X(k, N, Z, le, L) {
      for (var B = [], P = 0, Y = N.length; P < Y; ++P)
        Oe(N, String(P)) ? B.push(V(
          k,
          N,
          Z,
          le,
          String(P),
          !0
        )) : B.push("");
      return L.forEach(function(Q) {
        Q.match(/^\d+$/) || B.push(V(
          k,
          N,
          Z,
          le,
          Q,
          !0
        ));
      }), B;
    }
    function V(k, N, Z, le, L, B) {
      var P, Y, Q;
      if (Q = Object.getOwnPropertyDescriptor(N, L) || { value: N[L] }, Q.get ? Q.set ? Y = k.stylize("[Getter/Setter]", "special") : Y = k.stylize("[Getter]", "special") : Q.set && (Y = k.stylize("[Setter]", "special")), Oe(le, L) || (P = "[" + L + "]"), Y || (k.seen.indexOf(Q.value) < 0 ? (D(Z) ? Y = A(k, Q.value, null) : Y = A(k, Q.value, Z - 1), Y.indexOf(`
`) > -1 && (B ? Y = Y.split(`
`).map(function(v) {
        return "  " + v;
      }).join(`
`).slice(2) : Y = `
` + Y.split(`
`).map(function(v) {
        return "   " + v;
      }).join(`
`))) : Y = k.stylize("[Circular]", "special")), F(P)) {
        if (B && L.match(/^\d+$/))
          return Y;
        P = JSON.stringify("" + L), P.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (P = P.slice(1, -1), P = k.stylize(P, "name")) : (P = P.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), P = k.stylize(P, "string"));
      }
      return P + ": " + Y;
    }
    function H(k, N, Z) {
      var le = k.reduce(function(L, B) {
        return B.indexOf(`
`) >= 0, L + B.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return le > 60 ? Z[0] + (N === "" ? "" : N + `
 `) + " " + k.join(`,
  `) + " " + Z[1] : Z[0] + N + " " + k.join(", ") + " " + Z[1];
    }
    n.types = Ju();
    function x(k) {
      return Array.isArray(k);
    }
    n.isArray = x;
    function E(k) {
      return typeof k == "boolean";
    }
    n.isBoolean = E;
    function D(k) {
      return k === null;
    }
    n.isNull = D;
    function O(k) {
      return k == null;
    }
    n.isNullOrUndefined = O;
    function z(k) {
      return typeof k == "number";
    }
    n.isNumber = z;
    function $(k) {
      return typeof k == "string";
    }
    n.isString = $;
    function J(k) {
      return typeof k == "symbol";
    }
    n.isSymbol = J;
    function F(k) {
      return k === void 0;
    }
    n.isUndefined = F;
    function ee(k) {
      return oe(k) && me(k) === "[object RegExp]";
    }
    n.isRegExp = ee, n.types.isRegExp = ee;
    function oe(k) {
      return typeof k == "object" && k !== null;
    }
    n.isObject = oe;
    function ae(k) {
      return oe(k) && me(k) === "[object Date]";
    }
    n.isDate = ae, n.types.isDate = ae;
    function fe(k) {
      return oe(k) && (me(k) === "[object Error]" || k instanceof Error);
    }
    n.isError = fe, n.types.isNativeError = fe;
    function I(k) {
      return typeof k == "function";
    }
    n.isFunction = I;
    function ne(k) {
      return k === null || typeof k == "boolean" || typeof k == "number" || typeof k == "string" || typeof k == "symbol" || // ES6 symbol
      typeof k > "u";
    }
    n.isPrimitive = ne, n.isBuffer = Hu();
    function me(k) {
      return Object.prototype.toString.call(k);
    }
    function be(k) {
      return k < 10 ? "0" + k.toString(10) : k.toString(10);
    }
    var we = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function We() {
      var k = /* @__PURE__ */ new Date(), N = [
        be(k.getHours()),
        be(k.getMinutes()),
        be(k.getSeconds())
      ].join(":");
      return [k.getDate(), we[k.getMonth()], N].join(" ");
    }
    n.log = function() {
      console.log("%s - %s", We(), n.format.apply(n, arguments));
    }, n.inherits = jt, n._extend = function(k, N) {
      if (!N || !oe(N))
        return k;
      for (var Z = Object.keys(N), le = Z.length; le--; )
        k[Z[le]] = N[Z[le]];
      return k;
    };
    function Oe(k, N) {
      return Object.prototype.hasOwnProperty.call(k, N);
    }
    var Me = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
    n.promisify = function(N) {
      if (typeof N != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (Me && N[Me]) {
        var Z = N[Me];
        if (typeof Z != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(Z, Me, {
          value: Z,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), Z;
      }
      function Z() {
        for (var le, L, B = new Promise(function(Q, v) {
          le = Q, L = v;
        }), P = [], Y = 0; Y < arguments.length; Y++)
          P.push(arguments[Y]);
        P.push(function(Q, v) {
          Q ? L(Q) : le(v);
        });
        try {
          N.apply(this, P);
        } catch (Q) {
          L(Q);
        }
        return B;
      }
      return Object.setPrototypeOf(Z, Object.getPrototypeOf(N)), Me && Object.defineProperty(Z, Me, {
        value: Z,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        Z,
        t(N)
      );
    }, n.promisify.custom = Me;
    function Le(k, N) {
      if (!k) {
        var Z = new Error("Promise was rejected with a falsy value");
        Z.reason = k, k = Z;
      }
      return N(k);
    }
    function qe(k) {
      if (typeof k != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function N() {
        for (var Z = [], le = 0; le < arguments.length; le++)
          Z.push(arguments[le]);
        var L = Z.pop();
        if (typeof L != "function")
          throw new TypeError("The last argument must be of type Function");
        var B = this, P = function() {
          return L.apply(B, arguments);
        };
        k.apply(this, Z).then(
          function(Y) {
            ge.nextTick(P.bind(null, null, Y));
          },
          function(Y) {
            ge.nextTick(Le.bind(null, Y, P));
          }
        );
      }
      return Object.setPrototypeOf(N, Object.getPrototypeOf(k)), Object.defineProperties(
        N,
        t(k)
      ), N;
    }
    n.callbackify = qe;
  }(ri)), ri;
}
var ro, Aa;
function Zu() {
  if (Aa)
    return ro;
  Aa = 1;
  function n(V, H) {
    var x = Object.keys(V);
    if (Object.getOwnPropertySymbols) {
      var E = Object.getOwnPropertySymbols(V);
      H && (E = E.filter(function(D) {
        return Object.getOwnPropertyDescriptor(V, D).enumerable;
      })), x.push.apply(x, E);
    }
    return x;
  }
  function t(V) {
    for (var H = 1; H < arguments.length; H++) {
      var x = arguments[H] != null ? arguments[H] : {};
      H % 2 ? n(Object(x), !0).forEach(function(E) {
        p(V, E, x[E]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(V, Object.getOwnPropertyDescriptors(x)) : n(Object(x)).forEach(function(E) {
        Object.defineProperty(V, E, Object.getOwnPropertyDescriptor(x, E));
      });
    }
    return V;
  }
  function p(V, H, x) {
    return H = e(H), H in V ? Object.defineProperty(V, H, { value: x, enumerable: !0, configurable: !0, writable: !0 }) : V[H] = x, V;
  }
  function f(V, H) {
    if (!(V instanceof H))
      throw new TypeError("Cannot call a class as a function");
  }
  function l(V, H) {
    for (var x = 0; x < H.length; x++) {
      var E = H[x];
      E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(V, e(E.key), E);
    }
  }
  function i(V, H, x) {
    return H && l(V.prototype, H), x && l(V, x), Object.defineProperty(V, "prototype", { writable: !1 }), V;
  }
  function e(V) {
    var H = r(V, "string");
    return typeof H == "symbol" ? H : String(H);
  }
  function r(V, H) {
    if (typeof V != "object" || V === null)
      return V;
    var x = V[Symbol.toPrimitive];
    if (x !== void 0) {
      var E = x.call(V, H || "default");
      if (typeof E != "object")
        return E;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (H === "string" ? String : Number)(V);
  }
  var s = zr(), d = s.Buffer, A = Hs(), _ = A.inspect, M = _ && _.custom || "inspect";
  function X(V, H, x) {
    d.prototype.copy.call(V, H, x);
  }
  return ro = /* @__PURE__ */ function() {
    function V() {
      f(this, V), this.head = null, this.tail = null, this.length = 0;
    }
    return i(V, [{
      key: "push",
      value: function(x) {
        var E = {
          data: x,
          next: null
        };
        this.length > 0 ? this.tail.next = E : this.head = E, this.tail = E, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(x) {
        var E = {
          data: x,
          next: this.head
        };
        this.length === 0 && (this.tail = E), this.head = E, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var x = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, x;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(x) {
        if (this.length === 0)
          return "";
        for (var E = this.head, D = "" + E.data; E = E.next; )
          D += x + E.data;
        return D;
      }
    }, {
      key: "concat",
      value: function(x) {
        if (this.length === 0)
          return d.alloc(0);
        for (var E = d.allocUnsafe(x >>> 0), D = this.head, O = 0; D; )
          X(D.data, E, O), O += D.data.length, D = D.next;
        return E;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(x, E) {
        var D;
        return x < this.head.data.length ? (D = this.head.data.slice(0, x), this.head.data = this.head.data.slice(x)) : x === this.head.data.length ? D = this.shift() : D = E ? this._getString(x) : this._getBuffer(x), D;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(x) {
        var E = this.head, D = 1, O = E.data;
        for (x -= O.length; E = E.next; ) {
          var z = E.data, $ = x > z.length ? z.length : x;
          if ($ === z.length ? O += z : O += z.slice(0, x), x -= $, x === 0) {
            $ === z.length ? (++D, E.next ? this.head = E.next : this.head = this.tail = null) : (this.head = E, E.data = z.slice($));
            break;
          }
          ++D;
        }
        return this.length -= D, O;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(x) {
        var E = d.allocUnsafe(x), D = this.head, O = 1;
        for (D.data.copy(E), x -= D.data.length; D = D.next; ) {
          var z = D.data, $ = x > z.length ? z.length : x;
          if (z.copy(E, E.length - x, 0, $), x -= $, x === 0) {
            $ === z.length ? (++O, D.next ? this.head = D.next : this.head = this.tail = null) : (this.head = D, D.data = z.slice($));
            break;
          }
          ++O;
        }
        return this.length -= O, E;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: M,
      value: function(x, E) {
        return _(this, t(t({}, E), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), V;
  }(), ro;
}
var io, Ia;
function Zs() {
  if (Ia)
    return io;
  Ia = 1;
  function n(e, r) {
    var s = this, d = this._readableState && this._readableState.destroyed, A = this._writableState && this._writableState.destroyed;
    return d || A ? (r ? r(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, ge.nextTick(l, this, e)) : ge.nextTick(l, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(_) {
      !r && _ ? s._writableState ? s._writableState.errorEmitted ? ge.nextTick(p, s) : (s._writableState.errorEmitted = !0, ge.nextTick(t, s, _)) : ge.nextTick(t, s, _) : r ? (ge.nextTick(p, s), r(_)) : ge.nextTick(p, s);
    }), this);
  }
  function t(e, r) {
    l(e, r), p(e);
  }
  function p(e) {
    e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
  }
  function f() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function l(e, r) {
    e.emit("error", r);
  }
  function i(e, r) {
    var s = e._readableState, d = e._writableState;
    s && s.autoDestroy || d && d.autoDestroy ? e.destroy(r) : e.emit("error", r);
  }
  return io = {
    destroy: n,
    undestroy: f,
    errorOrDestroy: i
  }, io;
}
var oo = {}, Wa;
function er() {
  if (Wa)
    return oo;
  Wa = 1;
  function n(r, s) {
    r.prototype = Object.create(s.prototype), r.prototype.constructor = r, r.__proto__ = s;
  }
  var t = {};
  function p(r, s, d) {
    d || (d = Error);
    function A(M, X, V) {
      return typeof s == "string" ? s : s(M, X, V);
    }
    var _ = /* @__PURE__ */ function(M) {
      n(X, M);
      function X(V, H, x) {
        return M.call(this, A(V, H, x)) || this;
      }
      return X;
    }(d);
    _.prototype.name = d.name, _.prototype.code = r, t[r] = _;
  }
  function f(r, s) {
    if (Array.isArray(r)) {
      var d = r.length;
      return r = r.map(function(A) {
        return String(A);
      }), d > 2 ? "one of ".concat(s, " ").concat(r.slice(0, d - 1).join(", "), ", or ") + r[d - 1] : d === 2 ? "one of ".concat(s, " ").concat(r[0], " or ").concat(r[1]) : "of ".concat(s, " ").concat(r[0]);
    } else
      return "of ".concat(s, " ").concat(String(r));
  }
  function l(r, s, d) {
    return r.substr(!d || d < 0 ? 0 : +d, s.length) === s;
  }
  function i(r, s, d) {
    return (d === void 0 || d > r.length) && (d = r.length), r.substring(d - s.length, d) === s;
  }
  function e(r, s, d) {
    return typeof d != "number" && (d = 0), d + s.length > r.length ? !1 : r.indexOf(s, d) !== -1;
  }
  return p("ERR_INVALID_OPT_VALUE", function(r, s) {
    return 'The value "' + s + '" is invalid for option "' + r + '"';
  }, TypeError), p("ERR_INVALID_ARG_TYPE", function(r, s, d) {
    var A;
    typeof s == "string" && l(s, "not ") ? (A = "must not be", s = s.replace(/^not /, "")) : A = "must be";
    var _;
    if (i(r, " argument"))
      _ = "The ".concat(r, " ").concat(A, " ").concat(f(s, "type"));
    else {
      var M = e(r, ".") ? "property" : "argument";
      _ = 'The "'.concat(r, '" ').concat(M, " ").concat(A, " ").concat(f(s, "type"));
    }
    return _ += ". Received type ".concat(typeof d), _;
  }, TypeError), p("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), p("ERR_METHOD_NOT_IMPLEMENTED", function(r) {
    return "The " + r + " method is not implemented";
  }), p("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), p("ERR_STREAM_DESTROYED", function(r) {
    return "Cannot call " + r + " after a stream was destroyed";
  }), p("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), p("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), p("ERR_STREAM_WRITE_AFTER_END", "write after end"), p("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), p("ERR_UNKNOWN_ENCODING", function(r) {
    return "Unknown encoding: " + r;
  }, TypeError), p("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), oo.codes = t, oo;
}
var no, _a;
function Ks() {
  if (_a)
    return no;
  _a = 1;
  var n = er().codes.ERR_INVALID_OPT_VALUE;
  function t(f, l, i) {
    return f.highWaterMark != null ? f.highWaterMark : l ? f[i] : null;
  }
  function p(f, l, i, e) {
    var r = t(l, e, i);
    if (r != null) {
      if (!(isFinite(r) && Math.floor(r) === r) || r < 0) {
        var s = e ? i : "highWaterMark";
        throw new n(s, r);
      }
      return Math.floor(r);
    }
    return f.objectMode ? 16 : 16 * 1024;
  }
  return no = {
    getHighWaterMark: p
  }, no;
}
var ao, Pa;
function Ku() {
  if (Pa)
    return ao;
  Pa = 1, ao = n;
  function n(p, f) {
    if (t("noDeprecation"))
      return p;
    var l = !1;
    function i() {
      if (!l) {
        if (t("throwDeprecation"))
          throw new Error(f);
        t("traceDeprecation") ? console.trace(f) : console.warn(f), l = !0;
      }
      return p.apply(this, arguments);
    }
    return i;
  }
  function t(p) {
    try {
      if (!Ce.localStorage)
        return !1;
    } catch {
      return !1;
    }
    var f = Ce.localStorage[p];
    return f == null ? !1 : String(f).toLowerCase() === "true";
  }
  return ao;
}
var so, ka;
function Ys() {
  if (ka)
    return so;
  ka = 1, so = ee;
  function n(L) {
    var B = this;
    this.next = null, this.entry = null, this.finish = function() {
      le(B, L);
    };
  }
  var t;
  ee.WritableState = J;
  var p = {
    deprecate: Ku()
  }, f = js(), l = zr().Buffer, i = (typeof Ce < "u" ? Ce : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function e(L) {
    return l.from(L);
  }
  function r(L) {
    return l.isBuffer(L) || L instanceof i;
  }
  var s = Zs(), d = Ks(), A = d.getHighWaterMark, _ = er().codes, M = _.ERR_INVALID_ARG_TYPE, X = _.ERR_METHOD_NOT_IMPLEMENTED, V = _.ERR_MULTIPLE_CALLBACK, H = _.ERR_STREAM_CANNOT_PIPE, x = _.ERR_STREAM_DESTROYED, E = _.ERR_STREAM_NULL_VALUES, D = _.ERR_STREAM_WRITE_AFTER_END, O = _.ERR_UNKNOWN_ENCODING, z = s.errorOrDestroy;
  jt(ee, f);
  function $() {
  }
  function J(L, B, P) {
    t = t || Jt(), L = L || {}, typeof P != "boolean" && (P = B instanceof t), this.objectMode = !!L.objectMode, P && (this.objectMode = this.objectMode || !!L.writableObjectMode), this.highWaterMark = A(this, L, "writableHighWaterMark", P), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Y = L.decodeStrings === !1;
    this.decodeStrings = !Y, this.defaultEncoding = L.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Q) {
      we(B, Q);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = L.emitClose !== !1, this.autoDestroy = !!L.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new n(this);
  }
  J.prototype.getBuffer = function() {
    for (var B = this.bufferedRequest, P = []; B; )
      P.push(B), B = B.next;
    return P;
  }, function() {
    try {
      Object.defineProperty(J.prototype, "buffer", {
        get: p.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var F;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (F = Function.prototype[Symbol.hasInstance], Object.defineProperty(ee, Symbol.hasInstance, {
    value: function(B) {
      return F.call(this, B) ? !0 : this !== ee ? !1 : B && B._writableState instanceof J;
    }
  })) : F = function(B) {
    return B instanceof this;
  };
  function ee(L) {
    t = t || Jt();
    var B = this instanceof t;
    if (!B && !F.call(ee, this))
      return new ee(L);
    this._writableState = new J(L, this, B), this.writable = !0, L && (typeof L.write == "function" && (this._write = L.write), typeof L.writev == "function" && (this._writev = L.writev), typeof L.destroy == "function" && (this._destroy = L.destroy), typeof L.final == "function" && (this._final = L.final)), f.call(this);
  }
  ee.prototype.pipe = function() {
    z(this, new H());
  };
  function oe(L, B) {
    var P = new D();
    z(L, P), ge.nextTick(B, P);
  }
  function ae(L, B, P, Y) {
    var Q;
    return P === null ? Q = new E() : typeof P != "string" && !B.objectMode && (Q = new M("chunk", ["string", "Buffer"], P)), Q ? (z(L, Q), ge.nextTick(Y, Q), !1) : !0;
  }
  ee.prototype.write = function(L, B, P) {
    var Y = this._writableState, Q = !1, v = !Y.objectMode && r(L);
    return v && !l.isBuffer(L) && (L = e(L)), typeof B == "function" && (P = B, B = null), v ? B = "buffer" : B || (B = Y.defaultEncoding), typeof P != "function" && (P = $), Y.ending ? oe(this, P) : (v || ae(this, Y, L, P)) && (Y.pendingcb++, Q = I(this, Y, v, L, B, P)), Q;
  }, ee.prototype.cork = function() {
    this._writableState.corked++;
  }, ee.prototype.uncork = function() {
    var L = this._writableState;
    L.corked && (L.corked--, !L.writing && !L.corked && !L.bufferProcessing && L.bufferedRequest && Me(this, L));
  }, ee.prototype.setDefaultEncoding = function(B) {
    if (typeof B == "string" && (B = B.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((B + "").toLowerCase()) > -1))
      throw new O(B);
    return this._writableState.defaultEncoding = B, this;
  }, Object.defineProperty(ee.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function fe(L, B, P) {
    return !L.objectMode && L.decodeStrings !== !1 && typeof B == "string" && (B = l.from(B, P)), B;
  }
  Object.defineProperty(ee.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function I(L, B, P, Y, Q, v) {
    if (!P) {
      var b = fe(B, Y, Q);
      Y !== b && (P = !0, Q = "buffer", Y = b);
    }
    var U = B.objectMode ? 1 : Y.length;
    B.length += U;
    var te = B.length < B.highWaterMark;
    if (te || (B.needDrain = !0), B.writing || B.corked) {
      var ye = B.lastBufferedRequest;
      B.lastBufferedRequest = {
        chunk: Y,
        encoding: Q,
        isBuf: P,
        callback: v,
        next: null
      }, ye ? ye.next = B.lastBufferedRequest : B.bufferedRequest = B.lastBufferedRequest, B.bufferedRequestCount += 1;
    } else
      ne(L, B, !1, U, Y, Q, v);
    return te;
  }
  function ne(L, B, P, Y, Q, v, b) {
    B.writelen = Y, B.writecb = b, B.writing = !0, B.sync = !0, B.destroyed ? B.onwrite(new x("write")) : P ? L._writev(Q, B.onwrite) : L._write(Q, v, B.onwrite), B.sync = !1;
  }
  function me(L, B, P, Y, Q) {
    --B.pendingcb, P ? (ge.nextTick(Q, Y), ge.nextTick(N, L, B), L._writableState.errorEmitted = !0, z(L, Y)) : (Q(Y), L._writableState.errorEmitted = !0, z(L, Y), N(L, B));
  }
  function be(L) {
    L.writing = !1, L.writecb = null, L.length -= L.writelen, L.writelen = 0;
  }
  function we(L, B) {
    var P = L._writableState, Y = P.sync, Q = P.writecb;
    if (typeof Q != "function")
      throw new V();
    if (be(P), B)
      me(L, P, Y, B, Q);
    else {
      var v = Le(P) || L.destroyed;
      !v && !P.corked && !P.bufferProcessing && P.bufferedRequest && Me(L, P), Y ? ge.nextTick(We, L, P, v, Q) : We(L, P, v, Q);
    }
  }
  function We(L, B, P, Y) {
    P || Oe(L, B), B.pendingcb--, Y(), N(L, B);
  }
  function Oe(L, B) {
    B.length === 0 && B.needDrain && (B.needDrain = !1, L.emit("drain"));
  }
  function Me(L, B) {
    B.bufferProcessing = !0;
    var P = B.bufferedRequest;
    if (L._writev && P && P.next) {
      var Y = B.bufferedRequestCount, Q = new Array(Y), v = B.corkedRequestsFree;
      v.entry = P;
      for (var b = 0, U = !0; P; )
        Q[b] = P, P.isBuf || (U = !1), P = P.next, b += 1;
      Q.allBuffers = U, ne(L, B, !0, B.length, Q, "", v.finish), B.pendingcb++, B.lastBufferedRequest = null, v.next ? (B.corkedRequestsFree = v.next, v.next = null) : B.corkedRequestsFree = new n(B), B.bufferedRequestCount = 0;
    } else {
      for (; P; ) {
        var te = P.chunk, ye = P.encoding, se = P.callback, he = B.objectMode ? 1 : te.length;
        if (ne(L, B, !1, he, te, ye, se), P = P.next, B.bufferedRequestCount--, B.writing)
          break;
      }
      P === null && (B.lastBufferedRequest = null);
    }
    B.bufferedRequest = P, B.bufferProcessing = !1;
  }
  ee.prototype._write = function(L, B, P) {
    P(new X("_write()"));
  }, ee.prototype._writev = null, ee.prototype.end = function(L, B, P) {
    var Y = this._writableState;
    return typeof L == "function" ? (P = L, L = null, B = null) : typeof B == "function" && (P = B, B = null), L != null && this.write(L, B), Y.corked && (Y.corked = 1, this.uncork()), Y.ending || Z(this, Y, P), this;
  }, Object.defineProperty(ee.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function Le(L) {
    return L.ending && L.length === 0 && L.bufferedRequest === null && !L.finished && !L.writing;
  }
  function qe(L, B) {
    L._final(function(P) {
      B.pendingcb--, P && z(L, P), B.prefinished = !0, L.emit("prefinish"), N(L, B);
    });
  }
  function k(L, B) {
    !B.prefinished && !B.finalCalled && (typeof L._final == "function" && !B.destroyed ? (B.pendingcb++, B.finalCalled = !0, ge.nextTick(qe, L, B)) : (B.prefinished = !0, L.emit("prefinish")));
  }
  function N(L, B) {
    var P = Le(B);
    if (P && (k(L, B), B.pendingcb === 0 && (B.finished = !0, L.emit("finish"), B.autoDestroy))) {
      var Y = L._readableState;
      (!Y || Y.autoDestroy && Y.endEmitted) && L.destroy();
    }
    return P;
  }
  function Z(L, B, P) {
    B.ending = !0, N(L, B), P && (B.finished ? ge.nextTick(P) : L.once("finish", P)), B.ended = !0, L.writable = !1;
  }
  function le(L, B, P) {
    var Y = L.entry;
    for (L.entry = null; Y; ) {
      var Q = Y.callback;
      B.pendingcb--, Q(P), Y = Y.next;
    }
    B.corkedRequestsFree.next = L;
  }
  return Object.defineProperty(ee.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(B) {
      this._writableState && (this._writableState.destroyed = B);
    }
  }), ee.prototype.destroy = s.destroy, ee.prototype._undestroy = s.undestroy, ee.prototype._destroy = function(L, B) {
    B(L);
  }, so;
}
var po, Ca;
function Jt() {
  if (Ca)
    return po;
  Ca = 1;
  var n = Object.keys || function(d) {
    var A = [];
    for (var _ in d)
      A.push(_);
    return A;
  };
  po = e;
  var t = Xs(), p = Ys();
  jt(e, t);
  for (var f = n(p.prototype), l = 0; l < f.length; l++) {
    var i = f[l];
    e.prototype[i] || (e.prototype[i] = p.prototype[i]);
  }
  function e(d) {
    if (!(this instanceof e))
      return new e(d);
    t.call(this, d), p.call(this, d), this.allowHalfOpen = !0, d && (d.readable === !1 && (this.readable = !1), d.writable === !1 && (this.writable = !1), d.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", r)));
  }
  Object.defineProperty(e.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(e.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(e.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function r() {
    this._writableState.ended || ge.nextTick(s, this);
  }
  function s(d) {
    d.end();
  }
  return Object.defineProperty(e.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(A) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = A, this._writableState.destroyed = A);
    }
  }), po;
}
var uo = {}, Fr = { exports: {} }, ja;
function Yu() {
  return ja || (ja = 1, function(n, t) {
    var p = zr(), f = p.Buffer;
    function l(e, r) {
      for (var s in e)
        r[s] = e[s];
    }
    f.from && f.alloc && f.allocUnsafe && f.allocUnsafeSlow ? n.exports = p : (l(p, t), t.Buffer = i);
    function i(e, r, s) {
      return f(e, r, s);
    }
    l(f, i), i.from = function(e, r, s) {
      if (typeof e == "number")
        throw new TypeError("Argument must not be a number");
      return f(e, r, s);
    }, i.alloc = function(e, r, s) {
      if (typeof e != "number")
        throw new TypeError("Argument must be a number");
      var d = f(e);
      return r !== void 0 ? typeof s == "string" ? d.fill(r, s) : d.fill(r) : d.fill(0), d;
    }, i.allocUnsafe = function(e) {
      if (typeof e != "number")
        throw new TypeError("Argument must be a number");
      return f(e);
    }, i.allocUnsafeSlow = function(e) {
      if (typeof e != "number")
        throw new TypeError("Argument must be a number");
      return p.SlowBuffer(e);
    };
  }(Fr, Fr.exports)), Fr.exports;
}
var za;
function xa() {
  if (za)
    return uo;
  za = 1;
  var n = Yu().Buffer, t = n.isEncoding || function(E) {
    switch (E = "" + E, E && E.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function p(E) {
    if (!E)
      return "utf8";
    for (var D; ; )
      switch (E) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return E;
        default:
          if (D)
            return;
          E = ("" + E).toLowerCase(), D = !0;
      }
  }
  function f(E) {
    var D = p(E);
    if (typeof D != "string" && (n.isEncoding === t || !t(E)))
      throw new Error("Unknown encoding: " + E);
    return D || E;
  }
  uo.StringDecoder = l;
  function l(E) {
    this.encoding = f(E);
    var D;
    switch (this.encoding) {
      case "utf16le":
        this.text = _, this.end = M, D = 4;
        break;
      case "utf8":
        this.fillLast = s, D = 4;
        break;
      case "base64":
        this.text = X, this.end = V, D = 3;
        break;
      default:
        this.write = H, this.end = x;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(D);
  }
  l.prototype.write = function(E) {
    if (E.length === 0)
      return "";
    var D, O;
    if (this.lastNeed) {
      if (D = this.fillLast(E), D === void 0)
        return "";
      O = this.lastNeed, this.lastNeed = 0;
    } else
      O = 0;
    return O < E.length ? D ? D + this.text(E, O) : this.text(E, O) : D || "";
  }, l.prototype.end = A, l.prototype.text = d, l.prototype.fillLast = function(E) {
    if (this.lastNeed <= E.length)
      return E.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    E.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, E.length), this.lastNeed -= E.length;
  };
  function i(E) {
    return E <= 127 ? 0 : E >> 5 === 6 ? 2 : E >> 4 === 14 ? 3 : E >> 3 === 30 ? 4 : E >> 6 === 2 ? -1 : -2;
  }
  function e(E, D, O) {
    var z = D.length - 1;
    if (z < O)
      return 0;
    var $ = i(D[z]);
    return $ >= 0 ? ($ > 0 && (E.lastNeed = $ - 1), $) : --z < O || $ === -2 ? 0 : ($ = i(D[z]), $ >= 0 ? ($ > 0 && (E.lastNeed = $ - 2), $) : --z < O || $ === -2 ? 0 : ($ = i(D[z]), $ >= 0 ? ($ > 0 && ($ === 2 ? $ = 0 : E.lastNeed = $ - 3), $) : 0));
  }
  function r(E, D, O) {
    if ((D[0] & 192) !== 128)
      return E.lastNeed = 0, "�";
    if (E.lastNeed > 1 && D.length > 1) {
      if ((D[1] & 192) !== 128)
        return E.lastNeed = 1, "�";
      if (E.lastNeed > 2 && D.length > 2 && (D[2] & 192) !== 128)
        return E.lastNeed = 2, "�";
    }
  }
  function s(E) {
    var D = this.lastTotal - this.lastNeed, O = r(this, E);
    if (O !== void 0)
      return O;
    if (this.lastNeed <= E.length)
      return E.copy(this.lastChar, D, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    E.copy(this.lastChar, D, 0, E.length), this.lastNeed -= E.length;
  }
  function d(E, D) {
    var O = e(this, E, D);
    if (!this.lastNeed)
      return E.toString("utf8", D);
    this.lastTotal = O;
    var z = E.length - (O - this.lastNeed);
    return E.copy(this.lastChar, 0, z), E.toString("utf8", D, z);
  }
  function A(E) {
    var D = E && E.length ? this.write(E) : "";
    return this.lastNeed ? D + "�" : D;
  }
  function _(E, D) {
    if ((E.length - D) % 2 === 0) {
      var O = E.toString("utf16le", D);
      if (O) {
        var z = O.charCodeAt(O.length - 1);
        if (z >= 55296 && z <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = E[E.length - 2], this.lastChar[1] = E[E.length - 1], O.slice(0, -1);
      }
      return O;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = E[E.length - 1], E.toString("utf16le", D, E.length - 1);
  }
  function M(E) {
    var D = E && E.length ? this.write(E) : "";
    if (this.lastNeed) {
      var O = this.lastTotal - this.lastNeed;
      return D + this.lastChar.toString("utf16le", 0, O);
    }
    return D;
  }
  function X(E, D) {
    var O = (E.length - D) % 3;
    return O === 0 ? E.toString("base64", D) : (this.lastNeed = 3 - O, this.lastTotal = 3, O === 1 ? this.lastChar[0] = E[E.length - 1] : (this.lastChar[0] = E[E.length - 2], this.lastChar[1] = E[E.length - 1]), E.toString("base64", D, E.length - O));
  }
  function V(E) {
    var D = E && E.length ? this.write(E) : "";
    return this.lastNeed ? D + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : D;
  }
  function H(E) {
    return E.toString(this.encoding);
  }
  function x(E) {
    return E && E.length ? this.write(E) : "";
  }
  return uo;
}
var lo, Na;
function on() {
  if (Na)
    return lo;
  Na = 1;
  var n = er().codes.ERR_STREAM_PREMATURE_CLOSE;
  function t(i) {
    var e = !1;
    return function() {
      if (!e) {
        e = !0;
        for (var r = arguments.length, s = new Array(r), d = 0; d < r; d++)
          s[d] = arguments[d];
        i.apply(this, s);
      }
    };
  }
  function p() {
  }
  function f(i) {
    return i.setHeader && typeof i.abort == "function";
  }
  function l(i, e, r) {
    if (typeof e == "function")
      return l(i, null, e);
    e || (e = {}), r = t(r || p);
    var s = e.readable || e.readable !== !1 && i.readable, d = e.writable || e.writable !== !1 && i.writable, A = function() {
      i.writable || M();
    }, _ = i._writableState && i._writableState.finished, M = function() {
      d = !1, _ = !0, s || r.call(i);
    }, X = i._readableState && i._readableState.endEmitted, V = function() {
      s = !1, X = !0, d || r.call(i);
    }, H = function(O) {
      r.call(i, O);
    }, x = function() {
      var O;
      if (s && !X)
        return (!i._readableState || !i._readableState.ended) && (O = new n()), r.call(i, O);
      if (d && !_)
        return (!i._writableState || !i._writableState.ended) && (O = new n()), r.call(i, O);
    }, E = function() {
      i.req.on("finish", M);
    };
    return f(i) ? (i.on("complete", M), i.on("abort", x), i.req ? E() : i.on("request", E)) : d && !i._writableState && (i.on("end", A), i.on("close", A)), i.on("end", V), i.on("finish", M), e.error !== !1 && i.on("error", H), i.on("close", x), function() {
      i.removeListener("complete", M), i.removeListener("abort", x), i.removeListener("request", E), i.req && i.req.removeListener("finish", M), i.removeListener("end", A), i.removeListener("close", A), i.removeListener("finish", M), i.removeListener("end", V), i.removeListener("error", H), i.removeListener("close", x);
    };
  }
  return lo = l, lo;
}
var co, Ua;
function Xu() {
  if (Ua)
    return co;
  Ua = 1;
  var n;
  function t(O, z, $) {
    return z = p(z), z in O ? Object.defineProperty(O, z, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : O[z] = $, O;
  }
  function p(O) {
    var z = f(O, "string");
    return typeof z == "symbol" ? z : String(z);
  }
  function f(O, z) {
    if (typeof O != "object" || O === null)
      return O;
    var $ = O[Symbol.toPrimitive];
    if ($ !== void 0) {
      var J = $.call(O, z || "default");
      if (typeof J != "object")
        return J;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (z === "string" ? String : Number)(O);
  }
  var l = on(), i = Symbol("lastResolve"), e = Symbol("lastReject"), r = Symbol("error"), s = Symbol("ended"), d = Symbol("lastPromise"), A = Symbol("handlePromise"), _ = Symbol("stream");
  function M(O, z) {
    return {
      value: O,
      done: z
    };
  }
  function X(O) {
    var z = O[i];
    if (z !== null) {
      var $ = O[_].read();
      $ !== null && (O[d] = null, O[i] = null, O[e] = null, z(M($, !1)));
    }
  }
  function V(O) {
    ge.nextTick(X, O);
  }
  function H(O, z) {
    return function($, J) {
      O.then(function() {
        if (z[s]) {
          $(M(void 0, !0));
          return;
        }
        z[A]($, J);
      }, J);
    };
  }
  var x = Object.getPrototypeOf(function() {
  }), E = Object.setPrototypeOf((n = {
    get stream() {
      return this[_];
    },
    next: function() {
      var z = this, $ = this[r];
      if ($ !== null)
        return Promise.reject($);
      if (this[s])
        return Promise.resolve(M(void 0, !0));
      if (this[_].destroyed)
        return new Promise(function(oe, ae) {
          ge.nextTick(function() {
            z[r] ? ae(z[r]) : oe(M(void 0, !0));
          });
        });
      var J = this[d], F;
      if (J)
        F = new Promise(H(J, this));
      else {
        var ee = this[_].read();
        if (ee !== null)
          return Promise.resolve(M(ee, !1));
        F = new Promise(this[A]);
      }
      return this[d] = F, F;
    }
  }, t(n, Symbol.asyncIterator, function() {
    return this;
  }), t(n, "return", function() {
    var z = this;
    return new Promise(function($, J) {
      z[_].destroy(null, function(F) {
        if (F) {
          J(F);
          return;
        }
        $(M(void 0, !0));
      });
    });
  }), n), x), D = function(z) {
    var $, J = Object.create(E, ($ = {}, t($, _, {
      value: z,
      writable: !0
    }), t($, i, {
      value: null,
      writable: !0
    }), t($, e, {
      value: null,
      writable: !0
    }), t($, r, {
      value: null,
      writable: !0
    }), t($, s, {
      value: z._readableState.endEmitted,
      writable: !0
    }), t($, A, {
      value: function(ee, oe) {
        var ae = J[_].read();
        ae ? (J[d] = null, J[i] = null, J[e] = null, ee(M(ae, !1))) : (J[i] = ee, J[e] = oe);
      },
      writable: !0
    }), $));
    return J[d] = null, l(z, function(F) {
      if (F && F.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var ee = J[e];
        ee !== null && (J[d] = null, J[i] = null, J[e] = null, ee(F)), J[r] = F;
        return;
      }
      var oe = J[i];
      oe !== null && (J[d] = null, J[i] = null, J[e] = null, oe(M(void 0, !0))), J[s] = !0;
    }), z.on("readable", V.bind(null, J)), J;
  };
  return co = D, co;
}
var fo, qa;
function Qu() {
  return qa || (qa = 1, fo = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fo;
}
var yo, Ga;
function Xs() {
  if (Ga)
    return yo;
  Ga = 1, yo = oe;
  var n;
  oe.ReadableState = ee, Xo.EventEmitter;
  var t = function(b, U) {
    return b.listeners(U).length;
  }, p = js(), f = zr().Buffer, l = (typeof Ce < "u" ? Ce : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function i(v) {
    return f.from(v);
  }
  function e(v) {
    return f.isBuffer(v) || v instanceof l;
  }
  var r = Hs(), s;
  r && r.debuglog ? s = r.debuglog("stream") : s = function() {
  };
  var d = Zu(), A = Zs(), _ = Ks(), M = _.getHighWaterMark, X = er().codes, V = X.ERR_INVALID_ARG_TYPE, H = X.ERR_STREAM_PUSH_AFTER_EOF, x = X.ERR_METHOD_NOT_IMPLEMENTED, E = X.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, D, O, z;
  jt(oe, p);
  var $ = A.errorOrDestroy, J = ["error", "close", "destroy", "pause", "resume"];
  function F(v, b, U) {
    if (typeof v.prependListener == "function")
      return v.prependListener(b, U);
    !v._events || !v._events[b] ? v.on(b, U) : Array.isArray(v._events[b]) ? v._events[b].unshift(U) : v._events[b] = [U, v._events[b]];
  }
  function ee(v, b, U) {
    n = n || Jt(), v = v || {}, typeof U != "boolean" && (U = b instanceof n), this.objectMode = !!v.objectMode, U && (this.objectMode = this.objectMode || !!v.readableObjectMode), this.highWaterMark = M(this, v, "readableHighWaterMark", U), this.buffer = new d(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = v.emitClose !== !1, this.autoDestroy = !!v.autoDestroy, this.destroyed = !1, this.defaultEncoding = v.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, v.encoding && (D || (D = xa().StringDecoder), this.decoder = new D(v.encoding), this.encoding = v.encoding);
  }
  function oe(v) {
    if (n = n || Jt(), !(this instanceof oe))
      return new oe(v);
    var b = this instanceof n;
    this._readableState = new ee(v, this, b), this.readable = !0, v && (typeof v.read == "function" && (this._read = v.read), typeof v.destroy == "function" && (this._destroy = v.destroy)), p.call(this);
  }
  Object.defineProperty(oe.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(b) {
      this._readableState && (this._readableState.destroyed = b);
    }
  }), oe.prototype.destroy = A.destroy, oe.prototype._undestroy = A.undestroy, oe.prototype._destroy = function(v, b) {
    b(v);
  }, oe.prototype.push = function(v, b) {
    var U = this._readableState, te;
    return U.objectMode ? te = !0 : typeof v == "string" && (b = b || U.defaultEncoding, b !== U.encoding && (v = f.from(v, b), b = ""), te = !0), ae(this, v, b, !1, te);
  }, oe.prototype.unshift = function(v) {
    return ae(this, v, null, !0, !1);
  };
  function ae(v, b, U, te, ye) {
    s("readableAddChunk", b);
    var se = v._readableState;
    if (b === null)
      se.reading = !1, we(v, se);
    else {
      var he;
      if (ye || (he = I(se, b)), he)
        $(v, he);
      else if (se.objectMode || b && b.length > 0)
        if (typeof b != "string" && !se.objectMode && Object.getPrototypeOf(b) !== f.prototype && (b = i(b)), te)
          se.endEmitted ? $(v, new E()) : fe(v, se, b, !0);
        else if (se.ended)
          $(v, new H());
        else {
          if (se.destroyed)
            return !1;
          se.reading = !1, se.decoder && !U ? (b = se.decoder.write(b), se.objectMode || b.length !== 0 ? fe(v, se, b, !1) : Me(v, se)) : fe(v, se, b, !1);
        }
      else
        te || (se.reading = !1, Me(v, se));
    }
    return !se.ended && (se.length < se.highWaterMark || se.length === 0);
  }
  function fe(v, b, U, te) {
    b.flowing && b.length === 0 && !b.sync ? (b.awaitDrain = 0, v.emit("data", U)) : (b.length += b.objectMode ? 1 : U.length, te ? b.buffer.unshift(U) : b.buffer.push(U), b.needReadable && We(v)), Me(v, b);
  }
  function I(v, b) {
    var U;
    return !e(b) && typeof b != "string" && b !== void 0 && !v.objectMode && (U = new V("chunk", ["string", "Buffer", "Uint8Array"], b)), U;
  }
  oe.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, oe.prototype.setEncoding = function(v) {
    D || (D = xa().StringDecoder);
    var b = new D(v);
    this._readableState.decoder = b, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var U = this._readableState.buffer.head, te = ""; U !== null; )
      te += b.write(U.data), U = U.next;
    return this._readableState.buffer.clear(), te !== "" && this._readableState.buffer.push(te), this._readableState.length = te.length, this;
  };
  var ne = 1073741824;
  function me(v) {
    return v >= ne ? v = ne : (v--, v |= v >>> 1, v |= v >>> 2, v |= v >>> 4, v |= v >>> 8, v |= v >>> 16, v++), v;
  }
  function be(v, b) {
    return v <= 0 || b.length === 0 && b.ended ? 0 : b.objectMode ? 1 : v !== v ? b.flowing && b.length ? b.buffer.head.data.length : b.length : (v > b.highWaterMark && (b.highWaterMark = me(v)), v <= b.length ? v : b.ended ? b.length : (b.needReadable = !0, 0));
  }
  oe.prototype.read = function(v) {
    s("read", v), v = parseInt(v, 10);
    var b = this._readableState, U = v;
    if (v !== 0 && (b.emittedReadable = !1), v === 0 && b.needReadable && ((b.highWaterMark !== 0 ? b.length >= b.highWaterMark : b.length > 0) || b.ended))
      return s("read: emitReadable", b.length, b.ended), b.length === 0 && b.ended ? P(this) : We(this), null;
    if (v = be(v, b), v === 0 && b.ended)
      return b.length === 0 && P(this), null;
    var te = b.needReadable;
    s("need readable", te), (b.length === 0 || b.length - v < b.highWaterMark) && (te = !0, s("length less than watermark", te)), b.ended || b.reading ? (te = !1, s("reading or ended", te)) : te && (s("do read"), b.reading = !0, b.sync = !0, b.length === 0 && (b.needReadable = !0), this._read(b.highWaterMark), b.sync = !1, b.reading || (v = be(U, b)));
    var ye;
    return v > 0 ? ye = B(v, b) : ye = null, ye === null ? (b.needReadable = b.length <= b.highWaterMark, v = 0) : (b.length -= v, b.awaitDrain = 0), b.length === 0 && (b.ended || (b.needReadable = !0), U !== v && b.ended && P(this)), ye !== null && this.emit("data", ye), ye;
  };
  function we(v, b) {
    if (s("onEofChunk"), !b.ended) {
      if (b.decoder) {
        var U = b.decoder.end();
        U && U.length && (b.buffer.push(U), b.length += b.objectMode ? 1 : U.length);
      }
      b.ended = !0, b.sync ? We(v) : (b.needReadable = !1, b.emittedReadable || (b.emittedReadable = !0, Oe(v)));
    }
  }
  function We(v) {
    var b = v._readableState;
    s("emitReadable", b.needReadable, b.emittedReadable), b.needReadable = !1, b.emittedReadable || (s("emitReadable", b.flowing), b.emittedReadable = !0, ge.nextTick(Oe, v));
  }
  function Oe(v) {
    var b = v._readableState;
    s("emitReadable_", b.destroyed, b.length, b.ended), !b.destroyed && (b.length || b.ended) && (v.emit("readable"), b.emittedReadable = !1), b.needReadable = !b.flowing && !b.ended && b.length <= b.highWaterMark, L(v);
  }
  function Me(v, b) {
    b.readingMore || (b.readingMore = !0, ge.nextTick(Le, v, b));
  }
  function Le(v, b) {
    for (; !b.reading && !b.ended && (b.length < b.highWaterMark || b.flowing && b.length === 0); ) {
      var U = b.length;
      if (s("maybeReadMore read 0"), v.read(0), U === b.length)
        break;
    }
    b.readingMore = !1;
  }
  oe.prototype._read = function(v) {
    $(this, new x("_read()"));
  }, oe.prototype.pipe = function(v, b) {
    var U = this, te = this._readableState;
    switch (te.pipesCount) {
      case 0:
        te.pipes = v;
        break;
      case 1:
        te.pipes = [te.pipes, v];
        break;
      default:
        te.pipes.push(v);
        break;
    }
    te.pipesCount += 1, s("pipe count=%d opts=%j", te.pipesCount, b);
    var ye = (!b || b.end !== !1) && v !== ge.stdout && v !== ge.stderr, se = ye ? ze : Xe;
    te.endEmitted ? ge.nextTick(se) : U.once("end", se), v.on("unpipe", he);
    function he(tt, rt) {
      s("onunpipe"), tt === U && rt && rt.hasUnpiped === !1 && (rt.hasUnpiped = !0, xe());
    }
    function ze() {
      s("onend"), v.end();
    }
    var q = qe(U);
    v.on("drain", q);
    var Ge = !1;
    function xe() {
      s("cleanup"), v.removeListener("close", Ne), v.removeListener("finish", ht), v.removeListener("drain", q), v.removeListener("error", Re), v.removeListener("unpipe", he), U.removeListener("end", ze), U.removeListener("end", Xe), U.removeListener("data", Se), Ge = !0, te.awaitDrain && (!v._writableState || v._writableState.needDrain) && q();
    }
    U.on("data", Se);
    function Se(tt) {
      s("ondata");
      var rt = v.write(tt);
      s("dest.write", rt), rt === !1 && ((te.pipesCount === 1 && te.pipes === v || te.pipesCount > 1 && Q(te.pipes, v) !== -1) && !Ge && (s("false write response, pause", te.awaitDrain), te.awaitDrain++), U.pause());
    }
    function Re(tt) {
      s("onerror", tt), Xe(), v.removeListener("error", Re), t(v, "error") === 0 && $(v, tt);
    }
    F(v, "error", Re);
    function Ne() {
      v.removeListener("finish", ht), Xe();
    }
    v.once("close", Ne);
    function ht() {
      s("onfinish"), v.removeListener("close", Ne), Xe();
    }
    v.once("finish", ht);
    function Xe() {
      s("unpipe"), U.unpipe(v);
    }
    return v.emit("pipe", U), te.flowing || (s("pipe resume"), U.resume()), v;
  };
  function qe(v) {
    return function() {
      var U = v._readableState;
      s("pipeOnDrain", U.awaitDrain), U.awaitDrain && U.awaitDrain--, U.awaitDrain === 0 && t(v, "data") && (U.flowing = !0, L(v));
    };
  }
  oe.prototype.unpipe = function(v) {
    var b = this._readableState, U = {
      hasUnpiped: !1
    };
    if (b.pipesCount === 0)
      return this;
    if (b.pipesCount === 1)
      return v && v !== b.pipes ? this : (v || (v = b.pipes), b.pipes = null, b.pipesCount = 0, b.flowing = !1, v && v.emit("unpipe", this, U), this);
    if (!v) {
      var te = b.pipes, ye = b.pipesCount;
      b.pipes = null, b.pipesCount = 0, b.flowing = !1;
      for (var se = 0; se < ye; se++)
        te[se].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var he = Q(b.pipes, v);
    return he === -1 ? this : (b.pipes.splice(he, 1), b.pipesCount -= 1, b.pipesCount === 1 && (b.pipes = b.pipes[0]), v.emit("unpipe", this, U), this);
  }, oe.prototype.on = function(v, b) {
    var U = p.prototype.on.call(this, v, b), te = this._readableState;
    return v === "data" ? (te.readableListening = this.listenerCount("readable") > 0, te.flowing !== !1 && this.resume()) : v === "readable" && !te.endEmitted && !te.readableListening && (te.readableListening = te.needReadable = !0, te.flowing = !1, te.emittedReadable = !1, s("on readable", te.length, te.reading), te.length ? We(this) : te.reading || ge.nextTick(N, this)), U;
  }, oe.prototype.addListener = oe.prototype.on, oe.prototype.removeListener = function(v, b) {
    var U = p.prototype.removeListener.call(this, v, b);
    return v === "readable" && ge.nextTick(k, this), U;
  }, oe.prototype.removeAllListeners = function(v) {
    var b = p.prototype.removeAllListeners.apply(this, arguments);
    return (v === "readable" || v === void 0) && ge.nextTick(k, this), b;
  };
  function k(v) {
    var b = v._readableState;
    b.readableListening = v.listenerCount("readable") > 0, b.resumeScheduled && !b.paused ? b.flowing = !0 : v.listenerCount("data") > 0 && v.resume();
  }
  function N(v) {
    s("readable nexttick read 0"), v.read(0);
  }
  oe.prototype.resume = function() {
    var v = this._readableState;
    return v.flowing || (s("resume"), v.flowing = !v.readableListening, Z(this, v)), v.paused = !1, this;
  };
  function Z(v, b) {
    b.resumeScheduled || (b.resumeScheduled = !0, ge.nextTick(le, v, b));
  }
  function le(v, b) {
    s("resume", b.reading), b.reading || v.read(0), b.resumeScheduled = !1, v.emit("resume"), L(v), b.flowing && !b.reading && v.read(0);
  }
  oe.prototype.pause = function() {
    return s("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (s("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function L(v) {
    var b = v._readableState;
    for (s("flow", b.flowing); b.flowing && v.read() !== null; )
      ;
  }
  oe.prototype.wrap = function(v) {
    var b = this, U = this._readableState, te = !1;
    v.on("end", function() {
      if (s("wrapped end"), U.decoder && !U.ended) {
        var he = U.decoder.end();
        he && he.length && b.push(he);
      }
      b.push(null);
    }), v.on("data", function(he) {
      if (s("wrapped data"), U.decoder && (he = U.decoder.write(he)), !(U.objectMode && he == null) && !(!U.objectMode && (!he || !he.length))) {
        var ze = b.push(he);
        ze || (te = !0, v.pause());
      }
    });
    for (var ye in v)
      this[ye] === void 0 && typeof v[ye] == "function" && (this[ye] = function(ze) {
        return function() {
          return v[ze].apply(v, arguments);
        };
      }(ye));
    for (var se = 0; se < J.length; se++)
      v.on(J[se], this.emit.bind(this, J[se]));
    return this._read = function(he) {
      s("wrapped _read", he), te && (te = !1, v.resume());
    }, this;
  }, typeof Symbol == "function" && (oe.prototype[Symbol.asyncIterator] = function() {
    return O === void 0 && (O = Xu()), O(this);
  }), Object.defineProperty(oe.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(oe.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(oe.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(b) {
      this._readableState && (this._readableState.flowing = b);
    }
  }), oe._fromList = B, Object.defineProperty(oe.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function B(v, b) {
    if (b.length === 0)
      return null;
    var U;
    return b.objectMode ? U = b.buffer.shift() : !v || v >= b.length ? (b.decoder ? U = b.buffer.join("") : b.buffer.length === 1 ? U = b.buffer.first() : U = b.buffer.concat(b.length), b.buffer.clear()) : U = b.buffer.consume(v, b.decoder), U;
  }
  function P(v) {
    var b = v._readableState;
    s("endReadable", b.endEmitted), b.endEmitted || (b.ended = !0, ge.nextTick(Y, b, v));
  }
  function Y(v, b) {
    if (s("endReadableNT", v.endEmitted, v.length), !v.endEmitted && v.length === 0 && (v.endEmitted = !0, b.readable = !1, b.emit("end"), v.autoDestroy)) {
      var U = b._writableState;
      (!U || U.autoDestroy && U.finished) && b.destroy();
    }
  }
  typeof Symbol == "function" && (oe.from = function(v, b) {
    return z === void 0 && (z = Qu()), z(oe, v, b);
  });
  function Q(v, b) {
    for (var U = 0, te = v.length; U < te; U++)
      if (v[U] === b)
        return U;
    return -1;
  }
  return yo;
}
var ho, Va;
function Qs() {
  if (Va)
    return ho;
  Va = 1, ho = r;
  var n = er().codes, t = n.ERR_METHOD_NOT_IMPLEMENTED, p = n.ERR_MULTIPLE_CALLBACK, f = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, l = n.ERR_TRANSFORM_WITH_LENGTH_0, i = Jt();
  jt(r, i);
  function e(A, _) {
    var M = this._transformState;
    M.transforming = !1;
    var X = M.writecb;
    if (X === null)
      return this.emit("error", new p());
    M.writechunk = null, M.writecb = null, _ != null && this.push(_), X(A);
    var V = this._readableState;
    V.reading = !1, (V.needReadable || V.length < V.highWaterMark) && this._read(V.highWaterMark);
  }
  function r(A) {
    if (!(this instanceof r))
      return new r(A);
    i.call(this, A), this._transformState = {
      afterTransform: e.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, A && (typeof A.transform == "function" && (this._transform = A.transform), typeof A.flush == "function" && (this._flush = A.flush)), this.on("prefinish", s);
  }
  function s() {
    var A = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(_, M) {
      d(A, _, M);
    }) : d(this, null, null);
  }
  r.prototype.push = function(A, _) {
    return this._transformState.needTransform = !1, i.prototype.push.call(this, A, _);
  }, r.prototype._transform = function(A, _, M) {
    M(new t("_transform()"));
  }, r.prototype._write = function(A, _, M) {
    var X = this._transformState;
    if (X.writecb = M, X.writechunk = A, X.writeencoding = _, !X.transforming) {
      var V = this._readableState;
      (X.needTransform || V.needReadable || V.length < V.highWaterMark) && this._read(V.highWaterMark);
    }
  }, r.prototype._read = function(A) {
    var _ = this._transformState;
    _.writechunk !== null && !_.transforming ? (_.transforming = !0, this._transform(_.writechunk, _.writeencoding, _.afterTransform)) : _.needTransform = !0;
  }, r.prototype._destroy = function(A, _) {
    i.prototype._destroy.call(this, A, function(M) {
      _(M);
    });
  };
  function d(A, _, M) {
    if (_)
      return A.emit("error", _);
    if (M != null && A.push(M), A._writableState.length)
      throw new l();
    if (A._transformState.transforming)
      throw new f();
    return A.push(null);
  }
  return ho;
}
var go, $a;
function el() {
  if ($a)
    return go;
  $a = 1, go = t;
  var n = Qs();
  jt(t, n);
  function t(p) {
    if (!(this instanceof t))
      return new t(p);
    n.call(this, p);
  }
  return t.prototype._transform = function(p, f, l) {
    l(null, p);
  }, go;
}
var mo, Ja;
function tl() {
  if (Ja)
    return mo;
  Ja = 1;
  var n;
  function t(M) {
    var X = !1;
    return function() {
      X || (X = !0, M.apply(void 0, arguments));
    };
  }
  var p = er().codes, f = p.ERR_MISSING_ARGS, l = p.ERR_STREAM_DESTROYED;
  function i(M) {
    if (M)
      throw M;
  }
  function e(M) {
    return M.setHeader && typeof M.abort == "function";
  }
  function r(M, X, V, H) {
    H = t(H);
    var x = !1;
    M.on("close", function() {
      x = !0;
    }), n === void 0 && (n = on()), n(M, {
      readable: X,
      writable: V
    }, function(D) {
      if (D)
        return H(D);
      x = !0, H();
    });
    var E = !1;
    return function(D) {
      if (!x && !E) {
        if (E = !0, e(M))
          return M.abort();
        if (typeof M.destroy == "function")
          return M.destroy();
        H(D || new l("pipe"));
      }
    };
  }
  function s(M) {
    M();
  }
  function d(M, X) {
    return M.pipe(X);
  }
  function A(M) {
    return !M.length || typeof M[M.length - 1] != "function" ? i : M.pop();
  }
  function _() {
    for (var M = arguments.length, X = new Array(M), V = 0; V < M; V++)
      X[V] = arguments[V];
    var H = A(X);
    if (Array.isArray(X[0]) && (X = X[0]), X.length < 2)
      throw new f("streams");
    var x, E = X.map(function(D, O) {
      var z = O < X.length - 1, $ = O > 0;
      return r(D, z, $, function(J) {
        x || (x = J), J && E.forEach(s), !z && (E.forEach(s), H(x));
      });
    });
    return X.reduce(d);
  }
  return mo = _, mo;
}
var rl = nt, nn = Xo.EventEmitter, il = jt;
il(nt, nn);
nt.Readable = Xs();
nt.Writable = Ys();
nt.Duplex = Jt();
nt.Transform = Qs();
nt.PassThrough = el();
nt.finished = on();
nt.pipeline = tl();
nt.Stream = nt;
function nt() {
  nn.call(this);
}
nt.prototype.pipe = function(n, t) {
  var p = this;
  function f(A) {
    n.writable && n.write(A) === !1 && p.pause && p.pause();
  }
  p.on("data", f);
  function l() {
    p.readable && p.resume && p.resume();
  }
  n.on("drain", l), !n._isStdio && (!t || t.end !== !1) && (p.on("end", e), p.on("close", r));
  var i = !1;
  function e() {
    i || (i = !0, n.end());
  }
  function r() {
    i || (i = !0, typeof n.destroy == "function" && n.destroy());
  }
  function s(A) {
    if (d(), nn.listenerCount(this, "error") === 0)
      throw A;
  }
  p.on("error", s), n.on("error", s);
  function d() {
    p.removeListener("data", f), n.removeListener("drain", l), p.removeListener("end", e), p.removeListener("close", r), p.removeListener("error", s), n.removeListener("error", s), p.removeListener("end", d), p.removeListener("close", d), n.removeListener("close", d);
  }
  return p.on("end", d), p.on("close", d), n.on("close", d), n.emit("pipe", p), n;
};
class ol {
  setAuthorizationHeader(t) {
    this.authorizationHeader = t;
  }
  setPrettyName(t) {
    this.prettyName = t;
  }
  constructor(t, p, f) {
    this.apiUrl = t, this.authorizationHeader = f, this.prettyName = p, this.geocodeService = this.mapMetadata(new Zo.GeocodeClient(this.apiUrl, null, null)), this.routeOptimizationService = this.mapMetadata(new Ko.RouteOptimizationClient(this.apiUrl, null, null));
  }
  mapMetadata(t) {
    for (const p in t) {
      if (typeof t[p] != "function")
        continue;
      const f = t[p];
      t[p] = (...l) => (l[1] = {
        ...l[1],
        Authorization: this.authorizationHeader,
        Prettyname: this.prettyName
      }, f.call(t, ...l));
    }
    return t;
  }
}
function nl(n, t, p) {
  return new Promise((f, l) => {
    n(t, {}, (i, e) => {
      i ? i.code !== Mn.OK && l(i) : f(p(e));
    }).on("data", (i) => f(p(i))).on("error", (i) => {
      i.code !== Mn.OK && l(i);
    });
  });
}
function al(n, t, p) {
  const f = new rl.Stream();
  return n(t, {}).on("error", (l) => f.emit("error", l)).on("data", (l) => f.emit("data", p(l))), f;
}
const dl = (n, t, p, f = "TEST") => {
  const l = new ol(n, t, p);
  function i(r, s, d, A, _) {
    const M = new Je.RouteOptimizationRq();
    return M.setId(Bn()), M.setLocationsList(r), M.setVehiclesList(d), M.setJobsList(s), A && M.setRelations(new Je.RelationList().setRelationsList(A)), _ && M.setOptions(_), M.setClient(f), al(l.routeOptimizationService.extOptimizeRoute, M, (X) => {
      var z, $;
      const V = {
        [Je.Status.StateType.UNKNOWN]: "Unknown",
        [Je.Status.StateType.FAILED]: "Failed",
        [Je.Status.StateType.CANCELED]: "Canceled",
        [Je.Status.StateType.FINISHED]: "Finished",
        [Je.Status.StateType.INPROGRESS]: "InProgress"
      }, H = {
        [Je.Step.StepType.END]: "End",
        [Je.Step.StepType.JOB]: "Job",
        [Je.Step.StepType.UNKNOWN]: "Unknown",
        [Je.Step.StepType.START]: "Start"
      }, x = X.getStatus(), E = X.getSummary(), D = (z = X.getRoutes()) == null ? void 0 : z.getRoutesList(), O = ($ = X.getUnassigned()) == null ? void 0 : $.getJobsList();
      return {
        Id: X.getId(),
        Status: x ? {
          State: V[x.getState()]
        } : void 0,
        Summary: E ? {
          Code: E.getCode(),
          Description: E.getDescription(),
          JobsAssigned: E.getJobsassigned(),
          JobsUnassigned: E.getJobsunassigned(),
          TotalRoutes: E.getTotalroutes(),
          TotalDistance: E.getTotaldistance(),
          TotalDuration: E.getTotalduration(),
          TotalServices: E.getTotalservice(),
          LicenseUtilization: E.getLicenseutilization()
        } : void 0,
        Routes: {
          Routes: D ? D.map((J) => {
            var F, ee, oe;
            return {
              Steps: J.getStepsList().map((ae) => ({
                JobId: ae.getJobid(),
                Type: H[ae.getType()]
              })),
              Description: J.getDescription(),
              VehicleId: J.getVehicleid(),
              VehicleIndex: J.getVehicleindex(),
              VehicleDate: J.getVehicledate() ? {
                Year: (F = J.getVehicledate()) == null ? void 0 : F.getYear(),
                Month: (ee = J.getVehicledate()) == null ? void 0 : ee.getMonth(),
                Day: (oe = J.getVehicledate()) == null ? void 0 : oe.getDay()
              } : void 0,
              Cost: J.getCost(),
              Duration: J.getDuration(),
              Distance: J.getDistance()
            };
          }) : []
        },
        Unassigned: {
          Jobs: (O == null ? void 0 : O.map((J) => ({
            JobId: J.getJobid(),
            Reason: J.getReason(),
            Type: J.getType(),
            Location: J.getLocation()
          }))) || []
        }
      };
    });
  }
  function e(r, s) {
    const d = new pt.SearchRq();
    return d.setSearchitemsList(r), d.setId(Bn()), s && d.setMaxresults(s), d.setClient(f), nl(l.geocodeService.extSearch, d, (A) => {
      const _ = {
        [pt.SearchRs.ResultType.ERROR]: "Error",
        [pt.SearchRs.ResultType.SUCCESS]: "Success",
        [pt.SearchRs.ResultType.UNKNOWN]: "Unknown"
      }, M = {
        [pt.LocationResult.LocationResultType.FOUND]: "Found",
        [pt.LocationResult.LocationResultType.NOTFOUND]: "NotFound",
        [pt.LocationResult.LocationResultType.UNKNOWN]: "Unknown"
      };
      return {
        Id: A.getId(),
        Result: _[A.getResult()],
        Locations: A.getLocationsList().map((X) => {
          const V = X.getLocation();
          return {
            Result: M[X.getResult()],
            Location: V ? {
              Latitude: V.getLatitude(),
              Longitude: V.getLongitude()
            } : void 0,
            Score: X.getScore(),
            Id: X.getId()
          };
        })
      };
    });
  }
  return {
    search: e,
    optimizeRoute: i
  };
};
export {
  sl as Common,
  ll as CommonCommon,
  ol as GeoServiceGrpcClient,
  pl as Geocode,
  ul as GeocodeGrpcWeb,
  cl as RouteOptimization,
  fl as RouteOptimizationGrpcWeb,
  dl as createApi
};
